// AgriWare Operations Management
// Translations — all languages, all screens

// Keys are documented in the mobile app's translations.ts.
// Ops-specific keys are added below as pages are converted.

const translations = {
  'en-GB': {
    'verify.err_reference_required': "A document reference is required.",
    'verify.err_rate_limited': "Too many attempts. Try again shortly.",
    'verify.err_not_found': "No passport was issued with that reference.",
    'verify.err_code_mismatch': "The organisation code and reference do not match.",
    'verify.err_unknown_section': "Unknown section.",
    'verify.err_read_failed': "The record could not be read.",
    'verify.intro': "Enter the reference printed on the document to confirm it was issued by Agriware Operations. To see the machine's full record, add the issuing organisation's code — both are printed on the passport.",
    'verify.orgcode_optional': "— optional, for the full record",
    'verify.title': "Verify a machine passport",
    'verify.reference_label': "Document reference",
    'verify.orgcode_label': "Organisation code",
    'verify.checking': "Checking…",
    'verify.submit': "Verify",
    'verify.not_verified': "Not verified",
    'verify.withdrawn': "Withdrawn",
    'verify.genuine': "Genuine document",
    'verify.genuine_superseded': "Genuine, but superseded",
    'verify.superseded_note': "A more recent passport has been issued for this machine",
    'verify.fingerprint': "Document fingerprint (SHA-256)",
    'verify.no_result': "No result.",
    'verify.err_not_verified': "That document could not be verified.",
    'verify.err_unreachable': "The verification service could not be reached. Please try again.",
    'verify.row_reference': "Reference",
    'verify.row_issued_by': "Issued by",
    'verify.row_issued_on': "Issued on",
    'verify.not_recorded': "Not recorded",
    'verify.row_make_model': "Make and model",
    'verify.row_status': "Current status",
    'verify.blocked_from_use': "Blocked from use",
    'verify.in_service': "In service",
    'verify.no_open_defects': "No open defects recorded against this machine.",
    'verify.defect_history': "Defect history",
    'verify.no_resolved_defects': "No resolved defects recorded against this machine.",
    'verify.inspection_record': "Inspection record",
    'verify.check_log': "Check log",
    'verify.no_checks': "No checks recorded against this machine.",
    'verify.service_history': "Service history",
    'verify.no_services': "No service records held for this machine.",
    'verify.checks_recorded': "Checks recorded",
    'verify.pass_rate': "Pass rate",
    'verify.defects_raised': "Defects raised",
    'verify.most_recent_check': "Most recent check",
    'verify.show_more': "Show more",
    'verify.showing_of': "Showing {shown} of {total}",
    'verify.details': "Details",
    'verify.hide': "Hide",
    'verify.all_passed': "All passed",
    'verify.n_failed': "{n} failed",
    'verify.blocked_the_machine': "blocked the machine",
    'verify.blocking': "Blocking",
    'verify.raised': "Raised",
    'verify.resolved': "Resolved",
    'verify.revised_after_issue': "revised after issue",
    'verify.next_service': "Next service",
    'verify.parts': "Parts",
    'verify.external': "external",
    'verify.sealed': "sealed",
    'verify.language': "Language",
    'emergency.tel_number': "999",
    'emergency.no_movement': "No movement detected",
    'emergency.triggered_generic': "Emergency triggered",
    'emergency.community_badge': "Community alert — nearby emergency",
    'emergency.panel_responders': "Responders",
    'emergency.machine_involved': "Machine involved",
    'emergency.impact_label': "Impact",
    'emergency.ago': "ago",
    'emergency.location_unavailable': "Location not available",
    'emergency.open_in_maps': "Open in Google Maps",
    'emergency.im_responding': "I'm responding",
    'emergency.confirming': "Confirming…",
    'emergency.mark_resolved': "Mark as resolved",
    'emergency.resolving': "Resolving…",
    'emergency.called_automatically_at': "999 called automatically at {time}",
    'emergency.state_alert': "EMERGENCY ALERT",
    'emergency.state_awaiting': "AWAITING RESPONSE",
    'emergency.state_needs_help': "OPERATOR NEEDS HELP",
    'emergency.state_no_response': "NO RESPONSE FROM OPERATOR",
    'emergency.seconds_to_respond': "{n}s for the operator to respond",
    'billing.over_limit_row': "Beyond your plan's included machines",
    'billing.over_limit_full': "This machine is beyond your plan's included machines. Add it to your subscription to see its record.",
    'nav.reports': "Reports",
    'site.not_found': "Site not found",
    'site.details': "Site details",
    'site.edit': "Edit site",
    'site.updated': "Site updated",
    'site.err_update': "Failed to update site",
    'site.no_address': "No address recorded",
    'site.no_machines': "No machines at this site",
    'site.no_staff': "No one assigned to this site",
    'site.no_defects': "No open defects at this site",
    'checks.new_template': "New template",
    'set.language': "Language",
    'set.language_hint': "Applies to everyone in your organisation",
    'set.your_organisation': "Your organisation",
    'set.group_organisation': "Organisation",
    'set.group_safety': "Safety and compliance",
    'set.group_system': "System",
    'set.reports': "Reports",
    'set.org_details': "Organisation details",
    'set.org_details_hint': "Name, address, company number, branding",
    'set.sites_hint': "Yards, depots and where machines live",
    'set.roles': "Roles and permissions",
    'set.roles_hint': "What each role can see and do",
    'set.billing_hint': "Subscription and payment method",
    'set.coshh_hint': "Substances held and their assessments",
    'set.risk_hint': "Assessments and reviews",
    'set.reports_hint': "Fleet health, compliance, carbon, cost and insurance packs",
    'set.integrations': "Integrations",
    'set.integrations_hint': "Telematics, dealer systems and Almanac",
    'set.notifications_hint': "What gets sent, to whom",
    'set.audit_log': "Audit log",
    'set.audit_log_hint': "Who changed what, and when",
    'set.data': "Data",
    'set.data_hint': "Export and retention",
    'set.data_retention': "Data & retention",
    'set.export_title': "Export your data",
    'set.export_desc': "Export a complete copy of your organisation data including all machine records, service history, check records, staff profiles and qualifications.",
    'set.export_coming_soon': "Data export coming soon",
    'set.export_btn': "Export all data",
    'set.retention_title': "Data retention",
    'set.retention_desc': "Your data is retained for the lifetime of your subscription plus 12 months after cancellation. Machine service records and sealed job cards are retained indefinitely as they may be required for legal and insurance purposes.",
    'set.danger_zone': "Danger zone",
    'set.danger_desc': "Deleting your organisation will permanently remove all data except sealed machine records which are required for compliance. This action cannot be undone.",
    'set.delete_org': "Delete organisation",
    'set.delete_org_toast': "Please contact support to delete your organisation",
    'set.audit_log_subtitle': "Complete record of all actions in your organisation",
    'set.audit_search': "Search audit log…",
    'set.col_action': "Action",
    'set.no_audit': "No audit entries",
    'set.audit_empty_msg': "Actions will appear here as they happen",
    'set.notif_title': "Notification settings",
    'set.notif_desc': "Control which events trigger push notifications for managers and admins in your organisation.",
    'set.notif_saved': "Notification preferences saved",
    'set.save_preferences': "Save preferences",
    'set.notif_check_failed': "Check failed",
    'set.notif_check_failed_desc': "When an operator submits a failed check",
    'set.notif_machine_blocked': "Machine blocked",
    'set.notif_machine_blocked_desc': "When a machine is automatically blocked after a fail",
    'set.notif_defect': "Defect reported",
    'set.notif_defect_desc': "When an operator reports a defect",
    'set.notif_near_miss': "Near miss reported",
    'set.notif_near_miss_desc': "When a near miss is submitted",
    'set.notif_qual_expiring': "Qualification expiring (30d)",
    'set.notif_qual_expiring_desc': "When a staff qualification expires within 30 days",
    'set.notif_qual_expired': "Qualification expired",
    'set.notif_qual_expired_desc': "When a staff qualification has expired",
    'set.notif_service_due': "Service due",
    'set.notif_service_due_desc': "When a machine is approaching its service interval",
    'set.notif_fuel_low': "Fuel tank low",
    'set.notif_fuel_low_desc': "When a derv tank drops below the threshold",
    'set.notif_emergency': "Emergency alert",
    'set.notif_emergency_desc': "Always on — cannot be disabled",
    'set.notif_announcement': "Announcements",
    'set.notif_announcement_desc': "When management sends an announcement",
    'set.no_sites_msg': "Add your first farm or site location",
    'set.err_site_name': "Site name is required",
    'set.site_added': "Site added",
    'set.err_site_add': "Failed to add site",
    'set.site_name': "Site name",
    'set.site_name_placeholder': "e.g. Home Farm",
    'set.address': "Address",
    'set.address_placeholder': "e.g. Home Farm, Farm Lane, HP20 1AB",
    'set.roles_title': "Roles & permissions",
    'set.role_admin_full': "Full access to all sites, machines, staff, settings and billing. Can send announcements and manage all data.",
    'set.role_manager_full': "Site-scoped access. Manages machines and staff at their assigned site. Cannot access billing or org settings.",
    'set.role_operator_full': "Mobile app access only. Completes daily checks, logs fuel fills and can report defects and near misses.",
    'set.perm_all_machines': "All machines across all sites",
    'set.perm_all_staff': "All staff management",
    'set.perm_all_settings': "All settings",
    'set.perm_announcements': "Send announcements",
    'set.perm_emergencies': "Resolve emergencies",
    'set.perm_site_machines': "Machines at their site",
    'set.perm_site_staff': "Staff at their site",
    'set.perm_checks_defects': "Checks and defects",
    'set.perm_shifts': "Shift management",
    'set.perm_daily_checks_app': "Daily checks (app)",
    'set.perm_fuel_fills_app': "Fuel fills (app)",
    'set.perm_defect_app': "Defect reporting (app)",
    'set.perm_near_miss_app': "Near miss reporting (app)",
    'set.perm_own_quals': "View own qualifications",
    'set.perm_sos': "Emergency SOS",
    'set.org_settings': "Organisation settings",
    'set.identity': "Identity",
    'set.org_name': "Organisation name",
    'set.trading_name': "Trading name",
    'set.if_different': "If different",
    'set.company_number': "Company number",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "VAT number",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Industry type",
    'set.ind_farm': "Farm",
    'set.ind_estate': "Estate",
    'set.ind_contractor': "Agricultural contractor",
    'set.ind_dealership': "Dealership",
    'set.ind_other': "Other",
    'set.primary_email': "Primary email",
    'set.phone_number': "Phone number",
    'set.website': "Website",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Address line 1",
    'set.address2': "Address line 2",
    'set.town': "Town / City",
    'set.county': "County",
    'set.postcode': "Postcode",
    'set.branding': "Branding",
    'set.brand_colour': "Brand colour",
    'set.compliance': "Compliance",
    'set.hse_number': "HSE registration number",
    'set.insurance_provider': "Insurance provider",
    'set.policy_number': "Policy number",
    'set.insurance_expiry': "Insurance expiry",
    'set.sharing_transfers': "Sharing & transfers",
    'set.org_code_desc': "Your organisation code is used to receive shared machines and transfers from other Agriware customers. Share it with anyone you co-own machinery with, or anyone selling you a machine.",
    'set.emails': "Emails",
    'set.hold_the_yard': "Weekly Hold the Yard email",
    'set.hold_the_yard_desc': "A Monday summary of last week's pre-use checks, sent to organisation admins and managers.",
    'set.org_code': "Organisation code",
    'set.generating': "Generating…",
    'set.copied': "Copied!",
    'set.copy': "Copy",
    'set.org_saved': "Organisation settings saved",
    'set.err_save': "Failed to save settings",
    'set.save_changes': "Save changes",
    'set.status_trialing': "Trialing",
    'set.status_past_due': "Past due",
    'set.status_cancelled': "Cancelled",
    'set.status_unpaid': "Unpaid",
    'set.status_incomplete': "Incomplete",
    'set.billing_title': "Billing & subscription",
    'set.billing_subtitle': "Manage your Agriware Operations subscription.",
    'set.plan_standard': "Standard",
    'set.per_month': "/month · cancel anytime",
    'set.grandfathered': "This organisation has grandfathered access. Billing details aren't available because this account predates Stripe integration.",
    'set.next_billing': "Next billing date:",
    'set.feat_registry': "Machine registry and service history",
    'set.feat_checks': "Daily checks and inspections",
    'set.feat_defects': "Fault and defect tracking",
    'set.feat_staff': "Staff qualifications and shifts",
    'set.feat_reporting': "Reporting suite",
    'set.feat_unlimited': "Unlimited sites and operators",
    'set.err_no_portal': "No portal URL returned.",
    'set.err_portal': "Could not open billing portal. Please try again or contact support.",
    'set.opening_portal': "Opening billing portal…",
    'set.manage_billing': "Manage billing",
    'set.admin_only_billing': "Only organisation admins can manage billing.",
    'set.stripe_note': "Billing is processed securely by Stripe. We never see your card details.",
    'int.abax_desc': "Pull engine hours, location and utilisation straight from ABAX trackers, so hours arrive on their own rather than being typed in.",
    'int.abax_detail': "Automatic hours would keep service intervals, carbon estimates and check compliance accurate without anyone entering a reading.",
    'int.dms_desc': "Link to your dealer's DMS to raise job requests, approve estimates and receive sealed job cards against the right machine.",
    'int.dms_detail': "Work done by your dealer lands on the machine record automatically, and appears on its passport.",
    'int.almanac_desc': "See how your machines compare with the same models across every Agriware fleet — typical failure points, service intervals and reliability by model.",
    'int.almanac_detail': "Almanac works by pooling anonymised defect and service records across organisations. Your data contributes; you see the aggregate in return.",
    'int.consent_shared': "Shared: machine make and model, defect types, hours at failure, service intervals",
    'int.consent_never': "Never shared: your organisation name, sites, staff, operators, costs or documents",
    'int.consent_threshold': "Figures are only shown where enough machines exist to keep individual fleets unidentifiable",
    'int.consent_withdraw': "You can withdraw at any time — contributed records are removed from future aggregates",
    'int.err_update': "Could not update this integration",
    'int.interest_noted': "Noted — we will be in touch when this is ready",
    'int.almanac_enabled': "Almanac enabled",
    'int.almanac_disabled': "Almanac disabled",
    'int.subtitle': "Connect Agriware Operations with the systems you already use",
    'int.admin_only': "Only an organisation admin can change integrations.",
    'int.enabled': "Enabled",
    'int.in_development': "In development",
    'int.withdraw': "Withdraw",
    'int.enable_almanac': "Enable Almanac",
    'int.interest_registered': "Interest registered",
    'int.register_interest': "Register interest",
    'int.less': "Less",
    'int.what_this_does': "What this does",
    'int.footer': "Using something that isn't here? Tell us what you'd like connected — what people ask for decides what gets built next.",
    'tmpl.scope_all_desc': "Applies to every machine in the organisation",
    'tmpl.scope_category': "By category",
    'tmpl.scope_category_desc': "Applies to selected categories",
    'tmpl.scope_specific_desc': "Applies to one machine only",
    'tmpl.freq_daily': "Daily",
    'tmpl.freq_daily_helper': "Must be completed by the due time each day",
    'tmpl.freq_weekly': "Weekly",
    'tmpl.freq_weekly_helper': "Must be completed once per week",
    'tmpl.freq_hourly': "Hours-based",
    'tmpl.freq_hourly_helper': "Triggered every X engine hours",
    'tmpl.freq_monthly': "Monthly",
    'tmpl.freq_monthly_helper': "Must be completed once per month",
    'tmpl.item_passfail': "Pass / Fail",
    'tmpl.item_numeric': "Numeric",
    'tmpl.item_text': "Text",
    'tmpl.item_photo': "Photo",
    'tmpl.item_signature': "Signature",
    'tmpl.fail_none': "Log only",
    'tmpl.fail_flag': "Log and notify",
    'tmpl.fail_block': "Log, notify and block",
    'tmpl.section_default': "Section",
    'tmpl.err_name': "Template name is required",
    'tmpl.err_category': "Select at least one category",
    'tmpl.err_machine': "Select a machine",
    'tmpl.err_items': "Add at least one check item",
    'tmpl.updated': "Template updated",
    'tmpl.created': "Template created",
    'tmpl.err_save': "Failed to save template",
    'tmpl.name_placeholder': "Template name",
    'tmpl.save': "Save template",
    'tmpl.settings': "Template settings",
    'tmpl.description_placeholder': "Brief description of when this template is used",
    'tmpl.applies_to': "Applies to",
    'tmpl.select_categories_caps': "SELECT CATEGORIES",
    'tmpl.select_machine_caps': "SELECT MACHINE",
    'tmpl.choose_machine': "Choose a machine…",
    'tmpl.frequency': "Check frequency",
    'tmpl.estimated_time': "Estimated time (minutes)",
    'tmpl.every_x_hours': "Every X engine hours",
    'tmpl.due_by_time': "Due by time",
    'tmpl.due_by_hint': "— overdue reminder fires at this time",
    'tmpl.due_by_note': "Push notification sent to operator and site manager if not completed by this time",
    'tmpl.item_one': "item",
    'tmpl.item_many': "items",
    'tmpl.new_item': "New check item",
    'tmpl.add_item': "Add check item",
    'tmpl.add_section': "Add section",
    'tmpl.item_panel_title': "Check item",
    'tmpl.select_item_hint': "Select a check item on the left to edit its settings here.",
    'tmpl.label': "Label",
    'tmpl.label_placeholder': "e.g. Engine oil level",
    'tmpl.if_fails': "If this fails",
    'tmpl.required': "Required",
    'tmpl.required_hint': "Operator must complete this item",
    'status.active': "Active",
    'status.shared': "Shared",
    'status.transferred': "Transferred",
    'status.archived': "Archived",
    'status.issues': "Issues",
    'status.emergency': "Emergency",
    'status.closed': "Closed",
    'status.due': "Due",
    'status.draft': "Draft",
    'status.approved': "Approved",
    'status.declined': "Declined",
    'status.scheduled': "Scheduled",
    'photo.title': "Profile photo",
    'photo.upload_title': "Upload a photo",
    'photo.upload_note': "JPG, PNG or WebP · Max 5MB · Will be cropped to a circle",
    'photo.choose': "Choose photo",
    'photo.drag_hint': "Drag to reposition · Scroll or slide to zoom",
    'photo.change': "Change photo",
    'photo.save': "Save photo",
    'upsell.derv_title': "Fuel management",
    'upsell.derv_desc': "Track derv tank levels, log fills, manage suppliers and monitor fuel usage per machine across all sites.",
    'upsell.coshh_title': "COSHH register",
    'upsell.coshh_desc': "Maintain a digital register of hazardous substances, safety data sheets and required PPE for your workforce.",
    'upsell.risk_title': "Risk assessments",
    'upsell.risk_desc': "Create, manage and seal risk assessments per machine or task. Operators acknowledge before starting work.",
    'upsell.jobs_title': "DMS integration",
    'upsell.jobs_desc': "Request workshop jobs from your dealer, approve estimates and receive sealed job cards directly on your machine profiles.",
    'upsell.reporting_title': "Reports & analytics",
    'upsell.reporting_desc': "Fleet health, compliance, qualification status, fuel usage, carbon emissions and cost per machine reports.",
    'upsell.quals_title': "Qualification tracking",
    'upsell.quals_desc': "Log staff tickets and certificates with expiry tracking, push notifications and machine-qualification gating.",
    'upsell.sharing_title': "Machine sharing",
    'upsell.sharing_desc': "Share machine records with other Agriware Ops organisations — ideal for contractors and shared equipment.",
    'upsell.transfers_title': "Machine transfers",
    'upsell.transfers_desc': "Transfer machines between Ops users or DMS accounts with full ownership history and digital logbook.",
    'upsell.carbon_title': "Carbon reporting",
    'upsell.carbon_desc': "Automatic CO₂ emissions calculations based on fuel consumption. DEFRA-standard reporting for your fleet.",
    'upsell.not_included': "This feature is not included in your current plan.",
    'upsell.upgrade': "Upgrade your plan",
    'service.record_not_found': "Record not found",
    'service.record_title_service': "Service record",
    'service.record_title_repair': "Repair record",
    'service.record_title_inspection': "Inspection record",
    'service.record_suffix': "record",
    'service.email_btn': "Email",
    'service.email_coming_soon': "Email export coming soon",
    'service.sealed_by_workshop': "Sealed by {name} and cannot be modified",
    'service.the_workshop': "the workshop",
    'service.sealed_permanent': "This record is permanently sealed and cannot be modified",
    'service.sealed_by': "Sealed by",
    'service.at_suffix': "at {name}",
    'service.job_ref': "job {ref}",
    'service.photos_video': "Photos and video",
    'service.job_photo': "Job photo",
    'service.files_copying': "Some files are still being copied.",
    'service.date_of_service': "Date of service",
    'service.hours_at_service': "Hours at service",
    'service.total_cost': "Total cost",
    'service.record_details': "Record details",
    'service.type': "Type",
    'service.performed_by': "Performed by",
    'service.performed_by_type': "Performed by type",
    'service.next_service_hours': "Next service hours",
    'service.next_service_date': "Next service date",
    'service.notes': "Notes",
    'service.parts_used': "Parts used",
    'service.col_part': "Part",
    'service.col_qty': "Qty",
    'service.col_cost': "Cost",
    'service.parts_total': "Parts total",
    'service.cost_breakdown': "Cost breakdown",
    'service.labour_cost': "Labour cost",
    'service.parts_cost': "Parts cost",
    'service.total': "Total",
    'service.audit_trail': "Audit trail",
    'service.record_created_by': "Record created by",
    'service.record_sealed_by': "Record sealed by",
    'service.type_service': "Service",
    'service.type_service_desc': "Routine scheduled service",
    'service.type_repair': "Repair",
    'service.type_repair_desc': "Unscheduled repair work",
    'service.type_inspection': "Inspection",
    'service.type_inspection_desc': "Safety or compliance check",
    'service.by_internal': "In-house",
    'service.by_dealer': "Dealer",
    'service.by_external': "External contractor",
    'service.err_description': "Please enter a description",
    'service.err_date': "Please enter the date of service",
    'service.added_toast': "Service record added and sealed",
    'service.err_save': "Failed to save record — please try again",
    'service.seal_note': "This record will be permanently sealed once saved",
    'service.record_type': "Record type",
    'service.description_placeholder': "Describe the work carried out…",
    'service.performed_by_placeholder': "Name or company",
    'service.additional_notes': "Additional notes",
    'service.notes_placeholder': "Any additional notes…",
    'service.add_part': "Add part",
    'service.part_name': "Part name",
    'service.cost_placeholder': "Cost £",
    'service.cost_next_service': "Cost & next service",
    'service.labour_cost_field': "Labour cost (£)",
    'service.next_hours_placeholder': "e.g. 1750",
    'service.seal_warning': "Once saved, this record is permanently sealed and cannot be edited. Make sure all details are correct before saving.",
    'service.save_seal': "Save & seal record",
    'dashboard.there': "there",
    'dashboard.total_machines': "Total machines",
    'dashboard.blocked_machines': "Blocked machines",
    'dashboard.open_incidents': "Open incidents",
    'dashboard.open_defects': "Open defects",
    'dashboard.fuel_tanks': "Fuel tanks",
    'common.of': "of",
    'dashboard.fleet': "Fleet",
    'common.view_all': "View all",
    'dashboard.no_machines': "No machines yet",
    'dashboard.no_machines_msg': "Add your first machine to get started",
    'dashboard.recent_incidents': "Recent incidents",
    'dashboard.no_incidents_msg': "No incidents recorded",
    'dashboard.recent_defects': "Recent defects",
    'dashboard.no_defects': "No defects",
    'dashboard.no_defects_msg': "No defects reported",
    'dashboard.defect_reported': "Defect reported",
    'dashboard.group_overview': "Group overview",
    'dashboard.send_announcement': "Send announcement",
    'dashboard.sites': "Sites",
    'dashboard.no_sites': "No sites yet",
    'dashboard.no_sites_msg': "Add your first site in Settings to get started",
    'dashboard.add_site': "Add site",
    'dashboard.status_monitor': "Monitor",
    'dashboard.status_all_good': "All good",
    'dashboard.derv': "Derv",
    'dashboard.derv_level': "Derv level",
    'qual.short_forklift': "Forklift",
    'qual.short_sprayer': "Sprayer",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Driving",
    'qual.short_firstaid': "First aid",
    'qual.short_chainsaw': "Chainsaw",
    'qual.short_pesticide': "Pesticide",
    'qual.short_telehandler': "Telehandler",
    'qual.short_atv': "ATV",
    'qual.short_other': "Other",
    'qual.forklift': "Forklift operator licence",
    'qual.sprayer': "PA1/PA6 Sprayer certificate",
    'qual.cscs': "CSCS card",
    'qual.driving': "Driving licence",
    'qual.firstaid': "First aid certificate",
    'qual.chainsaw': "Chainsaw certificate",
    'qual.pesticide': "Pesticide application",
    'qual.telehandler': "Telehandler certificate",
    'qual.atv': "ATV/quad bike certificate",
    'qual.other': "Other qualification",
    'staff.n_expired': "expired",
    'staff.n_expiring': "expiring",
    'staff.n_valid': "valid",
    'common.none': "None",
    'staff.tab_members': "Members",
    'staff.tab_qualifications': "Qualifications",
    'staff.tab_shifts': "Shifts",
    'staff.member_one': "member",
    'staff.member_many': "members",
    'staff.alert_one': "qualification alert",
    'staff.alert_many': "qualification alerts",
    'staff.invite': "Invite staff",
    'staff.create_shift': "Create shift",
    'staff.search': "Search by name or email…",
    'staff.none_found': "No staff found",
    'staff.adjust_search': "Try adjusting your search",
    'staff.invite_first': "Invite your first team member",
    'staff.stat_total_quals': "Total qualifications",
    'staff.stat_valid': "Valid",
    'staff.stat_expiring_30d': "Expiring (30d)",
    'staff.stat_expiring': "Expiring",
    'staff.stat_expired': "Expired",
    'staff.qual_one': "qualification",
    'staff.qual_many': "qualifications",
    'staff.expires': "Expires",
    'staff.no_quals': "No qualifications recorded",
    'staff.no_quals_msg': "Add qualifications from each staff member's profile",
    'staff.no_shifts': "No shifts yet",
    'staff.no_shifts_msg': "Create your first shift to start tracking who is working",
    'staff.shift': "Shift",
    'staff.checked_in': "checked in",
    'staff.not_found': "Staff member not found",
    'staff.add_qualification': "Add qualification",
    'staff.expired_alert_one': "qualification has expired — this operator may not be authorised to use certain machines",
    'staff.expired_alert_many': "qualifications have expired — this operator may not be authorised to use certain machines",
    'staff.expiring_alert_one': "qualification expiring within 30 days",
    'staff.expiring_alert_many': "qualifications expiring within 30 days",
    'staff.tab_details': "Details",
    'staff.contact': "Contact",
    'staff.account': "Account",
    'staff.onboarding': "Onboarding",
    'staff.complete': "Complete",
    'staff.job_title': "Job title",
    'staff.joined': "Joined",
    'staff.invited_by': "Invited by",
    'staff.quals_tickets': "Qualifications & tickets",
    'staff.no_quals_profile_msg': "Add this operator's tickets and certificates",
    'staff.issued': "Issued",
    'staff.no_expiry': "No expiry",
    'staff.expires_today': "Expires today",
    'staff.days_remaining_one': "day remaining",
    'staff.days_remaining_many': "days remaining",
    'staff.expired_days_ago_one': "Expired {n} day ago",
    'staff.expired_days_ago_many': "Expired {n} days ago",
    'staff.view_certificate': "View certificate",
    'staff.assigned_machines': "Assigned machines",
    'staff.no_machines': "No machines assigned",
    'staff.no_machines_msg': "This operator has no machines assigned to them",
    'staff.err_first_name': "First name is required",
    'staff.err_last_name': "Last name is required",
    'staff.err_email': "Please enter a valid email address",
    'staff.err_site': "Please select a site",
    'staff.err_create_prefix': "Failed to create account:",
    'staff.err_timeout': "Timed out waiting for account creation. Please refresh and try again.",
    'staff.err_create': "Failed to create account — please try again",
    'staff.copy_greeting': "Hi {name},",
    'staff.copy_body': "Your account has been created for Agriware Operations.",
    'staff.copy_email': "Email:",
    'staff.copy_temp_password': "Temporary password:",
    'staff.copy_footer': "You'll be prompted to change your password on first login.",
    'staff.copied_toast': "Login details copied to clipboard",
    'staff.role_admin_desc': "Full access to all sites and settings",
    'staff.role_manager_desc': "Manages a single site, staff and machines",
    'staff.role_operator_desc': "Completes daily checks via the mobile app",
    'staff.add_member': "Add staff member",
    'staff.add_member_sub': "Their account will be created instantly. You'll see their login details to share with them.",
    'staff.account_created': "Account created",
    'staff.share_details_pre': "Share these login details with",
    'staff.share_details_post': "They'll be prompted to change the password on first login.",
    'staff.label_email_caps': "EMAIL",
    'staff.label_temp_password_caps': "TEMPORARY PASSWORD",
    'staff.copy_login_details': "Copy login details",
    'staff.add_another': "Add another",
    'staff.back_to_staff': "Back to staff",
    'staff.personal_details': "Personal details",
    'staff.first_name': "First name",
    'staff.last_name': "Last name",
    'staff.work_email': "Work email",
    'staff.site_assignment': "Site assignment",
    'staff.no_sites': "No sites set up yet — add a site in Settings first",
    'staff.creating_account': "Creating account…",
    'staff.create_account': "Create account",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Please select a qualification type",
    'qual.err_name': "Please enter the qualification name",
    'qual.err_issue_date': "Please enter the issue date",
    'qual.err_expiry': "Please enter the expiry date or mark as no expiry",
    'qual.added_toast': "Qualification added",
    'qual.err_save': "Failed to save qualification — please try again",
    'qual.back_staff_profile': "Staff profile",
    'qual.subtitle': "Record a ticket, certificate or licence for this operator",
    'qual.type_title': "Qualification type",
    'qual.name_label': "Qualification name",
    'qual.name_placeholder': "e.g. NPTC Brushcutter certificate",
    'qual.cert_details': "Certificate details",
    'qual.cert_number': "Certificate number",
    'common.optional_suffix': "— optional",
    'qual.cert_number_placeholder': "e.g. NPORS-123456",
    'qual.issuing_body': "Issuing body",
    'qual.issuing_body_placeholder': "e.g. NPORS, LANTRA, CITB",
    'qual.issue_date': "Issue date",
    'qual.expiry_date': "Expiry date",
    'qual.no_expiry_label': "This qualification has no expiry date",
    'qual.cert_document': "Certificate document",
    'qual.upload_note': "Upload a photo or scan of the certificate. This is stored privately and never shared.",
    'common.remove': "Remove",
    'qual.click_upload': "Click to upload certificate",
    'qual.file_types': "JPG, PNG or PDF",
    'common.saving': "Saving…",
    'qual.save': "Save qualification",
    'defects.title': "Defects",
    'defects.n_open': "open",
    'defects.n_critical': "critical",
    'defects.stat_total': "Total defects",
    'defects.status_open': "Open",
    'defects.status_in_progress': "In progress",
    'defects.status_resolved': "Resolved",
    'defects.all_severities': "All severities",
    'defects.sev_minor': "Minor",
    'defects.sev_moderate': "Moderate",
    'defects.sev_major': "Major",
    'defects.sev_critical': "Critical",
    'defects.search': "Search defects…",
    'common.clear': "Clear",
    'defects.col_description': "Description",
    'defects.reported_by': "Reported by",
    'defects.col_severity': "Severity",
    'defects.no_description': "No description",
    'defects.none_found': "No defects found",
    'defects.none_reported': "No defects have been reported",
    'defects.acknowledged_toast': "Defect acknowledged",
    'defects.acknowledge_failed': "Failed to acknowledge defect",
    'defects.resolved_released': "Defect resolved — machine released",
    'defects.resolved_toast': "Defect resolved",
    'defects.resolve_failed': "Failed to resolve defect",
    'defects.not_found': "Defect not found",
    'defects.report_title': "Defect report",
    'defects.acknowledge': "Acknowledge",
    'defects.raise_job': "Raise job",
    'defects.resolve': "Resolve",
    'defects.blocking_banner': "Machine blocked — a manager must record a written release before it returns to service",
    'defects.details_title': "Defect details",
    'defects.no_description_provided': "No description provided",
    'defects.reported_at': "Reported at",
    'defects.location': "Location",
    'defects.photos': "Photos",
    'defects.acknowledgement': "Acknowledgement",
    'defects.acknowledged_by': "Acknowledged by",
    'defects.resolved_by': "Resolved by",
    'defects.return_to_service': "Return to service",
    'defects.revised': "Revised",
    'defects.revised_by_suffix': "by {name}",
    'defects.view_machine_profile': "View machine profile",
    'defects.resolve_and_release': "Resolve and return to service",
    'defects.resolve_defect': "Resolve defect",
    'defects.release_machine': "Release machine",
    'defects.mark_resolved': "Mark as resolved",
    'defects.release_warning': "This machine is blocked. Your written release will be recorded against your name and role, and will appear on the machine's passport.",
    'defects.resolution_details': "Resolution details",
    'defects.resolution_placeholder': "Describe how the defect was resolved…",
    'defects.narrative_placeholder': "What was found, what was done, and how the machine was checked before release. Include works order numbers and test details where relevant.",
    'defects.chars_needed_one': "more character needed",
    'defects.chars_needed_many': "more characters needed",
    'defects.characters': "characters",
    'defects.permanent_note': "This will be permanently recorded against the defect report.",
    'machines.tab_overview': "Overview",
    'machines.tab_history': "History",
    'machines.tab_documents': "Documents",
    'machines.tab_operators': "Operators",
    'machines.tab_sharing': "Sharing",
    'machines.tab_incidents': "Incidents",
    'machines.pdf_only': "Only PDF files are accepted.",
    'machines.replace_confirm': "Replace the existing {name}? The old file will be deleted.",
    'machines.delete_doc_confirm': "Delete this document? This cannot be undone.",
    'machines.uploaded': "Uploaded",
    'machines.no_file_yet': "No file yet",
    'machines.uploading': "Uploading…",
    'machines.view_document': "View document",
    'common.replace': "Replace",
    'common.delete': "Delete",
    'common.upload': "Upload",
    'machines.doc_type_manual': "Manual",
    'machines.doc_type_private': "Private",
    'machines.doc_operators_manual': "Operator's manual",
    'machines.doc_workshop_manual': "Workshop manual",
    'machines.untitled_document': "Untitled document",
    'machines.add_document': "Add document",
    'machines.documents_intro': "Operator and workshop manuals are typed slots — they help us identify the right document when sharing with the Agriware library. Other private documents are visible only to your organisation.",
    'machines.returned_to_service': "Machine returned to service",
    'machines.not_blocked': "This machine is not blocked",
    'machines.resolve_defect_first': "Resolve the open defect to return this machine to service",
    'machines.return_failed': "Failed to return the machine to service",
    'machines.machine_not_found': "Machine not found",
    'common.unknown': "Unknown",
    'machines.unblock': "Unblock",
    'service.add_record': "Add service record",
    'machines.serial_number': "Serial number",
    'machines.year': "Year",
    'machines.blocked_banner': "Machine blocked — do not use",
    'machines.current_hours': "Current hours",
    'machines.next_service': "Next service",
    'machines.service_records': "Service records",
    'machines.service_progress': "Service progress",
    'machines.cost_over_time': "Cost over time",
    'machines.cost_over_time_sub': "Service, repair and cumulative cost of ownership",
    'machines.cost_empty': "Cost data will appear as service records are added.",
    'machines.series_service': "Service",
    'machines.series_repair': "Repair",
    'machines.series_cumulative': "Cumulative",
    'machines.details_title': "Machine details",
    'machines.make': "Make",
    'machines.model': "Model",
    'machines.category': "Category",
    'machines.assigned_to': "Assigned to",
    'machines.pool_machine': "Pool machine",
    'machines.unassigned': "Unassigned",
    'machines.purchase_value': "Purchase & value",
    'machines.purchase_date': "Purchase date",
    'machines.purchase_price': "Purchase price",
    'machines.depreciation_rate': "Depreciation rate",
    'machines.per_year': "per year",
    'machines.estimated_life': "Estimated life",
    'common.unit_years': "years",
    'machines.cost_tracking': "Cost tracking",
    'machines.total_service_cost': "Total service cost",
    'machines.total_repair_cost': "Total repair cost",
    'machines.total_fuel_cost': "Total fuel cost",
    'machines.total_cost_ownership': "Total cost of ownership",
    'machines.service_history': "Service & repair history",
    'service.add_record_short': "Add record",
    'service.none_yet': "No service records yet",
    'service.none_yet_msg': "Add your first service or repair record",
    'service.sealed': "Sealed",
    'service.workshop': "Workshop",
    'common.photo_one': "photo",
    'common.photo_many': "photos",
    'machines.assigned_operators': "Assigned operators",
    'machines.no_operator': "No operator assigned",
    'machines.no_operator_msg': "This machine has no assigned operator",
    'machines.pool_machine_msg': "This is a pool machine — available to all operators",
    'machines.ownership_sharing': "Ownership & sharing",
    'machines.share_machine': "Share machine",
    'machines.current_owner': "Current owner",
    'machines.your_organisation': "Your organisation",
    'machines.shared_with': "Shared with",
    'machines.not_shared': "Not shared with any other organisations",
    'machines.incident_history': "Incident history",
    'incidents.none': "No incidents",
    'incidents.none_msg': "No incidents recorded for this machine",
    'incidents.impact_detected': "Impact detected",
    'incidents.manual_sos': "Manual SOS",
    'incidents.man_down': "Man-down alert",
    'machines.unblock_title': "Return machine to service",
    'machines.confirm_unblock': "Confirm unblock",
    'machines.unblock_warning': "Your written statement is recorded against the check that stopped this machine, and appears on its passport. If the machine is blocked by an open defect, resolve the defect instead.",
    'machines.blocked_reason': "Blocked reason",
    'machines.unblock_statement': "Return to service statement",
    'machines.unblock_placeholder': "What was found, what was done, and how the machine was checked before release.",
    'checks.history_title': "Check history",
    'checks.stat_total': "Total checks",
    'checks.stat_passed': "Passed",
    'checks.stat_failed': "Failed",
    'checks.n_passed': "passed",
    'checks.n_failed': "failed",
    'common.clear_filters': "Clear filters",
    'checks.not_found': "Check not found",
    'common.export_pdf': "Export PDF",
    'common.pdf_coming_soon': "PDF export coming soon",
    'checks.item_failed_one': "item failed",
    'checks.item_failed_many': "items failed",
    'checks.auto_blocked': "Machine was automatically blocked on submission",
    'checks.sealed_record': "Sealed record",
    'checks.submitted_by': "Submitted by",
    'checks.submitted_at': "Submitted at",
    'checks.hours_at_check': "Hours at check",
    'checks.stat_total_items': "Total items",
    'checks.stat_mileage': "Mileage",
    'checks.details_title': "Check details",
    'checks.failed_items': "Failed items",
    'checks.no_items_recorded': "No check items recorded",
    'checks.alt_defect_photo': "Defect photo",
    'checks.alt_check_photo': "Check photo",
    'common.unit_hrs': "hrs",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Templates",
    'checks.tab_history': "History",
    'checks.create_template': "Create template",
    'checks.scope_specific': "Specific machine",
    'checks.scope_all': "All machines",
    'checks.categories': "categories",
    'checks.items': "items",
    'checks.title': "Checks",
    'checks.template_one': "template",
    'checks.template_many': "templates",
    'checks.record_one': "record",
    'checks.record_many': "records",
    'checks.no_templates': "No check templates yet",
    'checks.no_templates_msg': "Create templates to define what operators need to check before using machines",
    'checks.search': "Search by machine or operator…",
    'checks.all_results': "All results",
    'checks.pass': "Pass",
    'checks.fail': "Fail",
    'checks.none_found': "No checks found",
    'checks.adjust_filters': "Try adjusting your filters",
    'checks.none_submitted': "No checks have been submitted yet",
    'checks.col_operator': "Operator",
    'checks.col_datetime': "Date & time",
    'checks.col_result': "Result",
    'machines.add': "Add machine",
    'machines.col_machine': "Machine",
    'machines.col_serial': "Serial / Reg",
    'machines.col_site': "Site",
    'machines.col_hours': "Hours",
    'machines.col_status': "Status",
    'machines.title': "Machines",
    'machines.count_one': "machine",
    'machines.count_many': "machines",
    'machines.blocked': "blocked",
    'machines.search': "Search by make, model, serial or reg…",
    'machines.all_sites': "All sites",
    'machines.all_statuses': "All statuses",
    'machines.available': "Available",
    'machines.blocked_one': "Blocked",
    'machines.none_found': "No machines found",
    'machines.view': "View",
    'cat.all': "All categories",
    'cat.agricultural': "Agricultural",
    'cat.groundcare': "Groundcare",
    'cat.plant': "Plant",
    'cat.vehicle': "Vehicle",
    'cat.atv': "ATV",
    'nav.dashboard': "Dashboard",
    'nav.staff': "Staff",
    'nav.checks': "Checks",
    'nav.safety': "Safety",
    'nav.operations': "Operations",
    'nav.settings': "Settings",
    'nav.billing': "Billing",
    'nav.sign_out': "Sign out",
    'role.admin': "Admin",
    'role.manager': "Manager",
    'role.operator': "Operator",
    'app.name': 'AgriWare Operations',
    'app.tagline': 'Management',
    'nav.home': 'Home',
    'nav.machines': 'Machines',
    'nav.profile': 'Profile',
    'common.back': 'Back',
    'common.cancel': 'Cancel',
    'common.save': 'Save',
    'common.edit': 'Edit',
    'common.done': 'Done',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.ok': 'OK',
    'common.error': 'Error',
    'common.loading': 'Loading...',
    'common.retry': 'Retry',
    'common.search': 'Search',
    'common.submit': 'Submit',
    'common.confirm': 'Confirm',
    'common.close': 'Close',
    'common.pass': 'Pass',
    'common.fail': 'Fail',
    'common.total': 'total',
    'common.today': 'Today',
    'common.yesterday': 'Yesterday',
    'common.online_only': 'Online only',
    'common.last_synced': 'Last synced',
    'common.back_to_app': 'Back to app',
    'common.gps_shared': 'GPS shared',
    'common.yes_via_saas': 'Yes — via SaaS',
    'common.not_called': 'Not called',
    'login.sign_in': 'Sign in',
    'login.email': 'Email address',
    'login.password': 'Password',
    'login.forgot_password': 'Forgot password?',
    'login.no_account': "Don't have an account?",
    'login.request_access': 'Request access',
    'login.account_created_by_org': 'Your account has been created by your organisation.',
    'login.email_placeholder': 'you@organisation.com',
    'login.password_placeholder': 'Enter your password',
    'login.error_empty': 'Please enter your email and password.',
    'login.error_invalid': 'Invalid email or password. Please try again.',
    'dashboard.greeting_morning': 'Good morning,',
    'dashboard.greeting_afternoon': 'Good afternoon,',
    'dashboard.greeting_evening': 'Good evening,',
    'dashboard.todays_tasks': "Today's tasks",
    'dashboard.completed': 'Completed',
    'dashboard.overdue': 'Overdue',
    'dashboard.in_progress': 'In progress',
    'dashboard.upcoming': 'Upcoming',
    'dashboard.pending': 'Pending',
    'machines.search_placeholder': 'Search machines...',
    'machines.favourites': 'Favourites',
    'machines.all_machines': 'All machines',
    'machines.operational': 'Operational',
    'machines.needs_attention': 'Needs attention',
    'machines.fault': 'Fault',
    'machines.unsafe_to_operate': 'Unsafe to operate',
    'machines.registration': 'Registration',
    'machines.assigned_operator': 'Assigned operator',
    'machines.engine_hours': 'Engine hours',
    'machines.documents': 'Documents',
    'machines.log_fault': 'Log a fault',
    'machines.operator_manual': 'Operator manual',
    'machines.service_record': 'Service record',
    'machines.insurance': 'Insurance certificate',
    'machines.mot': 'MOT certificate',
    'daily_check.title': 'Daily check',
    'daily_check.start': 'Start daily check',
    'daily_check.required': 'Daily check required',
    'daily_check.required_msg': 'Must be completed before operating this machine.',
    'daily_check.complete': 'Check complete',
    'daily_check.complete_msg': 'Completed by',
    'daily_check.submit': 'Submit check',
    'daily_check.items_remaining': 'items remaining',
    'daily_check.reward_title': 'Thank you!',
    'daily_check.reward_subtitle': 'Your daily check has been recorded.\nHonest checks keep everyone safe.',
    'daily_check.back_to_machine': 'Back to machine',
    'daily_check.day_streak': 'Day streak',
    'daily_check.completion_rate': 'Completion rate',
    'daily_check.cat_lights': 'Lights & visibility',
    'daily_check.cat_fluids': 'Fluids',
    'daily_check.cat_tyres': 'Tyres & wheels',
    'daily_check.cat_safety': 'Safety',
    'daily_check.cat_controls': 'Controls',
    'daily_check.cat_body': 'Body & attachments',
    'daily_check.lights_working': 'All lights working',
    'daily_check.mirrors': 'Mirrors clean and adjusted',
    'daily_check.windscreen': 'Windscreen clean and undamaged',
    'daily_check.engine_oil': 'Engine oil level',
    'daily_check.coolant': 'Coolant level',
    'daily_check.hydraulic': 'Hydraulic fluid level',
    'daily_check.fuel': 'Fuel level adequate',
    'daily_check.tyre_pressure': 'Tyre pressures correct',
    'daily_check.tyre_damage': 'No visible tyre damage',
    'daily_check.wheel_nuts': 'Wheel nuts secure',
    'daily_check.fire_extinguisher': 'Fire extinguisher present',
    'daily_check.first_aid': 'First aid kit present',
    'daily_check.rops': 'ROPS structure undamaged',
    'daily_check.seatbelt': 'Seatbelt working correctly',
    'daily_check.brakes': 'Brakes working correctly',
    'daily_check.steering': 'Steering responsive',
    'daily_check.horn': 'Horn working',
    'daily_check.body_damage': 'No visible body damage',
    'daily_check.attachments': 'Attachments secure',
    'daily_check.pto_guard': 'PTO guard in place',
    'log_fault.title': 'Log a fault',
    'log_fault.description': 'Description',
    'log_fault.description_placeholder': 'Describe the fault...',
    'log_fault.photos': 'Photos',
    'log_fault.add_photo': 'Add photo',
    'log_fault.submit': 'Submit fault report',
    'log_fault.success': 'Fault logged successfully',
    'emergency.title': 'Emergency',
    'emergency.what_emergency': "What's the emergency?",
    'emergency.select_type': 'Select the type of emergency.\nThe appropriate contacts will be called immediately.',
    'emergency.vibrating': 'Vibrating',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Medical emergency',
    'emergency.medical_sub': 'Injury, illness or unconscious person on site',
    'emergency.calls_999': 'Calls 999 immediately',
    'emergency.electrical': 'Electrical emergency',
    'emergency.electrical_sub': 'Powerline strike or electrical contact — stay in the cab',
    'emergency.calls_105': 'Calls 105 immediately',
    'emergency.no_signal': 'Emergency numbers stored on device — available without signal',
    'emergency.gps_auto': 'GPS location shared automatically',
    'emergency.999_called': '999 called',
    'emergency.105_called': '105 called',
    'emergency.services_contacted': 'Emergency services have been contacted.\nYour supervisor has also been notified.',
    'emergency.power_contacted': 'Power emergency line contacted.\nYour supervisor has also been notified.',
    'emergency.emergency_type': 'Emergency type',
    'emergency.number_called': 'Number called',
    'emergency.location': 'Location',
    'emergency.admin_notified': 'Admin notified',
    'emergency.stay_in_cab': 'Stay in the cab',
    'emergency.stay_in_cab_msg': 'Do not exit the vehicle. Wait until the power authority confirms the line is safe. Keep windows closed.',
    'emergency.medical_type': 'Medical',
    'emergency.electrical_type': 'Electrical',
    'crash.are_you_okay': 'Are you okay?',
    'crash.impact_detected': 'A possible impact has been detected.\nPlease respond or help will be called.',
    'crash.im_okay': "I'm okay",
    'crash.dismiss_alert': 'Dismiss alert — no action taken',
    'crash.i_need_help': 'I need help',
    'crash.notify_supervisor': 'Notify supervisor with GPS location',
    'crash.call_999': 'Call 999',
    'crash.call_emergency': 'Call emergency services immediately',
    'crash.glad_okay': "Glad you're okay",
    'crash.alert_dismissed': 'Alert dismissed. No notification has been sent.',
    'crash.help_on_way': 'Help is on the way',
    'crash.supervisor_notified': 'Your supervisor has been notified with your GPS location.',
    'crash.auto_dialled': '999 auto-dialled',
    'crash.no_response': 'No response detected. Emergency services called automatically. Voice message broadcasting.',
    'crash.broadcasting': 'Broadcasting message',
    'crash.repeating': 'Repeating every 15 seconds',
    'crash.admin_notified': 'Admin notified',
    'crash.emergency_services': 'Emergency services',
    'profile.title': 'Profile',
    'profile.personal_info': 'Personal info',
    'profile.full_name': 'Full name',
    'profile.email': 'Email',
    'profile.phone': 'Phone',
    'profile.role': 'Role',
    'profile.organisation': 'Organisation',
    'profile.emergency_contact': 'Emergency contact',
    'profile.emergency_contact_note': 'Your supervisor will be contacted in an emergency',
    'profile.contact_name': 'Contact name',
    'profile.contact_phone': 'Contact phone',
    'profile.notifications': 'Notifications',
    'profile.task_reminders': 'Task reminders',
    'profile.overdue_alerts': 'Overdue alerts',
    'profile.crash_detection': 'Crash detection',
    'profile.account_security': 'Account & security',
    'profile.change_password': 'Change password',
    'profile.two_factor': 'Two-factor authentication',
    'profile.login_activity': 'Login activity',
    'profile.app_settings': 'App settings',
    'profile.theme': 'Theme',
    'profile.language': 'Language',
    'profile.sign_out': 'Sign out',
    'profile.sign_out_confirm': 'Sign out',
    'profile.sign_out_msg': 'Are you sure you want to sign out?',
    'profile.field_staff': 'Field staff',
    'theme.light': 'Light',
    'theme.dark': 'Dark',
    'theme.system': 'System default',
  },

  'en-US': {
  },

  'fr': {
    'verify.err_reference_required': "Une référence de document est requise.",
    'verify.err_rate_limited': "Trop de tentatives. Réessayez dans un instant.",
    'verify.err_not_found': "Aucun passeport n'a été émis sous cette référence.",
    'verify.err_code_mismatch': "Le code de l'organisation et la référence ne correspondent pas.",
    'verify.err_unknown_section': "Section inconnue.",
    'verify.err_read_failed': "Le dossier n'a pas pu être lu.",
    'verify.intro': "Saisissez la référence imprimée sur le document pour confirmer qu'il a été émis par Agriware Operations. Pour consulter le dossier complet de la machine, ajoutez le code de l'organisation émettrice — les deux figurent sur le passeport.",
    'verify.orgcode_optional': "— facultatif, pour le dossier complet",
    'verify.title': "Vérifier un passeport machine",
    'verify.reference_label': "Référence du document",
    'verify.orgcode_label': "Code de l'organisation",
    'verify.checking': "Vérification…",
    'verify.submit': "Vérifier",
    'verify.not_verified': "Non vérifié",
    'verify.withdrawn': "Retiré",
    'verify.genuine': "Document authentique",
    'verify.genuine_superseded': "Authentique, mais remplacé",
    'verify.superseded_note': "Un passeport plus récent a été émis pour cette machine",
    'verify.fingerprint': "Empreinte du document (SHA-256)",
    'verify.no_result': "Aucun résultat.",
    'verify.err_not_verified': "Ce document n'a pas pu être vérifié.",
    'verify.err_unreachable': "Le service de vérification est injoignable. Veuillez réessayer.",
    'verify.row_reference': "Référence",
    'verify.row_issued_by': "Émis par",
    'verify.row_issued_on': "Émis le",
    'verify.not_recorded': "Non renseigné",
    'verify.row_make_model': "Marque et modèle",
    'verify.row_status': "Statut actuel",
    'verify.blocked_from_use': "Interdite d'utilisation",
    'verify.in_service': "En service",
    'verify.no_open_defects': "Aucun défaut ouvert enregistré pour cette machine.",
    'verify.defect_history': "Historique des défauts",
    'verify.no_resolved_defects': "Aucun défaut résolu enregistré pour cette machine.",
    'verify.inspection_record': "Relevé d'inspection",
    'verify.check_log': "Journal des contrôles",
    'verify.no_checks': "Aucun contrôle enregistré pour cette machine.",
    'verify.service_history': "Historique d'entretien",
    'verify.no_services': "Aucune fiche d'entretien pour cette machine.",
    'verify.checks_recorded': "Contrôles enregistrés",
    'verify.pass_rate': "Taux de conformité",
    'verify.defects_raised': "Défauts signalés",
    'verify.most_recent_check': "Dernier contrôle",
    'verify.show_more': "Afficher plus",
    'verify.showing_of': "{shown} sur {total} affichés",
    'verify.details': "Détails",
    'verify.hide': "Masquer",
    'verify.all_passed': "Tous conformes",
    'verify.n_failed': "{n} non conformes",
    'verify.blocked_the_machine': "a bloqué la machine",
    'verify.blocking': "Bloquant",
    'verify.raised': "Signalé",
    'verify.resolved': "Résolu",
    'verify.revised_after_issue': "révisé après émission",
    'verify.next_service': "Prochain entretien",
    'verify.parts': "Pièces",
    'verify.external': "externe",
    'verify.sealed': "scellée",
    'verify.language': "Langue",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Aucun mouvement détecté",
    'emergency.triggered_generic': "Urgence déclenchée",
    'emergency.community_badge': "Alerte communautaire — urgence à proximité",
    'emergency.panel_responders': "Intervenants",
    'emergency.machine_involved': "Machine concernée",
    'emergency.impact_label': "Choc",
    'emergency.ago': "écoulées",
    'emergency.location_unavailable': "Localisation non disponible",
    'emergency.open_in_maps': "Ouvrir dans Google Maps",
    'emergency.im_responding': "J'interviens",
    'emergency.confirming': "Confirmation…",
    'emergency.mark_resolved': "Marquer comme clôturé",
    'emergency.resolving': "Clôture…",
    'emergency.called_automatically_at': "Le 112 a été appelé automatiquement à {time}",
    'emergency.state_alert': "ALERTE URGENCE",
    'emergency.state_awaiting': "EN ATTENTE DE RÉPONSE",
    'emergency.state_needs_help': "L'OPÉRATEUR A BESOIN D'AIDE",
    'emergency.state_no_response': "AUCUNE RÉPONSE DE L'OPÉRATEUR",
    'emergency.seconds_to_respond': "{n} s pour que l'opérateur réponde",
    'billing.over_limit_row': "Au-delà des machines incluses dans votre formule",
    'billing.over_limit_full': "Cette machine dépasse les machines incluses dans votre formule. Ajoutez-la à votre abonnement pour consulter son dossier.",
    'nav.reports': "Rapports",
    'site.not_found': "Site introuvable",
    'site.details': "Détails du site",
    'site.edit': "Modifier le site",
    'site.updated': "Site mis à jour",
    'site.err_update': "Échec de la mise à jour du site",
    'site.no_address': "Aucune adresse enregistrée",
    'site.no_machines': "Aucune machine sur ce site",
    'site.no_staff': "Personne n'est affecté à ce site",
    'site.no_defects': "Aucun défaut ouvert sur ce site",
    'checks.new_template': "Nouveau modèle",
    'set.language': "Langue",
    'set.language_hint': "S'applique à toute votre organisation",
    'set.your_organisation': "Votre organisation",
    'set.group_organisation': "Organisation",
    'set.group_safety': "Sécurité et conformité",
    'set.group_system': "Système",
    'set.reports': "Rapports",
    'set.org_details': "Informations sur l'organisation",
    'set.org_details_hint': "Nom, adresse, numéro de société, image de marque",
    'set.sites_hint': "Cours, dépôts et lieux de stationnement des machines",
    'set.roles': "Rôles et autorisations",
    'set.roles_hint': "Ce que chaque rôle peut voir et faire",
    'set.billing_hint': "Abonnement et moyen de paiement",
    'set.coshh_hint': "Substances détenues et leurs évaluations",
    'set.risk_hint': "Évaluations et revues",
    'set.reports_hint': "État du parc, conformité, carbone, coûts et dossiers d’assurance",
    'set.integrations': "Intégrations",
    'set.integrations_hint': "Télématique, systèmes concessionnaires et Almanac",
    'set.notifications_hint': "Ce qui est envoyé, et à qui",
    'set.audit_log': "Journal d’audit",
    'set.audit_log_hint': "Qui a modifié quoi, et quand",
    'set.data': "Données",
    'set.data_hint': "Export et conservation",
    'set.data_retention': "Données et conservation",
    'set.export_title': "Exporter vos données",
    'set.export_desc': "Exportez une copie complète des données de votre organisation : dossiers machine, historique d'entretien, contrôles, fiches du personnel et qualifications.",
    'set.export_coming_soon': "Export des données bientôt disponible",
    'set.export_btn': "Exporter toutes les données",
    'set.retention_title': "Conservation des données",
    'set.retention_desc': "Vos données sont conservées pendant toute la durée de votre abonnement, puis 12 mois après sa résiliation. Les fiches d'entretien et les ordres de travail scellés sont conservés indéfiniment car ils peuvent être exigés à des fins juridiques et d'assurance.",
    'set.danger_zone': "Zone sensible",
    'set.danger_desc': "La suppression de votre organisation efface définitivement toutes les données, sauf les dossiers machine scellés requis pour la conformité. Cette action est irréversible.",
    'set.delete_org': "Supprimer l'organisation",
    'set.delete_org_toast': "Contactez l'assistance pour supprimer votre organisation",
    'set.audit_log_subtitle': "Enregistrement complet de toutes les actions dans votre organisation",
    'set.audit_search': "Rechercher dans le journal d'audit…",
    'set.col_action': "Action",
    'set.no_audit': "Aucune entrée d'audit",
    'set.audit_empty_msg': "Les actions apparaîtront ici au fur et à mesure",
    'set.notif_title': "Paramètres de notification",
    'set.notif_desc': "Choisissez les événements qui déclenchent des notifications push pour les responsables et administrateurs de votre organisation.",
    'set.notif_saved': "Préférences de notification enregistrées",
    'set.save_preferences': "Enregistrer les préférences",
    'set.notif_check_failed': "Contrôle non conforme",
    'set.notif_check_failed_desc': "Lorsqu'un opérateur soumet un contrôle non conforme",
    'set.notif_machine_blocked': "Machine bloquée",
    'set.notif_machine_blocked_desc': "Lorsqu'une machine est bloquée automatiquement après une non-conformité",
    'set.notif_defect': "Défaut signalé",
    'set.notif_defect_desc': "Lorsqu'un opérateur signale un défaut",
    'set.notif_near_miss': "Presque-accident signalé",
    'set.notif_near_miss_desc': "Lorsqu'un presque-accident est soumis",
    'set.notif_qual_expiring': "Qualification expirant (30 j)",
    'set.notif_qual_expiring_desc': "Lorsqu'une qualification expire dans les 30 jours",
    'set.notif_qual_expired': "Qualification expirée",
    'set.notif_qual_expired_desc': "Lorsqu'une qualification a expiré",
    'set.notif_service_due': "Entretien à échéance",
    'set.notif_service_due_desc': "Lorsqu'une machine approche de son intervalle d'entretien",
    'set.notif_fuel_low': "Niveau de cuve bas",
    'set.notif_fuel_low_desc': "Lorsqu'une cuve de gazole passe sous le seuil",
    'set.notif_emergency': "Alerte d'urgence",
    'set.notif_emergency_desc': "Toujours activé — ne peut pas être désactivé",
    'set.notif_announcement': "Annonces",
    'set.notif_announcement_desc': "Lorsque la direction envoie une annonce",
    'set.no_sites_msg': "Ajoutez votre première exploitation ou votre premier site",
    'set.err_site_name': "Le nom du site est obligatoire",
    'set.site_added': "Site ajouté",
    'set.err_site_add': "Échec de l'ajout du site",
    'set.site_name': "Nom du site",
    'set.site_name_placeholder': "p. ex. Ferme principale",
    'set.address': "Adresse",
    'set.address_placeholder': "p. ex. Ferme principale, chemin des Champs, 75000",
    'set.roles_title': "Rôles et autorisations",
    'set.role_admin_full': "Accès complet à tous les sites, machines, personnel, paramètres et facturation. Peut envoyer des annonces et gérer toutes les données.",
    'set.role_manager_full': "Accès limité au site. Gère les machines et le personnel de son site. Pas d'accès à la facturation ni aux paramètres de l'organisation.",
    'set.role_operator_full': "Accès à l'application mobile uniquement. Réalise les contrôles quotidiens, enregistre les pleins et peut signaler défauts et presque-accidents.",
    'set.perm_all_machines': "Toutes les machines de tous les sites",
    'set.perm_all_staff': "Gestion de tout le personnel",
    'set.perm_all_settings': "Tous les paramètres",
    'set.perm_announcements': "Envoyer des annonces",
    'set.perm_emergencies': "Clôturer les urgences",
    'set.perm_site_machines': "Machines de leur site",
    'set.perm_site_staff': "Personnel de leur site",
    'set.perm_checks_defects': "Contrôles et défauts",
    'set.perm_shifts': "Gestion des postes",
    'set.perm_daily_checks_app': "Contrôles quotidiens (app)",
    'set.perm_fuel_fills_app': "Pleins de carburant (app)",
    'set.perm_defect_app': "Signalement de défauts (app)",
    'set.perm_near_miss_app': "Signalement de presque-accidents (app)",
    'set.perm_own_quals': "Consulter ses propres qualifications",
    'set.perm_sos': "SOS urgence",
    'set.org_settings': "Paramètres de l'organisation",
    'set.identity': "Identité",
    'set.org_name': "Nom de l'organisation",
    'set.trading_name': "Nom commercial",
    'set.if_different': "Si différent",
    'set.company_number': "Numéro de société",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "Numéro de TVA",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Secteur d'activité",
    'set.ind_farm': "Exploitation agricole",
    'set.ind_estate': "Domaine",
    'set.ind_contractor': "Entrepreneur de travaux agricoles",
    'set.ind_dealership': "Concession",
    'set.ind_other': "Autre",
    'set.primary_email': "E-mail principal",
    'set.phone_number': "Numéro de téléphone",
    'set.website': "Site web",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Adresse ligne 1",
    'set.address2': "Adresse ligne 2",
    'set.town': "Ville",
    'set.county': "Département",
    'set.postcode': "Code postal",
    'set.branding': "Image de marque",
    'set.brand_colour': "Couleur de marque",
    'set.compliance': "Conformité",
    'set.hse_number': "Numéro d'enregistrement HSE",
    'set.insurance_provider': "Assureur",
    'set.policy_number': "Numéro de police",
    'set.insurance_expiry': "Échéance de l'assurance",
    'set.sharing_transfers': "Partage et transferts",
    'set.org_code_desc': "Votre code d'organisation permet de recevoir des machines partagées et des transferts d'autres clients Agriware. Communiquez-le à toute personne avec qui vous partagez du matériel ou qui vous vend une machine.",
    'set.emails': "E-mails",
    'set.hold_the_yard': "E-mail hebdomadaire Hold the Yard",
    'set.hold_the_yard_desc': "Un récapitulatif, chaque lundi, des contrôles avant utilisation de la semaine précédente, envoyé aux administrateurs et aux responsables de l'organisation.",
    'set.org_code': "Code d'organisation",
    'set.generating': "Génération…",
    'set.copied': "Copié !",
    'set.copy': "Copier",
    'set.org_saved': "Paramètres de l'organisation enregistrés",
    'set.err_save': "Échec de l'enregistrement des paramètres",
    'set.save_changes': "Enregistrer les modifications",
    'set.status_trialing': "Période d'essai",
    'set.status_past_due': "En retard de paiement",
    'set.status_cancelled': "Résilié",
    'set.status_unpaid': "Impayé",
    'set.status_incomplete': "Incomplet",
    'set.billing_title': "Facturation et abonnement",
    'set.billing_subtitle': "Gérez votre abonnement Agriware Operations.",
    'set.plan_standard': "Standard",
    'set.per_month': "/mois · résiliable à tout moment",
    'set.grandfathered': "Cette organisation bénéficie d'un accès historique. Les informations de facturation ne sont pas disponibles car ce compte est antérieur à l'intégration Stripe.",
    'set.next_billing': "Prochaine date de facturation :",
    'set.feat_registry': "Registre des machines et historique d'entretien",
    'set.feat_checks': "Contrôles quotidiens et inspections",
    'set.feat_defects': "Suivi des pannes et des défauts",
    'set.feat_staff': "Qualifications et postes du personnel",
    'set.feat_reporting': "Suite de rapports",
    'set.feat_unlimited': "Sites et opérateurs illimités",
    'set.err_no_portal': "Aucune URL de portail renvoyée.",
    'set.err_portal': "Impossible d'ouvrir le portail de facturation. Réessayez ou contactez l'assistance.",
    'set.opening_portal': "Ouverture du portail de facturation…",
    'set.manage_billing': "Gérer la facturation",
    'set.admin_only_billing': "Seuls les administrateurs de l'organisation peuvent gérer la facturation.",
    'set.stripe_note': "La facturation est traitée en toute sécurité par Stripe. Nous ne voyons jamais vos données de carte.",
    'int.abax_desc': "Récupérez heures moteur, position et utilisation directement depuis les traceurs ABAX : les heures arrivent seules au lieu d'être saisies.",
    'int.abax_detail': "Des heures automatiques garderaient intervalles d'entretien, estimations carbone et conformité des contrôles exacts sans aucune saisie.",
    'int.dms_desc': "Reliez-vous au DMS de votre concessionnaire pour créer des demandes d'intervention, approuver les devis et recevoir des ordres de travail scellés sur la bonne machine.",
    'int.dms_detail': "Les travaux réalisés par votre concessionnaire s'ajoutent automatiquement au dossier machine et figurent sur son passeport.",
    'int.almanac_desc': "Comparez vos machines aux mêmes modèles de tous les parcs Agriware : points de défaillance typiques, intervalles d'entretien et fiabilité par modèle.",
    'int.almanac_detail': "Almanac regroupe des données anonymisées de défauts et d'entretien issues de plusieurs organisations. Vos données contribuent ; en retour, vous voyez l'agrégat.",
    'int.consent_shared': "Partagé : marque et modèle, types de défauts, heures à la panne, intervalles d'entretien",
    'int.consent_never': "Jamais partagé : nom de votre organisation, sites, personnel, opérateurs, coûts ou documents",
    'int.consent_threshold': "Les chiffres ne sont affichés que lorsqu'il y a assez de machines pour que les parcs individuels restent non identifiables",
    'int.consent_withdraw': "Vous pouvez vous retirer à tout moment : les données transmises sont retirées des agrégats futurs",
    'int.err_update': "Impossible de mettre à jour cette intégration",
    'int.interest_noted': "Noté — nous vous contacterons dès que ce sera prêt",
    'int.almanac_enabled': "Almanac activé",
    'int.almanac_disabled': "Almanac désactivé",
    'int.subtitle': "Connectez Agriware Operations aux systèmes que vous utilisez déjà",
    'int.admin_only': "Seul un administrateur de l'organisation peut modifier les intégrations.",
    'int.enabled': "Activé",
    'int.in_development': "En développement",
    'int.withdraw': "Se retirer",
    'int.enable_almanac': "Activer Almanac",
    'int.interest_registered': "Intérêt enregistré",
    'int.register_interest': "Manifester son intérêt",
    'int.less': "Moins",
    'int.what_this_does': "Ce que cela fait",
    'int.footer': "Vous utilisez un outil absent de cette liste ? Dites-nous ce que vous aimeriez connecter : les demandes décident de ce qui sera développé ensuite.",
    'tmpl.scope_all_desc': "S'applique à toutes les machines de l'organisation",
    'tmpl.scope_category': "Par catégorie",
    'tmpl.scope_category_desc': "S'applique aux catégories sélectionnées",
    'tmpl.scope_specific_desc': "S'applique à une seule machine",
    'tmpl.freq_daily': "Quotidien",
    'tmpl.freq_daily_helper': "Doit être réalisé chaque jour avant l'heure limite",
    'tmpl.freq_weekly': "Hebdomadaire",
    'tmpl.freq_weekly_helper': "Doit être réalisé une fois par semaine",
    'tmpl.freq_hourly': "Selon les heures",
    'tmpl.freq_hourly_helper': "Déclenché toutes les X heures moteur",
    'tmpl.freq_monthly': "Mensuel",
    'tmpl.freq_monthly_helper': "Doit être réalisé une fois par mois",
    'tmpl.item_passfail': "Conforme / Non conforme",
    'tmpl.item_numeric': "Numérique",
    'tmpl.item_text': "Texte",
    'tmpl.item_photo': "Photo",
    'tmpl.item_signature': "Signature",
    'tmpl.fail_none': "Consigner uniquement",
    'tmpl.fail_flag': "Consigner et notifier",
    'tmpl.fail_block': "Consigner, notifier et bloquer",
    'tmpl.section_default': "Section",
    'tmpl.err_name': "Le nom du modèle est obligatoire",
    'tmpl.err_category': "Sélectionnez au moins une catégorie",
    'tmpl.err_machine': "Sélectionnez une machine",
    'tmpl.err_items': "Ajoutez au moins un point de contrôle",
    'tmpl.updated': "Modèle mis à jour",
    'tmpl.created': "Modèle créé",
    'tmpl.err_save': "Échec de l'enregistrement du modèle",
    'tmpl.name_placeholder': "Nom du modèle",
    'tmpl.save': "Enregistrer le modèle",
    'tmpl.settings': "Paramètres du modèle",
    'tmpl.description_placeholder': "Brève description des cas d'utilisation de ce modèle",
    'tmpl.applies_to': "S'applique à",
    'tmpl.select_categories_caps': "SÉLECTIONNER LES CATÉGORIES",
    'tmpl.select_machine_caps': "SÉLECTIONNER LA MACHINE",
    'tmpl.choose_machine': "Choisir une machine…",
    'tmpl.frequency': "Fréquence des contrôles",
    'tmpl.estimated_time': "Durée estimée (minutes)",
    'tmpl.every_x_hours': "Toutes les X heures moteur",
    'tmpl.due_by_time': "Heure limite",
    'tmpl.due_by_hint': "— le rappel de retard est envoyé à cette heure",
    'tmpl.due_by_note': "Notification push envoyée à l'opérateur et au responsable de site si non réalisé à cette heure",
    'tmpl.item_one': "élément",
    'tmpl.item_many': "éléments",
    'tmpl.new_item': "Nouveau point de contrôle",
    'tmpl.add_item': "Ajouter un point de contrôle",
    'tmpl.add_section': "Ajouter une section",
    'tmpl.item_panel_title': "Point de contrôle",
    'tmpl.select_item_hint': "Sélectionnez un point de contrôle à gauche pour en modifier les paramètres ici.",
    'tmpl.label': "Libellé",
    'tmpl.label_placeholder': "p. ex. niveau d'huile moteur",
    'tmpl.if_fails': "En cas de non-conformité",
    'tmpl.required': "Obligatoire",
    'tmpl.required_hint': "L'opérateur doit renseigner ce point",
    'status.active': "Actif",
    'status.shared': "Partagée",
    'status.transferred': "Transférée",
    'status.archived': "Archivée",
    'status.issues': "Anomalies",
    'status.emergency': "Urgence",
    'status.closed': "Clôturé",
    'status.due': "À échéance",
    'status.draft': "Brouillon",
    'status.approved': "Approuvé",
    'status.declined': "Refusé",
    'status.scheduled': "Planifié",
    'photo.title': "Photo de profil",
    'photo.upload_title': "Téléverser une photo",
    'photo.upload_note': "JPG, PNG ou WebP · 5 Mo max · sera recadrée en cercle",
    'photo.choose': "Choisir une photo",
    'photo.drag_hint': "Faites glisser pour repositionner · molette ou curseur pour zoomer",
    'photo.change': "Changer de photo",
    'photo.save': "Enregistrer la photo",
    'upsell.derv_title': "Gestion du carburant",
    'upsell.derv_desc': "Suivez les niveaux de cuve, enregistrez les pleins, gérez les fournisseurs et surveillez la consommation par machine sur tous les sites.",
    'upsell.coshh_title': "Registre des produits dangereux",
    'upsell.coshh_desc': "Tenez un registre numérique des substances dangereuses, des fiches de données de sécurité et des EPI requis pour vos équipes.",
    'upsell.risk_title': "Évaluations des risques",
    'upsell.risk_desc': "Créez, gérez et scellez des évaluations des risques par machine ou par tâche. Les opérateurs les valident avant de commencer.",
    'upsell.jobs_title': "Intégration DMS",
    'upsell.jobs_desc': "Demandez des interventions à votre concessionnaire, approuvez les devis et recevez des ordres de travail scellés directement sur les fiches machine.",
    'upsell.reporting_title': "Rapports et analyses",
    'upsell.reporting_desc': "Rapports sur l'état du parc, la conformité, les qualifications, la consommation, les émissions de CO₂ et le coût par machine.",
    'upsell.quals_title': "Suivi des qualifications",
    'upsell.quals_desc': "Enregistrez les certificats du personnel avec suivi des échéances, notifications push et blocage des machines selon les qualifications.",
    'upsell.sharing_title': "Partage de machines",
    'upsell.sharing_desc': "Partagez les dossiers machine avec d'autres organisations Agriware Ops — idéal pour les entrepreneurs et le matériel partagé.",
    'upsell.transfers_title': "Transferts de machines",
    'upsell.transfers_desc': "Transférez des machines entre utilisateurs Ops ou comptes DMS avec l'historique complet de propriété et un carnet numérique.",
    'upsell.carbon_title': "Reporting carbone",
    'upsell.carbon_desc': "Calcul automatique des émissions de CO₂ selon la consommation de carburant. Reporting au standard DEFRA pour votre parc.",
    'upsell.not_included': "Cette fonctionnalité n'est pas incluse dans votre formule actuelle.",
    'upsell.upgrade': "Passer à une formule supérieure",
    'service.record_not_found': "Fiche introuvable",
    'service.record_title_service': "Fiche d'entretien",
    'service.record_title_repair': "Fiche de réparation",
    'service.record_title_inspection': "Fiche d'inspection",
    'service.record_suffix': "fiche",
    'service.email_btn': "E-mail",
    'service.email_coming_soon': "Export par e-mail bientôt disponible",
    'service.sealed_by_workshop': "Scellée par {name} et non modifiable",
    'service.the_workshop': "l'atelier",
    'service.sealed_permanent': "Cette fiche est scellée de façon permanente et ne peut pas être modifiée",
    'service.sealed_by': "Scellée par",
    'service.at_suffix': "chez {name}",
    'service.job_ref': "ordre {ref}",
    'service.photos_video': "Photos et vidéo",
    'service.job_photo': "Photo de l'intervention",
    'service.files_copying': "Certains fichiers sont encore en cours de copie.",
    'service.date_of_service': "Date d'entretien",
    'service.hours_at_service': "Heures à l'entretien",
    'service.total_cost': "Coût total",
    'service.record_details': "Détails de la fiche",
    'service.type': "Type",
    'service.performed_by': "Réalisé par",
    'service.performed_by_type': "Type de prestataire",
    'service.next_service_hours': "Heures avant prochain entretien",
    'service.next_service_date': "Date du prochain entretien",
    'service.notes': "Remarques",
    'service.parts_used': "Pièces utilisées",
    'service.col_part': "Pièce",
    'service.col_qty': "Qté",
    'service.col_cost': "Coût",
    'service.parts_total': "Total pièces",
    'service.cost_breakdown': "Détail des coûts",
    'service.labour_cost': "Coût de main-d'œuvre",
    'service.parts_cost': "Coût des pièces",
    'service.total': "Total",
    'service.audit_trail': "Piste d’audit",
    'service.record_created_by': "Fiche créée par",
    'service.record_sealed_by': "Fiche scellée par",
    'service.type_service': "Entretien",
    'service.type_service_desc': "Entretien périodique planifié",
    'service.type_repair': "Réparation",
    'service.type_repair_desc': "Travaux de réparation non planifiés",
    'service.type_inspection': "Inspection",
    'service.type_inspection_desc': "Contrôle de sécurité ou de conformité",
    'service.by_internal': "En interne",
    'service.by_dealer': "Concessionnaire",
    'service.by_external': "Prestataire externe",
    'service.err_description': "Veuillez saisir une description",
    'service.err_date': "Veuillez saisir la date d'entretien",
    'service.added_toast': "Fiche d'entretien ajoutée et scellée",
    'service.err_save': "Échec de l'enregistrement de la fiche — veuillez réessayer",
    'service.seal_note': "Cette fiche sera scellée de façon permanente une fois enregistrée",
    'service.record_type': "Type de fiche",
    'service.description_placeholder': "Décrivez les travaux réalisés…",
    'service.performed_by_placeholder': "Nom ou société",
    'service.additional_notes': "Remarques complémentaires",
    'service.notes_placeholder': "Remarques éventuelles…",
    'service.add_part': "Ajouter une pièce",
    'service.part_name': "Nom de la pièce",
    'service.cost_placeholder': "Coût £",
    'service.cost_next_service': "Coût et prochain entretien",
    'service.labour_cost_field': "Coût de main-d'œuvre (£)",
    'service.next_hours_placeholder': "p. ex. 1750",
    'service.seal_warning': "Une fois enregistrée, cette fiche est scellée de façon permanente et ne peut plus être modifiée. Vérifiez tous les détails avant d'enregistrer.",
    'service.save_seal': "Enregistrer et sceller la fiche",
    'dashboard.there': "à vous",
    'dashboard.total_machines': "Total des machines",
    'dashboard.blocked_machines': "Machines bloquées",
    'dashboard.open_incidents': "Incidents ouverts",
    'dashboard.open_defects': "Défauts ouverts",
    'dashboard.fuel_tanks': "Cuves à carburant",
    'common.of': "sur",
    'dashboard.fleet': "Parc matériel",
    'common.view_all': "Tout voir",
    'dashboard.no_machines': "Aucune machine",
    'dashboard.no_machines_msg': "Ajoutez votre première machine pour commencer",
    'dashboard.recent_incidents': "Incidents récents",
    'dashboard.no_incidents_msg': "Aucun incident enregistré",
    'dashboard.recent_defects': "Défauts récents",
    'dashboard.no_defects': "Aucun défaut",
    'dashboard.no_defects_msg': "Aucun défaut signalé",
    'dashboard.defect_reported': "Défaut signalé",
    'dashboard.group_overview': "Vue du groupe",
    'dashboard.send_announcement': "Envoyer une annonce",
    'dashboard.sites': "Sites",
    'dashboard.no_sites': "Aucun site",
    'dashboard.no_sites_msg': "Ajoutez votre premier site dans les Paramètres pour commencer",
    'dashboard.add_site': "Ajouter un site",
    'dashboard.status_monitor': "À surveiller",
    'dashboard.status_all_good': "Tout va bien",
    'dashboard.derv': "Gazole",
    'dashboard.derv_level': "Niveau de gazole",
    'qual.short_forklift': "Chariot élévateur",
    'qual.short_sprayer': "Pulvérisateur",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Conduite",
    'qual.short_firstaid': "Premiers secours",
    'qual.short_chainsaw': "Tronçonneuse",
    'qual.short_pesticide': "Produits phytosanitaires",
    'qual.short_telehandler': "Télescopique",
    'qual.short_atv': "Quad",
    'qual.short_other': "Autre",
    'qual.forklift': "CACES chariot élévateur",
    'qual.sprayer': "Certificat pulvérisateur PA1/PA6",
    'qual.cscs': "Carte CSCS",
    'qual.driving': "Permis de conduire",
    'qual.firstaid': "Certificat de premiers secours",
    'qual.chainsaw': "Certificat tronçonneuse",
    'qual.pesticide': "Certiphyto (application)",
    'qual.telehandler': "CACES télescopique",
    'qual.atv': "Certificat quad/ATV",
    'qual.other': "Autre qualification",
    'staff.n_expired': "expirées",
    'staff.n_expiring': "bientôt expirées",
    'staff.n_valid': "valides",
    'common.none': "Aucune",
    'staff.tab_members': "Membres",
    'staff.tab_qualifications': "Qualifications",
    'staff.tab_shifts': "Postes",
    'staff.member_one': "membre",
    'staff.member_many': "membres",
    'staff.alert_one': "alerte de qualification",
    'staff.alert_many': "alertes de qualification",
    'staff.invite': "Inviter du personnel",
    'staff.create_shift': "Créer un poste",
    'staff.search': "Rechercher par nom ou e-mail…",
    'staff.none_found': "Aucun membre du personnel trouvé",
    'staff.adjust_search': "Essayez de modifier votre recherche",
    'staff.invite_first': "Invitez votre premier collaborateur",
    'staff.stat_total_quals': "Total des qualifications",
    'staff.stat_valid': "Valides",
    'staff.stat_expiring_30d': "Expirent (30 j)",
    'staff.stat_expiring': "Expirent",
    'staff.stat_expired': "Expirées",
    'staff.qual_one': "qualification",
    'staff.qual_many': "qualifications",
    'staff.expires': "Expire le",
    'staff.no_quals': "Aucune qualification enregistrée",
    'staff.no_quals_msg': "Ajoutez les qualifications depuis la fiche de chaque collaborateur",
    'staff.no_shifts': "Aucun poste",
    'staff.no_shifts_msg': "Créez votre premier poste pour suivre qui travaille",
    'staff.shift': "Poste",
    'staff.checked_in': "pointés",
    'staff.not_found': "Membre du personnel introuvable",
    'staff.add_qualification': "Ajouter une qualification",
    'staff.expired_alert_one': "qualification a expiré — cet opérateur n'est peut-être pas autorisé à utiliser certaines machines",
    'staff.expired_alert_many': "qualifications ont expiré — cet opérateur n'est peut-être pas autorisé à utiliser certaines machines",
    'staff.expiring_alert_one': "qualification expire sous 30 jours",
    'staff.expiring_alert_many': "qualifications expirent sous 30 jours",
    'staff.tab_details': "Détails",
    'staff.contact': "Contact",
    'staff.account': "Compte",
    'staff.onboarding': "Intégration",
    'staff.complete': "Terminée",
    'staff.job_title': "Fonction",
    'staff.joined': "Arrivé le",
    'staff.invited_by': "Invité par",
    'staff.quals_tickets': "Qualifications et certificats",
    'staff.no_quals_profile_msg': "Ajoutez les certificats et attestations de cet opérateur",
    'staff.issued': "Délivré le",
    'staff.no_expiry': "Pas d'expiration",
    'staff.expires_today': "Expire aujourd'hui",
    'staff.days_remaining_one': "jour restant",
    'staff.days_remaining_many': "jours restants",
    'staff.expired_days_ago_one': "Expiré il y a {n} jour",
    'staff.expired_days_ago_many': "Expiré il y a {n} jours",
    'staff.view_certificate': "Voir le certificat",
    'staff.assigned_machines': "Machines affectées",
    'staff.no_machines': "Aucune machine affectée",
    'staff.no_machines_msg': "Aucune machine n'est affectée à cet opérateur",
    'staff.err_first_name': "Le prénom est obligatoire",
    'staff.err_last_name': "Le nom est obligatoire",
    'staff.err_email': "Veuillez saisir une adresse e-mail valide",
    'staff.err_site': "Veuillez sélectionner un site",
    'staff.err_create_prefix': "Échec de la création du compte :",
    'staff.err_timeout': "Délai dépassé lors de la création du compte. Veuillez actualiser et réessayer.",
    'staff.err_create': "Échec de la création du compte — veuillez réessayer",
    'staff.copy_greeting': "Bonjour {name},",
    'staff.copy_body': "Votre compte Agriware Operations a été créé.",
    'staff.copy_email': "E-mail :",
    'staff.copy_temp_password': "Mot de passe temporaire :",
    'staff.copy_footer': "Vous serez invité à modifier votre mot de passe lors de la première connexion.",
    'staff.copied_toast': "Identifiants copiés dans le presse-papiers",
    'staff.role_admin_desc': "Accès complet à tous les sites et paramètres",
    'staff.role_manager_desc': "Gère un site, le personnel et les machines",
    'staff.role_operator_desc': "Réalise les contrôles quotidiens via l'application mobile",
    'staff.add_member': "Ajouter un membre du personnel",
    'staff.add_member_sub': "Le compte sera créé immédiatement. Vous verrez les identifiants à leur transmettre.",
    'staff.account_created': "Compte créé",
    'staff.share_details_pre': "Communiquez ces identifiants à",
    'staff.share_details_post': "Un changement de mot de passe sera demandé à la première connexion.",
    'staff.label_email_caps': "E-MAIL",
    'staff.label_temp_password_caps': "MOT DE PASSE TEMPORAIRE",
    'staff.copy_login_details': "Copier les identifiants",
    'staff.add_another': "En ajouter un autre",
    'staff.back_to_staff': "Retour au personnel",
    'staff.personal_details': "Informations personnelles",
    'staff.first_name': "Prénom",
    'staff.last_name': "Nom",
    'staff.work_email': "E-mail professionnel",
    'staff.site_assignment': "Affectation au site",
    'staff.no_sites': "Aucun site configuré — ajoutez d'abord un site dans les Paramètres",
    'staff.creating_account': "Création du compte…",
    'staff.create_account': "Créer le compte",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Veuillez sélectionner un type de qualification",
    'qual.err_name': "Veuillez saisir le nom de la qualification",
    'qual.err_issue_date': "Veuillez saisir la date de délivrance",
    'qual.err_expiry': "Veuillez saisir la date d'expiration ou cocher « sans expiration »",
    'qual.added_toast': "Qualification ajoutée",
    'qual.err_save': "Échec de l’enregistrement de la qualification — veuillez réessayer",
    'qual.back_staff_profile': "Fiche du personnel",
    'qual.subtitle': "Enregistrez un certificat, une attestation ou un permis pour cet opérateur",
    'qual.type_title': "Type de qualification",
    'qual.name_label': "Nom de la qualification",
    'qual.name_placeholder': "p. ex. certificat débroussailleuse NPTC",
    'qual.cert_details': "Détails du certificat",
    'qual.cert_number': "Numéro de certificat",
    'common.optional_suffix': "— facultatif",
    'qual.cert_number_placeholder': "p. ex. NPORS-123456",
    'qual.issuing_body': "Organisme émetteur",
    'qual.issuing_body_placeholder': "p. ex. NPORS, LANTRA, CITB",
    'qual.issue_date': "Date de délivrance",
    'qual.expiry_date': "Date d'expiration",
    'qual.no_expiry_label': "Cette qualification n'a pas de date d'expiration",
    'qual.cert_document': "Document du certificat",
    'qual.upload_note': "Téléversez une photo ou un scan du certificat. Il est stocké de façon privée et jamais partagé.",
    'common.remove': "Retirer",
    'qual.click_upload': "Cliquez pour téléverser le certificat",
    'qual.file_types': "JPG, PNG ou PDF",
    'common.saving': "Enregistrement…",
    'qual.save': "Enregistrer la qualification",
    'defects.title': "Défauts",
    'defects.n_open': "ouverts",
    'defects.n_critical': "critiques",
    'defects.stat_total': "Total des défauts",
    'defects.status_open': "Ouvert",
    'defects.status_in_progress': "En cours",
    'defects.status_resolved': "Résolu",
    'defects.all_severities': "Toutes les gravités",
    'defects.sev_minor': "Mineur",
    'defects.sev_moderate': "Modéré",
    'defects.sev_major': "Majeur",
    'defects.sev_critical': "Critique",
    'defects.search': "Rechercher des défauts…",
    'common.clear': "Effacer",
    'defects.col_description': "Description",
    'defects.reported_by': "Signalé par",
    'defects.col_severity': "Gravité",
    'defects.no_description': "Aucune description",
    'defects.none_found': "Aucun défaut trouvé",
    'defects.none_reported': "Aucun défaut n'a été signalé",
    'defects.acknowledged_toast': "Défaut pris en compte",
    'defects.acknowledge_failed': "Échec de la prise en compte du défaut",
    'defects.resolved_released': "Défaut résolu — machine remise en service",
    'defects.resolved_toast': "Défaut résolu",
    'defects.resolve_failed': "Échec de la résolution du défaut",
    'defects.not_found': "Défaut introuvable",
    'defects.report_title': "Rapport de défaut",
    'defects.acknowledge': "Prendre en compte",
    'defects.raise_job': "Créer un ordre de travail",
    'defects.resolve': "Résoudre",
    'defects.blocking_banner': "Machine bloquée — un responsable doit enregistrer une remise en service écrite avant sa réutilisation",
    'defects.details_title': "Détails du défaut",
    'defects.no_description_provided': "Aucune description fournie",
    'defects.reported_at': "Signalé le",
    'defects.location': "Emplacement",
    'defects.photos': "Photos",
    'defects.acknowledgement': "Prise en compte",
    'defects.acknowledged_by': "Pris en compte par",
    'defects.resolved_by': "Résolu par",
    'defects.return_to_service': "Remise en service",
    'defects.revised': "Révisée",
    'defects.revised_by_suffix': "par {name}",
    'defects.view_machine_profile': "Voir la fiche machine",
    'defects.resolve_and_release': "Résoudre et remettre en service",
    'defects.resolve_defect': "Résoudre le défaut",
    'defects.release_machine': "Remettre la machine en service",
    'defects.mark_resolved': "Marquer comme résolu",
    'defects.release_warning': "Cette machine est bloquée. Votre remise en service écrite sera enregistrée avec votre nom et votre fonction et figurera sur le passeport de la machine.",
    'defects.resolution_details': "Détails de la résolution",
    'defects.resolution_placeholder': "Décrivez comment le défaut a été résolu…",
    'defects.narrative_placeholder': "Ce qui a été constaté, ce qui a été fait et comment la machine a été contrôlée avant sa remise en service. Indiquez les numéros d'ordre de travail et les détails d'essai le cas échéant.",
    'defects.chars_needed_one': "caractère supplémentaire requis",
    'defects.chars_needed_many': "caractères supplémentaires requis",
    'defects.characters': "caractères",
    'defects.permanent_note': "Cette information sera enregistrée de façon permanente dans le rapport de défaut.",
    'machines.tab_overview': "Aperçu",
    'machines.tab_history': "Historique",
    'machines.tab_documents': "Documents",
    'machines.tab_operators': "Opérateurs",
    'machines.tab_sharing': "Partage",
    'machines.tab_incidents': "Incidents",
    'machines.pdf_only': "Seuls les fichiers PDF sont acceptés.",
    'machines.replace_confirm': "Remplacer le document existant ({name}) ? L’ancien fichier sera supprimé.",
    'machines.delete_doc_confirm': "Supprimer ce document ? Cette action est irréversible.",
    'machines.uploaded': "Téléversé",
    'machines.no_file_yet': "Aucun fichier",
    'machines.uploading': "Téléversement…",
    'machines.view_document': "Voir le document",
    'common.replace': "Remplacer",
    'common.delete': "Supprimer",
    'common.upload': "Téléverser",
    'machines.doc_type_manual': "Manuel",
    'machines.doc_type_private': "Privé",
    'machines.doc_operators_manual': "Manuel d'utilisation",
    'machines.doc_workshop_manual': "Manuel d'atelier",
    'machines.untitled_document': "Document sans titre",
    'machines.add_document': "Ajouter un document",
    'machines.documents_intro': "Le manuel d'utilisation et le manuel d'atelier occupent des emplacements dédiés — cela nous aide à identifier le bon document lors du partage avec la bibliothèque Agriware. Les autres documents privés ne sont visibles que par votre organisation.",
    'machines.returned_to_service': "Machine remise en service",
    'machines.not_blocked': "Cette machine n'est pas bloquée",
    'machines.resolve_defect_first': "Résolvez le défaut ouvert pour remettre cette machine en service",
    'machines.return_failed': "Échec de la remise en service de la machine",
    'machines.machine_not_found': "Machine introuvable",
    'common.unknown': "Inconnu",
    'machines.unblock': "Débloquer",
    'service.add_record': "Ajouter une fiche d'entretien",
    'machines.serial_number': "Numéro de série",
    'machines.year': "Année",
    'machines.blocked_banner': "Machine bloquée — ne pas utiliser",
    'machines.current_hours': "Heures actuelles",
    'machines.next_service': "Prochain entretien",
    'machines.service_records': "Fiches d'entretien",
    'machines.service_progress': "Progression vers l'entretien",
    'machines.cost_over_time': "Évolution des coûts",
    'machines.cost_over_time_sub': "Entretien, réparation et coût de possession cumulé",
    'machines.cost_empty': "Les données de coût apparaîtront à mesure que des fiches d'entretien sont ajoutées.",
    'machines.series_service': "Entretien",
    'machines.series_repair': "Réparation",
    'machines.series_cumulative': "Cumulé",
    'machines.details_title': "Détails de la machine",
    'machines.make': "Marque",
    'machines.model': "Modèle",
    'machines.category': "Catégorie",
    'machines.assigned_to': "Affectée à",
    'machines.pool_machine': "Machine en pool",
    'machines.unassigned': "Non affectée",
    'machines.purchase_value': "Achat et valeur",
    'machines.purchase_date': "Date d'achat",
    'machines.purchase_price': "Prix d'achat",
    'machines.depreciation_rate': "Taux d'amortissement",
    'machines.per_year': "par an",
    'machines.estimated_life': "Durée de vie estimée",
    'common.unit_years': "ans",
    'machines.cost_tracking': "Suivi des coûts",
    'machines.total_service_cost': "Coût total d'entretien",
    'machines.total_repair_cost': "Coût total de réparation",
    'machines.total_fuel_cost': "Coût total de carburant",
    'machines.total_cost_ownership': "Coût total de possession",
    'machines.service_history': "Historique d'entretien et de réparation",
    'service.add_record_short': "Ajouter une fiche",
    'service.none_yet': "Aucune fiche d'entretien",
    'service.none_yet_msg': "Ajoutez votre première fiche d'entretien ou de réparation",
    'service.sealed': "Scellée",
    'service.workshop': "Atelier",
    'common.photo_one': "photo",
    'common.photo_many': "photos",
    'machines.assigned_operators': "Opérateurs affectés",
    'machines.no_operator': "Aucun opérateur affecté",
    'machines.no_operator_msg': "Aucun opérateur n'est affecté à cette machine",
    'machines.pool_machine_msg': "Cette machine est en pool — disponible pour tous les opérateurs",
    'machines.ownership_sharing': "Propriété et partage",
    'machines.share_machine': "Partager la machine",
    'machines.current_owner': "Propriétaire actuel",
    'machines.your_organisation': "Votre organisation",
    'machines.shared_with': "Partagée avec",
    'machines.not_shared': "Partagée avec aucune autre organisation",
    'machines.incident_history': "Historique des incidents",
    'incidents.none': "Aucun incident",
    'incidents.none_msg': "Aucun incident enregistré pour cette machine",
    'incidents.impact_detected': "Choc détecté",
    'incidents.manual_sos': "SOS manuel",
    'incidents.man_down': "Alerte homme à terre",
    'machines.unblock_title': "Remettre la machine en service",
    'machines.confirm_unblock': "Confirmer le déblocage",
    'machines.unblock_warning': "Votre déclaration écrite est enregistrée avec le contrôle qui a arrêté cette machine et figure sur son passeport. Si la machine est bloquée par un défaut ouvert, résolvez plutôt le défaut.",
    'machines.blocked_reason': "Motif du blocage",
    'machines.unblock_statement': "Déclaration de remise en service",
    'machines.unblock_placeholder': "Ce qui a été constaté, ce qui a été fait et comment la machine a été contrôlée avant sa remise en service.",
    'checks.history_title': "Historique des contrôles",
    'checks.stat_total': "Total des contrôles",
    'checks.stat_passed': "Conformes",
    'checks.stat_failed': "Non conformes",
    'checks.n_passed': "conformes",
    'checks.n_failed': "non conformes",
    'common.clear_filters': "Effacer les filtres",
    'checks.not_found': "Contrôle introuvable",
    'common.export_pdf': "Exporter en PDF",
    'common.pdf_coming_soon': "Export PDF bientôt disponible",
    'checks.item_failed_one': "élément non conforme",
    'checks.item_failed_many': "éléments non conformes",
    'checks.auto_blocked': "La machine a été bloquée automatiquement à la soumission",
    'checks.sealed_record': "Enregistrement scellé",
    'checks.submitted_by': "Soumis par",
    'checks.submitted_at': "Soumis le",
    'checks.hours_at_check': "Heures au contrôle",
    'checks.stat_total_items': "Total éléments",
    'checks.stat_mileage': "Kilométrage",
    'checks.details_title': "Détails du contrôle",
    'checks.failed_items': "Éléments non conformes",
    'checks.no_items_recorded': "Aucun élément de contrôle enregistré",
    'checks.alt_defect_photo': "Photo du défaut",
    'checks.alt_check_photo': "Photo du contrôle",
    'common.unit_hrs': "h",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Modèles",
    'checks.tab_history': "Historique",
    'checks.create_template': "Créer un modèle",
    'checks.scope_specific': "Machine spécifique",
    'checks.scope_all': "Toutes les machines",
    'checks.categories': "catégories",
    'checks.items': "éléments",
    'checks.title': "Contrôles",
    'checks.template_one': "modèle",
    'checks.template_many': "modèles",
    'checks.record_one': "enregistrement",
    'checks.record_many': "enregistrements",
    'checks.no_templates': "Aucun modèle de contrôle",
    'checks.no_templates_msg': "Créez des modèles pour définir ce que les opérateurs doivent contrôler avant utilisation",
    'checks.search': "Rechercher par machine ou opérateur…",
    'checks.all_results': "Tous les résultats",
    'checks.pass': "Conforme",
    'checks.fail': "Non conforme",
    'checks.none_found': "Aucun contrôle trouvé",
    'checks.adjust_filters': "Essayez de modifier vos filtres",
    'checks.none_submitted': "Aucun contrôle n’a encore été soumis",
    'checks.col_operator': "Opérateur",
    'checks.col_datetime': "Date et heure",
    'checks.col_result': "Résultat",
    'machines.add': "Ajouter une machine",
    'machines.col_machine': "Machine",
    'machines.col_serial': "N° série / Immat.",
    'machines.col_site': "Site",
    'machines.col_hours': "Heures",
    'machines.col_status': "Statut",
    'machines.title': "Machines",
    'machines.count_one': "machine",
    'machines.count_many': "machines",
    'machines.blocked': "bloquée(s)",
    'machines.search': "Rechercher par marque, modèle, n° de série ou immat.…",
    'machines.all_sites': "Tous les sites",
    'machines.all_statuses': "Tous les statuts",
    'machines.available': "Disponible",
    'machines.blocked_one': "Bloquée",
    'machines.none_found': "Aucune machine trouvée",
    'machines.view': "Voir",
    'cat.all': "Toutes catégories",
    'cat.agricultural': "Agricole",
    'cat.groundcare': "Entretien des espaces verts",
    'cat.plant': "Engins",
    'cat.vehicle': "Véhicule",
    'cat.atv': "Quad",
    'nav.dashboard': "Tableau de bord",
    'nav.staff': "Personnel",
    'nav.checks': "Contrôles",
    'nav.safety': "Sécurité",
    'nav.operations': "Opérations",
    'nav.settings': "Paramètres",
    'nav.billing': "Facturation",
    'nav.sign_out': "Se déconnecter",
    'role.admin': "Administrateur",
    'role.manager': "Responsable",
    'role.operator': "Opérateur",
    'app.name': 'AgriWare Opérations',
    'app.tagline': 'Gestion',
    'nav.home': 'Accueil',
    'nav.machines': 'Machines',
    'nav.profile': 'Profil',
    'common.back': 'Retour',
    'common.cancel': 'Annuler',
    'common.save': 'Enregistrer',
    'common.edit': 'Modifier',
    'common.done': 'Terminé',
    'common.yes': 'Oui',
    'common.no': 'Non',
    'common.ok': 'OK',
    'common.error': 'Erreur',
    'common.loading': 'Chargement...',
    'common.retry': 'Réessayer',
    'common.search': 'Rechercher',
    'common.submit': 'Soumettre',
    'common.confirm': 'Confirmer',
    'common.close': 'Fermer',
    'common.pass': 'Réussi',
    'common.fail': 'Échoué',
    'common.total': 'total',
    'common.today': "Aujourd'hui",
    'common.yesterday': 'Hier',
    'common.online_only': 'En ligne uniquement',
    'common.last_synced': 'Dernière sync',
    'common.back_to_app': "Retour à l'app",
    'common.gps_shared': 'GPS partagé',
    'common.yes_via_saas': 'Oui — via SaaS',
    'common.not_called': 'Non appelé',
    'login.sign_in': 'Se connecter',
    'login.email': 'Adresse e-mail',
    'login.password': 'Mot de passe',
    'login.forgot_password': 'Mot de passe oublié ?',
    'login.no_account': 'Pas de compte ?',
    'login.request_access': 'Demander un accès',
    'login.account_created_by_org': 'Votre compte a été créé par votre organisation.',
    'login.email_placeholder': 'vous@organisation.com',
    'login.password_placeholder': 'Entrez votre mot de passe',
    'login.error_empty': 'Veuillez entrer votre e-mail et votre mot de passe.',
    'login.error_invalid': 'E-mail ou mot de passe invalide. Veuillez réessayer.',
    'dashboard.greeting_morning': 'Bonjour,',
    'dashboard.greeting_afternoon': 'Bon après-midi,',
    'dashboard.greeting_evening': 'Bonsoir,',
    'dashboard.todays_tasks': "Tâches d'aujourd'hui",
    'dashboard.completed': 'Terminées',
    'dashboard.overdue': 'En retard',
    'dashboard.in_progress': 'En cours',
    'dashboard.upcoming': 'À venir',
    'dashboard.pending': 'En attente',
    'machines.search_placeholder': 'Rechercher des machines...',
    'machines.favourites': 'Favoris',
    'machines.all_machines': 'Toutes les machines',
    'machines.operational': 'Opérationnel',
    'machines.needs_attention': 'Attention requise',
    'machines.fault': 'Défaut',
    'machines.unsafe_to_operate': 'Dangereux à utiliser',
    'machines.registration': 'Immatriculation',
    'machines.assigned_operator': 'Opérateur assigné',
    'machines.engine_hours': 'Heures moteur',
    'machines.documents': 'Documents',
    'machines.log_fault': 'Signaler un défaut',
    'machines.operator_manual': "Manuel de l'opérateur",
    'machines.service_record': 'Carnet de service',
    'machines.insurance': "Certificat d'assurance",
    'machines.mot': 'Certificat de contrôle technique',
    'daily_check.title': 'Contrôle quotidien',
    'daily_check.start': 'Démarrer le contrôle',
    'daily_check.required': 'Contrôle requis',
    'daily_check.required_msg': 'Doit être effectué avant de faire fonctionner cette machine.',
    'daily_check.complete': 'Contrôle terminé',
    'daily_check.complete_msg': 'Complété par',
    'daily_check.submit': 'Soumettre le contrôle',
    'daily_check.items_remaining': 'éléments restants',
    'daily_check.reward_title': 'Merci !',
    'daily_check.reward_subtitle': 'Votre contrôle quotidien a été enregistré.\nDes contrôles honnêtes assurent la sécurité de tous.',
    'daily_check.back_to_machine': 'Retour à la machine',
    'daily_check.day_streak': 'Série de jours',
    'daily_check.completion_rate': 'Taux de complétion',
    'daily_check.cat_lights': 'Éclairage et visibilité',
    'daily_check.cat_fluids': 'Fluides',
    'daily_check.cat_tyres': 'Pneus et roues',
    'daily_check.cat_safety': 'Sécurité',
    'daily_check.cat_controls': 'Commandes',
    'daily_check.cat_body': 'Carrosserie et accessoires',
    'daily_check.lights_working': 'Tous les feux fonctionnent',
    'daily_check.mirrors': 'Rétroviseurs propres et réglés',
    'daily_check.windscreen': 'Pare-brise propre et intact',
    'daily_check.engine_oil': "Niveau d'huile moteur",
    'daily_check.coolant': 'Niveau de liquide de refroidissement',
    'daily_check.hydraulic': 'Niveau de fluide hydraulique',
    'daily_check.fuel': 'Niveau de carburant adéquat',
    'daily_check.tyre_pressure': 'Pression des pneus correcte',
    'daily_check.tyre_damage': 'Pas de dommages visibles aux pneus',
    'daily_check.wheel_nuts': 'Écrous de roue serrés',
    'daily_check.fire_extinguisher': 'Extincteur présent',
    'daily_check.first_aid': 'Trousse de premiers secours présente',
    'daily_check.rops': 'Structure ROPS intacte',
    'daily_check.seatbelt': 'Ceinture de sécurité fonctionnelle',
    'daily_check.brakes': 'Freins fonctionnels',
    'daily_check.steering': 'Direction réactive',
    'daily_check.horn': 'Avertisseur sonore fonctionnel',
    'daily_check.body_damage': 'Pas de dommages visibles à la carrosserie',
    'daily_check.attachments': 'Accessoires fixés',
    'daily_check.pto_guard': 'Protège-prise de force en place',
    'log_fault.title': 'Signaler un défaut',
    'log_fault.description': 'Description',
    'log_fault.description_placeholder': 'Décrivez le défaut...',
    'log_fault.photos': 'Photos',
    'log_fault.add_photo': 'Ajouter une photo',
    'log_fault.submit': 'Soumettre le rapport',
    'log_fault.success': 'Défaut signalé avec succès',
    'emergency.title': 'Urgence',
    'emergency.what_emergency': "Quelle est l'urgence ?",
    'emergency.select_type': "Sélectionnez le type d'urgence.\nLes contacts appropriés seront appelés immédiatement.",
    'emergency.vibrating': 'Vibration',
    'emergency.alarm': 'Alarme',
    'emergency.medical': 'Urgence médicale',
    'emergency.medical_sub': 'Blessure, maladie ou personne inconsciente sur le site',
    'emergency.calls_999': 'Appelle le 112 immédiatement',
    'emergency.electrical': 'Urgence électrique',
    'emergency.electrical_sub': "Choc électrique ou contact avec une ligne — restez dans la cabine",
    'emergency.calls_105': 'Appelle le 114 immédiatement',
    'emergency.no_signal': 'Numéros d\'urgence stockés sur l\'appareil — disponibles sans signal',
    'emergency.gps_auto': 'Position GPS partagée automatiquement',
    'emergency.999_called': '112 appelé',
    'emergency.105_called': '114 appelé',
    'emergency.services_contacted': 'Les services d\'urgence ont été contactés.\nVotre superviseur a également été notifié.',
    'emergency.power_contacted': 'La ligne d\'urgence électrique a été contactée.\nVotre superviseur a également été notifié.',
    'emergency.emergency_type': 'Type d\'urgence',
    'emergency.number_called': 'Numéro appelé',
    'emergency.location': 'Localisation',
    'emergency.admin_notified': 'Admin notifié',
    'emergency.stay_in_cab': 'Restez dans la cabine',
    'emergency.stay_in_cab_msg': 'Ne quittez pas le véhicule. Attendez que l\'autorité électrique confirme que la ligne est sécurisée. Gardez les fenêtres fermées.',
    'emergency.medical_type': 'Médical',
    'emergency.electrical_type': 'Électrique',
    'crash.are_you_okay': 'Êtes-vous en sécurité ?',
    'crash.impact_detected': 'Un possible impact a été détecté.\nVeuillez répondre ou des secours seront appelés.',
    'crash.im_okay': 'Je vais bien',
    'crash.dismiss_alert': 'Ignorer l\'alerte — aucune action',
    'crash.i_need_help': "J'ai besoin d'aide",
    'crash.notify_supervisor': 'Notifier le superviseur avec la position GPS',
    'crash.call_999': 'Appeler le 15',
    'crash.call_emergency': 'Appeler les secours immédiatement',
    'crash.glad_okay': 'Heureux que vous alliez bien',
    'crash.alert_dismissed': 'Alerte ignorée. Aucune notification envoyée.',
    'crash.help_on_way': 'Les secours arrivent',
    'crash.supervisor_notified': 'Votre superviseur a été notifié avec votre position GPS.',
    'crash.auto_dialled': '15 composé automatiquement',
    'crash.no_response': 'Aucune réponse. Secours appelés automatiquement. Message vocal diffusé.',
    'crash.broadcasting': 'Diffusion du message',
    'crash.repeating': 'Répétition toutes les 15 secondes',
    'crash.admin_notified': 'Admin notifié',
    'crash.emergency_services': 'Services d\'urgence',
    'profile.title': 'Profil',
    'profile.personal_info': 'Informations personnelles',
    'profile.full_name': 'Nom complet',
    'profile.email': 'E-mail',
    'profile.phone': 'Téléphone',
    'profile.role': 'Rôle',
    'profile.organisation': 'Organisation',
    'profile.emergency_contact': 'Contact d\'urgence',
    'profile.emergency_contact_note': 'Votre superviseur sera contacté en cas d\'urgence',
    'profile.contact_name': 'Nom du contact',
    'profile.contact_phone': 'Téléphone du contact',
    'profile.notifications': 'Notifications',
    'profile.task_reminders': 'Rappels de tâches',
    'profile.overdue_alerts': 'Alertes de retard',
    'profile.crash_detection': 'Détection de collision',
    'profile.account_security': 'Compte et sécurité',
    'profile.change_password': 'Changer le mot de passe',
    'profile.two_factor': 'Authentification à deux facteurs',
    'profile.login_activity': 'Activité de connexion',
    'profile.app_settings': "Paramètres de l'application",
    'profile.theme': 'Thème',
    'profile.language': 'Langue',
    'profile.sign_out': 'Se déconnecter',
    'profile.sign_out_confirm': 'Se déconnecter',
    'profile.sign_out_msg': 'Êtes-vous sûr de vouloir vous déconnecter ?',
    'profile.field_staff': 'Personnel de terrain',
    'theme.light': 'Clair',
    'theme.dark': 'Sombre',
    'theme.system': 'Système par défaut',
  },

  'de': {
    'verify.err_reference_required': "Eine Dokumentreferenz ist erforderlich.",
    'verify.err_rate_limited': "Zu viele Versuche. Bitte versuchen Sie es in Kürze erneut.",
    'verify.err_not_found': "Unter dieser Referenz wurde kein Maschinenpass ausgestellt.",
    'verify.err_code_mismatch': "Organisationscode und Referenz stimmen nicht überein.",
    'verify.err_unknown_section': "Unbekannter Abschnitt.",
    'verify.err_read_failed': "Der Datensatz konnte nicht gelesen werden.",
    'verify.intro': "Geben Sie die auf dem Dokument aufgedruckte Referenz ein, um zu bestätigen, dass es von Agriware Operations ausgestellt wurde. Für den vollständigen Datensatz der Maschine fügen Sie den Code der ausstellenden Organisation hinzu — beide stehen auf dem Maschinenpass.",
    'verify.orgcode_optional': "— optional, für den vollständigen Datensatz",
    'verify.title': "Maschinenpass prüfen",
    'verify.reference_label': "Dokumentreferenz",
    'verify.orgcode_label': "Organisationscode",
    'verify.checking': "Wird geprüft…",
    'verify.submit': "Prüfen",
    'verify.not_verified': "Nicht verifiziert",
    'verify.withdrawn': "Zurückgezogen",
    'verify.genuine': "Echtes Dokument",
    'verify.genuine_superseded': "Echt, aber überholt",
    'verify.superseded_note': "Für diese Maschine wurde ein neuerer Pass ausgestellt",
    'verify.fingerprint': "Dokument-Fingerabdruck (SHA-256)",
    'verify.no_result': "Kein Ergebnis.",
    'verify.err_not_verified': "Dieses Dokument konnte nicht verifiziert werden.",
    'verify.err_unreachable': "Der Prüfdienst war nicht erreichbar. Bitte versuchen Sie es erneut.",
    'verify.row_reference': "Referenz",
    'verify.row_issued_by': "Ausgestellt von",
    'verify.row_issued_on': "Ausgestellt am",
    'verify.not_recorded': "Nicht erfasst",
    'verify.row_make_model': "Marke und Modell",
    'verify.row_status': "Aktueller Status",
    'verify.blocked_from_use': "Für den Einsatz gesperrt",
    'verify.in_service': "Im Einsatz",
    'verify.no_open_defects': "Für diese Maschine sind keine offenen Mängel erfasst.",
    'verify.defect_history': "Mängelverlauf",
    'verify.no_resolved_defects': "Für diese Maschine sind keine behobenen Mängel erfasst.",
    'verify.inspection_record': "Prüfnachweis",
    'verify.check_log': "Prüfprotokoll",
    'verify.no_checks': "Für diese Maschine sind keine Prüfungen erfasst.",
    'verify.service_history': "Wartungsverlauf",
    'verify.no_services': "Für diese Maschine liegen keine Wartungseinträge vor.",
    'verify.checks_recorded': "Erfasste Prüfungen",
    'verify.pass_rate': "Bestehensquote",
    'verify.defects_raised': "Gemeldete Mängel",
    'verify.most_recent_check': "Letzte Prüfung",
    'verify.show_more': "Mehr anzeigen",
    'verify.showing_of': "{shown} von {total} angezeigt",
    'verify.details': "Details",
    'verify.hide': "Ausblenden",
    'verify.all_passed': "Alle bestanden",
    'verify.n_failed': "{n} nicht bestanden",
    'verify.blocked_the_machine': "Maschine gesperrt",
    'verify.blocking': "Sperrend",
    'verify.raised': "Gemeldet",
    'verify.resolved': "Behoben",
    'verify.revised_after_issue': "nach Ausstellung überarbeitet",
    'verify.next_service': "Nächste Wartung",
    'verify.parts': "Teile",
    'verify.external': "extern",
    'verify.sealed': "versiegelt",
    'verify.language': "Sprache",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Keine Bewegung erkannt",
    'emergency.triggered_generic': "Notfall ausgelöst",
    'emergency.community_badge': "Gemeinschaftsalarm — Notfall in der Nähe",
    'emergency.panel_responders': "Helfer",
    'emergency.machine_involved': "Beteiligte Maschine",
    'emergency.impact_label': "Aufprall",
    'emergency.ago': "her",
    'emergency.location_unavailable': "Standort nicht verfügbar",
    'emergency.open_in_maps': "In Google Maps öffnen",
    'emergency.im_responding': "Ich reagiere",
    'emergency.confirming': "Wird bestätigt…",
    'emergency.mark_resolved': "Als erledigt markieren",
    'emergency.resolving': "Wird abgeschlossen…",
    'emergency.called_automatically_at': "112 automatisch angerufen um {time}",
    'emergency.state_alert': "NOTFALLALARM",
    'emergency.state_awaiting': "WARTET AUF ANTWORT",
    'emergency.state_needs_help': "BEDIENER BRAUCHT HILFE",
    'emergency.state_no_response': "KEINE ANTWORT VOM BEDIENER",
    'emergency.seconds_to_respond': "{n} s für die Antwort des Bedieners",
    'billing.over_limit_row': "Über die im Tarif enthaltenen Maschinen hinaus",
    'billing.over_limit_full': "Diese Maschine liegt über den in Ihrem Tarif enthaltenen Maschinen. Nehmen Sie sie in Ihr Abonnement auf, um ihre Historie zu sehen.",
    'nav.reports': "Berichte",
    'site.not_found': "Standort nicht gefunden",
    'site.details': "Standortdetails",
    'site.edit': "Standort bearbeiten",
    'site.updated': "Standort aktualisiert",
    'site.err_update': "Standort konnte nicht aktualisiert werden",
    'site.no_address': "Keine Adresse hinterlegt",
    'site.no_machines': "Keine Maschinen an diesem Standort",
    'site.no_staff': "Diesem Standort ist niemand zugewiesen",
    'site.no_defects': "Keine offenen Mängel an diesem Standort",
    'checks.new_template': "Neue Vorlage",
    'set.language': "Sprache",
    'set.language_hint': "Gilt für alle in Ihrer Organisation",
    'set.your_organisation': "Ihre Organisation",
    'set.group_organisation': "Organisation",
    'set.group_safety': "Sicherheit und Compliance",
    'set.group_system': "System",
    'set.reports': "Berichte",
    'set.org_details': "Organisationsdaten",
    'set.org_details_hint': "Name, Anschrift, Handelsregisternummer, Branding",
    'set.sites_hint': "Höfe, Depots und Standorte der Maschinen",
    'set.roles': "Rollen und Berechtigungen",
    'set.roles_hint': "Was jede Rolle sehen und tun darf",
    'set.billing_hint': "Abonnement und Zahlungsmethode",
    'set.coshh_hint': "Vorhandene Stoffe und ihre Beurteilungen",
    'set.risk_hint': "Beurteilungen und Überprüfungen",
    'set.reports_hint': "Flottenzustand, Compliance, CO₂, Kosten und Versicherungsunterlagen",
    'set.integrations': "Integrationen",
    'set.integrations_hint': "Telematik, Händlersysteme und Almanac",
    'set.notifications_hint': "Was an wen gesendet wird",
    'set.audit_log': "Prüfprotokoll",
    'set.audit_log_hint': "Wer hat was und wann geändert",
    'set.data': "Daten",
    'set.data_hint': "Export und Aufbewahrung",
    'set.data_retention': "Daten & Aufbewahrung",
    'set.export_title': "Ihre Daten exportieren",
    'set.export_desc': "Exportieren Sie eine vollständige Kopie Ihrer Organisationsdaten samt aller Maschinendaten, Wartungshistorie, Prüfprotokolle, Personalprofile und Qualifikationen.",
    'set.export_coming_soon': "Datenexport folgt in Kürze",
    'set.export_btn': "Alle Daten exportieren",
    'set.retention_title': "Datenaufbewahrung",
    'set.retention_desc': "Ihre Daten werden für die Dauer Ihres Abonnements sowie 12 Monate nach der Kündigung aufbewahrt. Wartungseinträge und versiegelte Auftragskarten werden unbefristet aufbewahrt, da sie für rechtliche und versicherungstechnische Zwecke benötigt werden können.",
    'set.danger_zone': "Gefahrenbereich",
    'set.danger_desc': "Beim Löschen Ihrer Organisation werden alle Daten dauerhaft entfernt, mit Ausnahme versiegelter Maschinendaten, die für die Compliance erforderlich sind. Dies kann nicht rückgängig gemacht werden.",
    'set.delete_org': "Organisation löschen",
    'set.delete_org_toast': "Bitte wenden Sie sich an den Support, um Ihre Organisation zu löschen",
    'set.audit_log_subtitle': "Vollständige Aufzeichnung aller Aktionen in Ihrer Organisation",
    'set.audit_search': "Prüfprotokoll durchsuchen…",
    'set.col_action': "Aktion",
    'set.no_audit': "Keine Protokolleinträge",
    'set.audit_empty_msg': "Aktionen erscheinen hier, sobald sie stattfinden",
    'set.notif_title': "Benachrichtigungseinstellungen",
    'set.notif_desc': "Legen Sie fest, welche Ereignisse Push-Benachrichtigungen für Führungskräfte und Admins Ihrer Organisation auslösen.",
    'set.notif_saved': "Benachrichtigungseinstellungen gespeichert",
    'set.save_preferences': "Einstellungen speichern",
    'set.notif_check_failed': "Prüfung nicht bestanden",
    'set.notif_check_failed_desc': "Wenn ein Bediener eine nicht bestandene Prüfung einreicht",
    'set.notif_machine_blocked': "Maschine gesperrt",
    'set.notif_machine_blocked_desc': "Wenn eine Maschine nach einer nicht bestandenen Prüfung automatisch gesperrt wird",
    'set.notif_defect': "Mangel gemeldet",
    'set.notif_defect_desc': "Wenn ein Bediener einen Mangel meldet",
    'set.notif_near_miss': "Beinaheunfall gemeldet",
    'set.notif_near_miss_desc': "Wenn ein Beinaheunfall gemeldet wird",
    'set.notif_qual_expiring': "Qualifikation läuft ab (30 T.)",
    'set.notif_qual_expiring_desc': "Wenn eine Qualifikation innerhalb von 30 Tagen abläuft",
    'set.notif_qual_expired': "Qualifikation abgelaufen",
    'set.notif_qual_expired_desc': "Wenn eine Qualifikation abgelaufen ist",
    'set.notif_service_due': "Wartung fällig",
    'set.notif_service_due_desc': "Wenn eine Maschine ihr Wartungsintervall erreicht",
    'set.notif_fuel_low': "Kraftstofftank niedrig",
    'set.notif_fuel_low_desc': "Wenn ein Dieseltank unter den Schwellenwert fällt",
    'set.notif_emergency': "Notfallalarm",
    'set.notif_emergency_desc': "Immer aktiv — kann nicht deaktiviert werden",
    'set.notif_announcement': "Mitteilungen",
    'set.notif_announcement_desc': "Wenn die Leitung eine Mitteilung versendet",
    'set.no_sites_msg': "Legen Sie Ihren ersten Betrieb oder Standort an",
    'set.err_site_name': "Standortname ist erforderlich",
    'set.site_added': "Standort hinzugefügt",
    'set.err_site_add': "Standort konnte nicht hinzugefügt werden",
    'set.site_name': "Standortname",
    'set.site_name_placeholder': "z. B. Haupthof",
    'set.address': "Anschrift",
    'set.address_placeholder': "z. B. Haupthof, Feldweg 1, 12345 Musterstadt",
    'set.roles_title': "Rollen & Berechtigungen",
    'set.role_admin_full': "Vollzugriff auf alle Standorte, Maschinen, Personal, Einstellungen und Abrechnung. Kann Mitteilungen senden und alle Daten verwalten.",
    'set.role_manager_full': "Auf den Standort begrenzter Zugriff. Verwaltet Maschinen und Personal am zugewiesenen Standort. Kein Zugriff auf Abrechnung oder Organisationseinstellungen.",
    'set.role_operator_full': "Nur Zugriff über die mobile App. Führt tägliche Prüfungen durch, erfasst Betankungen und kann Mängel und Beinaheunfälle melden.",
    'set.perm_all_machines': "Alle Maschinen an allen Standorten",
    'set.perm_all_staff': "Verwaltung des gesamten Personals",
    'set.perm_all_settings': "Alle Einstellungen",
    'set.perm_announcements': "Mitteilungen senden",
    'set.perm_emergencies': "Notfälle abschließen",
    'set.perm_site_machines': "Maschinen an ihrem Standort",
    'set.perm_site_staff': "Personal an ihrem Standort",
    'set.perm_checks_defects': "Prüfungen und Mängel",
    'set.perm_shifts': "Schichtverwaltung",
    'set.perm_daily_checks_app': "Tägliche Prüfungen (App)",
    'set.perm_fuel_fills_app': "Betankungen (App)",
    'set.perm_defect_app': "Mangelmeldung (App)",
    'set.perm_near_miss_app': "Beinaheunfallmeldung (App)",
    'set.perm_own_quals': "Eigene Qualifikationen einsehen",
    'set.perm_sos': "Notfall-SOS",
    'set.org_settings': "Organisationseinstellungen",
    'set.identity': "Identität",
    'set.org_name': "Name der Organisation",
    'set.trading_name': "Handelsname",
    'set.if_different': "Falls abweichend",
    'set.company_number': "Handelsregisternummer",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "USt-IdNr.",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Branche",
    'set.ind_farm': "Landwirtschaftsbetrieb",
    'set.ind_estate': "Gut",
    'set.ind_contractor': "Lohnunternehmen",
    'set.ind_dealership': "Händler",
    'set.ind_other': "Sonstiges",
    'set.primary_email': "Haupt-E-Mail-Adresse",
    'set.phone_number': "Telefonnummer",
    'set.website': "Website",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Adresszeile 1",
    'set.address2': "Adresszeile 2",
    'set.town': "Ort / Stadt",
    'set.county': "Landkreis",
    'set.postcode': "PLZ",
    'set.branding': "Branding",
    'set.brand_colour': "Markenfarbe",
    'set.compliance': "Compliance",
    'set.hse_number': "HSE-Registrierungsnummer",
    'set.insurance_provider': "Versicherer",
    'set.policy_number': "Versicherungsscheinnummer",
    'set.insurance_expiry': "Ablauf der Versicherung",
    'set.sharing_transfers': "Freigabe & Übertragungen",
    'set.org_code_desc': "Ihr Organisationscode dient zum Empfang freigegebener Maschinen und Übertragungen von anderen Agriware-Kunden. Geben Sie ihn an alle weiter, mit denen Sie Technik gemeinsam besitzen, oder an jemanden, der Ihnen eine Maschine verkauft.",
    'set.emails': "E-Mails",
    'set.hold_the_yard': "Wöchentliche Hold-the-Yard-E-Mail",
    'set.hold_the_yard_desc': "Jeden Montag eine Zusammenfassung der Einsatzprüfungen der Vorwoche, gesendet an die Administratoren und Manager Ihrer Organisation.",
    'set.org_code': "Organisationscode",
    'set.generating': "Wird erstellt…",
    'set.copied': "Kopiert!",
    'set.copy': "Kopieren",
    'set.org_saved': "Organisationseinstellungen gespeichert",
    'set.err_save': "Einstellungen konnten nicht gespeichert werden",
    'set.save_changes': "Änderungen speichern",
    'set.status_trialing': "Testphase",
    'set.status_past_due': "Überfällig",
    'set.status_cancelled': "Gekündigt",
    'set.status_unpaid': "Unbezahlt",
    'set.status_incomplete': "Unvollständig",
    'set.billing_title': "Abrechnung & Abonnement",
    'set.billing_subtitle': "Verwalten Sie Ihr Agriware-Operations-Abonnement.",
    'set.plan_standard': "Standard",
    'set.per_month': "/Monat · jederzeit kündbar",
    'set.grandfathered': "Diese Organisation hat Bestandsschutz. Abrechnungsdaten sind nicht verfügbar, da dieses Konto älter als die Stripe-Integration ist.",
    'set.next_billing': "Nächstes Abrechnungsdatum:",
    'set.feat_registry': "Maschinenregister und Wartungshistorie",
    'set.feat_checks': "Tägliche Prüfungen und Inspektionen",
    'set.feat_defects': "Fehler- und Mängelverfolgung",
    'set.feat_staff': "Qualifikationen und Schichten des Personals",
    'set.feat_reporting': "Berichtspaket",
    'set.feat_unlimited': "Unbegrenzte Standorte und Bediener",
    'set.err_no_portal': "Keine Portal-URL erhalten.",
    'set.err_portal': "Abrechnungsportal konnte nicht geöffnet werden. Bitte erneut versuchen oder den Support kontaktieren.",
    'set.opening_portal': "Abrechnungsportal wird geöffnet…",
    'set.manage_billing': "Abrechnung verwalten",
    'set.admin_only_billing': "Nur Organisations-Admins können die Abrechnung verwalten.",
    'set.stripe_note': "Die Abrechnung erfolgt sicher über Stripe. Wir sehen Ihre Kartendaten nie.",
    'int.abax_desc': "Betriebsstunden, Standort und Auslastung direkt von ABAX-Trackern übernehmen, damit Stunden von selbst ankommen statt eingetippt zu werden.",
    'int.abax_detail': "Automatische Stunden würden Wartungsintervalle, CO₂-Schätzungen und Prüf-Compliance korrekt halten, ohne dass jemand einen Zählerstand eingibt.",
    'int.dms_desc': "Verbinden Sie sich mit dem DMS Ihres Händlers, um Auftragsanfragen zu stellen, Kostenvoranschläge zu genehmigen und versiegelte Auftragskarten der richtigen Maschine zuzuordnen.",
    'int.dms_detail': "Vom Händler ausgeführte Arbeiten landen automatisch in den Maschinendaten und erscheinen im Maschinenpass.",
    'int.almanac_desc': "Sehen Sie, wie Ihre Maschinen im Vergleich zu denselben Modellen in allen Agriware-Flotten abschneiden — typische Schwachstellen, Wartungsintervalle und Zuverlässigkeit je Modell.",
    'int.almanac_detail': "Almanac bündelt anonymisierte Mängel- und Wartungsdaten mehrerer Organisationen. Ihre Daten fließen ein; im Gegenzug sehen Sie die Gesamtauswertung.",
    'int.consent_shared': "Geteilt: Marke und Modell der Maschine, Mangelarten, Betriebsstunden bei Ausfall, Wartungsintervalle",
    'int.consent_never': "Nie geteilt: Name Ihrer Organisation, Standorte, Personal, Bediener, Kosten oder Dokumente",
    'int.consent_threshold': "Zahlen werden nur angezeigt, wenn genügend Maschinen vorhanden sind, damit einzelne Flotten nicht identifizierbar sind",
    'int.consent_withdraw': "Sie können jederzeit widerrufen — eingebrachte Daten werden aus künftigen Auswertungen entfernt",
    'int.err_update': "Diese Integration konnte nicht aktualisiert werden",
    'int.interest_noted': "Notiert — wir melden uns, sobald das bereitsteht",
    'int.almanac_enabled': "Almanac aktiviert",
    'int.almanac_disabled': "Almanac deaktiviert",
    'int.subtitle': "Verbinden Sie Agriware Operations mit den Systemen, die Sie bereits nutzen",
    'int.admin_only': "Nur ein Organisations-Admin kann Integrationen ändern.",
    'int.enabled': "Aktiviert",
    'int.in_development': "In Entwicklung",
    'int.withdraw': "Widerrufen",
    'int.enable_almanac': "Almanac aktivieren",
    'int.interest_registered': "Interesse vermerkt",
    'int.register_interest': "Interesse bekunden",
    'int.less': "Weniger",
    'int.what_this_does': "Was das bewirkt",
    'int.footer': "Nutzen Sie etwas, das hier fehlt? Sagen Sie uns, was Sie angebunden haben möchten — Ihre Wünsche bestimmen, was als Nächstes gebaut wird.",
    'tmpl.scope_all_desc': "Gilt für jede Maschine der Organisation",
    'tmpl.scope_category': "Nach Kategorie",
    'tmpl.scope_category_desc': "Gilt für ausgewählte Kategorien",
    'tmpl.scope_specific_desc': "Gilt nur für eine Maschine",
    'tmpl.freq_daily': "Täglich",
    'tmpl.freq_daily_helper': "Muss täglich bis zur Fälligkeitszeit erledigt sein",
    'tmpl.freq_weekly': "Wöchentlich",
    'tmpl.freq_weekly_helper': "Muss einmal pro Woche erledigt werden",
    'tmpl.freq_hourly': "Nach Betriebsstunden",
    'tmpl.freq_hourly_helper': "Wird alle X Betriebsstunden ausgelöst",
    'tmpl.freq_monthly': "Monatlich",
    'tmpl.freq_monthly_helper': "Muss einmal pro Monat erledigt werden",
    'tmpl.item_passfail': "Bestanden / Nicht bestanden",
    'tmpl.item_numeric': "Zahl",
    'tmpl.item_text': "Text",
    'tmpl.item_photo': "Foto",
    'tmpl.item_signature': "Unterschrift",
    'tmpl.fail_none': "Nur protokollieren",
    'tmpl.fail_flag': "Protokollieren und benachrichtigen",
    'tmpl.fail_block': "Protokollieren, benachrichtigen und sperren",
    'tmpl.section_default': "Abschnitt",
    'tmpl.err_name': "Vorlagenname ist erforderlich",
    'tmpl.err_category': "Wählen Sie mindestens eine Kategorie",
    'tmpl.err_machine': "Wählen Sie eine Maschine",
    'tmpl.err_items': "Fügen Sie mindestens einen Prüfpunkt hinzu",
    'tmpl.updated': "Vorlage aktualisiert",
    'tmpl.created': "Vorlage erstellt",
    'tmpl.err_save': "Vorlage konnte nicht gespeichert werden",
    'tmpl.name_placeholder': "Vorlagenname",
    'tmpl.save': "Vorlage speichern",
    'tmpl.settings': "Vorlageneinstellungen",
    'tmpl.description_placeholder': "Kurze Beschreibung, wann diese Vorlage verwendet wird",
    'tmpl.applies_to': "Gilt für",
    'tmpl.select_categories_caps': "KATEGORIEN WÄHLEN",
    'tmpl.select_machine_caps': "MASCHINE WÄHLEN",
    'tmpl.choose_machine': "Maschine auswählen…",
    'tmpl.frequency': "Prüfintervall",
    'tmpl.estimated_time': "Geschätzte Dauer (Minuten)",
    'tmpl.every_x_hours': "Alle X Betriebsstunden",
    'tmpl.due_by_time': "Fällig bis",
    'tmpl.due_by_hint': "— die Überfälligkeitserinnerung wird zu dieser Zeit ausgelöst",
    'tmpl.due_by_note': "Push-Benachrichtigung an Bediener und Standortleitung, wenn bis dahin nicht erledigt",
    'tmpl.item_one': "Punkt",
    'tmpl.item_many': "Punkte",
    'tmpl.new_item': "Neuer Prüfpunkt",
    'tmpl.add_item': "Prüfpunkt hinzufügen",
    'tmpl.add_section': "Abschnitt hinzufügen",
    'tmpl.item_panel_title': "Prüfpunkt",
    'tmpl.select_item_hint': "Wählen Sie links einen Prüfpunkt aus, um seine Einstellungen hier zu bearbeiten.",
    'tmpl.label': "Bezeichnung",
    'tmpl.label_placeholder': "z. B. Motorölstand",
    'tmpl.if_fails': "Wenn dieser Punkt nicht bestanden wird",
    'tmpl.required': "Pflichtfeld",
    'tmpl.required_hint': "Der Bediener muss diesen Punkt ausfüllen",
    'status.active': "Aktiv",
    'status.shared': "Freigegeben",
    'status.transferred': "Übertragen",
    'status.archived': "Archiviert",
    'status.issues': "Beanstandungen",
    'status.emergency': "Notfall",
    'status.closed': "Geschlossen",
    'status.due': "Fällig",
    'status.draft': "Entwurf",
    'status.approved': "Genehmigt",
    'status.declined': "Abgelehnt",
    'status.scheduled': "Geplant",
    'photo.title': "Profilfoto",
    'photo.upload_title': "Foto hochladen",
    'photo.upload_note': "JPG, PNG oder WebP · max. 5 MB · wird kreisförmig zugeschnitten",
    'photo.choose': "Foto auswählen",
    'photo.drag_hint': "Zum Verschieben ziehen · zum Zoomen scrollen oder Regler nutzen",
    'photo.change': "Foto ändern",
    'photo.save': "Foto speichern",
    'upsell.derv_title': "Kraftstoffverwaltung",
    'upsell.derv_desc': "Tankfüllstände verfolgen, Betankungen erfassen, Lieferanten verwalten und den Kraftstoffverbrauch je Maschine über alle Standorte überwachen.",
    'upsell.coshh_title': "Gefahrstoffregister",
    'upsell.coshh_desc': "Führen Sie ein digitales Register gefährlicher Stoffe, Sicherheitsdatenblätter und der erforderlichen PSA für Ihre Belegschaft.",
    'upsell.risk_title': "Gefährdungsbeurteilungen",
    'upsell.risk_desc': "Erstellen, verwalten und versiegeln Sie Gefährdungsbeurteilungen je Maschine oder Tätigkeit. Bediener bestätigen vor Arbeitsbeginn.",
    'upsell.jobs_title': "DMS-Integration",
    'upsell.jobs_desc': "Fordern Sie Werkstattaufträge bei Ihrem Händler an, genehmigen Sie Kostenvoranschläge und erhalten Sie versiegelte Auftragskarten direkt im Maschinenprofil.",
    'upsell.reporting_title': "Berichte & Auswertungen",
    'upsell.reporting_desc': "Berichte zu Flottenzustand, Compliance, Qualifikationsstatus, Kraftstoffverbrauch, CO₂-Emissionen und Kosten je Maschine.",
    'upsell.quals_title': "Qualifikationsverfolgung",
    'upsell.quals_desc': "Erfassen Sie Scheine und Zertifikate Ihrer Mitarbeitenden mit Ablaufverfolgung, Push-Benachrichtigungen und Maschinenfreigabe nach Qualifikation.",
    'upsell.sharing_title': "Maschinenfreigabe",
    'upsell.sharing_desc': "Geben Sie Maschinendaten für andere Agriware-Ops-Organisationen frei — ideal für Lohnunternehmer und gemeinsam genutzte Technik.",
    'upsell.transfers_title': "Maschinenübertragungen",
    'upsell.transfers_desc': "Übertragen Sie Maschinen zwischen Ops-Nutzern oder DMS-Konten — mit vollständiger Eigentumshistorie und digitalem Fahrtenbuch.",
    'upsell.carbon_title': "CO₂-Berichterstattung",
    'upsell.carbon_desc': "Automatische CO₂-Berechnung auf Basis des Kraftstoffverbrauchs. Berichterstattung nach DEFRA-Standard für Ihre Flotte.",
    'upsell.not_included': "Diese Funktion ist in Ihrem aktuellen Tarif nicht enthalten.",
    'upsell.upgrade': "Tarif upgraden",
    'service.record_not_found': "Eintrag nicht gefunden",
    'service.record_title_service': "Wartungseintrag",
    'service.record_title_repair': "Reparatureintrag",
    'service.record_title_inspection': "Prüfeintrag",
    'service.record_suffix': "Eintrag",
    'service.email_btn': "E-Mail",
    'service.email_coming_soon': "E-Mail-Export folgt in Kürze",
    'service.sealed_by_workshop': "Von {name} versiegelt und nicht änderbar",
    'service.the_workshop': "die Werkstatt",
    'service.sealed_permanent': "Dieser Eintrag ist dauerhaft versiegelt und kann nicht geändert werden",
    'service.sealed_by': "Versiegelt von",
    'service.at_suffix': "bei {name}",
    'service.job_ref': "Auftrag {ref}",
    'service.photos_video': "Fotos und Video",
    'service.job_photo': "Auftragsfoto",
    'service.files_copying': "Einige Dateien werden noch kopiert.",
    'service.date_of_service': "Wartungsdatum",
    'service.hours_at_service': "Betriebsstunden bei Wartung",
    'service.total_cost': "Gesamtkosten",
    'service.record_details': "Eintragsdetails",
    'service.type': "Art",
    'service.performed_by': "Durchgeführt von",
    'service.performed_by_type': "Art des Ausführenden",
    'service.next_service_hours': "Betriebsstunden bis nächste Wartung",
    'service.next_service_date': "Datum der nächsten Wartung",
    'service.notes': "Notizen",
    'service.parts_used': "Verwendete Teile",
    'service.col_part': "Teil",
    'service.col_qty': "Menge",
    'service.col_cost': "Kosten",
    'service.parts_total': "Teile gesamt",
    'service.cost_breakdown': "Kostenaufstellung",
    'service.labour_cost': "Arbeitskosten",
    'service.parts_cost': "Teilekosten",
    'service.total': "Gesamt",
    'service.audit_trail': "Änderungsprotokoll",
    'service.record_created_by': "Eintrag erstellt von",
    'service.record_sealed_by': "Eintrag versiegelt von",
    'service.type_service': "Wartung",
    'service.type_service_desc': "Planmäßige Routinewartung",
    'service.type_repair': "Reparatur",
    'service.type_repair_desc': "Außerplanmäßige Reparaturarbeiten",
    'service.type_inspection': "Prüfung",
    'service.type_inspection_desc': "Sicherheits- oder Compliance-Prüfung",
    'service.by_internal': "Intern",
    'service.by_dealer': "Händler",
    'service.by_external': "Externer Dienstleister",
    'service.err_description': "Bitte geben Sie eine Beschreibung ein",
    'service.err_date': "Bitte geben Sie das Wartungsdatum ein",
    'service.added_toast': "Wartungseintrag hinzugefügt und versiegelt",
    'service.err_save': "Eintrag konnte nicht gespeichert werden — bitte erneut versuchen",
    'service.seal_note': "Dieser Eintrag wird nach dem Speichern dauerhaft versiegelt",
    'service.record_type': "Eintragsart",
    'service.description_placeholder': "Beschreiben Sie die ausgeführten Arbeiten…",
    'service.performed_by_placeholder': "Name oder Firma",
    'service.additional_notes': "Zusätzliche Notizen",
    'service.notes_placeholder': "Weitere Notizen…",
    'service.add_part': "Teil hinzufügen",
    'service.part_name': "Teilebezeichnung",
    'service.cost_placeholder': "Kosten £",
    'service.cost_next_service': "Kosten & nächste Wartung",
    'service.labour_cost_field': "Arbeitskosten (£)",
    'service.next_hours_placeholder': "z. B. 1750",
    'service.seal_warning': "Nach dem Speichern ist dieser Eintrag dauerhaft versiegelt und kann nicht mehr bearbeitet werden. Prüfen Sie alle Angaben vor dem Speichern.",
    'service.save_seal': "Eintrag speichern & versiegeln",
    'dashboard.there': "zusammen",
    'dashboard.total_machines': "Maschinen gesamt",
    'dashboard.blocked_machines': "Gesperrte Maschinen",
    'dashboard.open_incidents': "Offene Vorfälle",
    'dashboard.open_defects': "Offene Mängel",
    'dashboard.fuel_tanks': "Kraftstofftanks",
    'common.of': "von",
    'dashboard.fleet': "Fuhrpark",
    'common.view_all': "Alle anzeigen",
    'dashboard.no_machines': "Noch keine Maschinen",
    'dashboard.no_machines_msg': "Fügen Sie Ihre erste Maschine hinzu, um zu starten",
    'dashboard.recent_incidents': "Aktuelle Vorfälle",
    'dashboard.no_incidents_msg': "Keine Vorfälle erfasst",
    'dashboard.recent_defects': "Aktuelle Mängel",
    'dashboard.no_defects': "Keine Mängel",
    'dashboard.no_defects_msg': "Keine Mängel gemeldet",
    'dashboard.defect_reported': "Mangel gemeldet",
    'dashboard.group_overview': "Gruppenübersicht",
    'dashboard.send_announcement': "Mitteilung senden",
    'dashboard.sites': "Standorte",
    'dashboard.no_sites': "Noch keine Standorte",
    'dashboard.no_sites_msg': "Legen Sie Ihren ersten Standort in den Einstellungen an, um zu starten",
    'dashboard.add_site': "Standort hinzufügen",
    'dashboard.status_monitor': "Beobachten",
    'dashboard.status_all_good': "Alles in Ordnung",
    'dashboard.derv': "Diesel",
    'dashboard.derv_level': "Dieselstand",
    'qual.short_forklift': "Stapler",
    'qual.short_sprayer': "Spritze",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Führerschein",
    'qual.short_firstaid': "Erste Hilfe",
    'qual.short_chainsaw': "Motorsäge",
    'qual.short_pesticide': "Pflanzenschutz",
    'qual.short_telehandler': "Teleskoplader",
    'qual.short_atv': "Quad",
    'qual.short_other': "Sonstiges",
    'qual.forklift': "Staplerschein",
    'qual.sprayer': "PA1/PA6-Spritzenschein",
    'qual.cscs': "CSCS-Karte",
    'qual.driving': "Führerschein",
    'qual.firstaid': "Erste-Hilfe-Schein",
    'qual.chainsaw': "Motorsägenschein",
    'qual.pesticide': "Pflanzenschutz-Sachkunde",
    'qual.telehandler': "Teleskoplader-Schein",
    'qual.atv': "Quad-/ATV-Schein",
    'qual.other': "Sonstige Qualifikation",
    'staff.n_expired': "abgelaufen",
    'staff.n_expiring': "laufen bald ab",
    'staff.n_valid': "gültig",
    'common.none': "Keine",
    'staff.tab_members': "Mitarbeitende",
    'staff.tab_qualifications': "Qualifikationen",
    'staff.tab_shifts': "Schichten",
    'staff.member_one': "Mitarbeitender",
    'staff.member_many': "Mitarbeitende",
    'staff.alert_one': "Qualifikationshinweis",
    'staff.alert_many': "Qualifikationshinweise",
    'staff.invite': "Personal einladen",
    'staff.create_shift': "Schicht anlegen",
    'staff.search': "Nach Name oder E-Mail suchen…",
    'staff.none_found': "Kein Personal gefunden",
    'staff.adjust_search': "Passen Sie Ihre Suche an",
    'staff.invite_first': "Laden Sie Ihren ersten Mitarbeitenden ein",
    'staff.stat_total_quals': "Qualifikationen gesamt",
    'staff.stat_valid': "Gültig",
    'staff.stat_expiring_30d': "Läuft ab (30 T.)",
    'staff.stat_expiring': "Läuft ab",
    'staff.stat_expired': "Abgelaufen",
    'staff.qual_one': "Qualifikation",
    'staff.qual_many': "Qualifikationen",
    'staff.expires': "Läuft ab am",
    'staff.no_quals': "Keine Qualifikationen erfasst",
    'staff.no_quals_msg': "Fügen Sie Qualifikationen im Profil der jeweiligen Person hinzu",
    'staff.no_shifts': "Noch keine Schichten",
    'staff.no_shifts_msg': "Legen Sie Ihre erste Schicht an, um zu erfassen, wer arbeitet",
    'staff.shift': "Schicht",
    'staff.checked_in': "eingecheckt",
    'staff.not_found': "Mitarbeitender nicht gefunden",
    'staff.add_qualification': "Qualifikation hinzufügen",
    'staff.expired_alert_one': "Qualifikation ist abgelaufen — dieser Bediener ist möglicherweise nicht für bestimmte Maschinen zugelassen",
    'staff.expired_alert_many': "Qualifikationen sind abgelaufen — dieser Bediener ist möglicherweise nicht für bestimmte Maschinen zugelassen",
    'staff.expiring_alert_one': "Qualifikation läuft in 30 Tagen ab",
    'staff.expiring_alert_many': "Qualifikationen laufen in 30 Tagen ab",
    'staff.tab_details': "Details",
    'staff.contact': "Kontakt",
    'staff.account': "Konto",
    'staff.onboarding': "Einführung",
    'staff.complete': "Abgeschlossen",
    'staff.job_title': "Funktion",
    'staff.joined': "Eingetreten am",
    'staff.invited_by': "Eingeladen von",
    'staff.quals_tickets': "Qualifikationen & Scheine",
    'staff.no_quals_profile_msg': "Fügen Sie die Scheine und Zertifikate dieses Bedieners hinzu",
    'staff.issued': "Ausgestellt",
    'staff.no_expiry': "Kein Ablaufdatum",
    'staff.expires_today': "Läuft heute ab",
    'staff.days_remaining_one': "Tag verbleibend",
    'staff.days_remaining_many': "Tage verbleibend",
    'staff.expired_days_ago_one': "Vor {n} Tag abgelaufen",
    'staff.expired_days_ago_many': "Vor {n} Tagen abgelaufen",
    'staff.view_certificate': "Zertifikat ansehen",
    'staff.assigned_machines': "Zugewiesene Maschinen",
    'staff.no_machines': "Keine Maschinen zugewiesen",
    'staff.no_machines_msg': "Diesem Bediener sind keine Maschinen zugewiesen",
    'staff.err_first_name': "Vorname ist erforderlich",
    'staff.err_last_name': "Nachname ist erforderlich",
    'staff.err_email': "Bitte geben Sie eine gültige E-Mail-Adresse ein",
    'staff.err_site': "Bitte wählen Sie einen Standort",
    'staff.err_create_prefix': "Konto konnte nicht erstellt werden:",
    'staff.err_timeout': "Zeitüberschreitung bei der Kontoerstellung. Bitte laden Sie neu und versuchen Sie es erneut.",
    'staff.err_create': "Konto konnte nicht erstellt werden — bitte erneut versuchen",
    'staff.copy_greeting': "Hallo {name},",
    'staff.copy_body': "Ihr Konto für Agriware Operations wurde erstellt.",
    'staff.copy_email': "E-Mail:",
    'staff.copy_temp_password': "Temporäres Passwort:",
    'staff.copy_footer': "Bei der ersten Anmeldung werden Sie aufgefordert, Ihr Passwort zu ändern.",
    'staff.copied_toast': "Zugangsdaten in die Zwischenablage kopiert",
    'staff.role_admin_desc': "Vollzugriff auf alle Standorte und Einstellungen",
    'staff.role_manager_desc': "Verwaltet einen Standort, Personal und Maschinen",
    'staff.role_operator_desc': "Führt tägliche Prüfungen über die mobile App durch",
    'staff.add_member': "Mitarbeitenden hinzufügen",
    'staff.add_member_sub': "Das Konto wird sofort erstellt. Sie erhalten die Zugangsdaten zum Weitergeben.",
    'staff.account_created': "Konto erstellt",
    'staff.share_details_pre': "Geben Sie diese Zugangsdaten weiter an",
    'staff.share_details_post': "Bei der ersten Anmeldung wird zum Ändern des Passworts aufgefordert.",
    'staff.label_email_caps': "E-MAIL",
    'staff.label_temp_password_caps': "TEMPORÄRES PASSWORT",
    'staff.copy_login_details': "Zugangsdaten kopieren",
    'staff.add_another': "Weitere hinzufügen",
    'staff.back_to_staff': "Zurück zum Personal",
    'staff.personal_details': "Persönliche Angaben",
    'staff.first_name': "Vorname",
    'staff.last_name': "Nachname",
    'staff.work_email': "Geschäftliche E-Mail",
    'staff.site_assignment': "Standortzuweisung",
    'staff.no_sites': "Noch keine Standorte angelegt — legen Sie zuerst einen Standort in den Einstellungen an",
    'staff.creating_account': "Konto wird erstellt…",
    'staff.create_account': "Konto erstellen",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Bitte wählen Sie eine Qualifikationsart",
    'qual.err_name': "Bitte geben Sie die Bezeichnung der Qualifikation ein",
    'qual.err_issue_date': "Bitte geben Sie das Ausstellungsdatum ein",
    'qual.err_expiry': "Bitte geben Sie das Ablaufdatum ein oder markieren Sie „kein Ablaufdatum“",
    'qual.added_toast': "Qualifikation hinzugefügt",
    'qual.err_save': "Qualifikation konnte nicht gespeichert werden — bitte erneut versuchen",
    'qual.back_staff_profile': "Mitarbeiterprofil",
    'qual.subtitle': "Erfassen Sie einen Schein, ein Zertifikat oder eine Lizenz für diesen Bediener",
    'qual.type_title': "Qualifikationsart",
    'qual.name_label': "Bezeichnung der Qualifikation",
    'qual.name_placeholder': "z. B. NPTC-Freischneiderschein",
    'qual.cert_details': "Angaben zum Zertifikat",
    'qual.cert_number': "Zertifikatsnummer",
    'common.optional_suffix': "— optional",
    'qual.cert_number_placeholder': "z. B. NPORS-123456",
    'qual.issuing_body': "Ausstellende Stelle",
    'qual.issuing_body_placeholder': "z. B. NPORS, LANTRA, CITB",
    'qual.issue_date': "Ausstellungsdatum",
    'qual.expiry_date': "Ablaufdatum",
    'qual.no_expiry_label': "Diese Qualifikation hat kein Ablaufdatum",
    'qual.cert_document': "Zertifikatsdokument",
    'qual.upload_note': "Laden Sie ein Foto oder einen Scan des Zertifikats hoch. Es wird privat gespeichert und nie geteilt.",
    'common.remove': "Entfernen",
    'qual.click_upload': "Zum Hochladen des Zertifikats klicken",
    'qual.file_types': "JPG, PNG oder PDF",
    'common.saving': "Wird gespeichert…",
    'qual.save': "Qualifikation speichern",
    'defects.title': "Mängel",
    'defects.n_open': "offen",
    'defects.n_critical': "kritisch",
    'defects.stat_total': "Mängel gesamt",
    'defects.status_open': "Offen",
    'defects.status_in_progress': "In Bearbeitung",
    'defects.status_resolved': "Behoben",
    'defects.all_severities': "Alle Schweregrade",
    'defects.sev_minor': "Gering",
    'defects.sev_moderate': "Mittel",
    'defects.sev_major': "Schwer",
    'defects.sev_critical': "Kritisch",
    'defects.search': "Mängel suchen…",
    'common.clear': "Zurücksetzen",
    'defects.col_description': "Beschreibung",
    'defects.reported_by': "Gemeldet von",
    'defects.col_severity': "Schweregrad",
    'defects.no_description': "Keine Beschreibung",
    'defects.none_found': "Keine Mängel gefunden",
    'defects.none_reported': "Es wurden keine Mängel gemeldet",
    'defects.acknowledged_toast': "Mangel zur Kenntnis genommen",
    'defects.acknowledge_failed': "Der Mangel konnte nicht zur Kenntnis genommen werden",
    'defects.resolved_released': "Mangel behoben — Maschine freigegeben",
    'defects.resolved_toast': "Mangel behoben",
    'defects.resolve_failed': "Der Mangel konnte nicht behoben werden",
    'defects.not_found': "Mangel nicht gefunden",
    'defects.report_title': "Mangelmeldung",
    'defects.acknowledge': "Zur Kenntnis nehmen",
    'defects.raise_job': "Auftrag anlegen",
    'defects.resolve': "Beheben",
    'defects.blocking_banner': "Maschine gesperrt — eine Führungskraft muss eine schriftliche Freigabe erfassen, bevor sie wieder eingesetzt wird",
    'defects.details_title': "Mangeldetails",
    'defects.no_description_provided': "Keine Beschreibung angegeben",
    'defects.reported_at': "Gemeldet am",
    'defects.location': "Ort",
    'defects.photos': "Fotos",
    'defects.acknowledgement': "Kenntnisnahme",
    'defects.acknowledged_by': "Zur Kenntnis genommen von",
    'defects.resolved_by': "Behoben von",
    'defects.return_to_service': "Wiederfreigabe",
    'defects.revised': "Überarbeitet",
    'defects.revised_by_suffix': "von {name}",
    'defects.view_machine_profile': "Maschinenprofil ansehen",
    'defects.resolve_and_release': "Beheben und wieder freigeben",
    'defects.resolve_defect': "Mangel beheben",
    'defects.release_machine': "Maschine freigeben",
    'defects.mark_resolved': "Als behoben markieren",
    'defects.release_warning': "Diese Maschine ist gesperrt. Ihre schriftliche Freigabe wird mit Ihrem Namen und Ihrer Funktion erfasst und erscheint im Maschinenpass.",
    'defects.resolution_details': "Angaben zur Behebung",
    'defects.resolution_placeholder': "Beschreiben Sie, wie der Mangel behoben wurde…",
    'defects.narrative_placeholder': "Was festgestellt wurde, was getan wurde und wie die Maschine vor der Freigabe geprüft wurde. Nennen Sie ggf. Auftragsnummern und Prüfangaben.",
    'defects.chars_needed_one': "weiteres Zeichen erforderlich",
    'defects.chars_needed_many': "weitere Zeichen erforderlich",
    'defects.characters': "Zeichen",
    'defects.permanent_note': "Dies wird dauerhaft zur Mangelmeldung erfasst.",
    'machines.tab_overview': "Übersicht",
    'machines.tab_history': "Verlauf",
    'machines.tab_documents': "Dokumente",
    'machines.tab_operators': "Bediener",
    'machines.tab_sharing': "Freigabe",
    'machines.tab_incidents': "Vorfälle",
    'machines.pdf_only': "Es werden nur PDF-Dateien akzeptiert.",
    'machines.replace_confirm': "{name} ersetzen? Die alte Datei wird gelöscht.",
    'machines.delete_doc_confirm': "Dieses Dokument löschen? Dies kann nicht rückgängig gemacht werden.",
    'machines.uploaded': "Hochgeladen",
    'machines.no_file_yet': "Noch keine Datei",
    'machines.uploading': "Wird hochgeladen…",
    'machines.view_document': "Dokument ansehen",
    'common.replace': "Ersetzen",
    'common.delete': "Löschen",
    'common.upload': "Hochladen",
    'machines.doc_type_manual': "Handbuch",
    'machines.doc_type_private': "Privat",
    'machines.doc_operators_manual': "Betriebsanleitung",
    'machines.doc_workshop_manual': "Werkstatthandbuch",
    'machines.untitled_document': "Unbenanntes Dokument",
    'machines.add_document': "Dokument hinzufügen",
    'machines.documents_intro': "Betriebs- und Werkstatthandbuch haben feste Plätze — so erkennen wir das richtige Dokument bei der Freigabe an die Agriware-Bibliothek. Andere private Dokumente sind nur für Ihre Organisation sichtbar.",
    'machines.returned_to_service': "Maschine wieder freigegeben",
    'machines.not_blocked': "Diese Maschine ist nicht gesperrt",
    'machines.resolve_defect_first': "Beheben Sie den offenen Mangel, um die Maschine wieder freizugeben",
    'machines.return_failed': "Die Maschine konnte nicht freigegeben werden",
    'machines.machine_not_found': "Maschine nicht gefunden",
    'common.unknown': "Unbekannt",
    'machines.unblock': "Freigeben",
    'service.add_record': "Wartungseintrag hinzufügen",
    'machines.serial_number': "Seriennummer",
    'machines.year': "Baujahr",
    'machines.blocked_banner': "Maschine gesperrt — nicht benutzen",
    'machines.current_hours': "Aktuelle Betriebsstunden",
    'machines.next_service': "Nächste Wartung",
    'machines.service_records': "Wartungseinträge",
    'machines.service_progress': "Wartungsfortschritt",
    'machines.cost_over_time': "Kostenentwicklung",
    'machines.cost_over_time_sub': "Wartung, Reparatur und kumulierte Besitzkosten",
    'machines.cost_empty': "Kostendaten erscheinen, sobald Wartungseinträge hinzugefügt werden.",
    'machines.series_service': "Wartung",
    'machines.series_repair': "Reparatur",
    'machines.series_cumulative': "Kumuliert",
    'machines.details_title': "Maschinendetails",
    'machines.make': "Marke",
    'machines.model': "Modell",
    'machines.category': "Kategorie",
    'machines.assigned_to': "Zugewiesen an",
    'machines.pool_machine': "Poolmaschine",
    'machines.unassigned': "Nicht zugewiesen",
    'machines.purchase_value': "Kauf & Wert",
    'machines.purchase_date': "Kaufdatum",
    'machines.purchase_price': "Kaufpreis",
    'machines.depreciation_rate': "Abschreibungssatz",
    'machines.per_year': "pro Jahr",
    'machines.estimated_life': "Geschätzte Nutzungsdauer",
    'common.unit_years': "Jahre",
    'machines.cost_tracking': "Kostenerfassung",
    'machines.total_service_cost': "Wartungskosten gesamt",
    'machines.total_repair_cost': "Reparaturkosten gesamt",
    'machines.total_fuel_cost': "Kraftstoffkosten gesamt",
    'machines.total_cost_ownership': "Gesamtbesitzkosten",
    'machines.service_history': "Wartungs- und Reparaturverlauf",
    'service.add_record_short': "Eintrag hinzufügen",
    'service.none_yet': "Noch keine Wartungseinträge",
    'service.none_yet_msg': "Fügen Sie Ihren ersten Wartungs- oder Reparatureintrag hinzu",
    'service.sealed': "Versiegelt",
    'service.workshop': "Werkstatt",
    'common.photo_one': "Foto",
    'common.photo_many': "Fotos",
    'machines.assigned_operators': "Zugewiesene Bediener",
    'machines.no_operator': "Kein Bediener zugewiesen",
    'machines.no_operator_msg': "Dieser Maschine ist kein Bediener zugewiesen",
    'machines.pool_machine_msg': "Dies ist eine Poolmaschine — für alle Bediener verfügbar",
    'machines.ownership_sharing': "Eigentum & Freigabe",
    'machines.share_machine': "Maschine freigeben",
    'machines.current_owner': "Aktueller Eigentümer",
    'machines.your_organisation': "Ihre Organisation",
    'machines.shared_with': "Freigegeben für",
    'machines.not_shared': "Für keine andere Organisation freigegeben",
    'machines.incident_history': "Vorfallverlauf",
    'incidents.none': "Keine Vorfälle",
    'incidents.none_msg': "Für diese Maschine sind keine Vorfälle erfasst",
    'incidents.impact_detected': "Aufprall erkannt",
    'incidents.manual_sos': "Manueller SOS",
    'incidents.man_down': "Personen-Notfallalarm",
    'machines.unblock_title': "Maschine wieder freigeben",
    'machines.confirm_unblock': "Freigabe bestätigen",
    'machines.unblock_warning': "Ihre schriftliche Erklärung wird zu der Prüfung erfasst, die diese Maschine gestoppt hat, und erscheint in ihrem Maschinenpass. Ist die Maschine durch einen offenen Mangel gesperrt, beheben Sie stattdessen den Mangel.",
    'machines.blocked_reason': "Sperrgrund",
    'machines.unblock_statement': "Freigabeerklärung",
    'machines.unblock_placeholder': "Was festgestellt wurde, was getan wurde und wie die Maschine vor der Freigabe geprüft wurde.",
    'checks.history_title': "Prüfverlauf",
    'checks.stat_total': "Prüfungen gesamt",
    'checks.stat_passed': "Bestanden",
    'checks.stat_failed': "Nicht bestanden",
    'checks.n_passed': "bestanden",
    'checks.n_failed': "nicht bestanden",
    'common.clear_filters': "Filter zurücksetzen",
    'checks.not_found': "Prüfung nicht gefunden",
    'common.export_pdf': "PDF exportieren",
    'common.pdf_coming_soon': "PDF-Export folgt in Kürze",
    'checks.item_failed_one': "Punkt nicht bestanden",
    'checks.item_failed_many': "Punkte nicht bestanden",
    'checks.auto_blocked': "Die Maschine wurde beim Absenden automatisch gesperrt",
    'checks.sealed_record': "Versiegelter Eintrag",
    'checks.submitted_by': "Eingereicht von",
    'checks.submitted_at': "Eingereicht am",
    'checks.hours_at_check': "Betriebsstunden bei Prüfung",
    'checks.stat_total_items': "Punkte gesamt",
    'checks.stat_mileage': "Kilometerstand",
    'checks.details_title': "Prüfdetails",
    'checks.failed_items': "Nicht bestandene Punkte",
    'checks.no_items_recorded': "Keine Prüfpunkte erfasst",
    'checks.alt_defect_photo': "Mängelfoto",
    'checks.alt_check_photo': "Prüffoto",
    'common.unit_hrs': "Std.",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Vorlagen",
    'checks.tab_history': "Verlauf",
    'checks.create_template': "Vorlage erstellen",
    'checks.scope_specific': "Bestimmte Maschine",
    'checks.scope_all': "Alle Maschinen",
    'checks.categories': "Kategorien",
    'checks.items': "Punkte",
    'checks.title': "Prüfungen",
    'checks.template_one': "Vorlage",
    'checks.template_many': "Vorlagen",
    'checks.record_one': "Eintrag",
    'checks.record_many': "Einträge",
    'checks.no_templates': "Noch keine Prüfvorlagen",
    'checks.no_templates_msg': "Erstellen Sie Vorlagen, um festzulegen, was Bediener vor dem Einsatz prüfen müssen",
    'checks.search': "Suche nach Maschine oder Bediener…",
    'checks.all_results': "Alle Ergebnisse",
    'checks.pass': "Bestanden",
    'checks.fail': "Nicht bestanden",
    'checks.none_found': "Keine Prüfungen gefunden",
    'checks.adjust_filters': "Passen Sie Ihre Filter an",
    'checks.none_submitted': "Es wurden noch keine Prüfungen eingereicht",
    'checks.col_operator': "Bediener",
    'checks.col_datetime': "Datum & Uhrzeit",
    'checks.col_result': "Ergebnis",
    'machines.add': "Maschine hinzufügen",
    'machines.col_machine': "Maschine",
    'machines.col_serial': "Seriennr. / Kennz.",
    'machines.col_site': "Standort",
    'machines.col_hours': "Stunden",
    'machines.col_status': "Status",
    'machines.title': "Maschinen",
    'machines.count_one': "Maschine",
    'machines.count_many': "Maschinen",
    'machines.blocked': "gesperrt",
    'machines.search': "Suche nach Marke, Modell, Seriennr. oder Kennz.…",
    'machines.all_sites': "Alle Standorte",
    'machines.all_statuses': "Alle Status",
    'machines.available': "Verfügbar",
    'machines.blocked_one': "Gesperrt",
    'machines.none_found': "Keine Maschinen gefunden",
    'machines.view': "Ansehen",
    'cat.all': "Alle Kategorien",
    'cat.agricultural': "Landwirtschaft",
    'cat.groundcare': "Grünpflege",
    'cat.plant': "Baumaschinen",
    'cat.vehicle': "Fahrzeug",
    'cat.atv': "ATV",
    'nav.dashboard': "Übersicht",
    'nav.staff': "Personal",
    'nav.checks': "Prüfungen",
    'nav.safety': "Sicherheit",
    'nav.operations': "Betrieb",
    'nav.settings': "Einstellungen",
    'nav.billing': "Abrechnung",
    'nav.sign_out': "Abmelden",
    'role.admin': "Administrator",
    'role.manager': "Manager",
    'role.operator': "Bediener",
    'app.name': 'AgriWare Betrieb',
    'app.tagline': 'Verwaltung',
    'nav.home': 'Startseite',
    'nav.machines': 'Maschinen',
    'nav.profile': 'Profil',
    'common.back': 'Zurück',
    'common.cancel': 'Abbrechen',
    'common.save': 'Speichern',
    'common.edit': 'Bearbeiten',
    'common.done': 'Fertig',
    'common.yes': 'Ja',
    'common.no': 'Nein',
    'common.ok': 'OK',
    'common.error': 'Fehler',
    'common.loading': 'Laden...',
    'common.retry': 'Wiederholen',
    'common.search': 'Suchen',
    'common.submit': 'Absenden',
    'common.confirm': 'Bestätigen',
    'common.close': 'Schließen',
    'common.pass': 'Bestanden',
    'common.fail': 'Nicht bestanden',
    'common.total': 'gesamt',
    'common.today': 'Heute',
    'common.yesterday': 'Gestern',
    'common.online_only': 'Nur online',
    'common.last_synced': 'Zuletzt synchronisiert',
    'common.back_to_app': 'Zurück zur App',
    'common.gps_shared': 'GPS geteilt',
    'common.yes_via_saas': 'Ja — über SaaS',
    'common.not_called': 'Nicht angerufen',
    'login.sign_in': 'Anmelden',
    'login.email': 'E-Mail-Adresse',
    'login.password': 'Passwort',
    'login.forgot_password': 'Passwort vergessen?',
    'login.no_account': 'Kein Konto?',
    'login.request_access': 'Zugang anfordern',
    'login.account_created_by_org': 'Ihr Konto wurde von Ihrer Organisation erstellt.',
    'login.email_placeholder': 'sie@organisation.de',
    'login.password_placeholder': 'Passwort eingeben',
    'login.error_empty': 'Bitte E-Mail und Passwort eingeben.',
    'login.error_invalid': 'Ungültige E-Mail oder Passwort. Bitte erneut versuchen.',
    'dashboard.greeting_morning': 'Guten Morgen,',
    'dashboard.greeting_afternoon': 'Guten Tag,',
    'dashboard.greeting_evening': 'Guten Abend,',
    'dashboard.todays_tasks': 'Heutige Aufgaben',
    'dashboard.completed': 'Abgeschlossen',
    'dashboard.overdue': 'Überfällig',
    'dashboard.in_progress': 'In Bearbeitung',
    'dashboard.upcoming': 'Bevorstehend',
    'dashboard.pending': 'Ausstehend',
    'machines.search_placeholder': 'Maschinen suchen...',
    'machines.favourites': 'Favoriten',
    'machines.all_machines': 'Alle Maschinen',
    'machines.operational': 'Betriebsbereit',
    'machines.needs_attention': 'Aufmerksamkeit erforderlich',
    'machines.fault': 'Fehler',
    'machines.unsafe_to_operate': 'Unsicher zu bedienen',
    'machines.registration': 'Kennzeichen',
    'machines.assigned_operator': 'Zugewiesener Bediener',
    'machines.engine_hours': 'Motorstunden',
    'machines.documents': 'Dokumente',
    'machines.log_fault': 'Fehler melden',
    'machines.operator_manual': 'Bedienungsanleitung',
    'machines.service_record': 'Serviceheft',
    'machines.insurance': 'Versicherungsnachweis',
    'machines.mot': 'HU-Bescheinigung',
    'daily_check.title': 'Tägliche Prüfung',
    'daily_check.start': 'Prüfung starten',
    'daily_check.required': 'Tägliche Prüfung erforderlich',
    'daily_check.required_msg': 'Muss vor dem Betrieb dieser Maschine abgeschlossen werden.',
    'daily_check.complete': 'Prüfung abgeschlossen',
    'daily_check.complete_msg': 'Abgeschlossen von',
    'daily_check.submit': 'Prüfung einreichen',
    'daily_check.items_remaining': 'Punkte verbleibend',
    'daily_check.reward_title': 'Danke!',
    'daily_check.reward_subtitle': 'Ihre tägliche Prüfung wurde aufgezeichnet.\nEhrliche Prüfungen schützen alle.',
    'daily_check.back_to_machine': 'Zurück zur Maschine',
    'daily_check.day_streak': 'Tage in Folge',
    'daily_check.completion_rate': 'Abschlussrate',
    'daily_check.cat_lights': 'Beleuchtung und Sicht',
    'daily_check.cat_fluids': 'Flüssigkeiten',
    'daily_check.cat_tyres': 'Reifen und Räder',
    'daily_check.cat_safety': 'Sicherheit',
    'daily_check.cat_controls': 'Steuerung',
    'daily_check.cat_body': 'Karosserie und Anbaugeräte',
    'daily_check.lights_working': 'Alle Lichter funktionieren',
    'daily_check.mirrors': 'Spiegel sauber und eingestellt',
    'daily_check.windscreen': 'Windschutzscheibe sauber und unbeschädigt',
    'daily_check.engine_oil': 'Motorölstand',
    'daily_check.coolant': 'Kühlmittelstand',
    'daily_check.hydraulic': 'Hydraulikflüssigkeitsstand',
    'daily_check.fuel': 'Kraftstoffstand ausreichend',
    'daily_check.tyre_pressure': 'Reifendruck korrekt',
    'daily_check.tyre_damage': 'Keine sichtbaren Reifenschäden',
    'daily_check.wheel_nuts': 'Radmuttern fest',
    'daily_check.fire_extinguisher': 'Feuerlöscher vorhanden',
    'daily_check.first_aid': 'Erste-Hilfe-Kit vorhanden',
    'daily_check.rops': 'ROPS-Struktur unbeschädigt',
    'daily_check.seatbelt': 'Sicherheitsgurt funktioniert',
    'daily_check.brakes': 'Bremsen funktionieren',
    'daily_check.steering': 'Lenkung reagiert',
    'daily_check.horn': 'Hupe funktioniert',
    'daily_check.body_damage': 'Keine sichtbaren Karosserieschäden',
    'daily_check.attachments': 'Anbaugeräte gesichert',
    'daily_check.pto_guard': 'Zapfwellenschutz vorhanden',
    'log_fault.title': 'Fehler melden',
    'log_fault.description': 'Beschreibung',
    'log_fault.description_placeholder': 'Fehler beschreiben...',
    'log_fault.photos': 'Fotos',
    'log_fault.add_photo': 'Foto hinzufügen',
    'log_fault.submit': 'Fehlerbericht einreichen',
    'log_fault.success': 'Fehler erfolgreich gemeldet',
    'emergency.title': 'Notfall',
    'emergency.what_emergency': 'Was ist der Notfall?',
    'emergency.select_type': 'Wählen Sie die Art des Notfalls.\nDie entsprechenden Kontakte werden sofort angerufen.',
    'emergency.vibrating': 'Vibration',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Medizinischer Notfall',
    'emergency.medical_sub': 'Verletzung, Krankheit oder bewusstlose Person vor Ort',
    'emergency.calls_999': 'Ruft sofort 112 an',
    'emergency.electrical': 'Elektrischer Notfall',
    'emergency.electrical_sub': 'Stromleitungskontakt — bleiben Sie in der Kabine',
    'emergency.calls_105': 'Ruft sofort 112 an',
    'emergency.no_signal': 'Notrufnummern auf dem Gerät gespeichert — ohne Signal verfügbar',
    'emergency.gps_auto': 'GPS-Position wird automatisch geteilt',
    'emergency.999_called': '112 angerufen',
    'emergency.105_called': 'Notfallleitung angerufen',
    'emergency.services_contacted': 'Rettungsdienste wurden kontaktiert.\nIhr Vorgesetzter wurde ebenfalls benachrichtigt.',
    'emergency.power_contacted': 'Elektrische Notfallleitung wurde kontaktiert.\nIhr Vorgesetzter wurde ebenfalls benachrichtigt.',
    'emergency.emergency_type': 'Notfalltyp',
    'emergency.number_called': 'Angerufene Nummer',
    'emergency.location': 'Standort',
    'emergency.admin_notified': 'Admin benachrichtigt',
    'emergency.stay_in_cab': 'Bleiben Sie in der Kabine',
    'emergency.stay_in_cab_msg': 'Verlassen Sie das Fahrzeug nicht. Warten Sie, bis die Behörde bestätigt, dass die Leitung sicher ist. Halten Sie die Fenster geschlossen.',
    'emergency.medical_type': 'Medizinisch',
    'emergency.electrical_type': 'Elektrisch',
    'crash.are_you_okay': 'Sind Sie in Sicherheit?',
    'crash.impact_detected': 'Ein möglicher Aufprall wurde erkannt.\nBitte antworten Sie, sonst wird Hilfe gerufen.',
    'crash.im_okay': 'Mir geht es gut',
    'crash.dismiss_alert': 'Alarm ignorieren — keine Aktion',
    'crash.i_need_help': 'Ich brauche Hilfe',
    'crash.notify_supervisor': 'Vorgesetzten mit GPS-Position benachrichtigen',
    'crash.call_999': '112 anrufen',
    'crash.call_emergency': 'Rettungsdienste sofort anrufen',
    'crash.glad_okay': 'Froh, dass es Ihnen gut geht',
    'crash.alert_dismissed': 'Alarm ignoriert. Keine Benachrichtigung gesendet.',
    'crash.help_on_way': 'Hilfe ist unterwegs',
    'crash.supervisor_notified': 'Ihr Vorgesetzter wurde mit Ihrer GPS-Position benachrichtigt.',
    'crash.auto_dialled': '112 automatisch gewählt',
    'crash.no_response': 'Keine Antwort. Rettungsdienste automatisch angerufen. Sprachnachricht wird übertragen.',
    'crash.broadcasting': 'Nachricht wird übertragen',
    'crash.repeating': 'Wiederholung alle 15 Sekunden',
    'crash.admin_notified': 'Admin benachrichtigt',
    'crash.emergency_services': 'Rettungsdienste',
    'profile.title': 'Profil',
    'profile.personal_info': 'Persönliche Daten',
    'profile.full_name': 'Vollständiger Name',
    'profile.email': 'E-Mail',
    'profile.phone': 'Telefon',
    'profile.role': 'Rolle',
    'profile.organisation': 'Organisation',
    'profile.emergency_contact': 'Notfallkontakt',
    'profile.emergency_contact_note': 'Ihr Vorgesetzter wird im Notfall kontaktiert',
    'profile.contact_name': 'Kontaktname',
    'profile.contact_phone': 'Kontakttelefon',
    'profile.notifications': 'Benachrichtigungen',
    'profile.task_reminders': 'Aufgabenerinnerungen',
    'profile.overdue_alerts': 'Überfälligkeitswarnungen',
    'profile.crash_detection': 'Aufprallerkennung',
    'profile.account_security': 'Konto und Sicherheit',
    'profile.change_password': 'Passwort ändern',
    'profile.two_factor': 'Zwei-Faktor-Authentifizierung',
    'profile.login_activity': 'Anmeldeaktivität',
    'profile.app_settings': 'App-Einstellungen',
    'profile.theme': 'Design',
    'profile.language': 'Sprache',
    'profile.sign_out': 'Abmelden',
    'profile.sign_out_confirm': 'Abmelden',
    'profile.sign_out_msg': 'Möchten Sie sich wirklich abmelden?',
    'profile.field_staff': 'Außendienstmitarbeiter',
    'theme.light': 'Hell',
    'theme.dark': 'Dunkel',
    'theme.system': 'Systemstandard',
  },

  'es': {
    'verify.err_reference_required': "Se requiere una referencia del documento.",
    'verify.err_rate_limited': "Demasiados intentos. Vuelva a intentarlo en breve.",
    'verify.err_not_found': "No se emitió ningún pasaporte con esa referencia.",
    'verify.err_code_mismatch': "El código de la organización y la referencia no coinciden.",
    'verify.err_unknown_section': "Sección desconocida.",
    'verify.err_read_failed': "No se pudo leer el registro.",
    'verify.intro': "Introduzca la referencia impresa en el documento para confirmar que lo emitió Agriware Operations. Para ver el historial completo de la máquina, añada el código de la organización emisora: ambos figuran en el pasaporte.",
    'verify.orgcode_optional': "— opcional, para el registro completo",
    'verify.title': "Verificar un pasaporte de máquina",
    'verify.reference_label': "Referencia del documento",
    'verify.orgcode_label': "Código de la organización",
    'verify.checking': "Comprobando…",
    'verify.submit': "Verificar",
    'verify.not_verified': "No verificado",
    'verify.withdrawn': "Retirado",
    'verify.genuine': "Documento auténtico",
    'verify.genuine_superseded': "Auténtico, pero sustituido",
    'verify.superseded_note': "Se ha emitido un pasaporte más reciente para esta máquina",
    'verify.fingerprint': "Huella del documento (SHA-256)",
    'verify.no_result': "Sin resultados.",
    'verify.err_not_verified': "No se ha podido verificar ese documento.",
    'verify.err_unreachable': "No se ha podido contactar con el servicio de verificación. Inténtelo de nuevo.",
    'verify.row_reference': "Referencia",
    'verify.row_issued_by': "Emitido por",
    'verify.row_issued_on': "Emitido el",
    'verify.not_recorded': "No registrado",
    'verify.row_make_model': "Marca y modelo",
    'verify.row_status': "Estado actual",
    'verify.blocked_from_use': "Bloqueada para su uso",
    'verify.in_service': "En servicio",
    'verify.no_open_defects': "No hay defectos abiertos registrados para esta máquina.",
    'verify.defect_history': "Historial de defectos",
    'verify.no_resolved_defects': "No hay defectos resueltos registrados para esta máquina.",
    'verify.inspection_record': "Registro de inspecciones",
    'verify.check_log': "Registro de comprobaciones",
    'verify.no_checks': "No hay comprobaciones registradas para esta máquina.",
    'verify.service_history': "Historial de mantenimiento",
    'verify.no_services': "No hay registros de mantenimiento para esta máquina.",
    'verify.checks_recorded': "Comprobaciones registradas",
    'verify.pass_rate': "Tasa de aptos",
    'verify.defects_raised': "Defectos notificados",
    'verify.most_recent_check': "Última comprobación",
    'verify.show_more': "Mostrar más",
    'verify.showing_of': "Mostrando {shown} de {total}",
    'verify.details': "Detalles",
    'verify.hide': "Ocultar",
    'verify.all_passed': "Todos aptos",
    'verify.n_failed': "{n} no aptos",
    'verify.blocked_the_machine': "bloqueó la máquina",
    'verify.blocking': "Bloqueante",
    'verify.raised': "Notificado",
    'verify.resolved': "Resuelto",
    'verify.revised_after_issue': "revisado tras la emisión",
    'verify.next_service': "Próximo mantenimiento",
    'verify.parts': "Piezas",
    'verify.external': "externo",
    'verify.sealed': "sellado",
    'verify.language': "Idioma",
    'emergency.tel_number': "112",
    'emergency.no_movement': "No se detecta movimiento",
    'emergency.triggered_generic': "Emergencia activada",
    'emergency.community_badge': "Alerta comunitaria: emergencia cercana",
    'emergency.panel_responders': "Personas que responden",
    'emergency.machine_involved': "Máquina implicada",
    'emergency.impact_label': "Impacto",
    'emergency.ago': "atrás",
    'emergency.location_unavailable': "Ubicación no disponible",
    'emergency.open_in_maps': "Abrir en Google Maps",
    'emergency.im_responding': "Voy a responder",
    'emergency.confirming': "Confirmando…",
    'emergency.mark_resolved': "Marcar como resuelto",
    'emergency.resolving': "Resolviendo…",
    'emergency.called_automatically_at': "Se ha llamado al 112 automáticamente a las {time}",
    'emergency.state_alert': "ALERTA DE EMERGENCIA",
    'emergency.state_awaiting': "ESPERANDO RESPUESTA",
    'emergency.state_needs_help': "EL OPERARIO NECESITA AYUDA",
    'emergency.state_no_response': "SIN RESPUESTA DEL OPERARIO",
    'emergency.seconds_to_respond': "{n} s para que el operario responda",
    'billing.over_limit_row': "Por encima de las máquinas incluidas en su plan",
    'billing.over_limit_full': "Esta máquina supera las incluidas en su plan. Añádala a su suscripción para ver su historial.",
    'nav.reports': "Informes",
    'site.not_found': "Emplazamiento no encontrado",
    'site.details': "Detalles del emplazamiento",
    'site.edit': "Editar emplazamiento",
    'site.updated': "Emplazamiento actualizado",
    'site.err_update': "No se ha podido actualizar el emplazamiento",
    'site.no_address': "No hay dirección registrada",
    'site.no_machines': "No hay máquinas en este emplazamiento",
    'site.no_staff': "No hay nadie asignado a este emplazamiento",
    'site.no_defects': "No hay defectos abiertos en este emplazamiento",
    'checks.new_template': "Nueva plantilla",
    'set.language': "Idioma",
    'set.language_hint': "Se aplica a toda su organización",
    'set.your_organisation': "Su organización",
    'set.group_organisation': "Organización",
    'set.group_safety': "Seguridad y cumplimiento",
    'set.group_system': "Sistema",
    'set.reports': "Informes",
    'set.org_details': "Datos de la organización",
    'set.org_details_hint': "Nombre, dirección, número de empresa, identidad visual",
    'set.sites_hint': "Patios, depósitos y dónde se guardan las máquinas",
    'set.roles': "Roles y permisos",
    'set.roles_hint': "Qué puede ver y hacer cada rol",
    'set.billing_hint': "Suscripción y método de pago",
    'set.coshh_hint': "Sustancias almacenadas y sus evaluaciones",
    'set.risk_hint': "Evaluaciones y revisiones",
    'set.reports_hint': "Estado de la flota, cumplimiento, carbono, costes y expedientes de seguro",
    'set.integrations': "Integraciones",
    'set.integrations_hint': "Telemática, sistemas de concesionario y Almanac",
    'set.notifications_hint': "Qué se envía y a quién",
    'set.audit_log': "Registro de auditoría",
    'set.audit_log_hint': "Quién cambió qué y cuándo",
    'set.data': "Datos",
    'set.data_hint': "Exportación y conservación",
    'set.data_retention': "Datos y conservación",
    'set.export_title': "Exportar sus datos",
    'set.export_desc': "Exporte una copia completa de los datos de su organización, incluidos registros de máquinas, historial de mantenimiento, comprobaciones, fichas de personal y cualificaciones.",
    'set.export_coming_soon': "Exportación de datos disponible próximamente",
    'set.export_btn': "Exportar todos los datos",
    'set.retention_title': "Conservación de datos",
    'set.retention_desc': "Sus datos se conservan durante la vigencia de su suscripción más 12 meses tras la cancelación. Los registros de mantenimiento y los partes de trabajo sellados se conservan indefinidamente, ya que pueden ser necesarios por motivos legales y de seguro.",
    'set.danger_zone': "Zona de peligro",
    'set.danger_desc': "Eliminar su organización borrará permanentemente todos los datos, salvo los registros de máquina sellados que son necesarios para el cumplimiento. Esta acción no se puede deshacer.",
    'set.delete_org': "Eliminar organización",
    'set.delete_org_toast': "Póngase en contacto con soporte para eliminar su organización",
    'set.audit_log_subtitle': "Registro completo de todas las acciones en su organización",
    'set.audit_search': "Buscar en el registro de auditoría…",
    'set.col_action': "Acción",
    'set.no_audit': "No hay entradas de auditoría",
    'set.audit_empty_msg': "Las acciones aparecerán aquí a medida que ocurran",
    'set.notif_title': "Ajustes de notificaciones",
    'set.notif_desc': "Controle qué eventos generan notificaciones push para responsables y administradores de su organización.",
    'set.notif_saved': "Preferencias de notificación guardadas",
    'set.save_preferences': "Guardar preferencias",
    'set.notif_check_failed': "Comprobación no apta",
    'set.notif_check_failed_desc': "Cuando un operario envía una comprobación no apta",
    'set.notif_machine_blocked': "Máquina bloqueada",
    'set.notif_machine_blocked_desc': "Cuando una máquina se bloquea automáticamente tras un fallo",
    'set.notif_defect': "Defecto notificado",
    'set.notif_defect_desc': "Cuando un operario notifica un defecto",
    'set.notif_near_miss': "Cuasi accidente notificado",
    'set.notif_near_miss_desc': "Cuando se envía un cuasi accidente",
    'set.notif_qual_expiring': "Cualificación por caducar (30 d)",
    'set.notif_qual_expiring_desc': "Cuando una cualificación caduca en 30 días",
    'set.notif_qual_expired': "Cualificación caducada",
    'set.notif_qual_expired_desc': "Cuando una cualificación ha caducado",
    'set.notif_service_due': "Mantenimiento pendiente",
    'set.notif_service_due_desc': "Cuando una máquina se acerca a su intervalo de mantenimiento",
    'set.notif_fuel_low': "Depósito de combustible bajo",
    'set.notif_fuel_low_desc': "Cuando un depósito de gasóleo baja del umbral",
    'set.notif_emergency': "Alerta de emergencia",
    'set.notif_emergency_desc': "Siempre activo: no se puede desactivar",
    'set.notif_announcement': "Avisos",
    'set.notif_announcement_desc': "Cuando la dirección envía un aviso",
    'set.no_sites_msg': "Añada su primera explotación o emplazamiento",
    'set.err_site_name': "El nombre del emplazamiento es obligatorio",
    'set.site_added': "Emplazamiento añadido",
    'set.err_site_add': "No se ha podido añadir el emplazamiento",
    'set.site_name': "Nombre del emplazamiento",
    'set.site_name_placeholder': "p. ej. Finca principal",
    'set.address': "Dirección",
    'set.address_placeholder': "p. ej. Finca principal, Camino del Campo, 28000",
    'set.roles_title': "Roles y permisos",
    'set.role_admin_full': "Acceso total a todos los emplazamientos, máquinas, personal, ajustes y facturación. Puede enviar avisos y gestionar todos los datos.",
    'set.role_manager_full': "Acceso limitado al emplazamiento. Gestiona máquinas y personal de su emplazamiento. No accede a facturación ni a ajustes de la organización.",
    'set.role_operator_full': "Solo acceso desde la app móvil. Realiza las comprobaciones diarias, registra repostajes y puede notificar defectos y cuasi accidentes.",
    'set.perm_all_machines': "Todas las máquinas de todos los emplazamientos",
    'set.perm_all_staff': "Gestión de todo el personal",
    'set.perm_all_settings': "Todos los ajustes",
    'set.perm_announcements': "Enviar avisos",
    'set.perm_emergencies': "Resolver emergencias",
    'set.perm_site_machines': "Máquinas de su emplazamiento",
    'set.perm_site_staff': "Personal de su emplazamiento",
    'set.perm_checks_defects': "Comprobaciones y defectos",
    'set.perm_shifts': "Gestión de turnos",
    'set.perm_daily_checks_app': "Comprobaciones diarias (app)",
    'set.perm_fuel_fills_app': "Repostajes (app)",
    'set.perm_defect_app': "Notificación de defectos (app)",
    'set.perm_near_miss_app': "Notificación de cuasi accidentes (app)",
    'set.perm_own_quals': "Ver las propias cualificaciones",
    'set.perm_sos': "SOS de emergencia",
    'set.org_settings': "Ajustes de la organización",
    'set.identity': "Identidad",
    'set.org_name': "Nombre de la organización",
    'set.trading_name': "Nombre comercial",
    'set.if_different': "Si es diferente",
    'set.company_number': "Número de empresa",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "Número de IVA",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Tipo de actividad",
    'set.ind_farm': "Explotación agrícola",
    'set.ind_estate': "Finca",
    'set.ind_contractor': "Contratista agrícola",
    'set.ind_dealership': "Concesionario",
    'set.ind_other': "Otro",
    'set.primary_email': "Correo principal",
    'set.phone_number': "Número de teléfono",
    'set.website': "Sitio web",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Dirección línea 1",
    'set.address2': "Dirección línea 2",
    'set.town': "Población / Ciudad",
    'set.county': "Provincia",
    'set.postcode': "Código postal",
    'set.branding': "Identidad visual",
    'set.brand_colour': "Color de marca",
    'set.compliance': "Cumplimiento",
    'set.hse_number': "Número de registro HSE",
    'set.insurance_provider': "Compañía de seguros",
    'set.policy_number': "Número de póliza",
    'set.insurance_expiry': "Vencimiento del seguro",
    'set.sharing_transfers': "Uso compartido y transferencias",
    'set.org_code_desc': "Su código de organización sirve para recibir máquinas compartidas y transferencias de otros clientes de Agriware. Compártalo con quienes cotitulen maquinaria con usted o le vendan una máquina.",
    'set.emails': "Correos electrónicos",
    'set.hold_the_yard': "Correo semanal Hold the Yard",
    'set.hold_the_yard_desc': "Un resumen cada lunes de las revisiones previas al uso de la semana anterior, enviado a los administradores y responsables de la organización.",
    'set.org_code': "Código de organización",
    'set.generating': "Generando…",
    'set.copied': "¡Copiado!",
    'set.copy': "Copiar",
    'set.org_saved': "Ajustes de la organización guardados",
    'set.err_save': "No se han podido guardar los ajustes",
    'set.save_changes': "Guardar cambios",
    'set.status_trialing': "En prueba",
    'set.status_past_due': "Pago vencido",
    'set.status_cancelled': "Cancelado",
    'set.status_unpaid': "Impagado",
    'set.status_incomplete': "Incompleto",
    'set.billing_title': "Facturación y suscripción",
    'set.billing_subtitle': "Gestione su suscripción a Agriware Operations.",
    'set.plan_standard': "Estándar",
    'set.per_month': "/mes · cancele cuando quiera",
    'set.grandfathered': "Esta organización tiene acceso heredado. Los datos de facturación no están disponibles porque esta cuenta es anterior a la integración con Stripe.",
    'set.next_billing': "Próxima fecha de facturación:",
    'set.feat_registry': "Registro de máquinas e historial de mantenimiento",
    'set.feat_checks': "Comprobaciones diarias e inspecciones",
    'set.feat_defects': "Seguimiento de averías y defectos",
    'set.feat_staff': "Cualificaciones y turnos del personal",
    'set.feat_reporting': "Conjunto de informes",
    'set.feat_unlimited': "Emplazamientos y operarios ilimitados",
    'set.err_no_portal': "No se ha devuelto ninguna URL del portal.",
    'set.err_portal': "No se ha podido abrir el portal de facturación. Inténtelo de nuevo o contacte con soporte.",
    'set.opening_portal': "Abriendo el portal de facturación…",
    'set.manage_billing': "Gestionar facturación",
    'set.admin_only_billing': "Solo los administradores de la organización pueden gestionar la facturación.",
    'set.stripe_note': "La facturación se procesa de forma segura mediante Stripe. Nunca vemos los datos de su tarjeta.",
    'int.abax_desc': "Obtenga horas de motor, ubicación y uso directamente de los localizadores ABAX, para que las horas lleguen solas en lugar de teclearlas.",
    'int.abax_detail': "Las horas automáticas mantendrían exactos los intervalos de mantenimiento, las estimaciones de carbono y el cumplimiento de comprobaciones sin introducir lecturas.",
    'int.dms_desc': "Conéctese al DMS de su concesionario para crear solicitudes de trabajo, aprobar presupuestos y recibir partes sellados en la máquina correcta.",
    'int.dms_detail': "El trabajo realizado por su concesionario se añade automáticamente al registro de la máquina y aparece en su pasaporte.",
    'int.almanac_desc': "Vea cómo se comparan sus máquinas con los mismos modelos en todas las flotas de Agriware: puntos de fallo típicos, intervalos de mantenimiento y fiabilidad por modelo.",
    'int.almanac_detail': "Almanac agrupa datos anonimizados de defectos y mantenimiento de varias organizaciones. Sus datos contribuyen y, a cambio, usted ve el agregado.",
    'int.consent_shared': "Se comparte: marca y modelo de la máquina, tipos de defecto, horas en el fallo, intervalos de mantenimiento",
    'int.consent_never': "Nunca se comparte: el nombre de su organización, emplazamientos, personal, operarios, costes o documentos",
    'int.consent_threshold': "Las cifras solo se muestran cuando hay suficientes máquinas para que las flotas individuales no sean identificables",
    'int.consent_withdraw': "Puede retirarse en cualquier momento: los registros aportados se eliminan de los agregados futuros",
    'int.err_update': "No se ha podido actualizar esta integración",
    'int.interest_noted': "Anotado: le avisaremos cuando esté listo",
    'int.almanac_enabled': "Almanac activado",
    'int.almanac_disabled': "Almanac desactivado",
    'int.subtitle': "Conecte Agriware Operations con los sistemas que ya utiliza",
    'int.admin_only': "Solo un administrador de la organización puede cambiar las integraciones.",
    'int.enabled': "Activado",
    'int.in_development': "En desarrollo",
    'int.withdraw': "Retirarse",
    'int.enable_almanac': "Activar Almanac",
    'int.interest_registered': "Interés registrado",
    'int.register_interest': "Registrar interés",
    'int.less': "Menos",
    'int.what_this_does': "Qué hace esto",
    'int.footer': "¿Usa algo que no aparece aquí? Díganos qué le gustaría conectar: lo que piden los usuarios decide qué se desarrolla a continuación.",
    'tmpl.scope_all_desc': "Se aplica a todas las máquinas de la organización",
    'tmpl.scope_category': "Por categoría",
    'tmpl.scope_category_desc': "Se aplica a las categorías seleccionadas",
    'tmpl.scope_specific_desc': "Se aplica a una sola máquina",
    'tmpl.freq_daily': "Diario",
    'tmpl.freq_daily_helper': "Debe completarse cada día antes de la hora límite",
    'tmpl.freq_weekly': "Semanal",
    'tmpl.freq_weekly_helper': "Debe completarse una vez por semana",
    'tmpl.freq_hourly': "Por horas",
    'tmpl.freq_hourly_helper': "Se activa cada X horas de motor",
    'tmpl.freq_monthly': "Mensual",
    'tmpl.freq_monthly_helper': "Debe completarse una vez al mes",
    'tmpl.item_passfail': "Apto / No apto",
    'tmpl.item_numeric': "Numérico",
    'tmpl.item_text': "Texto",
    'tmpl.item_photo': "Foto",
    'tmpl.item_signature': "Firma",
    'tmpl.fail_none': "Solo registrar",
    'tmpl.fail_flag': "Registrar y notificar",
    'tmpl.fail_block': "Registrar, notificar y bloquear",
    'tmpl.section_default': "Sección",
    'tmpl.err_name': "El nombre de la plantilla es obligatorio",
    'tmpl.err_category': "Seleccione al menos una categoría",
    'tmpl.err_machine': "Seleccione una máquina",
    'tmpl.err_items': "Añada al menos un elemento de comprobación",
    'tmpl.updated': "Plantilla actualizada",
    'tmpl.created': "Plantilla creada",
    'tmpl.err_save': "No se ha podido guardar la plantilla",
    'tmpl.name_placeholder': "Nombre de la plantilla",
    'tmpl.save': "Guardar plantilla",
    'tmpl.settings': "Ajustes de la plantilla",
    'tmpl.description_placeholder': "Breve descripción de cuándo se usa esta plantilla",
    'tmpl.applies_to': "Se aplica a",
    'tmpl.select_categories_caps': "SELECCIONAR CATEGORÍAS",
    'tmpl.select_machine_caps': "SELECCIONAR MÁQUINA",
    'tmpl.choose_machine': "Elija una máquina…",
    'tmpl.frequency': "Frecuencia de comprobación",
    'tmpl.estimated_time': "Tiempo estimado (minutos)",
    'tmpl.every_x_hours': "Cada X horas de motor",
    'tmpl.due_by_time': "Hora límite",
    'tmpl.due_by_hint': "— el aviso de retraso se envía a esta hora",
    'tmpl.due_by_note': "Se envía una notificación push al operario y al responsable del emplazamiento si no se completa a esta hora",
    'tmpl.item_one': "elemento",
    'tmpl.item_many': "elementos",
    'tmpl.new_item': "Nuevo elemento de comprobación",
    'tmpl.add_item': "Añadir elemento de comprobación",
    'tmpl.add_section': "Añadir sección",
    'tmpl.item_panel_title': "Elemento de comprobación",
    'tmpl.select_item_hint': "Seleccione un elemento de comprobación a la izquierda para editar sus ajustes aquí.",
    'tmpl.label': "Etiqueta",
    'tmpl.label_placeholder': "p. ej. nivel de aceite del motor",
    'tmpl.if_fails': "Si no es apto",
    'tmpl.required': "Obligatorio",
    'tmpl.required_hint': "El operario debe completar este elemento",
    'status.active': "Activo",
    'status.shared': "Compartida",
    'status.transferred': "Transferida",
    'status.archived': "Archivada",
    'status.issues': "Incidencias",
    'status.emergency': "Emergencia",
    'status.closed': "Cerrado",
    'status.due': "Pendiente",
    'status.draft': "Borrador",
    'status.approved': "Aprobado",
    'status.declined': "Rechazado",
    'status.scheduled': "Programado",
    'photo.title': "Foto de perfil",
    'photo.upload_title': "Subir una foto",
    'photo.upload_note': "JPG, PNG o WebP · máx. 5 MB · se recortará en círculo",
    'photo.choose': "Elegir foto",
    'photo.drag_hint': "Arrastre para reposicionar · desplace o use el control para hacer zoom",
    'photo.change': "Cambiar foto",
    'photo.save': "Guardar foto",
    'upsell.derv_title': "Gestión de combustible",
    'upsell.derv_desc': "Controle los niveles del depósito, registre repostajes, gestione proveedores y supervise el consumo por máquina en todos los emplazamientos.",
    'upsell.coshh_title': "Registro de sustancias peligrosas",
    'upsell.coshh_desc': "Mantenga un registro digital de sustancias peligrosas, fichas de datos de seguridad y los EPI necesarios para su plantilla.",
    'upsell.risk_title': "Evaluaciones de riesgos",
    'upsell.risk_desc': "Cree, gestione y selle evaluaciones de riesgos por máquina o tarea. Los operarios las confirman antes de empezar.",
    'upsell.jobs_title': "Integración con DMS",
    'upsell.jobs_desc': "Solicite trabajos de taller a su concesionario, apruebe presupuestos y reciba partes de trabajo sellados en las fichas de sus máquinas.",
    'upsell.reporting_title': "Informes y análisis",
    'upsell.reporting_desc': "Informes de estado de la flota, cumplimiento, cualificaciones, consumo, emisiones de CO₂ y coste por máquina.",
    'upsell.quals_title': "Seguimiento de cualificaciones",
    'upsell.quals_desc': "Registre los carnés y certificados del personal con control de caducidades, notificaciones push y bloqueo de máquinas según cualificación.",
    'upsell.sharing_title': "Uso compartido de máquinas",
    'upsell.sharing_desc': "Comparta los registros de máquinas con otras organizaciones de Agriware Ops: ideal para contratistas y equipos compartidos.",
    'upsell.transfers_title': "Transferencias de máquinas",
    'upsell.transfers_desc': "Transfiera máquinas entre usuarios de Ops o cuentas DMS con historial de propiedad completo y libro digital.",
    'upsell.carbon_title': "Informes de carbono",
    'upsell.carbon_desc': "Cálculo automático de emisiones de CO₂ según el consumo de combustible. Informes con el estándar DEFRA para su flota.",
    'upsell.not_included': "Esta función no está incluida en su plan actual.",
    'upsell.upgrade': "Mejorar su plan",
    'service.record_not_found': "Registro no encontrado",
    'service.record_title_service': "Registro de mantenimiento",
    'service.record_title_repair': "Registro de reparación",
    'service.record_title_inspection': "Registro de inspección",
    'service.record_suffix': "registro",
    'service.email_btn': "Correo",
    'service.email_coming_soon': "Exportación por correo disponible próximamente",
    'service.sealed_by_workshop': "Sellado por {name} y no se puede modificar",
    'service.the_workshop': "el taller",
    'service.sealed_permanent': "Este registro está sellado de forma permanente y no se puede modificar",
    'service.sealed_by': "Sellado por",
    'service.at_suffix': "en {name}",
    'service.job_ref': "orden {ref}",
    'service.photos_video': "Fotos y vídeo",
    'service.job_photo': "Foto del trabajo",
    'service.files_copying': "Todavía se están copiando algunos archivos.",
    'service.date_of_service': "Fecha del mantenimiento",
    'service.hours_at_service': "Horas en el mantenimiento",
    'service.total_cost': "Coste total",
    'service.record_details': "Detalles del registro",
    'service.type': "Tipo",
    'service.performed_by': "Realizado por",
    'service.performed_by_type': "Tipo de ejecutor",
    'service.next_service_hours': "Horas hasta el próximo mantenimiento",
    'service.next_service_date': "Fecha del próximo mantenimiento",
    'service.notes': "Notas",
    'service.parts_used': "Piezas utilizadas",
    'service.col_part': "Pieza",
    'service.col_qty': "Cant.",
    'service.col_cost': "Coste",
    'service.parts_total': "Total piezas",
    'service.cost_breakdown': "Desglose de costes",
    'service.labour_cost': "Coste de mano de obra",
    'service.parts_cost': "Coste de piezas",
    'service.total': "Total",
    'service.audit_trail': "Registro de auditoría",
    'service.record_created_by': "Registro creado por",
    'service.record_sealed_by': "Registro sellado por",
    'service.type_service': "Mantenimiento",
    'service.type_service_desc': "Mantenimiento programado de rutina",
    'service.type_repair': "Reparación",
    'service.type_repair_desc': "Trabajo de reparación no programado",
    'service.type_inspection': "Inspección",
    'service.type_inspection_desc': "Comprobación de seguridad o cumplimiento",
    'service.by_internal': "Interno",
    'service.by_dealer': "Concesionario",
    'service.by_external': "Contratista externo",
    'service.err_description': "Introduzca una descripción",
    'service.err_date': "Introduzca la fecha del mantenimiento",
    'service.added_toast': "Registro de mantenimiento añadido y sellado",
    'service.err_save': "No se ha podido guardar el registro: inténtelo de nuevo",
    'service.seal_note': "Este registro quedará sellado de forma permanente al guardarlo",
    'service.record_type': "Tipo de registro",
    'service.description_placeholder': "Describa el trabajo realizado…",
    'service.performed_by_placeholder': "Nombre o empresa",
    'service.additional_notes': "Notas adicionales",
    'service.notes_placeholder': "Cualquier nota adicional…",
    'service.add_part': "Añadir pieza",
    'service.part_name': "Nombre de la pieza",
    'service.cost_placeholder': "Coste £",
    'service.cost_next_service': "Coste y próximo mantenimiento",
    'service.labour_cost_field': "Coste de mano de obra (£)",
    'service.next_hours_placeholder': "p. ej. 1750",
    'service.seal_warning': "Una vez guardado, este registro queda sellado de forma permanente y no se puede editar. Compruebe que todos los datos son correctos antes de guardar.",
    'service.save_seal': "Guardar y sellar registro",
    'dashboard.there': "hola",
    'dashboard.total_machines': "Máquinas totales",
    'dashboard.blocked_machines': "Máquinas bloqueadas",
    'dashboard.open_incidents': "Incidentes abiertos",
    'dashboard.open_defects': "Defectos abiertos",
    'dashboard.fuel_tanks': "Depósitos de combustible",
    'common.of': "de",
    'dashboard.fleet': "Flota",
    'common.view_all': "Ver todo",
    'dashboard.no_machines': "Aún no hay máquinas",
    'dashboard.no_machines_msg': "Añada su primera máquina para empezar",
    'dashboard.recent_incidents': "Incidentes recientes",
    'dashboard.no_incidents_msg': "No hay incidentes registrados",
    'dashboard.recent_defects': "Defectos recientes",
    'dashboard.no_defects': "Sin defectos",
    'dashboard.no_defects_msg': "No se han notificado defectos",
    'dashboard.defect_reported': "Defecto notificado",
    'dashboard.group_overview': "Visión del grupo",
    'dashboard.send_announcement': "Enviar aviso",
    'dashboard.sites': "Emplazamientos",
    'dashboard.no_sites': "Aún no hay emplazamientos",
    'dashboard.no_sites_msg': "Añada su primer emplazamiento en Ajustes para empezar",
    'dashboard.add_site': "Añadir emplazamiento",
    'dashboard.status_monitor': "Vigilar",
    'dashboard.status_all_good': "Todo correcto",
    'dashboard.derv': "Gasóleo",
    'dashboard.derv_level': "Nivel de gasóleo",
    'qual.short_forklift': "Carretilla",
    'qual.short_sprayer': "Pulverizador",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Conducción",
    'qual.short_firstaid': "Primeros auxilios",
    'qual.short_chainsaw': "Motosierra",
    'qual.short_pesticide': "Fitosanitarios",
    'qual.short_telehandler': "Telescópica",
    'qual.short_atv': "Quad",
    'qual.short_other': "Otro",
    'qual.forklift': "Licencia de carretillero",
    'qual.sprayer': "Certificado de pulverizador PA1/PA6",
    'qual.cscs': "Tarjeta CSCS",
    'qual.driving': "Permiso de conducir",
    'qual.firstaid': "Certificado de primeros auxilios",
    'qual.chainsaw': "Certificado de motosierra",
    'qual.pesticide': "Aplicación de fitosanitarios",
    'qual.telehandler': "Certificado de telescópica",
    'qual.atv': "Certificado de quad/ATV",
    'qual.other': "Otra cualificación",
    'staff.n_expired': "caducadas",
    'staff.n_expiring': "por caducar",
    'staff.n_valid': "válidas",
    'common.none': "Ninguna",
    'staff.tab_members': "Miembros",
    'staff.tab_qualifications': "Cualificaciones",
    'staff.tab_shifts': "Turnos",
    'staff.member_one': "miembro",
    'staff.member_many': "miembros",
    'staff.alert_one': "alerta de cualificación",
    'staff.alert_many': "alertas de cualificación",
    'staff.invite': "Invitar personal",
    'staff.create_shift': "Crear turno",
    'staff.search': "Buscar por nombre o correo…",
    'staff.none_found': "No se ha encontrado personal",
    'staff.adjust_search': "Pruebe a ajustar la búsqueda",
    'staff.invite_first': "Invite a su primer miembro del equipo",
    'staff.stat_total_quals': "Cualificaciones totales",
    'staff.stat_valid': "Válidas",
    'staff.stat_expiring_30d': "Por caducar (30 d)",
    'staff.stat_expiring': "Por caducar",
    'staff.stat_expired': "Caducadas",
    'staff.qual_one': "cualificación",
    'staff.qual_many': "cualificaciones",
    'staff.expires': "Caduca el",
    'staff.no_quals': "No hay cualificaciones registradas",
    'staff.no_quals_msg': "Añada cualificaciones desde la ficha de cada empleado",
    'staff.no_shifts': "Aún no hay turnos",
    'staff.no_shifts_msg': "Cree su primer turno para saber quién está trabajando",
    'staff.shift': "Turno",
    'staff.checked_in': "fichados",
    'staff.not_found': "Miembro del personal no encontrado",
    'staff.add_qualification': "Añadir cualificación",
    'staff.expired_alert_one': "cualificación ha caducado: puede que este operario no esté autorizado para usar ciertas máquinas",
    'staff.expired_alert_many': "cualificaciones han caducado: puede que este operario no esté autorizado para usar ciertas máquinas",
    'staff.expiring_alert_one': "cualificación caduca en 30 días",
    'staff.expiring_alert_many': "cualificaciones caducan en 30 días",
    'staff.tab_details': "Detalles",
    'staff.contact': "Contacto",
    'staff.account': "Cuenta",
    'staff.onboarding': "Incorporación",
    'staff.complete': "Completada",
    'staff.job_title': "Puesto",
    'staff.joined': "Alta el",
    'staff.invited_by': "Invitado por",
    'staff.quals_tickets': "Cualificaciones y carnés",
    'staff.no_quals_profile_msg': "Añada los carnés y certificados de este operario",
    'staff.issued': "Expedido",
    'staff.no_expiry': "Sin caducidad",
    'staff.expires_today': "Caduca hoy",
    'staff.days_remaining_one': "día restante",
    'staff.days_remaining_many': "días restantes",
    'staff.expired_days_ago_one': "Caducado hace {n} día",
    'staff.expired_days_ago_many': "Caducado hace {n} días",
    'staff.view_certificate': "Ver certificado",
    'staff.assigned_machines': "Máquinas asignadas",
    'staff.no_machines': "Ninguna máquina asignada",
    'staff.no_machines_msg': "Este operario no tiene máquinas asignadas",
    'staff.err_first_name': "El nombre es obligatorio",
    'staff.err_last_name': "El apellido es obligatorio",
    'staff.err_email': "Introduzca una dirección de correo válida",
    'staff.err_site': "Seleccione un emplazamiento",
    'staff.err_create_prefix': "No se ha podido crear la cuenta:",
    'staff.err_timeout': "Se ha agotado el tiempo de espera al crear la cuenta. Actualice la página e inténtelo de nuevo.",
    'staff.err_create': "No se ha podido crear la cuenta: inténtelo de nuevo",
    'staff.copy_greeting': "Hola {name}:",
    'staff.copy_body': "Se ha creado su cuenta de Agriware Operations.",
    'staff.copy_email': "Correo electrónico:",
    'staff.copy_temp_password': "Contraseña temporal:",
    'staff.copy_footer': "Se le pedirá que cambie la contraseña en el primer inicio de sesión.",
    'staff.copied_toast': "Datos de acceso copiados al portapapeles",
    'staff.role_admin_desc': "Acceso total a todos los emplazamientos y ajustes",
    'staff.role_manager_desc': "Gestiona un emplazamiento, el personal y las máquinas",
    'staff.role_operator_desc': "Realiza las comprobaciones diarias desde la app móvil",
    'staff.add_member': "Añadir miembro del personal",
    'staff.add_member_sub': "La cuenta se creará al instante. Verá los datos de acceso para compartirlos.",
    'staff.account_created': "Cuenta creada",
    'staff.share_details_pre': "Comparta estos datos de acceso con",
    'staff.share_details_post': "Se le pedirá que cambie la contraseña en el primer inicio de sesión.",
    'staff.label_email_caps': "CORREO ELECTRÓNICO",
    'staff.label_temp_password_caps': "CONTRASEÑA TEMPORAL",
    'staff.copy_login_details': "Copiar datos de acceso",
    'staff.add_another': "Añadir otro",
    'staff.back_to_staff': "Volver a personal",
    'staff.personal_details': "Datos personales",
    'staff.first_name': "Nombre",
    'staff.last_name': "Apellidos",
    'staff.work_email': "Correo de trabajo",
    'staff.site_assignment': "Asignación de emplazamiento",
    'staff.no_sites': "Aún no hay emplazamientos: añada uno primero en Ajustes",
    'staff.creating_account': "Creando cuenta…",
    'staff.create_account': "Crear cuenta",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Seleccione un tipo de cualificación",
    'qual.err_name': "Introduzca el nombre de la cualificación",
    'qual.err_issue_date': "Introduzca la fecha de expedición",
    'qual.err_expiry': "Introduzca la fecha de caducidad o marque «sin caducidad»",
    'qual.added_toast': "Cualificación añadida",
    'qual.err_save': "No se ha podido guardar la cualificación: inténtelo de nuevo",
    'qual.back_staff_profile': "Ficha del empleado",
    'qual.subtitle': "Registre un carné, certificado o licencia de este operario",
    'qual.type_title': "Tipo de cualificación",
    'qual.name_label': "Nombre de la cualificación",
    'qual.name_placeholder': "p. ej. certificado de desbrozadora NPTC",
    'qual.cert_details': "Datos del certificado",
    'qual.cert_number': "Número de certificado",
    'common.optional_suffix': "— opcional",
    'qual.cert_number_placeholder': "p. ej. NPORS-123456",
    'qual.issuing_body': "Organismo emisor",
    'qual.issuing_body_placeholder': "p. ej. NPORS, LANTRA, CITB",
    'qual.issue_date': "Fecha de expedición",
    'qual.expiry_date': "Fecha de caducidad",
    'qual.no_expiry_label': "Esta cualificación no tiene fecha de caducidad",
    'qual.cert_document': "Documento del certificado",
    'qual.upload_note': "Suba una foto o un escaneo del certificado. Se almacena de forma privada y nunca se comparte.",
    'common.remove': "Quitar",
    'qual.click_upload': "Haga clic para subir el certificado",
    'qual.file_types': "JPG, PNG o PDF",
    'common.saving': "Guardando…",
    'qual.save': "Guardar cualificación",
    'defects.title': "Defectos",
    'defects.n_open': "abiertos",
    'defects.n_critical': "críticos",
    'defects.stat_total': "Defectos totales",
    'defects.status_open': "Abierto",
    'defects.status_in_progress': "En curso",
    'defects.status_resolved': "Resuelto",
    'defects.all_severities': "Todas las gravedades",
    'defects.sev_minor': "Leve",
    'defects.sev_moderate': "Moderado",
    'defects.sev_major': "Grave",
    'defects.sev_critical': "Crítico",
    'defects.search': "Buscar defectos…",
    'common.clear': "Borrar",
    'defects.col_description': "Descripción",
    'defects.reported_by': "Notificado por",
    'defects.col_severity': "Gravedad",
    'defects.no_description': "Sin descripción",
    'defects.none_found': "No se han encontrado defectos",
    'defects.none_reported': "No se ha notificado ningún defecto",
    'defects.acknowledged_toast': "Defecto aceptado",
    'defects.acknowledge_failed': "No se ha podido aceptar el defecto",
    'defects.resolved_released': "Defecto resuelto: máquina liberada",
    'defects.resolved_toast': "Defecto resuelto",
    'defects.resolve_failed': "No se ha podido resolver el defecto",
    'defects.not_found': "Defecto no encontrado",
    'defects.report_title': "Informe de defecto",
    'defects.acknowledge': "Aceptar",
    'defects.raise_job': "Crear orden de trabajo",
    'defects.resolve': "Resolver",
    'defects.blocking_banner': "Máquina bloqueada: un responsable debe registrar una liberación por escrito antes de volver al servicio",
    'defects.details_title': "Detalles del defecto",
    'defects.no_description_provided': "No se ha facilitado ninguna descripción",
    'defects.reported_at': "Notificado el",
    'defects.location': "Ubicación",
    'defects.photos': "Fotos",
    'defects.acknowledgement': "Aceptación",
    'defects.acknowledged_by': "Aceptado por",
    'defects.resolved_by': "Resuelto por",
    'defects.return_to_service': "Devolución al servicio",
    'defects.revised': "Revisada",
    'defects.revised_by_suffix': "por {name}",
    'defects.view_machine_profile': "Ver ficha de la máquina",
    'defects.resolve_and_release': "Resolver y devolver al servicio",
    'defects.resolve_defect': "Resolver el defecto",
    'defects.release_machine': "Liberar la máquina",
    'defects.mark_resolved': "Marcar como resuelto",
    'defects.release_warning': "Esta máquina está bloqueada. Su liberación por escrito quedará registrada con su nombre y su función, y aparecerá en el pasaporte de la máquina.",
    'defects.resolution_details': "Detalles de la resolución",
    'defects.resolution_placeholder': "Describa cómo se resolvió el defecto…",
    'defects.narrative_placeholder': "Qué se encontró, qué se hizo y cómo se comprobó la máquina antes de liberarla. Incluya números de orden de trabajo y detalles de las pruebas cuando proceda.",
    'defects.chars_needed_one': "carácter más necesario",
    'defects.chars_needed_many': "caracteres más necesarios",
    'defects.characters': "caracteres",
    'defects.permanent_note': "Esto quedará registrado de forma permanente en el informe de defecto.",
    'machines.tab_overview': "Resumen",
    'machines.tab_history': "Historial",
    'machines.tab_documents': "Documentos",
    'machines.tab_operators': "Operarios",
    'machines.tab_sharing': "Uso compartido",
    'machines.tab_incidents': "Incidentes",
    'machines.pdf_only': "Solo se aceptan archivos PDF.",
    'machines.replace_confirm': "¿Sustituir el documento existente ({name})? Se eliminará el archivo anterior.",
    'machines.delete_doc_confirm': "¿Eliminar este documento? Esta acción no se puede deshacer.",
    'machines.uploaded': "Subido",
    'machines.no_file_yet': "Aún sin archivo",
    'machines.uploading': "Subiendo…",
    'machines.view_document': "Ver documento",
    'common.replace': "Sustituir",
    'common.delete': "Eliminar",
    'common.upload': "Subir",
    'machines.doc_type_manual': "Manual",
    'machines.doc_type_private': "Privado",
    'machines.doc_operators_manual': "Manual del operario",
    'machines.doc_workshop_manual': "Manual de taller",
    'machines.untitled_document': "Documento sin título",
    'machines.add_document': "Añadir documento",
    'machines.documents_intro': "El manual del operario y el manual de taller ocupan ranuras específicas: nos ayudan a identificar el documento correcto al compartirlo con la biblioteca de Agriware. El resto de documentos privados solo son visibles para su organización.",
    'machines.returned_to_service': "Máquina devuelta al servicio",
    'machines.not_blocked': "Esta máquina no está bloqueada",
    'machines.resolve_defect_first': "Resuelva el defecto abierto para devolver esta máquina al servicio",
    'machines.return_failed': "No se ha podido devolver la máquina al servicio",
    'machines.machine_not_found': "Máquina no encontrada",
    'common.unknown': "Desconocido",
    'machines.unblock': "Desbloquear",
    'service.add_record': "Añadir registro de mantenimiento",
    'machines.serial_number': "Número de serie",
    'machines.year': "Año",
    'machines.blocked_banner': "Máquina bloqueada — no utilizar",
    'machines.current_hours': "Horas actuales",
    'machines.next_service': "Próximo mantenimiento",
    'machines.service_records': "Registros de mantenimiento",
    'machines.service_progress': "Progreso hasta el mantenimiento",
    'machines.cost_over_time': "Evolución de costes",
    'machines.cost_over_time_sub': "Mantenimiento, reparación y coste de propiedad acumulado",
    'machines.cost_empty': "Los datos de coste aparecerán a medida que se añadan registros de mantenimiento.",
    'machines.series_service': "Mantenimiento",
    'machines.series_repair': "Reparación",
    'machines.series_cumulative': "Acumulado",
    'machines.details_title': "Detalles de la máquina",
    'machines.make': "Marca",
    'machines.model': "Modelo",
    'machines.category': "Categoría",
    'machines.assigned_to': "Asignada a",
    'machines.pool_machine': "Máquina compartida",
    'machines.unassigned': "Sin asignar",
    'machines.purchase_value': "Compra y valor",
    'machines.purchase_date': "Fecha de compra",
    'machines.purchase_price': "Precio de compra",
    'machines.depreciation_rate': "Tasa de amortización",
    'machines.per_year': "al año",
    'machines.estimated_life': "Vida útil estimada",
    'common.unit_years': "años",
    'machines.cost_tracking': "Seguimiento de costes",
    'machines.total_service_cost': "Coste total de mantenimiento",
    'machines.total_repair_cost': "Coste total de reparación",
    'machines.total_fuel_cost': "Coste total de combustible",
    'machines.total_cost_ownership': "Coste total de propiedad",
    'machines.service_history': "Historial de mantenimiento y reparaciones",
    'service.add_record_short': "Añadir registro",
    'service.none_yet': "Aún no hay registros de mantenimiento",
    'service.none_yet_msg': "Añada su primer registro de mantenimiento o reparación",
    'service.sealed': "Sellado",
    'service.workshop': "Taller",
    'common.photo_one': "foto",
    'common.photo_many': "fotos",
    'machines.assigned_operators': "Operarios asignados",
    'machines.no_operator': "Ningún operario asignado",
    'machines.no_operator_msg': "Esta máquina no tiene operario asignado",
    'machines.pool_machine_msg': "Es una máquina compartida: disponible para todos los operarios",
    'machines.ownership_sharing': "Propiedad y uso compartido",
    'machines.share_machine': "Compartir máquina",
    'machines.current_owner': "Propietario actual",
    'machines.your_organisation': "Su organización",
    'machines.shared_with': "Compartida con",
    'machines.not_shared': "No compartida con ninguna otra organización",
    'machines.incident_history': "Historial de incidentes",
    'incidents.none': "Sin incidentes",
    'incidents.none_msg': "No hay incidentes registrados para esta máquina",
    'incidents.impact_detected': "Impacto detectado",
    'incidents.manual_sos': "SOS manual",
    'incidents.man_down': "Alerta de hombre caído",
    'machines.unblock_title': "Devolver la máquina al servicio",
    'machines.confirm_unblock': "Confirmar desbloqueo",
    'machines.unblock_warning': "Su declaración escrita queda registrada junto a la comprobación que detuvo esta máquina y aparece en su pasaporte. Si la máquina está bloqueada por un defecto abierto, resuelva el defecto en su lugar.",
    'machines.blocked_reason': "Motivo del bloqueo",
    'machines.unblock_statement': "Declaración de devolución al servicio",
    'machines.unblock_placeholder': "Qué se encontró, qué se hizo y cómo se comprobó la máquina antes de liberarla.",
    'checks.history_title': "Historial de comprobaciones",
    'checks.stat_total': "Comprobaciones totales",
    'checks.stat_passed': "Aptas",
    'checks.stat_failed': "No aptas",
    'checks.n_passed': "aptas",
    'checks.n_failed': "no aptas",
    'common.clear_filters': "Borrar filtros",
    'checks.not_found': "Comprobación no encontrada",
    'common.export_pdf': "Exportar PDF",
    'common.pdf_coming_soon': "Exportación a PDF disponible próximamente",
    'checks.item_failed_one': "elemento no apto",
    'checks.item_failed_many': "elementos no aptos",
    'checks.auto_blocked': "La máquina se bloqueó automáticamente al enviar",
    'checks.sealed_record': "Registro sellado",
    'checks.submitted_by': "Enviada por",
    'checks.submitted_at': "Enviada el",
    'checks.hours_at_check': "Horas en la comprobación",
    'checks.stat_total_items': "Elementos totales",
    'checks.stat_mileage': "Kilometraje",
    'checks.details_title': "Detalles de la comprobación",
    'checks.failed_items': "Elementos no aptos",
    'checks.no_items_recorded': "No se han registrado elementos de comprobación",
    'checks.alt_defect_photo': "Foto del defecto",
    'checks.alt_check_photo': "Foto de la comprobación",
    'common.unit_hrs': "h",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Plantillas",
    'checks.tab_history': "Historial",
    'checks.create_template': "Crear plantilla",
    'checks.scope_specific': "Máquina específica",
    'checks.scope_all': "Todas las máquinas",
    'checks.categories': "categorías",
    'checks.items': "elementos",
    'checks.title': "Comprobaciones",
    'checks.template_one': "plantilla",
    'checks.template_many': "plantillas",
    'checks.record_one': "registro",
    'checks.record_many': "registros",
    'checks.no_templates': "Aún no hay plantillas",
    'checks.no_templates_msg': "Cree plantillas para definir qué deben comprobar los operarios antes de usar las máquinas",
    'checks.search': "Buscar por máquina u operario…",
    'checks.all_results': "Todos los resultados",
    'checks.pass': "Apto",
    'checks.fail': "No apto",
    'checks.none_found': "No se han encontrado comprobaciones",
    'checks.adjust_filters': "Pruebe a ajustar los filtros",
    'checks.none_submitted': "Aún no se ha enviado ninguna comprobación",
    'checks.col_operator': "Operario",
    'checks.col_datetime': "Fecha y hora",
    'checks.col_result': "Resultado",
    'machines.add': "Añadir máquina",
    'machines.col_machine': "Máquina",
    'machines.col_serial': "N.º serie / Matrícula",
    'machines.col_site': "Emplazamiento",
    'machines.col_hours': "Horas",
    'machines.col_status': "Estado",
    'machines.title': "Máquinas",
    'machines.count_one': "máquina",
    'machines.count_many': "máquinas",
    'machines.blocked': "bloqueada(s)",
    'machines.search': "Buscar por marca, modelo, n.º de serie o matrícula…",
    'machines.all_sites': "Todos los emplazamientos",
    'machines.all_statuses': "Todos los estados",
    'machines.available': "Disponible",
    'machines.blocked_one': "Bloqueada",
    'machines.none_found': "No se han encontrado máquinas",
    'machines.view': "Ver",
    'cat.all': "Todas las categorías",
    'cat.agricultural': "Agrícola",
    'cat.groundcare': "Mantenimiento de zonas verdes",
    'cat.plant': "Maquinaria",
    'cat.vehicle': "Vehículo",
    'cat.atv': "Quad",
    'nav.dashboard': "Panel",
    'nav.staff': "Personal",
    'nav.checks': "Comprobaciones",
    'nav.safety': "Seguridad",
    'nav.operations': "Operaciones",
    'nav.settings': "Ajustes",
    'nav.billing': "Facturación",
    'nav.sign_out': "Cerrar sesión",
    'role.admin': "Administrador",
    'role.manager': "Responsable",
    'role.operator': "Operario",
    'app.name': 'AgriWare Operaciones',
    'app.tagline': 'Gestión',
    'nav.home': 'Inicio',
    'nav.machines': 'Máquinas',
    'nav.profile': 'Perfil',
    'common.back': 'Volver',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'common.edit': 'Editar',
    'common.done': 'Hecho',
    'common.yes': 'Sí',
    'common.no': 'No',
    'common.ok': 'OK',
    'common.error': 'Error',
    'common.loading': 'Cargando...',
    'common.retry': 'Reintentar',
    'common.search': 'Buscar',
    'common.submit': 'Enviar',
    'common.confirm': 'Confirmar',
    'common.close': 'Cerrar',
    'common.pass': 'Aprobado',
    'common.fail': 'Fallido',
    'common.total': 'total',
    'common.today': 'Hoy',
    'common.yesterday': 'Ayer',
    'common.online_only': 'Solo en línea',
    'common.last_synced': 'Última sincronización',
    'common.back_to_app': 'Volver a la app',
    'common.gps_shared': 'GPS compartido',
    'common.yes_via_saas': 'Sí — vía SaaS',
    'common.not_called': 'No llamado',
    'login.sign_in': 'Iniciar sesión',
    'login.email': 'Correo electrónico',
    'login.password': 'Contraseña',
    'login.forgot_password': '¿Olvidó su contraseña?',
    'login.no_account': '¿No tiene cuenta?',
    'login.request_access': 'Solicitar acceso',
    'login.account_created_by_org': 'Su cuenta ha sido creada por su organización.',
    'login.email_placeholder': 'usted@organizacion.com',
    'login.password_placeholder': 'Ingrese su contraseña',
    'login.error_empty': 'Por favor ingrese su correo y contraseña.',
    'login.error_invalid': 'Correo o contraseña inválidos. Inténtelo de nuevo.',
    'dashboard.greeting_morning': 'Buenos días,',
    'dashboard.greeting_afternoon': 'Buenas tardes,',
    'dashboard.greeting_evening': 'Buenas noches,',
    'dashboard.todays_tasks': 'Tareas de hoy',
    'dashboard.completed': 'Completadas',
    'dashboard.overdue': 'Atrasadas',
    'dashboard.in_progress': 'En progreso',
    'dashboard.upcoming': 'Próximas',
    'dashboard.pending': 'Pendientes',
    'machines.search_placeholder': 'Buscar máquinas...',
    'machines.favourites': 'Favoritas',
    'machines.all_machines': 'Todas las máquinas',
    'machines.operational': 'Operacional',
    'machines.needs_attention': 'Requiere atención',
    'machines.fault': 'Avería',
    'machines.unsafe_to_operate': 'No es seguro operar',
    'machines.registration': 'Matrícula',
    'machines.assigned_operator': 'Operador asignado',
    'machines.engine_hours': 'Horas de motor',
    'machines.documents': 'Documentos',
    'machines.log_fault': 'Registrar avería',
    'machines.operator_manual': 'Manual del operador',
    'machines.service_record': 'Historial de servicio',
    'machines.insurance': 'Certificado de seguro',
    'machines.mot': 'ITV',
    'daily_check.title': 'Revisión diaria',
    'daily_check.start': 'Iniciar revisión',
    'daily_check.required': 'Revisión requerida',
    'daily_check.required_msg': 'Debe completarse antes de operar esta máquina.',
    'daily_check.complete': 'Revisión completa',
    'daily_check.complete_msg': 'Completado por',
    'daily_check.submit': 'Enviar revisión',
    'daily_check.items_remaining': 'elementos restantes',
    'daily_check.reward_title': '¡Gracias!',
    'daily_check.reward_subtitle': 'Su revisión diaria ha sido registrada.\nLas revisiones honestas mantienen a todos seguros.',
    'daily_check.back_to_machine': 'Volver a la máquina',
    'daily_check.day_streak': 'Días consecutivos',
    'daily_check.completion_rate': 'Tasa de finalización',
    'daily_check.cat_lights': 'Luces y visibilidad',
    'daily_check.cat_fluids': 'Fluidos',
    'daily_check.cat_tyres': 'Neumáticos y ruedas',
    'daily_check.cat_safety': 'Seguridad',
    'daily_check.cat_controls': 'Controles',
    'daily_check.cat_body': 'Carrocería y accesorios',
    'daily_check.lights_working': 'Todas las luces funcionan',
    'daily_check.mirrors': 'Espejos limpios y ajustados',
    'daily_check.windscreen': 'Parabrisas limpio e intacto',
    'daily_check.engine_oil': 'Nivel de aceite del motor',
    'daily_check.coolant': 'Nivel de refrigerante',
    'daily_check.hydraulic': 'Nivel de fluido hidráulico',
    'daily_check.fuel': 'Nivel de combustible adecuado',
    'daily_check.tyre_pressure': 'Presión de neumáticos correcta',
    'daily_check.tyre_damage': 'Sin daños visibles en neumáticos',
    'daily_check.wheel_nuts': 'Tuercas de rueda apretadas',
    'daily_check.fire_extinguisher': 'Extintor presente',
    'daily_check.first_aid': 'Botiquín presente',
    'daily_check.rops': 'Estructura ROPS intacta',
    'daily_check.seatbelt': 'Cinturón de seguridad funciona',
    'daily_check.brakes': 'Frenos funcionan',
    'daily_check.steering': 'Dirección responsiva',
    'daily_check.horn': 'Bocina funciona',
    'daily_check.body_damage': 'Sin daños visibles en carrocería',
    'daily_check.attachments': 'Accesorios asegurados',
    'daily_check.pto_guard': 'Protector de toma de fuerza en su lugar',
    'log_fault.title': 'Registrar avería',
    'log_fault.description': 'Descripción',
    'log_fault.description_placeholder': 'Describa la avería...',
    'log_fault.photos': 'Fotos',
    'log_fault.add_photo': 'Añadir foto',
    'log_fault.submit': 'Enviar informe',
    'log_fault.success': 'Avería registrada con éxito',
    'emergency.title': 'Emergencia',
    'emergency.what_emergency': '¿Cuál es la emergencia?',
    'emergency.select_type': 'Seleccione el tipo de emergencia.\nLos contactos apropiados serán llamados inmediatamente.',
    'emergency.vibrating': 'Vibración',
    'emergency.alarm': 'Alarma',
    'emergency.medical': 'Emergencia médica',
    'emergency.medical_sub': 'Lesión, enfermedad o persona inconsciente en el sitio',
    'emergency.calls_999': 'Llama al 112 inmediatamente',
    'emergency.electrical': 'Emergencia eléctrica',
    'emergency.electrical_sub': 'Contacto con línea eléctrica — quédese en la cabina',
    'emergency.calls_105': 'Llama al 112 inmediatamente',
    'emergency.no_signal': 'Números de emergencia almacenados en el dispositivo — disponibles sin señal',
    'emergency.gps_auto': 'Posición GPS compartida automáticamente',
    'emergency.999_called': '112 llamado',
    'emergency.105_called': 'Línea de emergencia llamada',
    'emergency.services_contacted': 'Los servicios de emergencia han sido contactados.\nSu supervisor también ha sido notificado.',
    'emergency.power_contacted': 'La línea de emergencia eléctrica ha sido contactada.\nSu supervisor también ha sido notificado.',
    'emergency.emergency_type': 'Tipo de emergencia',
    'emergency.number_called': 'Número llamado',
    'emergency.location': 'Ubicación',
    'emergency.admin_notified': 'Admin notificado',
    'emergency.stay_in_cab': 'Quédese en la cabina',
    'emergency.stay_in_cab_msg': 'No salga del vehículo. Espere hasta que la autoridad confirme que la línea es segura. Mantenga las ventanas cerradas.',
    'emergency.medical_type': 'Médica',
    'emergency.electrical_type': 'Eléctrica',
    'crash.are_you_okay': '¿Está bien?',
    'crash.impact_detected': 'Se ha detectado un posible impacto.\nPor favor responda o se llamará ayuda.',
    'crash.im_okay': 'Estoy bien',
    'crash.dismiss_alert': 'Ignorar alerta — sin acción',
    'crash.i_need_help': 'Necesito ayuda',
    'crash.notify_supervisor': 'Notificar supervisor con posición GPS',
    'crash.call_999': 'Llamar al 112',
    'crash.call_emergency': 'Llamar a emergencias inmediatamente',
    'crash.glad_okay': 'Nos alegra que esté bien',
    'crash.alert_dismissed': 'Alerta ignorada. No se ha enviado ninguna notificación.',
    'crash.help_on_way': 'La ayuda está en camino',
    'crash.supervisor_notified': 'Su supervisor ha sido notificado con su posición GPS.',
    'crash.auto_dialled': '112 marcado automáticamente',
    'crash.no_response': 'Sin respuesta. Servicios de emergencia llamados automáticamente. Mensaje de voz en emisión.',
    'crash.broadcasting': 'Emitiendo mensaje',
    'crash.repeating': 'Repitiendo cada 15 segundos',
    'crash.admin_notified': 'Admin notificado',
    'crash.emergency_services': 'Servicios de emergencia',
    'profile.title': 'Perfil',
    'profile.personal_info': 'Información personal',
    'profile.full_name': 'Nombre completo',
    'profile.email': 'Correo',
    'profile.phone': 'Teléfono',
    'profile.role': 'Rol',
    'profile.organisation': 'Organización',
    'profile.emergency_contact': 'Contacto de emergencia',
    'profile.emergency_contact_note': 'Su supervisor será contactado en caso de emergencia',
    'profile.contact_name': 'Nombre del contacto',
    'profile.contact_phone': 'Teléfono del contacto',
    'profile.notifications': 'Notificaciones',
    'profile.task_reminders': 'Recordatorios de tareas',
    'profile.overdue_alerts': 'Alertas de retraso',
    'profile.crash_detection': 'Detección de impacto',
    'profile.account_security': 'Cuenta y seguridad',
    'profile.change_password': 'Cambiar contraseña',
    'profile.two_factor': 'Autenticación de dos factores',
    'profile.login_activity': 'Actividad de inicio de sesión',
    'profile.app_settings': 'Configuración de la app',
    'profile.theme': 'Tema',
    'profile.language': 'Idioma',
    'profile.sign_out': 'Cerrar sesión',
    'profile.sign_out_confirm': 'Cerrar sesión',
    'profile.sign_out_msg': '¿Está seguro de que desea cerrar sesión?',
    'profile.field_staff': 'Personal de campo',
    'theme.light': 'Claro',
    'theme.dark': 'Oscuro',
    'theme.system': 'Sistema predeterminado',
  },

  'it': {
    'verify.err_reference_required': "È necessario un riferimento del documento.",
    'verify.err_rate_limited': "Troppi tentativi. Riprova tra poco.",
    'verify.err_not_found': "Nessun passaporto è stato emesso con questo riferimento.",
    'verify.err_code_mismatch': "Il codice dell'organizzazione e il riferimento non corrispondono.",
    'verify.err_unknown_section': "Sezione sconosciuta.",
    'verify.err_read_failed': "Non è stato possibile leggere il record.",
    'verify.intro': "Inserisci il riferimento stampato sul documento per confermare che è stato emesso da Agriware Operations. Per vedere lo storico completo della macchina, aggiungi il codice dell'organizzazione emittente — entrambi sono riportati sul passaporto.",
    'verify.orgcode_optional': "— facoltativo, per il record completo",
    'verify.title': "Verifica un passaporto macchina",
    'verify.reference_label': "Riferimento documento",
    'verify.orgcode_label': "Codice organizzazione",
    'verify.checking': "Verifica in corso…",
    'verify.submit': "Verifica",
    'verify.not_verified': "Non verificato",
    'verify.withdrawn': "Ritirato",
    'verify.genuine': "Documento autentico",
    'verify.genuine_superseded': "Autentico, ma sostituito",
    'verify.superseded_note': "Per questa macchina è stato emesso un passaporto più recente",
    'verify.fingerprint': "Impronta del documento (SHA-256)",
    'verify.no_result': "Nessun risultato.",
    'verify.err_not_verified': "Non è stato possibile verificare il documento.",
    'verify.err_unreachable': "Impossibile contattare il servizio di verifica. Riprova.",
    'verify.row_reference': "Riferimento",
    'verify.row_issued_by': "Emesso da",
    'verify.row_issued_on': "Emesso il",
    'verify.not_recorded': "Non registrato",
    'verify.row_make_model': "Marca e modello",
    'verify.row_status': "Stato attuale",
    'verify.blocked_from_use': "Bloccata all’uso",
    'verify.in_service': "In servizio",
    'verify.no_open_defects': "Nessun difetto aperto registrato per questa macchina.",
    'verify.defect_history': "Storico difetti",
    'verify.no_resolved_defects': "Nessun difetto risolto registrato per questa macchina.",
    'verify.inspection_record': "Registro delle ispezioni",
    'verify.check_log': "Registro dei controlli",
    'verify.no_checks': "Nessun controllo registrato per questa macchina.",
    'verify.service_history': "Storico manutenzioni",
    'verify.no_services': "Nessuna registrazione di manutenzione per questa macchina.",
    'verify.checks_recorded': "Controlli registrati",
    'verify.pass_rate': "Percentuale superati",
    'verify.defects_raised': "Difetti segnalati",
    'verify.most_recent_check': "Ultimo controllo",
    'verify.show_more': "Mostra altro",
    'verify.showing_of': "Visualizzati {shown} di {total}",
    'verify.details': "Dettagli",
    'verify.hide': "Nascondi",
    'verify.all_passed': "Tutti superati",
    'verify.n_failed': "{n} non superati",
    'verify.blocked_the_machine': "ha bloccato la macchina",
    'verify.blocking': "Bloccante",
    'verify.raised': "Segnalato",
    'verify.resolved': "Risolto",
    'verify.revised_after_issue': "rivisto dopo l’emissione",
    'verify.next_service': "Prossima manutenzione",
    'verify.parts': "Ricambi",
    'verify.external': "esterno",
    'verify.sealed': "sigillata",
    'verify.language': "Lingua",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Nessun movimento rilevato",
    'emergency.triggered_generic': "Emergenza attivata",
    'emergency.community_badge': "Allerta community — emergenza nelle vicinanze",
    'emergency.panel_responders': "Chi è intervenuto",
    'emergency.machine_involved': "Macchina coinvolta",
    'emergency.impact_label': "Urto",
    'emergency.ago': "fa",
    'emergency.location_unavailable': "Posizione non disponibile",
    'emergency.open_in_maps': "Apri in Google Maps",
    'emergency.im_responding': "Intervengo io",
    'emergency.confirming': "Conferma in corso…",
    'emergency.mark_resolved': "Segna come chiuso",
    'emergency.resolving': "Chiusura in corso…",
    'emergency.called_automatically_at': "112 chiamato automaticamente alle {time}",
    'emergency.state_alert': "ALLARME EMERGENZA",
    'emergency.state_awaiting': "IN ATTESA DI RISPOSTA",
    'emergency.state_needs_help': "L'OPERATORE HA BISOGNO DI AIUTO",
    'emergency.state_no_response': "NESSUNA RISPOSTA DALL'OPERATORE",
    'emergency.seconds_to_respond': "{n} s per la risposta dell'operatore",
    'billing.over_limit_row': "Oltre le macchine incluse nel tuo piano",
    'billing.over_limit_full': "Questa macchina supera quelle incluse nel tuo piano. Aggiungila al tuo abbonamento per vederne lo storico.",
    'nav.reports': "Report",
    'site.not_found': "Sito non trovato",
    'site.details': "Dettagli del sito",
    'site.edit': "Modifica sito",
    'site.updated': "Sito aggiornato",
    'site.err_update': "Impossibile aggiornare il sito",
    'site.no_address': "Nessun indirizzo registrato",
    'site.no_machines': "Nessuna macchina in questo sito",
    'site.no_staff': "Nessuno assegnato a questo sito",
    'site.no_defects': "Nessun difetto aperto in questo sito",
    'checks.new_template': "Nuovo modello",
    'set.language': "Lingua",
    'set.language_hint': "Si applica a tutta l'organizzazione",
    'set.your_organisation': "La tua organizzazione",
    'set.group_organisation': "Organizzazione",
    'set.group_safety': "Sicurezza e conformità",
    'set.group_system': "Sistema",
    'set.reports': "Report",
    'set.org_details': "Dati dell’organizzazione",
    'set.org_details_hint': "Nome, indirizzo, numero societario, immagine",
    'set.sites_hint': "Piazzali, depositi e dove sono ricoverate le macchine",
    'set.roles': "Ruoli e autorizzazioni",
    'set.roles_hint': "Che cosa può vedere e fare ciascun ruolo",
    'set.billing_hint': "Abbonamento e metodo di pagamento",
    'set.coshh_hint': "Sostanze presenti e relative valutazioni",
    'set.risk_hint': "Valutazioni e revisioni",
    'set.reports_hint': "Stato del parco, conformità, emissioni, costi e fascicoli assicurativi",
    'set.integrations': "Integrazioni",
    'set.integrations_hint': "Telematica, sistemi dei concessionari e Almanac",
    'set.notifications_hint': "Che cosa viene inviato e a chi",
    'set.audit_log': "Registro di audit",
    'set.audit_log_hint': "Chi ha modificato che cosa e quando",
    'set.data': "Dati",
    'set.data_hint': "Esportazione e conservazione",
    'set.data_retention': "Dati e conservazione",
    'set.export_title': "Esporta i tuoi dati",
    'set.export_desc': "Esporta una copia completa dei dati della tua organizzazione: schede macchina, storico manutenzioni, controlli, schede del personale e qualifiche.",
    'set.export_coming_soon': "Esportazione dei dati in arrivo",
    'set.export_btn': "Esporta tutti i dati",
    'set.retention_title': "Conservazione dei dati",
    'set.retention_desc': "I tuoi dati sono conservati per tutta la durata dell’abbonamento più 12 mesi dopo la disdetta. Le registrazioni di manutenzione e le schede di lavoro sigillate sono conservate a tempo indeterminato perché possono servire a fini legali e assicurativi.",
    'set.danger_zone': "Zona critica",
    'set.danger_desc': "L’eliminazione della tua organizzazione rimuove definitivamente tutti i dati, tranne le schede macchina sigillate necessarie per la conformità. L’operazione non può essere annullata.",
    'set.delete_org': "Elimina organizzazione",
    'set.delete_org_toast': "Contatta l’assistenza per eliminare la tua organizzazione",
    'set.audit_log_subtitle': "Registro completo di tutte le azioni nella tua organizzazione",
    'set.audit_search': "Cerca nel registro di audit…",
    'set.col_action': "Azione",
    'set.no_audit': "Nessuna voce di audit",
    'set.audit_empty_msg': "Le azioni compariranno qui man mano che avvengono",
    'set.notif_title': "Impostazioni notifiche",
    'set.notif_desc': "Scegli quali eventi generano notifiche push per responsabili e amministratori della tua organizzazione.",
    'set.notif_saved': "Preferenze di notifica salvate",
    'set.save_preferences': "Salva preferenze",
    'set.notif_check_failed': "Controllo non superato",
    'set.notif_check_failed_desc': "Quando un operatore invia un controllo non superato",
    'set.notif_machine_blocked': "Macchina bloccata",
    'set.notif_machine_blocked_desc': "Quando una macchina viene bloccata automaticamente dopo un esito negativo",
    'set.notif_defect': "Difetto segnalato",
    'set.notif_defect_desc': "Quando un operatore segnala un difetto",
    'set.notif_near_miss': "Mancato incidente segnalato",
    'set.notif_near_miss_desc': "Quando viene inviato un mancato incidente",
    'set.notif_qual_expiring': "Qualifica in scadenza (30 gg)",
    'set.notif_qual_expiring_desc': "Quando una qualifica scade entro 30 giorni",
    'set.notif_qual_expired': "Qualifica scaduta",
    'set.notif_qual_expired_desc': "Quando una qualifica è scaduta",
    'set.notif_service_due': "Manutenzione in scadenza",
    'set.notif_service_due_desc': "Quando una macchina si avvicina all’intervallo di manutenzione",
    'set.notif_fuel_low': "Serbatoio carburante basso",
    'set.notif_fuel_low_desc': "Quando un serbatoio di gasolio scende sotto la soglia",
    'set.notif_emergency': "Allarme di emergenza",
    'set.notif_emergency_desc': "Sempre attivo — non disattivabile",
    'set.notif_announcement': "Comunicazioni",
    'set.notif_announcement_desc': "Quando la direzione invia una comunicazione",
    'set.no_sites_msg': "Aggiungi la tua prima azienda o sito",
    'set.err_site_name': "Il nome del sito è obbligatorio",
    'set.site_added': "Sito aggiunto",
    'set.err_site_add': "Impossibile aggiungere il sito",
    'set.site_name': "Nome del sito",
    'set.site_name_placeholder': "es. Azienda principale",
    'set.address': "Indirizzo",
    'set.address_placeholder': "es. Azienda principale, Via dei Campi 1, 00100",
    'set.roles_title': "Ruoli e autorizzazioni",
    'set.role_admin_full': "Accesso completo a tutti i siti, macchine, personale, impostazioni e fatturazione. Può inviare comunicazioni e gestire tutti i dati.",
    'set.role_manager_full': "Accesso limitato al sito. Gestisce macchine e personale del proprio sito. Non accede a fatturazione o impostazioni dell’organizzazione.",
    'set.role_operator_full': "Accesso solo tramite app mobile. Esegue i controlli giornalieri, registra i rifornimenti e può segnalare difetti e mancati incidenti.",
    'set.perm_all_machines': "Tutte le macchine di tutti i siti",
    'set.perm_all_staff': "Gestione di tutto il personale",
    'set.perm_all_settings': "Tutte le impostazioni",
    'set.perm_announcements': "Inviare comunicazioni",
    'set.perm_emergencies': "Chiudere le emergenze",
    'set.perm_site_machines': "Macchine del proprio sito",
    'set.perm_site_staff': "Personale del proprio sito",
    'set.perm_checks_defects': "Controlli e difetti",
    'set.perm_shifts': "Gestione dei turni",
    'set.perm_daily_checks_app': "Controlli giornalieri (app)",
    'set.perm_fuel_fills_app': "Rifornimenti (app)",
    'set.perm_defect_app': "Segnalazione difetti (app)",
    'set.perm_near_miss_app': "Segnalazione mancati incidenti (app)",
    'set.perm_own_quals': "Vedere le proprie qualifiche",
    'set.perm_sos': "SOS di emergenza",
    'set.org_settings': "Impostazioni dell’organizzazione",
    'set.identity': "Identità",
    'set.org_name': "Nome dell’organizzazione",
    'set.trading_name': "Nome commerciale",
    'set.if_different': "Se diverso",
    'set.company_number': "Numero societario",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "Partita IVA",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Settore di attività",
    'set.ind_farm': "Azienda agricola",
    'set.ind_estate': "Tenuta",
    'set.ind_contractor': "Contoterzista agricolo",
    'set.ind_dealership': "Concessionaria",
    'set.ind_other': "Altro",
    'set.primary_email': "E-mail principale",
    'set.phone_number': "Numero di telefono",
    'set.website': "Sito web",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Indirizzo riga 1",
    'set.address2': "Indirizzo riga 2",
    'set.town': "Città",
    'set.county': "Provincia",
    'set.postcode': "CAP",
    'set.branding': "Immagine coordinata",
    'set.brand_colour': "Colore del marchio",
    'set.compliance': "Conformità",
    'set.hse_number': "Numero di registrazione HSE",
    'set.insurance_provider': "Compagnia assicurativa",
    'set.policy_number': "Numero di polizza",
    'set.insurance_expiry': "Scadenza assicurazione",
    'set.sharing_transfers': "Condivisione e trasferimenti",
    'set.org_code_desc': "Il codice della tua organizzazione serve a ricevere macchine condivise e trasferimenti da altri clienti Agriware. Condividilo con chi possiede macchine insieme a te o con chi te ne vende una.",
    'set.emails': "Email",
    'set.hold_the_yard': "Email settimanale Hold the Yard",
    'set.hold_the_yard_desc': "Ogni lunedì un riepilogo dei controlli pre-utilizzo della settimana precedente, inviato agli amministratori e ai responsabili dell'organizzazione.",
    'set.org_code': "Codice organizzazione",
    'set.generating': "Generazione…",
    'set.copied': "Copiato!",
    'set.copy': "Copia",
    'set.org_saved': "Impostazioni dell’organizzazione salvate",
    'set.err_save': "Impossibile salvare le impostazioni",
    'set.save_changes': "Salva modifiche",
    'set.status_trialing': "In prova",
    'set.status_past_due': "Pagamento scaduto",
    'set.status_cancelled': "Disdetto",
    'set.status_unpaid': "Non pagato",
    'set.status_incomplete': "Incompleto",
    'set.billing_title': "Fatturazione e abbonamento",
    'set.billing_subtitle': "Gestisci il tuo abbonamento Agriware Operations.",
    'set.plan_standard': "Standard",
    'set.per_month': "/mese · disdici quando vuoi",
    'set.grandfathered': "Questa organizzazione ha un accesso storico. I dati di fatturazione non sono disponibili perché l’account precede l’integrazione con Stripe.",
    'set.next_billing': "Prossima data di fatturazione:",
    'set.feat_registry': "Registro macchine e storico manutenzioni",
    'set.feat_checks': "Controlli giornalieri e ispezioni",
    'set.feat_defects': "Monitoraggio di guasti e difetti",
    'set.feat_staff': "Qualifiche e turni del personale",
    'set.feat_reporting': "Suite di reportistica",
    'set.feat_unlimited': "Siti e operatori illimitati",
    'set.err_no_portal': "Nessun URL del portale restituito.",
    'set.err_portal': "Impossibile aprire il portale di fatturazione. Riprova o contatta l’assistenza.",
    'set.opening_portal': "Apertura del portale di fatturazione…",
    'set.manage_billing': "Gestisci fatturazione",
    'set.admin_only_billing': "Solo gli amministratori dell’organizzazione possono gestire la fatturazione.",
    'set.stripe_note': "La fatturazione è gestita in modo sicuro da Stripe. Non vediamo mai i dati della tua carta.",
    'int.abax_desc': "Acquisisci ore motore, posizione e utilizzo direttamente dai tracker ABAX: le ore arrivano da sole invece di essere digitate.",
    'int.abax_detail': "Le ore automatiche manterrebbero accurati intervalli di manutenzione, stime delle emissioni e conformità dei controlli senza inserire letture.",
    'int.dms_desc': "Collegati al DMS del tuo concessionario per aprire richieste di intervento, approvare i preventivi e ricevere schede di lavoro sigillate sulla macchina giusta.",
    'int.dms_detail': "Gli interventi eseguiti dal concessionario finiscono automaticamente nella scheda macchina e compaiono sul suo passaporto.",
    'int.almanac_desc': "Confronta le tue macchine con gli stessi modelli di tutti i parchi Agriware: punti di guasto tipici, intervalli di manutenzione e affidabilità per modello.",
    'int.almanac_detail': "Almanac aggrega dati anonimizzati su difetti e manutenzioni di più organizzazioni. I tuoi dati contribuiscono; in cambio vedi il dato aggregato.",
    'int.consent_shared': "Condiviso: marca e modello della macchina, tipi di difetto, ore al guasto, intervalli di manutenzione",
    'int.consent_never': "Mai condiviso: nome della tua organizzazione, siti, personale, operatori, costi o documenti",
    'int.consent_threshold': "I dati vengono mostrati solo quando ci sono abbastanza macchine da rendere non identificabili i singoli parchi",
    'int.consent_withdraw': "Puoi ritirarti in qualsiasi momento: i dati conferiti vengono rimossi dalle aggregazioni future",
    'int.err_update': "Impossibile aggiornare questa integrazione",
    'int.interest_noted': "Registrato — ti contatteremo quando sarà pronto",
    'int.almanac_enabled': "Almanac attivato",
    'int.almanac_disabled': "Almanac disattivato",
    'int.subtitle': "Collega Agriware Operations ai sistemi che già utilizzi",
    'int.admin_only': "Solo un amministratore dell’organizzazione può modificare le integrazioni.",
    'int.enabled': "Attivato",
    'int.in_development': "In sviluppo",
    'int.withdraw': "Ritirati",
    'int.enable_almanac': "Attiva Almanac",
    'int.interest_registered': "Interesse registrato",
    'int.register_interest': "Manifesta interesse",
    'int.less': "Meno",
    'int.what_this_does': "Che cosa fa",
    'int.footer': "Usi qualcosa che non trovi qui? Dicci che cosa vorresti collegare: le richieste decidono che cosa svilupperemo dopo.",
    'tmpl.scope_all_desc': "Si applica a tutte le macchine dell’organizzazione",
    'tmpl.scope_category': "Per categoria",
    'tmpl.scope_category_desc': "Si applica alle categorie selezionate",
    'tmpl.scope_specific_desc': "Si applica a una sola macchina",
    'tmpl.freq_daily': "Giornaliero",
    'tmpl.freq_daily_helper': "Deve essere completato ogni giorno entro l’orario previsto",
    'tmpl.freq_weekly': "Settimanale",
    'tmpl.freq_weekly_helper': "Deve essere completato una volta a settimana",
    'tmpl.freq_hourly': "In base alle ore",
    'tmpl.freq_hourly_helper': "Attivato ogni X ore motore",
    'tmpl.freq_monthly': "Mensile",
    'tmpl.freq_monthly_helper': "Deve essere completato una volta al mese",
    'tmpl.item_passfail': "Superato / Non superato",
    'tmpl.item_numeric': "Numerico",
    'tmpl.item_text': "Testo",
    'tmpl.item_photo': "Foto",
    'tmpl.item_signature': "Firma",
    'tmpl.fail_none': "Solo registrare",
    'tmpl.fail_flag': "Registrare e notificare",
    'tmpl.fail_block': "Registrare, notificare e bloccare",
    'tmpl.section_default': "Sezione",
    'tmpl.err_name': "Il nome del modello è obbligatorio",
    'tmpl.err_category': "Seleziona almeno una categoria",
    'tmpl.err_machine': "Seleziona una macchina",
    'tmpl.err_items': "Aggiungi almeno una voce di controllo",
    'tmpl.updated': "Modello aggiornato",
    'tmpl.created': "Modello creato",
    'tmpl.err_save': "Impossibile salvare il modello",
    'tmpl.name_placeholder': "Nome del modello",
    'tmpl.save': "Salva modello",
    'tmpl.settings': "Impostazioni del modello",
    'tmpl.description_placeholder': "Breve descrizione di quando si usa questo modello",
    'tmpl.applies_to': "Si applica a",
    'tmpl.select_categories_caps': "SELEZIONA CATEGORIE",
    'tmpl.select_machine_caps': "SELEZIONA MACCHINA",
    'tmpl.choose_machine': "Scegli una macchina…",
    'tmpl.frequency': "Frequenza dei controlli",
    'tmpl.estimated_time': "Tempo stimato (minuti)",
    'tmpl.every_x_hours': "Ogni X ore motore",
    'tmpl.due_by_time': "Entro le ore",
    'tmpl.due_by_hint': "— il promemoria di ritardo viene inviato a quest’ora",
    'tmpl.due_by_note': "Notifica push all’operatore e al responsabile del sito se non completato entro quest’ora",
    'tmpl.item_one': "voce",
    'tmpl.item_many': "voci",
    'tmpl.new_item': "Nuova voce di controllo",
    'tmpl.add_item': "Aggiungi voce di controllo",
    'tmpl.add_section': "Aggiungi sezione",
    'tmpl.item_panel_title': "Voce di controllo",
    'tmpl.select_item_hint': "Seleziona una voce di controllo a sinistra per modificarne le impostazioni qui.",
    'tmpl.label': "Etichetta",
    'tmpl.label_placeholder': "es. livello olio motore",
    'tmpl.if_fails': "In caso di esito negativo",
    'tmpl.required': "Obbligatorio",
    'tmpl.required_hint': "L’operatore deve compilare questa voce",
    'status.active': "Attivo",
    'status.shared': "Condivisa",
    'status.transferred': "Trasferita",
    'status.archived': "Archiviata",
    'status.issues': "Anomalie",
    'status.emergency': "Emergenza",
    'status.closed': "Chiuso",
    'status.due': "In scadenza",
    'status.draft': "Bozza",
    'status.approved': "Approvato",
    'status.declined': "Rifiutato",
    'status.scheduled': "Pianificato",
    'photo.title': "Foto profilo",
    'photo.upload_title': "Carica una foto",
    'photo.upload_note': "JPG, PNG o WebP · max 5 MB · verrà ritagliata a cerchio",
    'photo.choose': "Scegli foto",
    'photo.drag_hint': "Trascina per riposizionare · scorri o usa il cursore per lo zoom",
    'photo.change': "Cambia foto",
    'photo.save': "Salva foto",
    'upsell.derv_title': "Gestione carburante",
    'upsell.derv_desc': "Monitora i livelli dei serbatoi, registra i rifornimenti, gestisci i fornitori e controlla i consumi per macchina in tutti i siti.",
    'upsell.coshh_title': "Registro sostanze pericolose",
    'upsell.coshh_desc': "Gestisci un registro digitale delle sostanze pericolose, delle schede di sicurezza e dei DPI necessari per il personale.",
    'upsell.risk_title': "Valutazioni dei rischi",
    'upsell.risk_desc': "Crea, gestisci e sigilla valutazioni dei rischi per macchina o attività. Gli operatori le confermano prima di iniziare.",
    'upsell.jobs_title': "Integrazione DMS",
    'upsell.jobs_desc': "Richiedi interventi in officina al tuo concessionario, approva i preventivi e ricevi schede di lavoro sigillate direttamente sulle schede macchina.",
    'upsell.reporting_title': "Report e analisi",
    'upsell.reporting_desc': "Report su stato del parco macchine, conformità, qualifiche, consumi, emissioni di CO₂ e costo per macchina.",
    'upsell.quals_title': "Monitoraggio delle qualifiche",
    'upsell.quals_desc': "Registra patentini e attestati del personale con controllo delle scadenze, notifiche push e blocco delle macchine in base alla qualifica.",
    'upsell.sharing_title': "Condivisione macchine",
    'upsell.sharing_desc': "Condividi i dati delle macchine con altre organizzazioni Agriware Ops — ideale per contoterzisti e mezzi in comune.",
    'upsell.transfers_title': "Trasferimenti di macchine",
    'upsell.transfers_desc': "Trasferisci macchine tra utenti Ops o account DMS con storico completo di proprietà e libretto digitale.",
    'upsell.carbon_title': "Reporting delle emissioni",
    'upsell.carbon_desc': "Calcolo automatico delle emissioni di CO₂ in base ai consumi di carburante. Reporting secondo lo standard DEFRA per il tuo parco.",
    'upsell.not_included': "Questa funzione non è inclusa nel tuo piano attuale.",
    'upsell.upgrade': "Passa a un piano superiore",
    'service.record_not_found': "Registrazione non trovata",
    'service.record_title_service': "Registrazione di manutenzione",
    'service.record_title_repair': "Registrazione di riparazione",
    'service.record_title_inspection': "Registrazione di ispezione",
    'service.record_suffix': "registrazione",
    'service.email_btn': "E-mail",
    'service.email_coming_soon': "Esportazione via e-mail in arrivo",
    'service.sealed_by_workshop': "Sigillata da {name} e non modificabile",
    'service.the_workshop': "l’officina",
    'service.sealed_permanent': "Questa registrazione è sigillata in modo permanente e non può essere modificata",
    'service.sealed_by': "Sigillata da",
    'service.at_suffix': "presso {name}",
    'service.job_ref': "commessa {ref}",
    'service.photos_video': "Foto e video",
    'service.job_photo': "Foto dell’intervento",
    'service.files_copying': "Alcuni file sono ancora in fase di copia.",
    'service.date_of_service': "Data della manutenzione",
    'service.hours_at_service': "Ore alla manutenzione",
    'service.total_cost': "Costo totale",
    'service.record_details': "Dettagli registrazione",
    'service.type': "Tipo",
    'service.performed_by': "Eseguito da",
    'service.performed_by_type': "Tipo di esecutore",
    'service.next_service_hours': "Ore alla prossima manutenzione",
    'service.next_service_date': "Data della prossima manutenzione",
    'service.notes': "Note",
    'service.parts_used': "Ricambi utilizzati",
    'service.col_part': "Ricambio",
    'service.col_qty': "Q.tà",
    'service.col_cost': "Costo",
    'service.parts_total': "Totale ricambi",
    'service.cost_breakdown': "Dettaglio dei costi",
    'service.labour_cost': "Costo manodopera",
    'service.parts_cost': "Costo ricambi",
    'service.total': "Totale",
    'service.audit_trail': "Tracciato di audit",
    'service.record_created_by': "Registrazione creata da",
    'service.record_sealed_by': "Registrazione sigillata da",
    'service.type_service': "Manutenzione",
    'service.type_service_desc': "Manutenzione programmata di routine",
    'service.type_repair': "Riparazione",
    'service.type_repair_desc': "Intervento di riparazione non programmato",
    'service.type_inspection': "Ispezione",
    'service.type_inspection_desc': "Controllo di sicurezza o conformità",
    'service.by_internal': "Interno",
    'service.by_dealer': "Concessionario",
    'service.by_external': "Fornitore esterno",
    'service.err_description': "Inserisci una descrizione",
    'service.err_date': "Inserisci la data della manutenzione",
    'service.added_toast': "Registrazione di manutenzione aggiunta e sigillata",
    'service.err_save': "Impossibile salvare la registrazione — riprova",
    'service.seal_note': "Questa registrazione sarà sigillata in modo permanente al salvataggio",
    'service.record_type': "Tipo di registrazione",
    'service.description_placeholder': "Descrivi il lavoro svolto…",
    'service.performed_by_placeholder': "Nome o azienda",
    'service.additional_notes': "Note aggiuntive",
    'service.notes_placeholder': "Eventuali note aggiuntive…",
    'service.add_part': "Aggiungi ricambio",
    'service.part_name': "Nome del ricambio",
    'service.cost_placeholder': "Costo £",
    'service.cost_next_service': "Costo e prossima manutenzione",
    'service.labour_cost_field': "Costo manodopera (£)",
    'service.next_hours_placeholder': "es. 1750",
    'service.seal_warning': "Una volta salvata, questa registrazione è sigillata in modo permanente e non può essere modificata. Verifica che tutti i dati siano corretti prima di salvare.",
    'service.save_seal': "Salva e sigilla registrazione",
    'dashboard.there': "a te",
    'dashboard.total_machines': "Macchine totali",
    'dashboard.blocked_machines': "Macchine bloccate",
    'dashboard.open_incidents': "Incidenti aperti",
    'dashboard.open_defects': "Difetti aperti",
    'dashboard.fuel_tanks': "Serbatoi carburante",
    'common.of': "di",
    'dashboard.fleet': "Parco macchine",
    'common.view_all': "Vedi tutto",
    'dashboard.no_machines': "Nessuna macchina",
    'dashboard.no_machines_msg': "Aggiungi la prima macchina per iniziare",
    'dashboard.recent_incidents': "Incidenti recenti",
    'dashboard.no_incidents_msg': "Nessun incidente registrato",
    'dashboard.recent_defects': "Difetti recenti",
    'dashboard.no_defects': "Nessun difetto",
    'dashboard.no_defects_msg': "Nessun difetto segnalato",
    'dashboard.defect_reported': "Difetto segnalato",
    'dashboard.group_overview': "Panoramica gruppo",
    'dashboard.send_announcement': "Invia comunicazione",
    'dashboard.sites': "Siti",
    'dashboard.no_sites': "Nessun sito",
    'dashboard.no_sites_msg': "Aggiungi il primo sito nelle Impostazioni per iniziare",
    'dashboard.add_site': "Aggiungi sito",
    'dashboard.status_monitor': "Da monitorare",
    'dashboard.status_all_good': "Tutto a posto",
    'dashboard.derv': "Gasolio",
    'dashboard.derv_level': "Livello gasolio",
    'qual.short_forklift': "Muletto",
    'qual.short_sprayer': "Irroratrice",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Guida",
    'qual.short_firstaid': "Primo soccorso",
    'qual.short_chainsaw': "Motosega",
    'qual.short_pesticide': "Fitofarmaci",
    'qual.short_telehandler': "Sollevatore telescopico",
    'qual.short_atv': "Quad",
    'qual.short_other': "Altro",
    'qual.forklift': "Patentino per muletto",
    'qual.sprayer': "Certificato irroratrice PA1/PA6",
    'qual.cscs': "Tessera CSCS",
    'qual.driving': "Patente di guida",
    'qual.firstaid': "Attestato di primo soccorso",
    'qual.chainsaw': "Attestato motosega",
    'qual.pesticide': "Abilitazione fitofarmaci",
    'qual.telehandler': "Patentino sollevatore telescopico",
    'qual.atv': "Attestato quad/ATV",
    'qual.other': "Altra qualifica",
    'staff.n_expired': "scadute",
    'staff.n_expiring': "in scadenza",
    'staff.n_valid': "valide",
    'common.none': "Nessuna",
    'staff.tab_members': "Membri",
    'staff.tab_qualifications': "Qualifiche",
    'staff.tab_shifts': "Turni",
    'staff.member_one': "membro",
    'staff.member_many': "membri",
    'staff.alert_one': "avviso di qualifica",
    'staff.alert_many': "avvisi di qualifica",
    'staff.invite': "Invita personale",
    'staff.create_shift': "Crea turno",
    'staff.search': "Cerca per nome o e-mail…",
    'staff.none_found': "Nessun membro del personale trovato",
    'staff.adjust_search': "Prova a modificare la ricerca",
    'staff.invite_first': "Invita il primo membro del team",
    'staff.stat_total_quals': "Qualifiche totali",
    'staff.stat_valid': "Valide",
    'staff.stat_expiring_30d': "In scadenza (30 gg)",
    'staff.stat_expiring': "In scadenza",
    'staff.stat_expired': "Scadute",
    'staff.qual_one': "qualifica",
    'staff.qual_many': "qualifiche",
    'staff.expires': "Scade il",
    'staff.no_quals': "Nessuna qualifica registrata",
    'staff.no_quals_msg': "Aggiungi le qualifiche dalla scheda di ciascun membro del personale",
    'staff.no_shifts': "Nessun turno",
    'staff.no_shifts_msg': "Crea il primo turno per tenere traccia di chi è al lavoro",
    'staff.shift': "Turno",
    'staff.checked_in': "presenti",
    'staff.not_found': "Membro del personale non trovato",
    'staff.add_qualification': "Aggiungi qualifica",
    'staff.expired_alert_one': "qualifica è scaduta — questo operatore potrebbe non essere autorizzato a usare determinate macchine",
    'staff.expired_alert_many': "qualifiche sono scadute — questo operatore potrebbe non essere autorizzato a usare determinate macchine",
    'staff.expiring_alert_one': "qualifica scade entro 30 giorni",
    'staff.expiring_alert_many': "qualifiche scadono entro 30 giorni",
    'staff.tab_details': "Dettagli",
    'staff.contact': "Contatti",
    'staff.account': "Account",
    'staff.onboarding': "Inserimento",
    'staff.complete': "Completato",
    'staff.job_title': "Mansione",
    'staff.joined': "Ingresso il",
    'staff.invited_by': "Invitato da",
    'staff.quals_tickets': "Qualifiche e patentini",
    'staff.no_quals_profile_msg': "Aggiungi patentini e attestati di questo operatore",
    'staff.issued': "Rilasciato",
    'staff.no_expiry': "Senza scadenza",
    'staff.expires_today': "Scade oggi",
    'staff.days_remaining_one': "giorno rimanente",
    'staff.days_remaining_many': "giorni rimanenti",
    'staff.expired_days_ago_one': "Scaduto {n} giorno fa",
    'staff.expired_days_ago_many': "Scaduto {n} giorni fa",
    'staff.view_certificate': "Vedi attestato",
    'staff.assigned_machines': "Macchine assegnate",
    'staff.no_machines': "Nessuna macchina assegnata",
    'staff.no_machines_msg': "A questo operatore non è assegnata alcuna macchina",
    'staff.err_first_name': "Il nome è obbligatorio",
    'staff.err_last_name': "Il cognome è obbligatorio",
    'staff.err_email': "Inserisci un indirizzo e-mail valido",
    'staff.err_site': "Seleziona un sito",
    'staff.err_create_prefix': "Impossibile creare l’account:",
    'staff.err_timeout': "Tempo scaduto durante la creazione dell’account. Aggiorna la pagina e riprova.",
    'staff.err_create': "Impossibile creare l’account — riprova",
    'staff.copy_greeting': "Ciao {name},",
    'staff.copy_body': "Il tuo account Agriware Operations è stato creato.",
    'staff.copy_email': "E-mail:",
    'staff.copy_temp_password': "Password temporanea:",
    'staff.copy_footer': "Ti verrà chiesto di cambiare la password al primo accesso.",
    'staff.copied_toast': "Credenziali copiate negli appunti",
    'staff.role_admin_desc': "Accesso completo a tutti i siti e alle impostazioni",
    'staff.role_manager_desc': "Gestisce un sito, il personale e le macchine",
    'staff.role_operator_desc': "Esegue i controlli giornalieri tramite l’app mobile",
    'staff.add_member': "Aggiungi membro del personale",
    'staff.add_member_sub': "L’account verrà creato subito. Vedrai le credenziali da consegnare.",
    'staff.account_created': "Account creato",
    'staff.share_details_pre': "Condividi queste credenziali con",
    'staff.share_details_post': "Al primo accesso verrà richiesto di cambiare la password.",
    'staff.label_email_caps': "E-MAIL",
    'staff.label_temp_password_caps': "PASSWORD TEMPORANEA",
    'staff.copy_login_details': "Copia credenziali",
    'staff.add_another': "Aggiungine un altro",
    'staff.back_to_staff': "Torna al personale",
    'staff.personal_details': "Dati personali",
    'staff.first_name': "Nome",
    'staff.last_name': "Cognome",
    'staff.work_email': "E-mail di lavoro",
    'staff.site_assignment': "Assegnazione sito",
    'staff.no_sites': "Nessun sito configurato — aggiungi prima un sito nelle Impostazioni",
    'staff.creating_account': "Creazione account…",
    'staff.create_account': "Crea account",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Seleziona un tipo di qualifica",
    'qual.err_name': "Inserisci il nome della qualifica",
    'qual.err_issue_date': "Inserisci la data di rilascio",
    'qual.err_expiry': "Inserisci la data di scadenza o seleziona «senza scadenza»",
    'qual.added_toast': "Qualifica aggiunta",
    'qual.err_save': "Impossibile salvare la qualifica — riprova",
    'qual.back_staff_profile': "Scheda del personale",
    'qual.subtitle': "Registra un patentino, un attestato o una licenza per questo operatore",
    'qual.type_title': "Tipo di qualifica",
    'qual.name_label': "Nome della qualifica",
    'qual.name_placeholder': "es. attestato decespugliatore NPTC",
    'qual.cert_details': "Dettagli dell’attestato",
    'qual.cert_number': "Numero attestato",
    'common.optional_suffix': "— facoltativo",
    'qual.cert_number_placeholder': "es. NPORS-123456",
    'qual.issuing_body': "Ente rilasciante",
    'qual.issuing_body_placeholder': "es. NPORS, LANTRA, CITB",
    'qual.issue_date': "Data di rilascio",
    'qual.expiry_date': "Data di scadenza",
    'qual.no_expiry_label': "Questa qualifica non ha scadenza",
    'qual.cert_document': "Documento dell’attestato",
    'qual.upload_note': "Carica una foto o una scansione dell’attestato. Viene conservato in privato e mai condiviso.",
    'common.remove': "Rimuovi",
    'qual.click_upload': "Clicca per caricare l’attestato",
    'qual.file_types': "JPG, PNG o PDF",
    'common.saving': "Salvataggio…",
    'qual.save': "Salva qualifica",
    'defects.title': "Difetti",
    'defects.n_open': "aperti",
    'defects.n_critical': "critici",
    'defects.stat_total': "Difetti totali",
    'defects.status_open': "Aperto",
    'defects.status_in_progress': "In corso",
    'defects.status_resolved': "Risolto",
    'defects.all_severities': "Tutte le gravità",
    'defects.sev_minor': "Lieve",
    'defects.sev_moderate': "Moderato",
    'defects.sev_major': "Grave",
    'defects.sev_critical': "Critico",
    'defects.search': "Cerca difetti…",
    'common.clear': "Cancella",
    'defects.col_description': "Descrizione",
    'defects.reported_by': "Segnalato da",
    'defects.col_severity': "Gravità",
    'defects.no_description': "Nessuna descrizione",
    'defects.none_found': "Nessun difetto trovato",
    'defects.none_reported': "Non è stato segnalato alcun difetto",
    'defects.acknowledged_toast': "Difetto preso in carico",
    'defects.acknowledge_failed': "Impossibile prendere in carico il difetto",
    'defects.resolved_released': "Difetto risolto — macchina rilasciata",
    'defects.resolved_toast': "Difetto risolto",
    'defects.resolve_failed': "Impossibile risolvere il difetto",
    'defects.not_found': "Difetto non trovato",
    'defects.report_title': "Segnalazione difetto",
    'defects.acknowledge': "Prendi in carico",
    'defects.raise_job': "Apri commessa",
    'defects.resolve': "Risolvi",
    'defects.blocking_banner': "Macchina bloccata — un responsabile deve registrare un rilascio scritto prima del rientro in servizio",
    'defects.details_title': "Dettagli difetto",
    'defects.no_description_provided': "Nessuna descrizione fornita",
    'defects.reported_at': "Segnalato il",
    'defects.location': "Posizione",
    'defects.photos': "Foto",
    'defects.acknowledgement': "Presa in carico",
    'defects.acknowledged_by': "Preso in carico da",
    'defects.resolved_by': "Risolto da",
    'defects.return_to_service': "Rimessa in servizio",
    'defects.revised': "Rivista",
    'defects.revised_by_suffix': "da {name}",
    'defects.view_machine_profile': "Vedi scheda macchina",
    'defects.resolve_and_release': "Risolvi e rimetti in servizio",
    'defects.resolve_defect': "Risolvi il difetto",
    'defects.release_machine': "Rilascia la macchina",
    'defects.mark_resolved': "Segna come risolto",
    'defects.release_warning': "Questa macchina è bloccata. Il tuo rilascio scritto verrà registrato con il tuo nome e ruolo e comparirà sul passaporto della macchina.",
    'defects.resolution_details': "Dettagli della risoluzione",
    'defects.resolution_placeholder': "Descrivi come è stato risolto il difetto…",
    'defects.narrative_placeholder': "Che cosa è stato riscontrato, che cosa è stato fatto e come è stata controllata la macchina prima del rilascio. Indica i numeri di commessa e i dettagli delle prove ove pertinenti.",
    'defects.chars_needed_one': "carattere in più necessario",
    'defects.chars_needed_many': "caratteri in più necessari",
    'defects.characters': "caratteri",
    'defects.permanent_note': "Questa informazione verrà registrata in modo permanente nella segnalazione del difetto.",
    'machines.tab_overview': "Panoramica",
    'machines.tab_history': "Cronologia",
    'machines.tab_documents': "Documenti",
    'machines.tab_operators': "Operatori",
    'machines.tab_sharing': "Condivisione",
    'machines.tab_incidents': "Incidenti",
    'machines.pdf_only': "Sono accettati solo file PDF.",
    'machines.replace_confirm': "Sostituire il documento esistente ({name})? Il vecchio file verrà eliminato.",
    'machines.delete_doc_confirm': "Eliminare questo documento? L’operazione non può essere annullata.",
    'machines.uploaded': "Caricato",
    'machines.no_file_yet': "Nessun file",
    'machines.uploading': "Caricamento…",
    'machines.view_document': "Vedi documento",
    'common.replace': "Sostituisci",
    'common.delete': "Elimina",
    'common.upload': "Carica",
    'machines.doc_type_manual': "Manuale",
    'machines.doc_type_private': "Privato",
    'machines.doc_operators_manual': "Manuale d’uso",
    'machines.doc_workshop_manual': "Manuale d’officina",
    'machines.untitled_document': "Documento senza titolo",
    'machines.add_document': "Aggiungi documento",
    'machines.documents_intro': "Il manuale d’uso e il manuale d’officina hanno spazi dedicati: ci aiutano a individuare il documento giusto quando viene condiviso con la libreria Agriware. Gli altri documenti privati sono visibili solo alla tua organizzazione.",
    'machines.returned_to_service': "Macchina rimessa in servizio",
    'machines.not_blocked': "Questa macchina non è bloccata",
    'machines.resolve_defect_first': "Risolvi il difetto aperto per rimettere in servizio questa macchina",
    'machines.return_failed': "Impossibile rimettere in servizio la macchina",
    'machines.machine_not_found': "Macchina non trovata",
    'common.unknown': "Sconosciuto",
    'machines.unblock': "Sblocca",
    'service.add_record': "Aggiungi registrazione di manutenzione",
    'machines.serial_number': "Numero di matricola",
    'machines.year': "Anno",
    'machines.blocked_banner': "Macchina bloccata — non utilizzare",
    'machines.current_hours': "Ore attuali",
    'machines.next_service': "Prossima manutenzione",
    'machines.service_records': "Registrazioni di manutenzione",
    'machines.service_progress': "Avanzamento verso la manutenzione",
    'machines.cost_over_time': "Andamento dei costi",
    'machines.cost_over_time_sub': "Manutenzione, riparazione e costo di proprietà cumulato",
    'machines.cost_empty': "I dati di costo compariranno man mano che vengono aggiunte registrazioni di manutenzione.",
    'machines.series_service': "Manutenzione",
    'machines.series_repair': "Riparazione",
    'machines.series_cumulative': "Cumulato",
    'machines.details_title': "Dettagli macchina",
    'machines.make': "Marca",
    'machines.model': "Modello",
    'machines.category': "Categoria",
    'machines.assigned_to': "Assegnata a",
    'machines.pool_machine': "Macchina in pool",
    'machines.unassigned': "Non assegnata",
    'machines.purchase_value': "Acquisto e valore",
    'machines.purchase_date': "Data di acquisto",
    'machines.purchase_price': "Prezzo di acquisto",
    'machines.depreciation_rate': "Tasso di ammortamento",
    'machines.per_year': "all’anno",
    'machines.estimated_life': "Vita utile stimata",
    'common.unit_years': "anni",
    'machines.cost_tracking': "Monitoraggio costi",
    'machines.total_service_cost': "Costo totale manutenzione",
    'machines.total_repair_cost': "Costo totale riparazioni",
    'machines.total_fuel_cost': "Costo totale carburante",
    'machines.total_cost_ownership': "Costo totale di proprietà",
    'machines.service_history': "Storico manutenzioni e riparazioni",
    'service.add_record_short': "Aggiungi registrazione",
    'service.none_yet': "Nessuna registrazione di manutenzione",
    'service.none_yet_msg': "Aggiungi la tua prima registrazione di manutenzione o riparazione",
    'service.sealed': "Sigillata",
    'service.workshop': "Officina",
    'common.photo_one': "foto",
    'common.photo_many': "foto",
    'machines.assigned_operators': "Operatori assegnati",
    'machines.no_operator': "Nessun operatore assegnato",
    'machines.no_operator_msg': "A questa macchina non è assegnato alcun operatore",
    'machines.pool_machine_msg': "Questa è una macchina in pool — disponibile a tutti gli operatori",
    'machines.ownership_sharing': "Proprietà e condivisione",
    'machines.share_machine': "Condividi macchina",
    'machines.current_owner': "Proprietario attuale",
    'machines.your_organisation': "La tua organizzazione",
    'machines.shared_with': "Condivisa con",
    'machines.not_shared': "Non condivisa con altre organizzazioni",
    'machines.incident_history': "Storico incidenti",
    'incidents.none': "Nessun incidente",
    'incidents.none_msg': "Nessun incidente registrato per questa macchina",
    'incidents.impact_detected': "Urto rilevato",
    'incidents.manual_sos': "SOS manuale",
    'incidents.man_down': "Allarme uomo a terra",
    'machines.unblock_title': "Rimettere la macchina in servizio",
    'machines.confirm_unblock': "Conferma sblocco",
    'machines.unblock_warning': "La tua dichiarazione scritta viene registrata sul controllo che ha fermato questa macchina e compare sul suo passaporto. Se la macchina è bloccata da un difetto aperto, risolvi invece il difetto.",
    'machines.blocked_reason': "Motivo del blocco",
    'machines.unblock_statement': "Dichiarazione di rimessa in servizio",
    'machines.unblock_placeholder': "Che cosa è stato riscontrato, che cosa è stato fatto e come è stata controllata la macchina prima del rilascio.",
    'checks.history_title': "Cronologia controlli",
    'checks.stat_total': "Controlli totali",
    'checks.stat_passed': "Superati",
    'checks.stat_failed': "Non superati",
    'checks.n_passed': "superati",
    'checks.n_failed': "non superati",
    'common.clear_filters': "Cancella filtri",
    'checks.not_found': "Controllo non trovato",
    'common.export_pdf': "Esporta PDF",
    'common.pdf_coming_soon': "Esportazione PDF in arrivo",
    'checks.item_failed_one': "voce non superata",
    'checks.item_failed_many': "voci non superate",
    'checks.auto_blocked': "La macchina è stata bloccata automaticamente all’invio",
    'checks.sealed_record': "Registrazione sigillata",
    'checks.submitted_by': "Inviato da",
    'checks.submitted_at': "Inviato il",
    'checks.hours_at_check': "Ore al controllo",
    'checks.stat_total_items': "Voci totali",
    'checks.stat_mileage': "Chilometraggio",
    'checks.details_title': "Dettagli controllo",
    'checks.failed_items': "Voci non superate",
    'checks.no_items_recorded': "Nessuna voce di controllo registrata",
    'checks.alt_defect_photo': "Foto del difetto",
    'checks.alt_check_photo': "Foto del controllo",
    'common.unit_hrs': "ore",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Modelli",
    'checks.tab_history': "Cronologia",
    'checks.create_template': "Crea modello",
    'checks.scope_specific': "Macchina specifica",
    'checks.scope_all': "Tutte le macchine",
    'checks.categories': "categorie",
    'checks.items': "voci",
    'checks.title': "Controlli",
    'checks.template_one': "modello",
    'checks.template_many': "modelli",
    'checks.record_one': "registrazione",
    'checks.record_many': "registrazioni",
    'checks.no_templates': "Nessun modello di controllo",
    'checks.no_templates_msg': "Crea modelli per definire cosa gli operatori devono controllare prima dell’uso",
    'checks.search': "Cerca per macchina o operatore…",
    'checks.all_results': "Tutti i risultati",
    'checks.pass': "Superato",
    'checks.fail': "Non superato",
    'checks.none_found': "Nessun controllo trovato",
    'checks.adjust_filters': "Prova a modificare i filtri",
    'checks.none_submitted': "Non è ancora stato inviato alcun controllo",
    'checks.col_operator': "Operatore",
    'checks.col_datetime': "Data e ora",
    'checks.col_result': "Risultato",
    'machines.add': "Aggiungi macchina",
    'machines.col_machine': "Macchina",
    'machines.col_serial': "Matricola / Targa",
    'machines.col_site': "Sito",
    'machines.col_hours': "Ore",
    'machines.col_status': "Stato",
    'machines.title': "Macchine",
    'machines.count_one': "macchina",
    'machines.count_many': "macchine",
    'machines.blocked': "bloccata/e",
    'machines.search': "Cerca per marca, modello, matricola o targa…",
    'machines.all_sites': "Tutti i siti",
    'machines.all_statuses': "Tutti gli stati",
    'machines.available': "Disponibile",
    'machines.blocked_one': "Bloccata",
    'machines.none_found': "Nessuna macchina trovata",
    'machines.view': "Vedi",
    'cat.all': "Tutte le categorie",
    'cat.agricultural': "Agricolo",
    'cat.groundcare': "Manutenzione del verde",
    'cat.plant': "Mezzi d’opera",
    'cat.vehicle': "Veicolo",
    'cat.atv': "Quad",
    'nav.dashboard': "Cruscotto",
    'nav.staff': "Personale",
    'nav.checks': "Controlli",
    'nav.safety': "Sicurezza",
    'nav.operations': "Operazioni",
    'nav.settings': "Impostazioni",
    'nav.billing': "Fatturazione",
    'nav.sign_out': "Esci",
    'role.admin': "Amministratore",
    'role.manager': "Responsabile",
    'role.operator': "Operatore",
    'app.name': 'AgriWare Operazioni',
    'app.tagline': 'Gestione',
    'nav.home': 'Home',
    'nav.machines': 'Macchine',
    'nav.profile': 'Profilo',
    'common.back': 'Indietro',
    'common.cancel': 'Annulla',
    'common.save': 'Salva',
    'common.edit': 'Modifica',
    'common.done': 'Fine',
    'common.yes': 'Sì',
    'common.no': 'No',
    'common.ok': 'OK',
    'common.error': 'Errore',
    'common.loading': 'Caricamento...',
    'common.retry': 'Riprova',
    'common.search': 'Cerca',
    'common.submit': 'Invia',
    'common.confirm': 'Conferma',
    'common.close': 'Chiudi',
    'common.pass': 'Superato',
    'common.fail': 'Non superato',
    'common.total': 'totale',
    'common.today': 'Oggi',
    'common.yesterday': 'Ieri',
    'common.online_only': 'Solo online',
    'common.last_synced': 'Ultima sincronizzazione',
    'common.back_to_app': "Torna all'app",
    'common.gps_shared': 'GPS condiviso',
    'common.yes_via_saas': 'Sì — tramite SaaS',
    'common.not_called': 'Non chiamato',
    'login.sign_in': 'Accedi',
    'login.email': 'Indirizzo e-mail',
    'login.password': 'Password',
    'login.forgot_password': 'Password dimenticata?',
    'login.no_account': 'Non hai un account?',
    'login.request_access': 'Richiedi accesso',
    'login.account_created_by_org': 'Il tuo account è stato creato dalla tua organizzazione.',
    'login.email_placeholder': 'tu@organizzazione.it',
    'login.password_placeholder': 'Inserisci la password',
    'login.error_empty': 'Inserisci e-mail e password.',
    'login.error_invalid': 'E-mail o password non validi. Riprova.',
    'dashboard.greeting_morning': 'Buongiorno,',
    'dashboard.greeting_afternoon': 'Buon pomeriggio,',
    'dashboard.greeting_evening': 'Buonasera,',
    'dashboard.todays_tasks': 'Attività di oggi',
    'dashboard.completed': 'Completate',
    'dashboard.overdue': 'In ritardo',
    'dashboard.in_progress': 'In corso',
    'dashboard.upcoming': 'In arrivo',
    'dashboard.pending': 'In attesa',
    'machines.search_placeholder': 'Cerca macchine...',
    'machines.favourites': 'Preferiti',
    'machines.all_machines': 'Tutte le macchine',
    'machines.operational': 'Operativa',
    'machines.needs_attention': 'Richiede attenzione',
    'machines.fault': 'Guasto',
    'machines.unsafe_to_operate': 'Non sicuro da operare',
    'machines.registration': 'Targa',
    'machines.assigned_operator': 'Operatore assegnato',
    'machines.engine_hours': 'Ore motore',
    'machines.documents': 'Documenti',
    'machines.log_fault': 'Segnala guasto',
    'machines.operator_manual': 'Manuale operatore',
    'machines.service_record': 'Registro manutenzione',
    'machines.insurance': 'Certificato assicurativo',
    'machines.mot': 'Revisione',
    'daily_check.title': 'Controllo giornaliero',
    'daily_check.start': 'Avvia controllo',
    'daily_check.required': 'Controllo richiesto',
    'daily_check.required_msg': 'Deve essere completato prima di operare questa macchina.',
    'daily_check.complete': 'Controllo completato',
    'daily_check.complete_msg': 'Completato da',
    'daily_check.submit': 'Invia controllo',
    'daily_check.items_remaining': 'elementi rimanenti',
    'daily_check.reward_title': 'Grazie!',
    'daily_check.reward_subtitle': 'Il tuo controllo giornaliero è stato registrato.\nI controlli onesti mantengono tutti al sicuro.',
    'daily_check.back_to_machine': 'Torna alla macchina',
    'daily_check.day_streak': 'Giorni consecutivi',
    'daily_check.completion_rate': 'Tasso di completamento',
    'daily_check.cat_lights': 'Luci e visibilità',
    'daily_check.cat_fluids': 'Fluidi',
    'daily_check.cat_tyres': 'Pneumatici e ruote',
    'daily_check.cat_safety': 'Sicurezza',
    'daily_check.cat_controls': 'Comandi',
    'daily_check.cat_body': 'Carrozzeria e accessori',
    'daily_check.lights_working': 'Tutte le luci funzionano',
    'daily_check.mirrors': 'Specchi puliti e regolati',
    'daily_check.windscreen': 'Parabrezza pulito e integro',
    'daily_check.engine_oil': 'Livello olio motore',
    'daily_check.coolant': 'Livello liquido refrigerante',
    'daily_check.hydraulic': 'Livello fluido idraulico',
    'daily_check.fuel': 'Livello carburante adeguato',
    'daily_check.tyre_pressure': 'Pressione pneumatici corretta',
    'daily_check.tyre_damage': 'Nessun danno visibile ai pneumatici',
    'daily_check.wheel_nuts': 'Dadi ruota serrati',
    'daily_check.fire_extinguisher': 'Estintore presente',
    'daily_check.first_aid': 'Kit pronto soccorso presente',
    'daily_check.rops': 'Struttura ROPS integra',
    'daily_check.seatbelt': 'Cintura di sicurezza funzionante',
    'daily_check.brakes': 'Freni funzionanti',
    'daily_check.steering': 'Sterzo reattivo',
    'daily_check.horn': 'Clacson funzionante',
    'daily_check.body_damage': 'Nessun danno visibile alla carrozzeria',
    'daily_check.attachments': 'Accessori fissati',
    'daily_check.pto_guard': 'Protezione presa di forza in posizione',
    'log_fault.title': 'Segnala guasto',
    'log_fault.description': 'Descrizione',
    'log_fault.description_placeholder': 'Descrivi il guasto...',
    'log_fault.photos': 'Foto',
    'log_fault.add_photo': 'Aggiungi foto',
    'log_fault.submit': 'Invia rapporto',
    'log_fault.success': 'Guasto segnalato con successo',
    'emergency.title': 'Emergenza',
    'emergency.what_emergency': "Qual è l'emergenza?",
    'emergency.select_type': "Seleziona il tipo di emergenza.\nI contatti appropriati verranno chiamati immediatamente.",
    'emergency.vibrating': 'Vibrazione',
    'emergency.alarm': 'Allarme',
    'emergency.medical': 'Emergenza medica',
    'emergency.medical_sub': 'Lesione, malattia o persona incosciente in loco',
    'emergency.calls_999': 'Chiama il 112 immediatamente',
    'emergency.electrical': 'Emergenza elettrica',
    'emergency.electrical_sub': 'Contatto con linea elettrica — rimani in cabina',
    'emergency.calls_105': 'Chiama il 112 immediatamente',
    'emergency.no_signal': 'Numeri di emergenza memorizzati nel dispositivo — disponibili senza segnale',
    'emergency.gps_auto': 'Posizione GPS condivisa automaticamente',
    'emergency.999_called': '112 chiamato',
    'emergency.105_called': 'Linea emergenza chiamata',
    'emergency.services_contacted': 'I servizi di emergenza sono stati contattati.\nAnche il tuo supervisore è stato notificato.',
    'emergency.power_contacted': 'La linea di emergenza elettrica è stata contattata.\nAnche il tuo supervisore è stato notificato.',
    'emergency.emergency_type': 'Tipo di emergenza',
    'emergency.number_called': 'Numero chiamato',
    'emergency.location': 'Posizione',
    'emergency.admin_notified': 'Admin notificato',
    'emergency.stay_in_cab': 'Rimani in cabina',
    'emergency.stay_in_cab_msg': 'Non uscire dal veicolo. Aspetta che le autorità confermino che la linea è sicura. Tieni i finestrini chiusi.',
    'emergency.medical_type': 'Medica',
    'emergency.electrical_type': 'Elettrica',
    'crash.are_you_okay': 'Stai bene?',
    'crash.impact_detected': 'È stato rilevato un possibile impatto.\nRispondi o verrà chiamato aiuto.',
    'crash.im_okay': 'Sto bene',
    'crash.dismiss_alert': 'Ignora avviso — nessuna azione',
    'crash.i_need_help': 'Ho bisogno di aiuto',
    'crash.notify_supervisor': 'Notifica supervisore con posizione GPS',
    'crash.call_999': 'Chiama il 118',
    'crash.call_emergency': 'Chiama i soccorsi immediatamente',
    'crash.glad_okay': 'Siamo contenti che stai bene',
    'crash.alert_dismissed': 'Avviso ignorato. Nessuna notifica inviata.',
    'crash.help_on_way': 'I soccorsi sono in arrivo',
    'crash.supervisor_notified': 'Il tuo supervisore è stato notificato con la tua posizione GPS.',
    'crash.auto_dialled': '118 composto automaticamente',
    'crash.no_response': 'Nessuna risposta. Soccorsi chiamati automaticamente. Messaggio vocale in trasmissione.',
    'crash.broadcasting': 'Trasmissione messaggio',
    'crash.repeating': 'Ripetizione ogni 15 secondi',
    'crash.admin_notified': 'Admin notificato',
    'crash.emergency_services': 'Servizi di emergenza',
    'profile.title': 'Profilo',
    'profile.personal_info': 'Informazioni personali',
    'profile.full_name': 'Nome completo',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefono',
    'profile.role': 'Ruolo',
    'profile.organisation': 'Organizzazione',
    'profile.emergency_contact': 'Contatto di emergenza',
    'profile.emergency_contact_note': 'Il tuo supervisore verrà contattato in caso di emergenza',
    'profile.contact_name': 'Nome contatto',
    'profile.contact_phone': 'Telefono contatto',
    'profile.notifications': 'Notifiche',
    'profile.task_reminders': 'Promemoria attività',
    'profile.overdue_alerts': 'Avvisi di ritardo',
    'profile.crash_detection': 'Rilevamento impatto',
    'profile.account_security': 'Account e sicurezza',
    'profile.change_password': 'Cambia password',
    'profile.two_factor': 'Autenticazione a due fattori',
    'profile.login_activity': 'Attività di accesso',
    'profile.app_settings': "Impostazioni app",
    'profile.theme': 'Tema',
    'profile.language': 'Lingua',
    'profile.sign_out': 'Disconnetti',
    'profile.sign_out_confirm': 'Disconnetti',
    'profile.sign_out_msg': 'Sei sicuro di voler uscire?',
    'profile.field_staff': 'Personale di campo',
    'theme.light': 'Chiaro',
    'theme.dark': 'Scuro',
    'theme.system': 'Predefinito sistema',
  },

  'pt': {
    'verify.err_reference_required': "É necessária uma referência do documento.",
    'verify.err_rate_limited': "Demasiadas tentativas. Tente novamente em breve.",
    'verify.err_not_found': "Não foi emitido nenhum passaporte com essa referência.",
    'verify.err_code_mismatch': "O código da organização e a referência não correspondem.",
    'verify.err_unknown_section': "Secção desconhecida.",
    'verify.err_read_failed': "Não foi possível ler o registo.",
    'verify.intro': "Introduza a referência impressa no documento para confirmar que foi emitido pela Agriware Operations. Para ver o registo completo da máquina, adicione o código da organização emissora — ambos constam do passaporte.",
    'verify.orgcode_optional': "— opcional, para o registo completo",
    'verify.title': "Verificar um passaporte de máquina",
    'verify.reference_label': "Referência do documento",
    'verify.orgcode_label': "Código da organização",
    'verify.checking': "A verificar…",
    'verify.submit': "Verificar",
    'verify.not_verified': "Não verificado",
    'verify.withdrawn': "Retirado",
    'verify.genuine': "Documento autêntico",
    'verify.genuine_superseded': "Autêntico, mas substituído",
    'verify.superseded_note': "Foi emitido um passaporte mais recente para esta máquina",
    'verify.fingerprint': "Impressão digital do documento (SHA-256)",
    'verify.no_result': "Sem resultados.",
    'verify.err_not_verified': "Não foi possível verificar esse documento.",
    'verify.err_unreachable': "Não foi possível contactar o serviço de verificação. Tente novamente.",
    'verify.row_reference': "Referência",
    'verify.row_issued_by': "Emitido por",
    'verify.row_issued_on': "Emitido em",
    'verify.not_recorded': "Não registado",
    'verify.row_make_model': "Marca e modelo",
    'verify.row_status': "Estado atual",
    'verify.blocked_from_use': "Bloqueada para utilização",
    'verify.in_service': "Em serviço",
    'verify.no_open_defects': "Não há defeitos em aberto registados para esta máquina.",
    'verify.defect_history': "Histórico de defeitos",
    'verify.no_resolved_defects': "Não há defeitos resolvidos registados para esta máquina.",
    'verify.inspection_record': "Registo de inspeções",
    'verify.check_log': "Registo de verificações",
    'verify.no_checks': "Não há verificações registadas para esta máquina.",
    'verify.service_history': "Histórico de manutenção",
    'verify.no_services': "Não há registos de manutenção para esta máquina.",
    'verify.checks_recorded': "Verificações registadas",
    'verify.pass_rate': "Taxa de aprovação",
    'verify.defects_raised': "Defeitos comunicados",
    'verify.most_recent_check': "Última verificação",
    'verify.show_more': "Mostrar mais",
    'verify.showing_of': "A mostrar {shown} de {total}",
    'verify.details': "Detalhes",
    'verify.hide': "Ocultar",
    'verify.all_passed': "Todos aprovados",
    'verify.n_failed': "{n} reprovados",
    'verify.blocked_the_machine': "bloqueou a máquina",
    'verify.blocking': "Bloqueante",
    'verify.raised': "Comunicado",
    'verify.resolved': "Resolvido",
    'verify.revised_after_issue': "revisto após a emissão",
    'verify.next_service': "Próxima manutenção",
    'verify.parts': "Peças",
    'verify.external': "externo",
    'verify.sealed': "selado",
    'verify.language': "Idioma",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Nenhum movimento detetado",
    'emergency.triggered_generic': "Emergência acionada",
    'emergency.community_badge': "Alerta comunitário — emergência nas proximidades",
    'emergency.panel_responders': "Quem respondeu",
    'emergency.machine_involved': "Máquina envolvida",
    'emergency.impact_label': "Impacto",
    'emergency.ago': "atrás",
    'emergency.location_unavailable': "Localização não disponível",
    'emergency.open_in_maps': "Abrir no Google Maps",
    'emergency.im_responding': "Vou responder",
    'emergency.confirming': "A confirmar…",
    'emergency.mark_resolved': "Marcar como resolvido",
    'emergency.resolving': "A resolver…",
    'emergency.called_automatically_at': "112 chamado automaticamente às {time}",
    'emergency.state_alert': "ALERTA DE EMERGÊNCIA",
    'emergency.state_awaiting': "A AGUARDAR RESPOSTA",
    'emergency.state_needs_help': "O OPERADOR PRECISA DE AJUDA",
    'emergency.state_no_response': "SEM RESPOSTA DO OPERADOR",
    'emergency.seconds_to_respond': "{n} s para o operador responder",
    'billing.over_limit_row': "Além das máquinas incluídas no seu plano",
    'billing.over_limit_full': "Esta máquina excede as incluídas no seu plano. Adicione-a à sua subscrição para ver o respetivo registo.",
    'nav.reports': "Relatórios",
    'site.not_found': "Local não encontrado",
    'site.details': "Detalhes do local",
    'site.edit': "Editar local",
    'site.updated': "Local atualizado",
    'site.err_update': "Não foi possível atualizar o local",
    'site.no_address': "Sem morada registada",
    'site.no_machines': "Nenhuma máquina neste local",
    'site.no_staff': "Ninguém atribuído a este local",
    'site.no_defects': "Sem defeitos em aberto neste local",
    'checks.new_template': "Novo modelo",
    'set.language': "Idioma",
    'set.language_hint': "Aplica-se a toda a sua organização",
    'set.your_organisation': "A sua organização",
    'set.group_organisation': "Organização",
    'set.group_safety': "Segurança e conformidade",
    'set.group_system': "Sistema",
    'set.reports': "Relatórios",
    'set.org_details': "Dados da organização",
    'set.org_details_hint': "Nome, morada, número de empresa, imagem",
    'set.sites_hint': "Estaleiros, depósitos e onde ficam as máquinas",
    'set.roles': "Funções e permissões",
    'set.roles_hint': "O que cada função pode ver e fazer",
    'set.billing_hint': "Subscrição e método de pagamento",
    'set.coshh_hint': "Substâncias existentes e respetivas avaliações",
    'set.risk_hint': "Avaliações e revisões",
    'set.reports_hint': "Estado da frota, conformidade, carbono, custos e dossiês de seguro",
    'set.integrations': "Integrações",
    'set.integrations_hint': "Telemática, sistemas de concessionário e Almanac",
    'set.notifications_hint': "O que é enviado e a quem",
    'set.audit_log': "Registo de auditoria",
    'set.audit_log_hint': "Quem alterou o quê e quando",
    'set.data': "Dados",
    'set.data_hint': "Exportação e conservação",
    'set.data_retention': "Dados e conservação",
    'set.export_title': "Exportar os seus dados",
    'set.export_desc': "Exporte uma cópia completa dos dados da sua organização, incluindo registos de máquinas, histórico de manutenção, verificações, fichas de pessoal e qualificações.",
    'set.export_coming_soon': "Exportação de dados em breve",
    'set.export_btn': "Exportar todos os dados",
    'set.retention_title': "Conservação de dados",
    'set.retention_desc': "Os seus dados são conservados durante a vigência da subscrição mais 12 meses após o cancelamento. Os registos de manutenção e as fichas de trabalho seladas são conservados indefinidamente, pois podem ser exigidos para fins legais e de seguro.",
    'set.danger_zone': "Zona de perigo",
    'set.danger_desc': "Eliminar a sua organização remove permanentemente todos os dados, exceto os registos de máquina selados exigidos para conformidade. Esta ação não pode ser anulada.",
    'set.delete_org': "Eliminar organização",
    'set.delete_org_toast': "Contacte o suporte para eliminar a sua organização",
    'set.audit_log_subtitle': "Registo completo de todas as ações na sua organização",
    'set.audit_search': "Pesquisar no registo de auditoria…",
    'set.col_action': "Ação",
    'set.no_audit': "Sem entradas de auditoria",
    'set.audit_empty_msg': "As ações aparecem aqui à medida que ocorrem",
    'set.notif_title': "Definições de notificações",
    'set.notif_desc': "Controle que eventos geram notificações push para responsáveis e administradores da sua organização.",
    'set.notif_saved': "Preferências de notificação guardadas",
    'set.save_preferences': "Guardar preferências",
    'set.notif_check_failed': "Verificação reprovada",
    'set.notif_check_failed_desc': "Quando um operador submete uma verificação reprovada",
    'set.notif_machine_blocked': "Máquina bloqueada",
    'set.notif_machine_blocked_desc': "Quando uma máquina é bloqueada automaticamente após uma reprovação",
    'set.notif_defect': "Defeito comunicado",
    'set.notif_defect_desc': "Quando um operador comunica um defeito",
    'set.notif_near_miss': "Quase-acidente comunicado",
    'set.notif_near_miss_desc': "Quando é submetido um quase-acidente",
    'set.notif_qual_expiring': "Qualificação a caducar (30 d)",
    'set.notif_qual_expiring_desc': "Quando uma qualificação caduca dentro de 30 dias",
    'set.notif_qual_expired': "Qualificação caducada",
    'set.notif_qual_expired_desc': "Quando uma qualificação caducou",
    'set.notif_service_due': "Manutenção a vencer",
    'set.notif_service_due_desc': "Quando uma máquina se aproxima do intervalo de manutenção",
    'set.notif_fuel_low': "Depósito de combustível baixo",
    'set.notif_fuel_low_desc': "Quando um depósito de gasóleo desce abaixo do limite",
    'set.notif_emergency': "Alerta de emergência",
    'set.notif_emergency_desc': "Sempre ativo — não pode ser desativado",
    'set.notif_announcement': "Comunicados",
    'set.notif_announcement_desc': "Quando a gestão envia um comunicado",
    'set.no_sites_msg': "Adicione a sua primeira exploração ou local",
    'set.err_site_name': "O nome do local é obrigatório",
    'set.site_added': "Local adicionado",
    'set.err_site_add': "Não foi possível adicionar o local",
    'set.site_name': "Nome do local",
    'set.site_name_placeholder': "p. ex. Quinta principal",
    'set.address': "Morada",
    'set.address_placeholder': "p. ex. Quinta principal, Rua do Campo, 1000-000",
    'set.roles_title': "Funções e permissões",
    'set.role_admin_full': "Acesso total a todos os locais, máquinas, pessoal, definições e faturação. Pode enviar comunicados e gerir todos os dados.",
    'set.role_manager_full': "Acesso limitado ao local. Gere máquinas e pessoal do seu local. Não acede à faturação nem às definições da organização.",
    'set.role_operator_full': "Apenas acesso pela app móvel. Realiza as verificações diárias, regista abastecimentos e pode comunicar defeitos e quase-acidentes.",
    'set.perm_all_machines': "Todas as máquinas em todos os locais",
    'set.perm_all_staff': "Gestão de todo o pessoal",
    'set.perm_all_settings': "Todas as definições",
    'set.perm_announcements': "Enviar comunicados",
    'set.perm_emergencies': "Resolver emergências",
    'set.perm_site_machines': "Máquinas do seu local",
    'set.perm_site_staff': "Pessoal do seu local",
    'set.perm_checks_defects': "Verificações e defeitos",
    'set.perm_shifts': "Gestão de turnos",
    'set.perm_daily_checks_app': "Verificações diárias (app)",
    'set.perm_fuel_fills_app': "Abastecimentos (app)",
    'set.perm_defect_app': "Comunicação de defeitos (app)",
    'set.perm_near_miss_app': "Comunicação de quase-acidentes (app)",
    'set.perm_own_quals': "Ver as próprias qualificações",
    'set.perm_sos': "SOS de emergência",
    'set.org_settings': "Definições da organização",
    'set.identity': "Identidade",
    'set.org_name': "Nome da organização",
    'set.trading_name': "Nome comercial",
    'set.if_different': "Se for diferente",
    'set.company_number': "Número de empresa",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "Número de IVA",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Tipo de atividade",
    'set.ind_farm': "Exploração agrícola",
    'set.ind_estate': "Herdade",
    'set.ind_contractor': "Prestador de serviços agrícolas",
    'set.ind_dealership': "Concessionário",
    'set.ind_other': "Outro",
    'set.primary_email': "E-mail principal",
    'set.phone_number': "Número de telefone",
    'set.website': "Site",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Morada linha 1",
    'set.address2': "Morada linha 2",
    'set.town': "Localidade / Cidade",
    'set.county': "Distrito",
    'set.postcode': "Código postal",
    'set.branding': "Imagem",
    'set.brand_colour': "Cor da marca",
    'set.compliance': "Conformidade",
    'set.hse_number': "Número de registo HSE",
    'set.insurance_provider': "Seguradora",
    'set.policy_number': "Número de apólice",
    'set.insurance_expiry': "Validade do seguro",
    'set.sharing_transfers': "Partilha e transferências",
    'set.org_code_desc': "O código da sua organização serve para receber máquinas partilhadas e transferências de outros clientes Agriware. Partilhe-o com quem partilhe consigo a propriedade de máquinas ou lhe venda uma máquina.",
    'set.emails': "E-mails",
    'set.hold_the_yard': "E-mail semanal Hold the Yard",
    'set.hold_the_yard_desc': "Um resumo, todas as segundas-feiras, das verificações antes da utilização da semana anterior, enviado aos administradores e gestores da organização.",
    'set.org_code': "Código da organização",
    'set.generating': "A gerar…",
    'set.copied': "Copiado!",
    'set.copy': "Copiar",
    'set.org_saved': "Definições da organização guardadas",
    'set.err_save': "Não foi possível guardar as definições",
    'set.save_changes': "Guardar alterações",
    'set.status_trialing': "Em teste",
    'set.status_past_due': "Pagamento em atraso",
    'set.status_cancelled': "Cancelado",
    'set.status_unpaid': "Por pagar",
    'set.status_incomplete': "Incompleto",
    'set.billing_title': "Faturação e subscrição",
    'set.billing_subtitle': "Faça a gestão da sua subscrição do Agriware Operations.",
    'set.plan_standard': "Standard",
    'set.per_month': "/mês · cancele quando quiser",
    'set.grandfathered': "Esta organização tem acesso herdado. Os dados de faturação não estão disponíveis porque esta conta é anterior à integração com o Stripe.",
    'set.next_billing': "Próxima data de faturação:",
    'set.feat_registry': "Registo de máquinas e histórico de manutenção",
    'set.feat_checks': "Verificações diárias e inspeções",
    'set.feat_defects': "Acompanhamento de avarias e defeitos",
    'set.feat_staff': "Qualificações e turnos do pessoal",
    'set.feat_reporting': "Conjunto de relatórios",
    'set.feat_unlimited': "Locais e operadores ilimitados",
    'set.err_no_portal': "Não foi devolvido nenhum URL do portal.",
    'set.err_portal': "Não foi possível abrir o portal de faturação. Tente novamente ou contacte o suporte.",
    'set.opening_portal': "A abrir o portal de faturação…",
    'set.manage_billing': "Gerir faturação",
    'set.admin_only_billing': "Apenas os administradores da organização podem gerir a faturação.",
    'set.stripe_note': "A faturação é processada em segurança pelo Stripe. Nunca vemos os dados do seu cartão.",
    'int.abax_desc': "Obtenha horas de motor, localização e utilização diretamente dos rastreadores ABAX, para que as horas cheguem sozinhas em vez de serem digitadas.",
    'int.abax_detail': "As horas automáticas manteriam corretos os intervalos de manutenção, as estimativas de carbono e o cumprimento das verificações sem introduzir leituras.",
    'int.dms_desc': "Ligue-se ao DMS do seu concessionário para criar pedidos de trabalho, aprovar orçamentos e receber fichas de trabalho seladas na máquina certa.",
    'int.dms_detail': "O trabalho realizado pelo seu concessionário é adicionado automaticamente ao registo da máquina e aparece no respetivo passaporte.",
    'int.almanac_desc': "Veja como as suas máquinas se comparam com os mesmos modelos em todas as frotas Agriware — pontos de falha típicos, intervalos de manutenção e fiabilidade por modelo.",
    'int.almanac_detail': "O Almanac agrega dados anonimizados de defeitos e manutenção de várias organizações. Os seus dados contribuem; em troca, vê o agregado.",
    'int.consent_shared': "Partilhado: marca e modelo da máquina, tipos de defeito, horas na avaria, intervalos de manutenção",
    'int.consent_never': "Nunca partilhado: o nome da sua organização, locais, pessoal, operadores, custos ou documentos",
    'int.consent_threshold': "Os valores só são mostrados quando existem máquinas suficientes para que as frotas individuais não sejam identificáveis",
    'int.consent_withdraw': "Pode retirar-se a qualquer momento — os registos contribuídos são removidos de agregados futuros",
    'int.err_update': "Não foi possível atualizar esta integração",
    'int.interest_noted': "Registado — entraremos em contacto quando estiver pronto",
    'int.almanac_enabled': "Almanac ativado",
    'int.almanac_disabled': "Almanac desativado",
    'int.subtitle': "Ligue o Agriware Operations aos sistemas que já usa",
    'int.admin_only': "Apenas um administrador da organização pode alterar as integrações.",
    'int.enabled': "Ativado",
    'int.in_development': "Em desenvolvimento",
    'int.withdraw': "Retirar",
    'int.enable_almanac': "Ativar Almanac",
    'int.interest_registered': "Interesse registado",
    'int.register_interest': "Registar interesse",
    'int.less': "Menos",
    'int.what_this_does': "O que isto faz",
    'int.footer': "Usa algo que não está aqui? Diga-nos o que gostaria de ligar — os pedidos decidem o que é construído a seguir.",
    'tmpl.scope_all_desc': "Aplica-se a todas as máquinas da organização",
    'tmpl.scope_category': "Por categoria",
    'tmpl.scope_category_desc': "Aplica-se às categorias selecionadas",
    'tmpl.scope_specific_desc': "Aplica-se apenas a uma máquina",
    'tmpl.freq_daily': "Diário",
    'tmpl.freq_daily_helper': "Tem de ser concluído todos os dias até à hora-limite",
    'tmpl.freq_weekly': "Semanal",
    'tmpl.freq_weekly_helper': "Tem de ser concluído uma vez por semana",
    'tmpl.freq_hourly': "Por horas",
    'tmpl.freq_hourly_helper': "Acionado a cada X horas de motor",
    'tmpl.freq_monthly': "Mensal",
    'tmpl.freq_monthly_helper': "Tem de ser concluído uma vez por mês",
    'tmpl.item_passfail': "Aprovado / Reprovado",
    'tmpl.item_numeric': "Numérico",
    'tmpl.item_text': "Texto",
    'tmpl.item_photo': "Foto",
    'tmpl.item_signature': "Assinatura",
    'tmpl.fail_none': "Apenas registar",
    'tmpl.fail_flag': "Registar e notificar",
    'tmpl.fail_block': "Registar, notificar e bloquear",
    'tmpl.section_default': "Secção",
    'tmpl.err_name': "O nome do modelo é obrigatório",
    'tmpl.err_category': "Selecione pelo menos uma categoria",
    'tmpl.err_machine': "Selecione uma máquina",
    'tmpl.err_items': "Adicione pelo menos um item de verificação",
    'tmpl.updated': "Modelo atualizado",
    'tmpl.created': "Modelo criado",
    'tmpl.err_save': "Não foi possível guardar o modelo",
    'tmpl.name_placeholder': "Nome do modelo",
    'tmpl.save': "Guardar modelo",
    'tmpl.settings': "Definições do modelo",
    'tmpl.description_placeholder': "Breve descrição de quando este modelo é usado",
    'tmpl.applies_to': "Aplica-se a",
    'tmpl.select_categories_caps': "SELECIONAR CATEGORIAS",
    'tmpl.select_machine_caps': "SELECIONAR MÁQUINA",
    'tmpl.choose_machine': "Escolha uma máquina…",
    'tmpl.frequency': "Frequência de verificação",
    'tmpl.estimated_time': "Tempo estimado (minutos)",
    'tmpl.every_x_hours': "A cada X horas de motor",
    'tmpl.due_by_time': "Hora-limite",
    'tmpl.due_by_hint': "— o lembrete de atraso é enviado a esta hora",
    'tmpl.due_by_note': "É enviada uma notificação push ao operador e ao responsável do local se não for concluído até esta hora",
    'tmpl.item_one': "item",
    'tmpl.item_many': "itens",
    'tmpl.new_item': "Novo item de verificação",
    'tmpl.add_item': "Adicionar item de verificação",
    'tmpl.add_section': "Adicionar secção",
    'tmpl.item_panel_title': "Item de verificação",
    'tmpl.select_item_hint': "Selecione um item de verificação à esquerda para editar as definições aqui.",
    'tmpl.label': "Etiqueta",
    'tmpl.label_placeholder': "p. ex. nível de óleo do motor",
    'tmpl.if_fails': "Se for reprovado",
    'tmpl.required': "Obrigatório",
    'tmpl.required_hint': "O operador tem de preencher este item",
    'status.active': "Ativo",
    'status.shared': "Partilhada",
    'status.transferred': "Transferida",
    'status.archived': "Arquivada",
    'status.issues': "Anomalias",
    'status.emergency': "Emergência",
    'status.closed': "Fechado",
    'status.due': "A vencer",
    'status.draft': "Rascunho",
    'status.approved': "Aprovado",
    'status.declined': "Recusado",
    'status.scheduled': "Agendado",
    'photo.title': "Foto de perfil",
    'photo.upload_title': "Carregar uma foto",
    'photo.upload_note': "JPG, PNG ou WebP · máx. 5 MB · será recortada em círculo",
    'photo.choose': "Escolher foto",
    'photo.drag_hint': "Arraste para reposicionar · desloque ou use o cursor para ampliar",
    'photo.change': "Alterar foto",
    'photo.save': "Guardar foto",
    'upsell.derv_title': "Gestão de combustível",
    'upsell.derv_desc': "Acompanhe os níveis do depósito, registe abastecimentos, faça a gestão de fornecedores e monitorize o consumo por máquina em todos os locais.",
    'upsell.coshh_title': "Registo de substâncias perigosas",
    'upsell.coshh_desc': "Mantenha um registo digital de substâncias perigosas, fichas de dados de segurança e EPI necessários para os seus colaboradores.",
    'upsell.risk_title': "Avaliações de risco",
    'upsell.risk_desc': "Crie, faça a gestão e sele avaliações de risco por máquina ou tarefa. Os operadores confirmam antes de iniciar o trabalho.",
    'upsell.jobs_title': "Integração DMS",
    'upsell.jobs_desc': "Solicite trabalhos de oficina ao seu concessionário, aprove orçamentos e receba fichas de trabalho seladas diretamente nas fichas das máquinas.",
    'upsell.reporting_title': "Relatórios e análises",
    'upsell.reporting_desc': "Relatórios de estado da frota, conformidade, qualificações, consumo, emissões de CO₂ e custo por máquina.",
    'upsell.quals_title': "Acompanhamento de qualificações",
    'upsell.quals_desc': "Registe certificados do pessoal com controlo de validades, notificações push e bloqueio de máquinas conforme a qualificação.",
    'upsell.sharing_title': "Partilha de máquinas",
    'upsell.sharing_desc': "Partilhe os registos das máquinas com outras organizações Agriware Ops — ideal para prestadores e equipamento partilhado.",
    'upsell.transfers_title': "Transferências de máquinas",
    'upsell.transfers_desc': "Transfira máquinas entre utilizadores Ops ou contas DMS com histórico completo de propriedade e livrete digital.",
    'upsell.carbon_title': "Relatórios de carbono",
    'upsell.carbon_desc': "Cálculo automático das emissões de CO₂ com base no consumo de combustível. Relatórios segundo a norma DEFRA para a sua frota.",
    'upsell.not_included': "Esta funcionalidade não está incluída no seu plano atual.",
    'upsell.upgrade': "Atualizar o seu plano",
    'service.record_not_found': "Registo não encontrado",
    'service.record_title_service': "Registo de manutenção",
    'service.record_title_repair': "Registo de reparação",
    'service.record_title_inspection': "Registo de inspeção",
    'service.record_suffix': "registo",
    'service.email_btn': "E-mail",
    'service.email_coming_soon': "Exportação por e-mail em breve",
    'service.sealed_by_workshop': "Selado por {name} e não pode ser alterado",
    'service.the_workshop': "a oficina",
    'service.sealed_permanent': "Este registo está selado permanentemente e não pode ser alterado",
    'service.sealed_by': "Selado por",
    'service.at_suffix': "em {name}",
    'service.job_ref': "ordem {ref}",
    'service.photos_video': "Fotos e vídeo",
    'service.job_photo': "Foto do trabalho",
    'service.files_copying': "Alguns ficheiros ainda estão a ser copiados.",
    'service.date_of_service': "Data da manutenção",
    'service.hours_at_service': "Horas na manutenção",
    'service.total_cost': "Custo total",
    'service.record_details': "Detalhes do registo",
    'service.type': "Tipo",
    'service.performed_by': "Realizado por",
    'service.performed_by_type': "Tipo de executante",
    'service.next_service_hours': "Horas até à próxima manutenção",
    'service.next_service_date': "Data da próxima manutenção",
    'service.notes': "Notas",
    'service.parts_used': "Peças utilizadas",
    'service.col_part': "Peça",
    'service.col_qty': "Qtd.",
    'service.col_cost': "Custo",
    'service.parts_total': "Total de peças",
    'service.cost_breakdown': "Detalhe dos custos",
    'service.labour_cost': "Custo de mão de obra",
    'service.parts_cost': "Custo das peças",
    'service.total': "Total",
    'service.audit_trail': "Registo de auditoria",
    'service.record_created_by': "Registo criado por",
    'service.record_sealed_by': "Registo selado por",
    'service.type_service': "Manutenção",
    'service.type_service_desc': "Manutenção periódica programada",
    'service.type_repair': "Reparação",
    'service.type_repair_desc': "Trabalho de reparação não programado",
    'service.type_inspection': "Inspeção",
    'service.type_inspection_desc': "Verificação de segurança ou conformidade",
    'service.by_internal': "Interno",
    'service.by_dealer': "Concessionário",
    'service.by_external': "Prestador externo",
    'service.err_description': "Introduza uma descrição",
    'service.err_date': "Introduza a data da manutenção",
    'service.added_toast': "Registo de manutenção adicionado e selado",
    'service.err_save': "Não foi possível guardar o registo — tente novamente",
    'service.seal_note': "Este registo ficará selado permanentemente depois de guardado",
    'service.record_type': "Tipo de registo",
    'service.description_placeholder': "Descreva o trabalho realizado…",
    'service.performed_by_placeholder': "Nome ou empresa",
    'service.additional_notes': "Notas adicionais",
    'service.notes_placeholder': "Quaisquer notas adicionais…",
    'service.add_part': "Adicionar peça",
    'service.part_name': "Nome da peça",
    'service.cost_placeholder': "Custo £",
    'service.cost_next_service': "Custo e próxima manutenção",
    'service.labour_cost_field': "Custo de mão de obra (£)",
    'service.next_hours_placeholder': "p. ex. 1750",
    'service.seal_warning': "Depois de guardado, este registo fica selado permanentemente e não pode ser editado. Confirme que todos os dados estão corretos antes de guardar.",
    'service.save_seal': "Guardar e selar registo",
    'dashboard.there': "olá",
    'dashboard.total_machines': "Total de máquinas",
    'dashboard.blocked_machines': "Máquinas bloqueadas",
    'dashboard.open_incidents': "Incidentes abertos",
    'dashboard.open_defects': "Defeitos abertos",
    'dashboard.fuel_tanks': "Depósitos de combustível",
    'common.of': "de",
    'dashboard.fleet': "Frota",
    'common.view_all': "Ver tudo",
    'dashboard.no_machines': "Ainda sem máquinas",
    'dashboard.no_machines_msg': "Adicione a sua primeira máquina para começar",
    'dashboard.recent_incidents': "Incidentes recentes",
    'dashboard.no_incidents_msg': "Nenhum incidente registado",
    'dashboard.recent_defects': "Defeitos recentes",
    'dashboard.no_defects': "Sem defeitos",
    'dashboard.no_defects_msg': "Nenhum defeito comunicado",
    'dashboard.defect_reported': "Defeito comunicado",
    'dashboard.group_overview': "Visão do grupo",
    'dashboard.send_announcement': "Enviar comunicado",
    'dashboard.sites': "Locais",
    'dashboard.no_sites': "Ainda sem locais",
    'dashboard.no_sites_msg': "Adicione o seu primeiro local nas Definições para começar",
    'dashboard.add_site': "Adicionar local",
    'dashboard.status_monitor': "Vigiar",
    'dashboard.status_all_good': "Tudo bem",
    'dashboard.derv': "Gasóleo",
    'dashboard.derv_level': "Nível de gasóleo",
    'qual.short_forklift': "Empilhador",
    'qual.short_sprayer': "Pulverizador",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Condução",
    'qual.short_firstaid': "Primeiros socorros",
    'qual.short_chainsaw': "Motosserra",
    'qual.short_pesticide': "Fitofármacos",
    'qual.short_telehandler': "Telescópica",
    'qual.short_atv': "Moto4",
    'qual.short_other': "Outro",
    'qual.forklift': "Licença de operador de empilhador",
    'qual.sprayer': "Certificado de pulverizador PA1/PA6",
    'qual.cscs': "Cartão CSCS",
    'qual.driving': "Carta de condução",
    'qual.firstaid': "Certificado de primeiros socorros",
    'qual.chainsaw': "Certificado de motosserra",
    'qual.pesticide': "Aplicação de fitofármacos",
    'qual.telehandler': "Certificado de telescópica",
    'qual.atv': "Certificado de moto4/ATV",
    'qual.other': "Outra qualificação",
    'staff.n_expired': "caducadas",
    'staff.n_expiring': "a caducar",
    'staff.n_valid': "válidas",
    'common.none': "Nenhuma",
    'staff.tab_members': "Membros",
    'staff.tab_qualifications': "Qualificações",
    'staff.tab_shifts': "Turnos",
    'staff.member_one': "membro",
    'staff.member_many': "membros",
    'staff.alert_one': "alerta de qualificação",
    'staff.alert_many': "alertas de qualificação",
    'staff.invite': "Convidar pessoal",
    'staff.create_shift': "Criar turno",
    'staff.search': "Pesquisar por nome ou e-mail…",
    'staff.none_found': "Nenhum membro do pessoal encontrado",
    'staff.adjust_search': "Tente ajustar a pesquisa",
    'staff.invite_first': "Convide o seu primeiro membro da equipa",
    'staff.stat_total_quals': "Total de qualificações",
    'staff.stat_valid': "Válidas",
    'staff.stat_expiring_30d': "A caducar (30 d)",
    'staff.stat_expiring': "A caducar",
    'staff.stat_expired': "Caducadas",
    'staff.qual_one': "qualificação",
    'staff.qual_many': "qualificações",
    'staff.expires': "Caduca em",
    'staff.no_quals': "Nenhuma qualificação registada",
    'staff.no_quals_msg': "Adicione qualificações a partir da ficha de cada colaborador",
    'staff.no_shifts': "Ainda sem turnos",
    'staff.no_shifts_msg': "Crie o seu primeiro turno para acompanhar quem está a trabalhar",
    'staff.shift': "Turno",
    'staff.checked_in': "registados",
    'staff.not_found': "Membro do pessoal não encontrado",
    'staff.add_qualification': "Adicionar qualificação",
    'staff.expired_alert_one': "qualificação caducou — este operador pode não estar autorizado a usar certas máquinas",
    'staff.expired_alert_many': "qualificações caducaram — este operador pode não estar autorizado a usar certas máquinas",
    'staff.expiring_alert_one': "qualificação caduca dentro de 30 dias",
    'staff.expiring_alert_many': "qualificações caducam dentro de 30 dias",
    'staff.tab_details': "Detalhes",
    'staff.contact': "Contacto",
    'staff.account': "Conta",
    'staff.onboarding': "Integração",
    'staff.complete': "Concluída",
    'staff.job_title': "Função",
    'staff.joined': "Entrou em",
    'staff.invited_by': "Convidado por",
    'staff.quals_tickets': "Qualificações e certificados",
    'staff.no_quals_profile_msg': "Adicione os certificados deste operador",
    'staff.issued': "Emitido",
    'staff.no_expiry': "Sem validade",
    'staff.expires_today': "Caduca hoje",
    'staff.days_remaining_one': "dia restante",
    'staff.days_remaining_many': "dias restantes",
    'staff.expired_days_ago_one': "Caducou há {n} dia",
    'staff.expired_days_ago_many': "Caducou há {n} dias",
    'staff.view_certificate': "Ver certificado",
    'staff.assigned_machines': "Máquinas atribuídas",
    'staff.no_machines': "Nenhuma máquina atribuída",
    'staff.no_machines_msg': "Este operador não tem máquinas atribuídas",
    'staff.err_first_name': "O nome próprio é obrigatório",
    'staff.err_last_name': "O apelido é obrigatório",
    'staff.err_email': "Introduza um endereço de e-mail válido",
    'staff.err_site': "Selecione um local",
    'staff.err_create_prefix': "Não foi possível criar a conta:",
    'staff.err_timeout': "Tempo esgotado ao criar a conta. Atualize a página e tente novamente.",
    'staff.err_create': "Não foi possível criar a conta — tente novamente",
    'staff.copy_greeting': "Olá {name},",
    'staff.copy_body': "A sua conta do Agriware Operations foi criada.",
    'staff.copy_email': "E-mail:",
    'staff.copy_temp_password': "Palavra-passe temporária:",
    'staff.copy_footer': "Ser-lhe-á pedido que altere a palavra-passe no primeiro início de sessão.",
    'staff.copied_toast': "Dados de acesso copiados para a área de transferência",
    'staff.role_admin_desc': "Acesso total a todos os locais e definições",
    'staff.role_manager_desc': "Gere um local, o pessoal e as máquinas",
    'staff.role_operator_desc': "Realiza as verificações diárias através da app móvel",
    'staff.add_member': "Adicionar membro do pessoal",
    'staff.add_member_sub': "A conta será criada de imediato. Verá os dados de acesso para partilhar.",
    'staff.account_created': "Conta criada",
    'staff.share_details_pre': "Partilhe estes dados de acesso com",
    'staff.share_details_post': "Ser-lhe-á pedido que altere a palavra-passe no primeiro início de sessão.",
    'staff.label_email_caps': "E-MAIL",
    'staff.label_temp_password_caps': "PALAVRA-PASSE TEMPORÁRIA",
    'staff.copy_login_details': "Copiar dados de acesso",
    'staff.add_another': "Adicionar outro",
    'staff.back_to_staff': "Voltar ao pessoal",
    'staff.personal_details': "Dados pessoais",
    'staff.first_name': "Nome próprio",
    'staff.last_name': "Apelido",
    'staff.work_email': "E-mail profissional",
    'staff.site_assignment': "Atribuição de local",
    'staff.no_sites': "Ainda não há locais — adicione primeiro um local nas Definições",
    'staff.creating_account': "A criar conta…",
    'staff.create_account': "Criar conta",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Selecione um tipo de qualificação",
    'qual.err_name': "Introduza o nome da qualificação",
    'qual.err_issue_date': "Introduza a data de emissão",
    'qual.err_expiry': "Introduza a data de validade ou marque «sem validade»",
    'qual.added_toast': "Qualificação adicionada",
    'qual.err_save': "Não foi possível guardar a qualificação — tente novamente",
    'qual.back_staff_profile': "Ficha do colaborador",
    'qual.subtitle': "Registe um certificado, atestado ou licença deste operador",
    'qual.type_title': "Tipo de qualificação",
    'qual.name_label': "Nome da qualificação",
    'qual.name_placeholder': "p. ex. certificado de roçadora NPTC",
    'qual.cert_details': "Dados do certificado",
    'qual.cert_number': "Número do certificado",
    'common.optional_suffix': "— opcional",
    'qual.cert_number_placeholder': "p. ex. NPORS-123456",
    'qual.issuing_body': "Entidade emissora",
    'qual.issuing_body_placeholder': "p. ex. NPORS, LANTRA, CITB",
    'qual.issue_date': "Data de emissão",
    'qual.expiry_date': "Data de validade",
    'qual.no_expiry_label': "Esta qualificação não tem data de validade",
    'qual.cert_document': "Documento do certificado",
    'qual.upload_note': "Carregue uma foto ou digitalização do certificado. É guardado de forma privada e nunca partilhado.",
    'common.remove': "Remover",
    'qual.click_upload': "Clique para carregar o certificado",
    'qual.file_types': "JPG, PNG ou PDF",
    'common.saving': "A guardar…",
    'qual.save': "Guardar qualificação",
    'defects.title': "Defeitos",
    'defects.n_open': "abertos",
    'defects.n_critical': "críticos",
    'defects.stat_total': "Total de defeitos",
    'defects.status_open': "Aberto",
    'defects.status_in_progress': "Em curso",
    'defects.status_resolved': "Resolvido",
    'defects.all_severities': "Todas as gravidades",
    'defects.sev_minor': "Ligeiro",
    'defects.sev_moderate': "Moderado",
    'defects.sev_major': "Grave",
    'defects.sev_critical': "Crítico",
    'defects.search': "Pesquisar defeitos…",
    'common.clear': "Limpar",
    'defects.col_description': "Descrição",
    'defects.reported_by': "Comunicado por",
    'defects.col_severity': "Gravidade",
    'defects.no_description': "Sem descrição",
    'defects.none_found': "Nenhum defeito encontrado",
    'defects.none_reported': "Não foi comunicado nenhum defeito",
    'defects.acknowledged_toast': "Defeito confirmado",
    'defects.acknowledge_failed': "Não foi possível confirmar o defeito",
    'defects.resolved_released': "Defeito resolvido — máquina libertada",
    'defects.resolved_toast': "Defeito resolvido",
    'defects.resolve_failed': "Não foi possível resolver o defeito",
    'defects.not_found': "Defeito não encontrado",
    'defects.report_title': "Relatório de defeito",
    'defects.acknowledge': "Confirmar",
    'defects.raise_job': "Criar ordem de trabalho",
    'defects.resolve': "Resolver",
    'defects.blocking_banner': "Máquina bloqueada — um responsável tem de registar uma libertação escrita antes de voltar ao serviço",
    'defects.details_title': "Detalhes do defeito",
    'defects.no_description_provided': "Não foi fornecida qualquer descrição",
    'defects.reported_at': "Comunicado em",
    'defects.location': "Localização",
    'defects.photos': "Fotos",
    'defects.acknowledgement': "Confirmação",
    'defects.acknowledged_by': "Confirmado por",
    'defects.resolved_by': "Resolvido por",
    'defects.return_to_service': "Reposição em serviço",
    'defects.revised': "Revista",
    'defects.revised_by_suffix': "por {name}",
    'defects.view_machine_profile': "Ver ficha da máquina",
    'defects.resolve_and_release': "Resolver e repor em serviço",
    'defects.resolve_defect': "Resolver o defeito",
    'defects.release_machine': "Libertar a máquina",
    'defects.mark_resolved': "Marcar como resolvido",
    'defects.release_warning': "Esta máquina está bloqueada. A sua libertação escrita ficará registada com o seu nome e função e aparecerá no passaporte da máquina.",
    'defects.resolution_details': "Detalhes da resolução",
    'defects.resolution_placeholder': "Descreva como o defeito foi resolvido…",
    'defects.narrative_placeholder': "O que foi encontrado, o que foi feito e como a máquina foi verificada antes da libertação. Inclua números de ordem de trabalho e detalhes de ensaio quando aplicável.",
    'defects.chars_needed_one': "carácter adicional necessário",
    'defects.chars_needed_many': "carateres adicionais necessários",
    'defects.characters': "carateres",
    'defects.permanent_note': "Isto ficará permanentemente registado no relatório de defeito.",
    'machines.tab_overview': "Visão geral",
    'machines.tab_history': "Histórico",
    'machines.tab_documents': "Documentos",
    'machines.tab_operators': "Operadores",
    'machines.tab_sharing': "Partilha",
    'machines.tab_incidents': "Incidentes",
    'machines.pdf_only': "Só são aceites ficheiros PDF.",
    'machines.replace_confirm': "Substituir o documento existente ({name})? O ficheiro antigo será eliminado.",
    'machines.delete_doc_confirm': "Eliminar este documento? Esta ação não pode ser anulada.",
    'machines.uploaded': "Carregado",
    'machines.no_file_yet': "Ainda sem ficheiro",
    'machines.uploading': "A carregar…",
    'machines.view_document': "Ver documento",
    'common.replace': "Substituir",
    'common.delete': "Eliminar",
    'common.upload': "Carregar",
    'machines.doc_type_manual': "Manual",
    'machines.doc_type_private': "Privado",
    'machines.doc_operators_manual': "Manual do operador",
    'machines.doc_workshop_manual': "Manual de oficina",
    'machines.untitled_document': "Documento sem título",
    'machines.add_document': "Adicionar documento",
    'machines.documents_intro': "O manual do operador e o manual de oficina ocupam campos próprios — ajudam-nos a identificar o documento certo ao partilhar com a biblioteca Agriware. Os restantes documentos privados são visíveis apenas para a sua organização.",
    'machines.returned_to_service': "Máquina reposta em serviço",
    'machines.not_blocked': "Esta máquina não está bloqueada",
    'machines.resolve_defect_first': "Resolva o defeito em aberto para repor esta máquina em serviço",
    'machines.return_failed': "Não foi possível repor a máquina em serviço",
    'machines.machine_not_found': "Máquina não encontrada",
    'common.unknown': "Desconhecido",
    'machines.unblock': "Desbloquear",
    'service.add_record': "Adicionar registo de manutenção",
    'machines.serial_number': "Número de série",
    'machines.year': "Ano",
    'machines.blocked_banner': "Máquina bloqueada — não utilizar",
    'machines.current_hours': "Horas atuais",
    'machines.next_service': "Próxima manutenção",
    'machines.service_records': "Registos de manutenção",
    'machines.service_progress': "Progresso até à manutenção",
    'machines.cost_over_time': "Evolução dos custos",
    'machines.cost_over_time_sub': "Manutenção, reparação e custo de propriedade acumulado",
    'machines.cost_empty': "Os dados de custo aparecem à medida que forem adicionados registos de manutenção.",
    'machines.series_service': "Manutenção",
    'machines.series_repair': "Reparação",
    'machines.series_cumulative': "Acumulado",
    'machines.details_title': "Detalhes da máquina",
    'machines.make': "Marca",
    'machines.model': "Modelo",
    'machines.category': "Categoria",
    'machines.assigned_to': "Atribuída a",
    'machines.pool_machine': "Máquina de frota comum",
    'machines.unassigned': "Não atribuída",
    'machines.purchase_value': "Compra e valor",
    'machines.purchase_date': "Data de compra",
    'machines.purchase_price': "Preço de compra",
    'machines.depreciation_rate': "Taxa de depreciação",
    'machines.per_year': "por ano",
    'machines.estimated_life': "Vida útil estimada",
    'common.unit_years': "anos",
    'machines.cost_tracking': "Controlo de custos",
    'machines.total_service_cost': "Custo total de manutenção",
    'machines.total_repair_cost': "Custo total de reparação",
    'machines.total_fuel_cost': "Custo total de combustível",
    'machines.total_cost_ownership': "Custo total de propriedade",
    'machines.service_history': "Histórico de manutenção e reparações",
    'service.add_record_short': "Adicionar registo",
    'service.none_yet': "Ainda sem registos de manutenção",
    'service.none_yet_msg': "Adicione o seu primeiro registo de manutenção ou reparação",
    'service.sealed': "Selado",
    'service.workshop': "Oficina",
    'common.photo_one': "foto",
    'common.photo_many': "fotos",
    'machines.assigned_operators': "Operadores atribuídos",
    'machines.no_operator': "Nenhum operador atribuído",
    'machines.no_operator_msg': "Esta máquina não tem operador atribuído",
    'machines.pool_machine_msg': "Esta é uma máquina de frota comum — disponível para todos os operadores",
    'machines.ownership_sharing': "Propriedade e partilha",
    'machines.share_machine': "Partilhar máquina",
    'machines.current_owner': "Proprietário atual",
    'machines.your_organisation': "A sua organização",
    'machines.shared_with': "Partilhada com",
    'machines.not_shared': "Não partilhada com nenhuma outra organização",
    'machines.incident_history': "Histórico de incidentes",
    'incidents.none': "Sem incidentes",
    'incidents.none_msg': "Não há incidentes registados para esta máquina",
    'incidents.impact_detected': "Impacto detetado",
    'incidents.manual_sos': "SOS manual",
    'incidents.man_down': "Alerta de homem-morto",
    'machines.unblock_title': "Repor a máquina em serviço",
    'machines.confirm_unblock': "Confirmar desbloqueio",
    'machines.unblock_warning': "A sua declaração escrita fica registada na verificação que parou esta máquina e aparece no respetivo passaporte. Se a máquina estiver bloqueada por um defeito em aberto, resolva antes o defeito.",
    'machines.blocked_reason': "Motivo do bloqueio",
    'machines.unblock_statement': "Declaração de reposição em serviço",
    'machines.unblock_placeholder': "O que foi encontrado, o que foi feito e como a máquina foi verificada antes da libertação.",
    'checks.history_title': "Histórico de verificações",
    'checks.stat_total': "Total de verificações",
    'checks.stat_passed': "Aprovadas",
    'checks.stat_failed': "Reprovadas",
    'checks.n_passed': "aprovadas",
    'checks.n_failed': "reprovadas",
    'common.clear_filters': "Limpar filtros",
    'checks.not_found': "Verificação não encontrada",
    'common.export_pdf': "Exportar PDF",
    'common.pdf_coming_soon': "Exportação para PDF em breve",
    'checks.item_failed_one': "item reprovado",
    'checks.item_failed_many': "itens reprovados",
    'checks.auto_blocked': "A máquina foi bloqueada automaticamente na submissão",
    'checks.sealed_record': "Registo selado",
    'checks.submitted_by': "Submetido por",
    'checks.submitted_at': "Submetido em",
    'checks.hours_at_check': "Horas na verificação",
    'checks.stat_total_items': "Total de itens",
    'checks.stat_mileage': "Quilometragem",
    'checks.details_title': "Detalhes da verificação",
    'checks.failed_items': "Itens reprovados",
    'checks.no_items_recorded': "Nenhum item de verificação registado",
    'checks.alt_defect_photo': "Foto do defeito",
    'checks.alt_check_photo': "Foto da verificação",
    'common.unit_hrs': "h",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Modelos",
    'checks.tab_history': "Histórico",
    'checks.create_template': "Criar modelo",
    'checks.scope_specific': "Máquina específica",
    'checks.scope_all': "Todas as máquinas",
    'checks.categories': "categorias",
    'checks.items': "itens",
    'checks.title': "Verificações",
    'checks.template_one': "modelo",
    'checks.template_many': "modelos",
    'checks.record_one': "registo",
    'checks.record_many': "registos",
    'checks.no_templates': "Ainda sem modelos",
    'checks.no_templates_msg': "Crie modelos para definir o que os operadores devem verificar antes de usar as máquinas",
    'checks.search': "Pesquisar por máquina ou operador…",
    'checks.all_results': "Todos os resultados",
    'checks.pass': "Aprovado",
    'checks.fail': "Reprovado",
    'checks.none_found': "Nenhuma verificação encontrada",
    'checks.adjust_filters': "Tente ajustar os filtros",
    'checks.none_submitted': "Ainda não foi submetida nenhuma verificação",
    'checks.col_operator': "Operador",
    'checks.col_datetime': "Data e hora",
    'checks.col_result': "Resultado",
    'machines.add': "Adicionar máquina",
    'machines.col_machine': "Máquina",
    'machines.col_serial': "N.º série / Matrícula",
    'machines.col_site': "Local",
    'machines.col_hours': "Horas",
    'machines.col_status': "Estado",
    'machines.title': "Máquinas",
    'machines.count_one': "máquina",
    'machines.count_many': "máquinas",
    'machines.blocked': "bloqueada(s)",
    'machines.search': "Pesquisar por marca, modelo, n.º de série ou matrícula…",
    'machines.all_sites': "Todos os locais",
    'machines.all_statuses': "Todos os estados",
    'machines.available': "Disponível",
    'machines.blocked_one': "Bloqueada",
    'machines.none_found': "Nenhuma máquina encontrada",
    'machines.view': "Ver",
    'cat.all': "Todas as categorias",
    'cat.agricultural': "Agrícola",
    'cat.groundcare': "Manutenção de espaços verdes",
    'cat.plant': "Equipamento",
    'cat.vehicle': "Veículo",
    'cat.atv': "Moto-quatro",
    'nav.dashboard': "Painel",
    'nav.staff': "Pessoal",
    'nav.checks': "Verificações",
    'nav.safety': "Segurança",
    'nav.operations': "Operações",
    'nav.settings': "Definições",
    'nav.billing': "Faturação",
    'nav.sign_out': "Terminar sessão",
    'role.admin': "Administrador",
    'role.manager': "Gestor",
    'role.operator': "Operador",
    'app.name': 'AgriWare Operações',
    'app.tagline': 'Gestão',
    'nav.home': 'Início',
    'nav.machines': 'Máquinas',
    'nav.profile': 'Perfil',
    'common.back': 'Voltar',
    'common.cancel': 'Cancelar',
    'common.save': 'Guardar',
    'common.edit': 'Editar',
    'common.done': 'Concluído',
    'common.yes': 'Sim',
    'common.no': 'Não',
    'common.ok': 'OK',
    'common.error': 'Erro',
    'common.loading': 'A carregar...',
    'common.retry': 'Tentar novamente',
    'common.search': 'Pesquisar',
    'common.submit': 'Submeter',
    'common.confirm': 'Confirmar',
    'common.close': 'Fechar',
    'common.pass': 'Aprovado',
    'common.fail': 'Reprovado',
    'common.total': 'total',
    'common.today': 'Hoje',
    'common.yesterday': 'Ontem',
    'common.online_only': 'Apenas online',
    'common.last_synced': 'Última sincronização',
    'common.back_to_app': 'Voltar à app',
    'common.gps_shared': 'GPS partilhado',
    'common.yes_via_saas': 'Sim — via SaaS',
    'common.not_called': 'Não chamado',
    'login.sign_in': 'Entrar',
    'login.email': 'Endereço de e-mail',
    'login.password': 'Palavra-passe',
    'login.forgot_password': 'Esqueceu a palavra-passe?',
    'login.no_account': 'Não tem conta?',
    'login.request_access': 'Solicitar acesso',
    'login.account_created_by_org': 'A sua conta foi criada pela sua organização.',
    'login.email_placeholder': 'voce@organizacao.pt',
    'login.password_placeholder': 'Introduza a sua palavra-passe',
    'login.error_empty': 'Por favor introduza o seu e-mail e palavra-passe.',
    'login.error_invalid': 'E-mail ou palavra-passe inválidos. Tente novamente.',
    'dashboard.greeting_morning': 'Bom dia,',
    'dashboard.greeting_afternoon': 'Boa tarde,',
    'dashboard.greeting_evening': 'Boa noite,',
    'dashboard.todays_tasks': 'Tarefas de hoje',
    'dashboard.completed': 'Concluídas',
    'dashboard.overdue': 'Atrasadas',
    'dashboard.in_progress': 'Em curso',
    'dashboard.upcoming': 'Próximas',
    'dashboard.pending': 'Pendentes',
    'machines.search_placeholder': 'Pesquisar máquinas...',
    'machines.favourites': 'Favoritos',
    'machines.all_machines': 'Todas as máquinas',
    'machines.operational': 'Operacional',
    'machines.needs_attention': 'Requer atenção',
    'machines.fault': 'Avaria',
    'machines.unsafe_to_operate': 'Não é seguro operar',
    'machines.registration': 'Matrícula',
    'machines.assigned_operator': 'Operador atribuído',
    'machines.engine_hours': 'Horas de motor',
    'machines.documents': 'Documentos',
    'machines.log_fault': 'Registar avaria',
    'machines.operator_manual': 'Manual do operador',
    'machines.service_record': 'Registo de serviço',
    'machines.insurance': 'Certificado de seguro',
    'machines.mot': 'Inspeção',
    'daily_check.title': 'Verificação diária',
    'daily_check.start': 'Iniciar verificação',
    'daily_check.required': 'Verificação necessária',
    'daily_check.required_msg': 'Deve ser concluída antes de operar esta máquina.',
    'daily_check.complete': 'Verificação concluída',
    'daily_check.complete_msg': 'Concluído por',
    'daily_check.submit': 'Submeter verificação',
    'daily_check.items_remaining': 'itens restantes',
    'daily_check.reward_title': 'Obrigado!',
    'daily_check.reward_subtitle': 'A sua verificação diária foi registada.\nVerificações honestas mantêm todos seguros.',
    'daily_check.back_to_machine': 'Voltar à máquina',
    'daily_check.day_streak': 'Dias consecutivos',
    'daily_check.completion_rate': 'Taxa de conclusão',
    'daily_check.cat_lights': 'Luzes e visibilidade',
    'daily_check.cat_fluids': 'Fluidos',
    'daily_check.cat_tyres': 'Pneus e rodas',
    'daily_check.cat_safety': 'Segurança',
    'daily_check.cat_controls': 'Controlos',
    'daily_check.cat_body': 'Carroçaria e acessórios',
    'daily_check.lights_working': 'Todas as luzes funcionam',
    'daily_check.mirrors': 'Espelhos limpos e ajustados',
    'daily_check.windscreen': 'Para-brisas limpo e intacto',
    'daily_check.engine_oil': 'Nível de óleo do motor',
    'daily_check.coolant': 'Nível de líquido de arrefecimento',
    'daily_check.hydraulic': 'Nível de fluido hidráulico',
    'daily_check.fuel': 'Nível de combustível adequado',
    'daily_check.tyre_pressure': 'Pressão dos pneus correta',
    'daily_check.tyre_damage': 'Sem danos visíveis nos pneus',
    'daily_check.wheel_nuts': 'Porcas das rodas apertadas',
    'daily_check.fire_extinguisher': 'Extintor presente',
    'daily_check.first_aid': 'Kit de primeiros socorros presente',
    'daily_check.rops': 'Estrutura ROPS intacta',
    'daily_check.seatbelt': 'Cinto de segurança funcionando',
    'daily_check.brakes': 'Travões a funcionar',
    'daily_check.steering': 'Direção responsiva',
    'daily_check.horn': 'Buzina a funcionar',
    'daily_check.body_damage': 'Sem danos visíveis na carroçaria',
    'daily_check.attachments': 'Acessórios fixos',
    'daily_check.pto_guard': 'Protetor da tomada de força no lugar',
    'log_fault.title': 'Registar avaria',
    'log_fault.description': 'Descrição',
    'log_fault.description_placeholder': 'Descreva a avaria...',
    'log_fault.photos': 'Fotos',
    'log_fault.add_photo': 'Adicionar foto',
    'log_fault.submit': 'Submeter relatório',
    'log_fault.success': 'Avaria registada com sucesso',
    'emergency.title': 'Emergência',
    'emergency.what_emergency': 'Qual é a emergência?',
    'emergency.select_type': 'Selecione o tipo de emergência.\nOs contactos apropriados serão chamados imediatamente.',
    'emergency.vibrating': 'Vibração',
    'emergency.alarm': 'Alarme',
    'emergency.medical': 'Emergência médica',
    'emergency.medical_sub': 'Lesão, doença ou pessoa inconsciente no local',
    'emergency.calls_999': 'Liga para o 112 imediatamente',
    'emergency.electrical': 'Emergência elétrica',
    'emergency.electrical_sub': 'Contacto com linha elétrica — fique na cabine',
    'emergency.calls_105': 'Liga para o 112 imediatamente',
    'emergency.no_signal': 'Números de emergência guardados no dispositivo — disponíveis sem sinal',
    'emergency.gps_auto': 'Posição GPS partilhada automaticamente',
    'emergency.999_called': '112 chamado',
    'emergency.105_called': 'Linha de emergência chamada',
    'emergency.services_contacted': 'Os serviços de emergência foram contactados.\nO seu supervisor também foi notificado.',
    'emergency.power_contacted': 'A linha de emergência elétrica foi contactada.\nO seu supervisor também foi notificado.',
    'emergency.emergency_type': 'Tipo de emergência',
    'emergency.number_called': 'Número chamado',
    'emergency.location': 'Localização',
    'emergency.admin_notified': 'Admin notificado',
    'emergency.stay_in_cab': 'Fique na cabine',
    'emergency.stay_in_cab_msg': 'Não saia do veículo. Aguarde até que a autoridade confirme que a linha está segura. Mantenha as janelas fechadas.',
    'emergency.medical_type': 'Médica',
    'emergency.electrical_type': 'Elétrica',
    'crash.are_you_okay': 'Está bem?',
    'crash.impact_detected': 'Foi detetado um possível impacto.\nPor favor responda ou será chamada ajuda.',
    'crash.im_okay': 'Estou bem',
    'crash.dismiss_alert': 'Ignorar alerta — sem ação',
    'crash.i_need_help': 'Preciso de ajuda',
    'crash.notify_supervisor': 'Notificar supervisor com posição GPS',
    'crash.call_999': 'Ligar para o 112',
    'crash.call_emergency': 'Ligar para emergências imediatamente',
    'crash.glad_okay': 'Que bom que está bem',
    'crash.alert_dismissed': 'Alerta ignorado. Nenhuma notificação enviada.',
    'crash.help_on_way': 'A ajuda está a caminho',
    'crash.supervisor_notified': 'O seu supervisor foi notificado com a sua posição GPS.',
    'crash.auto_dialled': '112 marcado automaticamente',
    'crash.no_response': 'Sem resposta. Serviços de emergência chamados automaticamente. Mensagem de voz em transmissão.',
    'crash.broadcasting': 'A transmitir mensagem',
    'crash.repeating': 'A repetir a cada 15 segundos',
    'crash.admin_notified': 'Admin notificado',
    'crash.emergency_services': 'Serviços de emergência',
    'profile.title': 'Perfil',
    'profile.personal_info': 'Informação pessoal',
    'profile.full_name': 'Nome completo',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefone',
    'profile.role': 'Função',
    'profile.organisation': 'Organização',
    'profile.emergency_contact': 'Contacto de emergência',
    'profile.emergency_contact_note': 'O seu supervisor será contactado numa emergência',
    'profile.contact_name': 'Nome do contacto',
    'profile.contact_phone': 'Telefone do contacto',
    'profile.notifications': 'Notificações',
    'profile.task_reminders': 'Lembretes de tarefas',
    'profile.overdue_alerts': 'Alertas de atraso',
    'profile.crash_detection': 'Deteção de impacto',
    'profile.account_security': 'Conta e segurança',
    'profile.change_password': 'Alterar palavra-passe',
    'profile.two_factor': 'Autenticação de dois fatores',
    'profile.login_activity': 'Atividade de início de sessão',
    'profile.app_settings': 'Definições da app',
    'profile.theme': 'Tema',
    'profile.language': 'Idioma',
    'profile.sign_out': 'Terminar sessão',
    'profile.sign_out_confirm': 'Terminar sessão',
    'profile.sign_out_msg': 'Tem a certeza que quer terminar a sessão?',
    'profile.field_staff': 'Pessoal de campo',
    'theme.light': 'Claro',
    'theme.dark': 'Escuro',
    'theme.system': 'Padrão do sistema',
  },

  'nl': {
    'verify.err_reference_required': "Een documentreferentie is vereist.",
    'verify.err_rate_limited': "Te veel pogingen. Probeer het zo dadelijk opnieuw.",
    'verify.err_not_found': "Er is geen paspoort uitgegeven met die referentie.",
    'verify.err_code_mismatch': "De organisatiecode en de referentie komen niet overeen.",
    'verify.err_unknown_section': "Onbekend onderdeel.",
    'verify.err_read_failed': "Het dossier kon niet worden gelezen.",
    'verify.intro': "Voer de referentie in die op het document staat om te bevestigen dat het door Agriware Operations is uitgegeven. Voeg de code van de uitgevende organisatie toe om het volledige dossier van de machine te zien — beide staan op het paspoort.",
    'verify.orgcode_optional': "— optioneel, voor het volledige dossier",
    'verify.title': "Een machinepaspoort verifiëren",
    'verify.reference_label': "Documentreferentie",
    'verify.orgcode_label': "Organisatiecode",
    'verify.checking': "Controleren…",
    'verify.submit': "Verifiëren",
    'verify.not_verified': "Niet geverifieerd",
    'verify.withdrawn': "Ingetrokken",
    'verify.genuine': "Echt document",
    'verify.genuine_superseded': "Echt, maar vervangen",
    'verify.superseded_note': "Voor deze machine is een recenter paspoort uitgegeven",
    'verify.fingerprint': "Documentvingerafdruk (SHA-256)",
    'verify.no_result': "Geen resultaat.",
    'verify.err_not_verified': "Dit document kon niet worden geverifieerd.",
    'verify.err_unreachable': "De verificatiedienst was niet bereikbaar. Probeer het opnieuw.",
    'verify.row_reference': "Referentie",
    'verify.row_issued_by': "Uitgegeven door",
    'verify.row_issued_on': "Uitgegeven op",
    'verify.not_recorded': "Niet vastgelegd",
    'verify.row_make_model': "Merk en model",
    'verify.row_status': "Huidige status",
    'verify.blocked_from_use': "Geblokkeerd voor gebruik",
    'verify.in_service': "In gebruik",
    'verify.no_open_defects': "Geen openstaande gebreken vastgelegd voor deze machine.",
    'verify.defect_history': "Gebrekengeschiedenis",
    'verify.no_resolved_defects': "Geen opgeloste gebreken vastgelegd voor deze machine.",
    'verify.inspection_record': "Inspectieoverzicht",
    'verify.check_log': "Controlelogboek",
    'verify.no_checks': "Geen controles vastgelegd voor deze machine.",
    'verify.service_history': "Onderhoudsgeschiedenis",
    'verify.no_services': "Geen onderhoudsregistraties voor deze machine.",
    'verify.checks_recorded': "Vastgelegde controles",
    'verify.pass_rate': "Slaagpercentage",
    'verify.defects_raised': "Gemelde gebreken",
    'verify.most_recent_check': "Meest recente controle",
    'verify.show_more': "Meer tonen",
    'verify.showing_of': "{shown} van {total} getoond",
    'verify.details': "Details",
    'verify.hide': "Verbergen",
    'verify.all_passed': "Alles geslaagd",
    'verify.n_failed': "{n} afgekeurd",
    'verify.blocked_the_machine': "machine geblokkeerd",
    'verify.blocking': "Blokkerend",
    'verify.raised': "Gemeld",
    'verify.resolved': "Opgelost",
    'verify.revised_after_issue': "herzien na uitgifte",
    'verify.next_service': "Volgend onderhoud",
    'verify.parts': "Onderdelen",
    'verify.external': "extern",
    'verify.sealed': "vergrendeld",
    'verify.language': "Taal",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Geen beweging gedetecteerd",
    'emergency.triggered_generic': "Noodgeval geactiveerd",
    'emergency.community_badge': "Gemeenschapsmelding — noodgeval in de buurt",
    'emergency.panel_responders': "Reagerende personen",
    'emergency.machine_involved': "Betrokken machine",
    'emergency.impact_label': "Botsing",
    'emergency.ago': "geleden",
    'emergency.location_unavailable': "Locatie niet beschikbaar",
    'emergency.open_in_maps': "Openen in Google Maps",
    'emergency.im_responding': "Ik reageer",
    'emergency.confirming': "Bevestigen…",
    'emergency.mark_resolved': "Markeren als afgehandeld",
    'emergency.resolving': "Afhandelen…",
    'emergency.called_automatically_at': "112 automatisch gebeld om {time}",
    'emergency.state_alert': "NOODMELDING",
    'emergency.state_awaiting': "WACHT OP ANTWOORD",
    'emergency.state_needs_help': "BEDIENER HEEFT HULP NODIG",
    'emergency.state_no_response': "GEEN ANTWOORD VAN BEDIENER",
    'emergency.seconds_to_respond': "{n} s voor de bediener om te antwoorden",
    'billing.over_limit_row': "Buiten de machines in je abonnement",
    'billing.over_limit_full': "Deze machine valt buiten de machines in je abonnement. Voeg haar toe aan je abonnement om het dossier te zien.",
    'nav.reports': "Rapporten",
    'site.not_found': "Locatie niet gevonden",
    'site.details': "Locatiegegevens",
    'site.edit': "Locatie bewerken",
    'site.updated': "Locatie bijgewerkt",
    'site.err_update': "Locatie kon niet worden bijgewerkt",
    'site.no_address': "Geen adres vastgelegd",
    'site.no_machines': "Geen machines op deze locatie",
    'site.no_staff': "Niemand toegewezen aan deze locatie",
    'site.no_defects': "Geen openstaande gebreken op deze locatie",
    'checks.new_template': "Nieuw sjabloon",
    'set.language': "Taal",
    'set.language_hint': "Geldt voor iedereen in je organisatie",
    'set.your_organisation': "Jouw organisatie",
    'set.group_organisation': "Organisatie",
    'set.group_safety': "Veiligheid en naleving",
    'set.group_system': "Systeem",
    'set.reports': "Rapporten",
    'set.org_details': "Organisatiegegevens",
    'set.org_details_hint': "Naam, adres, KvK-nummer, huisstijl",
    'set.sites_hint': "Erven, depots en waar machines staan",
    'set.roles': "Rollen en rechten",
    'set.roles_hint': "Wat elke rol kan zien en doen",
    'set.billing_hint': "Abonnement en betaalmethode",
    'set.coshh_hint': "Aanwezige stoffen en hun beoordelingen",
    'set.risk_hint': "Beoordelingen en herzieningen",
    'set.reports_hint': "Staat van het wagenpark, naleving, CO₂, kosten en verzekeringsdossiers",
    'set.integrations': "Integraties",
    'set.integrations_hint': "Telematica, dealersystemen en Almanac",
    'set.notifications_hint': "Wat er wordt verstuurd, en aan wie",
    'set.audit_log': "Auditlogboek",
    'set.audit_log_hint': "Wie wat heeft gewijzigd, en wanneer",
    'set.data': "Gegevens",
    'set.data_hint': "Export en bewaring",
    'set.data_retention': "Gegevens en bewaring",
    'set.export_title': "Je gegevens exporteren",
    'set.export_desc': "Exporteer een volledige kopie van je organisatiegegevens, inclusief machinegegevens, onderhoudshistorie, controles, medewerkerprofielen en kwalificaties.",
    'set.export_coming_soon': "Gegevensexport binnenkort beschikbaar",
    'set.export_btn': "Alle gegevens exporteren",
    'set.retention_title': "Gegevensbewaring",
    'set.retention_desc': "Je gegevens worden bewaard gedurende de looptijd van je abonnement plus 12 maanden na opzegging. Onderhoudsregistraties en vergrendelde werkorders worden onbeperkt bewaard omdat ze nodig kunnen zijn voor juridische en verzekeringsdoeleinden.",
    'set.danger_zone': "Gevarenzone",
    'set.danger_desc': "Het verwijderen van je organisatie wist alle gegevens permanent, behalve vergrendelde machinegegevens die nodig zijn voor naleving. Dit kan niet ongedaan worden gemaakt.",
    'set.delete_org': "Organisatie verwijderen",
    'set.delete_org_toast': "Neem contact op met support om je organisatie te verwijderen",
    'set.audit_log_subtitle': "Volledig overzicht van alle acties in je organisatie",
    'set.audit_search': "Auditlogboek doorzoeken…",
    'set.col_action': "Actie",
    'set.no_audit': "Geen auditregels",
    'set.audit_empty_msg': "Acties verschijnen hier zodra ze plaatsvinden",
    'set.notif_title': "Meldingsinstellingen",
    'set.notif_desc': "Bepaal welke gebeurtenissen pushmeldingen sturen naar leidinggevenden en beheerders in je organisatie.",
    'set.notif_saved': "Meldingsvoorkeuren opgeslagen",
    'set.save_preferences': "Voorkeuren opslaan",
    'set.notif_check_failed': "Controle afgekeurd",
    'set.notif_check_failed_desc': "Wanneer een bediener een afgekeurde controle indient",
    'set.notif_machine_blocked': "Machine geblokkeerd",
    'set.notif_machine_blocked_desc': "Wanneer een machine automatisch wordt geblokkeerd na een afkeuring",
    'set.notif_defect': "Gebrek gemeld",
    'set.notif_defect_desc': "Wanneer een bediener een gebrek meldt",
    'set.notif_near_miss': "Bijna-ongeval gemeld",
    'set.notif_near_miss_desc': "Wanneer een bijna-ongeval wordt ingediend",
    'set.notif_qual_expiring': "Kwalificatie verloopt (30 d)",
    'set.notif_qual_expiring_desc': "Wanneer een kwalificatie binnen 30 dagen verloopt",
    'set.notif_qual_expired': "Kwalificatie verlopen",
    'set.notif_qual_expired_desc': "Wanneer een kwalificatie is verlopen",
    'set.notif_service_due': "Onderhoud verschuldigd",
    'set.notif_service_due_desc': "Wanneer een machine zijn onderhoudsinterval nadert",
    'set.notif_fuel_low': "Brandstoftank laag",
    'set.notif_fuel_low_desc': "Wanneer een dieseltank onder de drempel zakt",
    'set.notif_emergency': "Noodmelding",
    'set.notif_emergency_desc': "Altijd aan — kan niet worden uitgeschakeld",
    'set.notif_announcement': "Mededelingen",
    'set.notif_announcement_desc': "Wanneer het management een mededeling verstuurt",
    'set.no_sites_msg': "Voeg je eerste bedrijf of locatie toe",
    'set.err_site_name': "Locatienaam is verplicht",
    'set.site_added': "Locatie toegevoegd",
    'set.err_site_add': "Locatie kon niet worden toegevoegd",
    'set.site_name': "Locatienaam",
    'set.site_name_placeholder': "bijv. Hoofdbedrijf",
    'set.address': "Adres",
    'set.address_placeholder': "bijv. Hoofdbedrijf, Boerderijweg 1, 1234 AB",
    'set.roles_title': "Rollen en rechten",
    'set.role_admin_full': "Volledige toegang tot alle locaties, machines, personeel, instellingen en facturatie. Kan mededelingen versturen en alle gegevens beheren.",
    'set.role_manager_full': "Toegang beperkt tot de locatie. Beheert machines en personeel op de toegewezen locatie. Geen toegang tot facturatie of organisatie-instellingen.",
    'set.role_operator_full': "Alleen toegang via de mobiele app. Voert dagelijkse controles uit, registreert tankbeurten en kan gebreken en bijna-ongevallen melden.",
    'set.perm_all_machines': "Alle machines op alle locaties",
    'set.perm_all_staff': "Beheer van al het personeel",
    'set.perm_all_settings': "Alle instellingen",
    'set.perm_announcements': "Mededelingen versturen",
    'set.perm_emergencies': "Noodgevallen afhandelen",
    'set.perm_site_machines': "Machines op hun locatie",
    'set.perm_site_staff': "Personeel op hun locatie",
    'set.perm_checks_defects': "Controles en gebreken",
    'set.perm_shifts': "Dienstbeheer",
    'set.perm_daily_checks_app': "Dagelijkse controles (app)",
    'set.perm_fuel_fills_app': "Tankbeurten (app)",
    'set.perm_defect_app': "Gebreken melden (app)",
    'set.perm_near_miss_app': "Bijna-ongevallen melden (app)",
    'set.perm_own_quals': "Eigen kwalificaties bekijken",
    'set.perm_sos': "Nood-SOS",
    'set.org_settings': "Organisatie-instellingen",
    'set.identity': "Identiteit",
    'set.org_name': "Naam van de organisatie",
    'set.trading_name': "Handelsnaam",
    'set.if_different': "Indien afwijkend",
    'set.company_number': "KvK-nummer",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "Btw-nummer",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Type bedrijf",
    'set.ind_farm': "Landbouwbedrijf",
    'set.ind_estate': "Landgoed",
    'set.ind_contractor': "Loonwerker",
    'set.ind_dealership': "Dealerbedrijf",
    'set.ind_other': "Overig",
    'set.primary_email': "Primair e-mailadres",
    'set.phone_number': "Telefoonnummer",
    'set.website': "Website",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Adresregel 1",
    'set.address2': "Adresregel 2",
    'set.town': "Plaats",
    'set.county': "Provincie",
    'set.postcode': "Postcode",
    'set.branding': "Huisstijl",
    'set.brand_colour': "Huisstijlkleur",
    'set.compliance': "Naleving",
    'set.hse_number': "HSE-registratienummer",
    'set.insurance_provider': "Verzekeraar",
    'set.policy_number': "Polisnummer",
    'set.insurance_expiry': "Vervaldatum verzekering",
    'set.sharing_transfers': "Delen en overdrachten",
    'set.org_code_desc': "Je organisatiecode wordt gebruikt om gedeelde machines en overdrachten van andere Agriware-klanten te ontvangen. Deel hem met iedereen met wie je machines mede-eigenaar bent, of die je een machine verkoopt.",
    'set.emails': "E-mails",
    'set.hold_the_yard': "Wekelijkse Hold the Yard-e-mail",
    'set.hold_the_yard_desc': "Elke maandag een overzicht van de controles vóór gebruik van de afgelopen week, verstuurd naar de beheerders en managers van je organisatie.",
    'set.org_code': "Organisatiecode",
    'set.generating': "Genereren…",
    'set.copied': "Gekopieerd!",
    'set.copy': "Kopiëren",
    'set.org_saved': "Organisatie-instellingen opgeslagen",
    'set.err_save': "Instellingen konden niet worden opgeslagen",
    'set.save_changes': "Wijzigingen opslaan",
    'set.status_trialing': "Proefperiode",
    'set.status_past_due': "Betaling achterstallig",
    'set.status_cancelled': "Opgezegd",
    'set.status_unpaid': "Onbetaald",
    'set.status_incomplete': "Onvolledig",
    'set.billing_title': "Facturatie en abonnement",
    'set.billing_subtitle': "Beheer je Agriware Operations-abonnement.",
    'set.plan_standard': "Standaard",
    'set.per_month': "/maand · altijd opzegbaar",
    'set.grandfathered': "Deze organisatie heeft verworven toegang. Factuurgegevens zijn niet beschikbaar omdat dit account ouder is dan de Stripe-integratie.",
    'set.next_billing': "Volgende factuurdatum:",
    'set.feat_registry': "Machineregister en onderhoudshistorie",
    'set.feat_checks': "Dagelijkse controles en inspecties",
    'set.feat_defects': "Storings- en gebrekregistratie",
    'set.feat_staff': "Kwalificaties en diensten van personeel",
    'set.feat_reporting': "Rapportagepakket",
    'set.feat_unlimited': "Onbeperkt aantal locaties en bedieners",
    'set.err_no_portal': "Geen portal-URL ontvangen.",
    'set.err_portal': "Kan het factuurportaal niet openen. Probeer het opnieuw of neem contact op met support.",
    'set.opening_portal': "Factuurportaal openen…",
    'set.manage_billing': "Facturatie beheren",
    'set.admin_only_billing': "Alleen organisatiebeheerders kunnen de facturatie beheren.",
    'set.stripe_note': "De facturatie wordt veilig verwerkt door Stripe. Wij zien je kaartgegevens nooit.",
    'int.abax_desc': "Haal motoruren, locatie en gebruik rechtstreeks uit ABAX-trackers, zodat uren vanzelf binnenkomen in plaats van te worden ingetypt.",
    'int.abax_detail': "Automatische uren houden onderhoudsintervallen, CO₂-schattingen en controlenaleving accuraat zonder dat iemand een stand invoert.",
    'int.dms_desc': "Koppel met het DMS van je dealer om werkaanvragen te doen, offertes goed te keuren en vergrendelde werkorders op de juiste machine te ontvangen.",
    'int.dms_detail': "Werk van je dealer komt automatisch op het machinedossier en verschijnt op het machinepaspoort.",
    'int.almanac_desc': "Zie hoe je machines zich verhouden tot dezelfde modellen in alle Agriware-wagenparken — typische faalpunten, onderhoudsintervallen en betrouwbaarheid per model.",
    'int.almanac_detail': "Almanac bundelt geanonimiseerde gebrek- en onderhoudsgegevens van meerdere organisaties. Jouw gegevens dragen bij; in ruil zie je het totaalbeeld.",
    'int.consent_shared': "Gedeeld: merk en model van de machine, gebrektypen, uren bij uitval, onderhoudsintervallen",
    'int.consent_never': "Nooit gedeeld: je organisatienaam, locaties, personeel, bedieners, kosten of documenten",
    'int.consent_threshold': "Cijfers worden alleen getoond als er genoeg machines zijn om afzonderlijke wagenparken onherkenbaar te houden",
    'int.consent_withdraw': "Je kunt je op elk moment terugtrekken — bijgedragen gegevens worden uit toekomstige totalen verwijderd",
    'int.err_update': "Deze integratie kon niet worden bijgewerkt",
    'int.interest_noted': "Genoteerd — we nemen contact op zodra dit klaar is",
    'int.almanac_enabled': "Almanac ingeschakeld",
    'int.almanac_disabled': "Almanac uitgeschakeld",
    'int.subtitle': "Verbind Agriware Operations met de systemen die je al gebruikt",
    'int.admin_only': "Alleen een organisatiebeheerder kan integraties wijzigen.",
    'int.enabled': "Ingeschakeld",
    'int.in_development': "In ontwikkeling",
    'int.withdraw': "Terugtrekken",
    'int.enable_almanac': "Almanac inschakelen",
    'int.interest_registered': "Interesse geregistreerd",
    'int.register_interest': "Interesse doorgeven",
    'int.less': "Minder",
    'int.what_this_does': "Wat dit doet",
    'int.footer': "Gebruik je iets dat hier niet staat? Laat weten wat je gekoppeld wilt hebben — wat mensen vragen bepaalt wat we hierna bouwen.",
    'tmpl.scope_all_desc': "Geldt voor elke machine in de organisatie",
    'tmpl.scope_category': "Per categorie",
    'tmpl.scope_category_desc': "Geldt voor geselecteerde categorieën",
    'tmpl.scope_specific_desc': "Geldt voor slechts één machine",
    'tmpl.freq_daily': "Dagelijks",
    'tmpl.freq_daily_helper': "Moet elke dag vóór het tijdstip zijn afgerond",
    'tmpl.freq_weekly': "Wekelijks",
    'tmpl.freq_weekly_helper': "Moet één keer per week worden afgerond",
    'tmpl.freq_hourly': "Op basis van uren",
    'tmpl.freq_hourly_helper': "Wordt elke X motoruren geactiveerd",
    'tmpl.freq_monthly': "Maandelijks",
    'tmpl.freq_monthly_helper': "Moet één keer per maand worden afgerond",
    'tmpl.item_passfail': "Geslaagd / Afgekeurd",
    'tmpl.item_numeric': "Numeriek",
    'tmpl.item_text': "Tekst",
    'tmpl.item_photo': "Foto",
    'tmpl.item_signature': "Handtekening",
    'tmpl.fail_none': "Alleen vastleggen",
    'tmpl.fail_flag': "Vastleggen en melden",
    'tmpl.fail_block': "Vastleggen, melden en blokkeren",
    'tmpl.section_default': "Sectie",
    'tmpl.err_name': "Sjabloonnaam is verplicht",
    'tmpl.err_category': "Selecteer minstens één categorie",
    'tmpl.err_machine': "Selecteer een machine",
    'tmpl.err_items': "Voeg minstens één controle-item toe",
    'tmpl.updated': "Sjabloon bijgewerkt",
    'tmpl.created': "Sjabloon aangemaakt",
    'tmpl.err_save': "Sjabloon kon niet worden opgeslagen",
    'tmpl.name_placeholder': "Sjabloonnaam",
    'tmpl.save': "Sjabloon opslaan",
    'tmpl.settings': "Sjablooninstellingen",
    'tmpl.description_placeholder': "Korte omschrijving van wanneer dit sjabloon wordt gebruikt",
    'tmpl.applies_to': "Geldt voor",
    'tmpl.select_categories_caps': "CATEGORIEËN SELECTEREN",
    'tmpl.select_machine_caps': "MACHINE SELECTEREN",
    'tmpl.choose_machine': "Kies een machine…",
    'tmpl.frequency': "Controlefrequentie",
    'tmpl.estimated_time': "Geschatte tijd (minuten)",
    'tmpl.every_x_hours': "Elke X motoruren",
    'tmpl.due_by_time': "Uiterlijk om",
    'tmpl.due_by_hint': "— de herinnering bij overschrijding gaat op dit tijdstip af",
    'tmpl.due_by_note': "Pushmelding naar bediener en locatiebeheerder als het niet op tijd is afgerond",
    'tmpl.item_one': "item",
    'tmpl.item_many': "items",
    'tmpl.new_item': "Nieuw controle-item",
    'tmpl.add_item': "Controle-item toevoegen",
    'tmpl.add_section': "Sectie toevoegen",
    'tmpl.item_panel_title': "Controle-item",
    'tmpl.select_item_hint': "Selecteer links een controle-item om de instellingen hier te bewerken.",
    'tmpl.label': "Label",
    'tmpl.label_placeholder': "bijv. motoroliepeil",
    'tmpl.if_fails': "Als dit wordt afgekeurd",
    'tmpl.required': "Verplicht",
    'tmpl.required_hint': "De bediener moet dit item invullen",
    'status.active': "Actief",
    'status.shared': "Gedeeld",
    'status.transferred': "Overgedragen",
    'status.archived': "Gearchiveerd",
    'status.issues': "Aandachtspunten",
    'status.emergency': "Noodgeval",
    'status.closed': "Gesloten",
    'status.due': "Verschuldigd",
    'status.draft': "Concept",
    'status.approved': "Goedgekeurd",
    'status.declined': "Afgewezen",
    'status.scheduled': "Gepland",
    'photo.title': "Profielfoto",
    'photo.upload_title': "Een foto uploaden",
    'photo.upload_note': "JPG, PNG of WebP · max. 5 MB · wordt rond bijgesneden",
    'photo.choose': "Foto kiezen",
    'photo.drag_hint': "Sleep om te verplaatsen · scroll of schuif om te zoomen",
    'photo.change': "Foto wijzigen",
    'photo.save': "Foto opslaan",
    'upsell.derv_title': "Brandstofbeheer",
    'upsell.derv_desc': "Volg tankniveaus, registreer tankbeurten, beheer leveranciers en bewaak het brandstofverbruik per machine op alle locaties.",
    'upsell.coshh_title': "Register gevaarlijke stoffen",
    'upsell.coshh_desc': "Houd een digitaal register bij van gevaarlijke stoffen, veiligheidsinformatiebladen en vereiste PBM voor je medewerkers.",
    'upsell.risk_title': "Risicobeoordelingen",
    'upsell.risk_desc': "Maak, beheer en vergrendel risicobeoordelingen per machine of taak. Bedieners bevestigen deze voordat ze beginnen.",
    'upsell.jobs_title': "DMS-integratie",
    'upsell.jobs_desc': "Vraag werkplaatsopdrachten aan bij je dealer, keur offertes goed en ontvang vergrendelde werkorders direct op je machineprofielen.",
    'upsell.reporting_title': "Rapporten en analyses",
    'upsell.reporting_desc': "Rapporten over de staat van het wagenpark, naleving, kwalificaties, brandstofverbruik, CO₂-uitstoot en kosten per machine.",
    'upsell.quals_title': "Kwalificatiebewaking",
    'upsell.quals_desc': "Leg certificaten van medewerkers vast met vervaldatumbewaking, pushmeldingen en machinevrijgave op basis van kwalificatie.",
    'upsell.sharing_title': "Machines delen",
    'upsell.sharing_desc': "Deel machinegegevens met andere Agriware Ops-organisaties — ideaal voor loonwerkers en gedeeld materieel.",
    'upsell.transfers_title': "Machineoverdrachten",
    'upsell.transfers_desc': "Draag machines over tussen Ops-gebruikers of DMS-accounts met volledige eigendomshistorie en digitaal logboek.",
    'upsell.carbon_title': "CO₂-rapportage",
    'upsell.carbon_desc': "Automatische CO₂-berekening op basis van brandstofverbruik. Rapportage volgens de DEFRA-standaard voor je wagenpark.",
    'upsell.not_included': "Deze functie zit niet in je huidige abonnement.",
    'upsell.upgrade': "Abonnement upgraden",
    'service.record_not_found': "Registratie niet gevonden",
    'service.record_title_service': "Onderhoudsregistratie",
    'service.record_title_repair': "Reparatieregistratie",
    'service.record_title_inspection': "Inspectieregistratie",
    'service.record_suffix': "registratie",
    'service.email_btn': "E-mail",
    'service.email_coming_soon': "E-mailexport binnenkort beschikbaar",
    'service.sealed_by_workshop': "Vergrendeld door {name} en niet te wijzigen",
    'service.the_workshop': "de werkplaats",
    'service.sealed_permanent': "Deze registratie is permanent vergrendeld en kan niet worden gewijzigd",
    'service.sealed_by': "Vergrendeld door",
    'service.at_suffix': "bij {name}",
    'service.job_ref': "werkorder {ref}",
    'service.photos_video': "Foto's en video",
    'service.job_photo': "Werkfoto",
    'service.files_copying': "Sommige bestanden worden nog gekopieerd.",
    'service.date_of_service': "Onderhoudsdatum",
    'service.hours_at_service': "Uren bij onderhoud",
    'service.total_cost': "Totale kosten",
    'service.record_details': "Registratiegegevens",
    'service.type': "Type",
    'service.performed_by': "Uitgevoerd door",
    'service.performed_by_type': "Type uitvoerder",
    'service.next_service_hours': "Uren tot volgend onderhoud",
    'service.next_service_date': "Datum volgend onderhoud",
    'service.notes': "Notities",
    'service.parts_used': "Gebruikte onderdelen",
    'service.col_part': "Onderdeel",
    'service.col_qty': "Aantal",
    'service.col_cost': "Kosten",
    'service.parts_total': "Totaal onderdelen",
    'service.cost_breakdown': "Kostenspecificatie",
    'service.labour_cost': "Arbeidskosten",
    'service.parts_cost': "Onderdelenkosten",
    'service.total': "Totaal",
    'service.audit_trail': "Audittrail",
    'service.record_created_by': "Registratie aangemaakt door",
    'service.record_sealed_by': "Registratie vergrendeld door",
    'service.type_service': "Onderhoud",
    'service.type_service_desc': "Regulier gepland onderhoud",
    'service.type_repair': "Reparatie",
    'service.type_repair_desc': "Ongepland reparatiewerk",
    'service.type_inspection': "Inspectie",
    'service.type_inspection_desc': "Veiligheids- of nalevingscontrole",
    'service.by_internal': "Intern",
    'service.by_dealer': "Dealer",
    'service.by_external': "Externe aannemer",
    'service.err_description': "Voer een omschrijving in",
    'service.err_date': "Voer de onderhoudsdatum in",
    'service.added_toast': "Onderhoudsregistratie toegevoegd en vergrendeld",
    'service.err_save': "Registratie kon niet worden opgeslagen — probeer het opnieuw",
    'service.seal_note': "Deze registratie wordt na opslaan permanent vergrendeld",
    'service.record_type': "Registratietype",
    'service.description_placeholder': "Beschrijf het uitgevoerde werk…",
    'service.performed_by_placeholder': "Naam of bedrijf",
    'service.additional_notes': "Aanvullende notities",
    'service.notes_placeholder': "Eventuele aanvullende notities…",
    'service.add_part': "Onderdeel toevoegen",
    'service.part_name': "Naam onderdeel",
    'service.cost_placeholder': "Kosten £",
    'service.cost_next_service': "Kosten en volgend onderhoud",
    'service.labour_cost_field': "Arbeidskosten (£)",
    'service.next_hours_placeholder': "bijv. 1750",
    'service.seal_warning': "Na opslaan is deze registratie permanent vergrendeld en kan zij niet meer worden bewerkt. Controleer alle gegevens voordat je opslaat.",
    'service.save_seal': "Registratie opslaan en vergrendelen",
    'dashboard.there': "daar",
    'dashboard.total_machines': "Totaal machines",
    'dashboard.blocked_machines': "Geblokkeerde machines",
    'dashboard.open_incidents': "Open incidenten",
    'dashboard.open_defects': "Openstaande gebreken",
    'dashboard.fuel_tanks': "Brandstoftanks",
    'common.of': "van",
    'dashboard.fleet': "Wagenpark",
    'common.view_all': "Alles bekijken",
    'dashboard.no_machines': "Nog geen machines",
    'dashboard.no_machines_msg': "Voeg je eerste machine toe om te beginnen",
    'dashboard.recent_incidents': "Recente incidenten",
    'dashboard.no_incidents_msg': "Geen incidenten geregistreerd",
    'dashboard.recent_defects': "Recente gebreken",
    'dashboard.no_defects': "Geen gebreken",
    'dashboard.no_defects_msg': "Geen gebreken gemeld",
    'dashboard.defect_reported': "Gebrek gemeld",
    'dashboard.group_overview': "Groepsoverzicht",
    'dashboard.send_announcement': "Mededeling versturen",
    'dashboard.sites': "Locaties",
    'dashboard.no_sites': "Nog geen locaties",
    'dashboard.no_sites_msg': "Voeg je eerste locatie toe in Instellingen om te beginnen",
    'dashboard.add_site': "Locatie toevoegen",
    'dashboard.status_monitor': "In de gaten houden",
    'dashboard.status_all_good': "Alles in orde",
    'dashboard.derv': "Diesel",
    'dashboard.derv_level': "Dieselniveau",
    'qual.short_forklift': "Heftruck",
    'qual.short_sprayer': "Spuit",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Rijbewijs",
    'qual.short_firstaid': "EHBO",
    'qual.short_chainsaw': "Kettingzaag",
    'qual.short_pesticide': "Gewasbescherming",
    'qual.short_telehandler': "Verreiker",
    'qual.short_atv': "Quad",
    'qual.short_other': "Overig",
    'qual.forklift': "Heftruckcertificaat",
    'qual.sprayer': "PA1/PA6-spuitcertificaat",
    'qual.cscs': "CSCS-kaart",
    'qual.driving': "Rijbewijs",
    'qual.firstaid': "EHBO-diploma",
    'qual.chainsaw': "Kettingzaagcertificaat",
    'qual.pesticide': "Spuitlicentie gewasbescherming",
    'qual.telehandler': "Verreikercertificaat",
    'qual.atv': "Quad-/ATV-certificaat",
    'qual.other': "Overige kwalificatie",
    'staff.n_expired': "verlopen",
    'staff.n_expiring': "verlopen binnenkort",
    'staff.n_valid': "geldig",
    'common.none': "Geen",
    'staff.tab_members': "Medewerkers",
    'staff.tab_qualifications': "Kwalificaties",
    'staff.tab_shifts': "Diensten",
    'staff.member_one': "medewerker",
    'staff.member_many': "medewerkers",
    'staff.alert_one': "kwalificatiemelding",
    'staff.alert_many': "kwalificatiemeldingen",
    'staff.invite': "Personeel uitnodigen",
    'staff.create_shift': "Dienst aanmaken",
    'staff.search': "Zoek op naam of e-mail…",
    'staff.none_found': "Geen personeel gevonden",
    'staff.adjust_search': "Pas je zoekopdracht aan",
    'staff.invite_first': "Nodig je eerste teamlid uit",
    'staff.stat_total_quals': "Totaal kwalificaties",
    'staff.stat_valid': "Geldig",
    'staff.stat_expiring_30d': "Verloopt (30 d)",
    'staff.stat_expiring': "Verloopt",
    'staff.stat_expired': "Verlopen",
    'staff.qual_one': "kwalificatie",
    'staff.qual_many': "kwalificaties",
    'staff.expires': "Verloopt op",
    'staff.no_quals': "Geen kwalificaties vastgelegd",
    'staff.no_quals_msg': "Voeg kwalificaties toe via het profiel van elke medewerker",
    'staff.no_shifts': "Nog geen diensten",
    'staff.no_shifts_msg': "Maak je eerste dienst aan om bij te houden wie er werkt",
    'staff.shift': "Dienst",
    'staff.checked_in': "ingecheckt",
    'staff.not_found': "Medewerker niet gevonden",
    'staff.add_qualification': "Kwalificatie toevoegen",
    'staff.expired_alert_one': "kwalificatie is verlopen — deze bediener mag bepaalde machines mogelijk niet gebruiken",
    'staff.expired_alert_many': "kwalificaties zijn verlopen — deze bediener mag bepaalde machines mogelijk niet gebruiken",
    'staff.expiring_alert_one': "kwalificatie verloopt binnen 30 dagen",
    'staff.expiring_alert_many': "kwalificaties verlopen binnen 30 dagen",
    'staff.tab_details': "Gegevens",
    'staff.contact': "Contact",
    'staff.account': "Account",
    'staff.onboarding': "Onboarding",
    'staff.complete': "Voltooid",
    'staff.job_title': "Functie",
    'staff.joined': "In dienst sinds",
    'staff.invited_by': "Uitgenodigd door",
    'staff.quals_tickets': "Kwalificaties en certificaten",
    'staff.no_quals_profile_msg': "Voeg de certificaten van deze bediener toe",
    'staff.issued': "Afgegeven",
    'staff.no_expiry': "Geen vervaldatum",
    'staff.expires_today': "Verloopt vandaag",
    'staff.days_remaining_one': "dag resterend",
    'staff.days_remaining_many': "dagen resterend",
    'staff.expired_days_ago_one': "{n} dag geleden verlopen",
    'staff.expired_days_ago_many': "{n} dagen geleden verlopen",
    'staff.view_certificate': "Certificaat bekijken",
    'staff.assigned_machines': "Toegewezen machines",
    'staff.no_machines': "Geen machines toegewezen",
    'staff.no_machines_msg': "Aan deze bediener zijn geen machines toegewezen",
    'staff.err_first_name': "Voornaam is verplicht",
    'staff.err_last_name': "Achternaam is verplicht",
    'staff.err_email': "Voer een geldig e-mailadres in",
    'staff.err_site': "Selecteer een locatie",
    'staff.err_create_prefix': "Account kon niet worden aangemaakt:",
    'staff.err_timeout': "Time-out bij het aanmaken van het account. Vernieuw de pagina en probeer het opnieuw.",
    'staff.err_create': "Account kon niet worden aangemaakt — probeer het opnieuw",
    'staff.copy_greeting': "Hallo {name},",
    'staff.copy_body': "Je account voor Agriware Operations is aangemaakt.",
    'staff.copy_email': "E-mail:",
    'staff.copy_temp_password': "Tijdelijk wachtwoord:",
    'staff.copy_footer': "Bij de eerste aanmelding word je gevraagd je wachtwoord te wijzigen.",
    'staff.copied_toast': "Inloggegevens naar klembord gekopieerd",
    'staff.role_admin_desc': "Volledige toegang tot alle locaties en instellingen",
    'staff.role_manager_desc': "Beheert één locatie, personeel en machines",
    'staff.role_operator_desc': "Voert dagelijkse controles uit via de mobiele app",
    'staff.add_member': "Medewerker toevoegen",
    'staff.add_member_sub': "Het account wordt direct aangemaakt. Je krijgt de inloggegevens om te delen.",
    'staff.account_created': "Account aangemaakt",
    'staff.share_details_pre': "Deel deze inloggegevens met",
    'staff.share_details_post': "Bij de eerste aanmelding wordt gevraagd het wachtwoord te wijzigen.",
    'staff.label_email_caps': "E-MAIL",
    'staff.label_temp_password_caps': "TIJDELIJK WACHTWOORD",
    'staff.copy_login_details': "Inloggegevens kopiëren",
    'staff.add_another': "Nog een toevoegen",
    'staff.back_to_staff': "Terug naar personeel",
    'staff.personal_details': "Persoonsgegevens",
    'staff.first_name': "Voornaam",
    'staff.last_name': "Achternaam",
    'staff.work_email': "Werk-e-mail",
    'staff.site_assignment': "Locatietoewijzing",
    'staff.no_sites': "Nog geen locaties ingesteld — voeg eerst een locatie toe in Instellingen",
    'staff.creating_account': "Account aanmaken…",
    'staff.create_account': "Account aanmaken",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Selecteer een kwalificatietype",
    'qual.err_name': "Voer de naam van de kwalificatie in",
    'qual.err_issue_date': "Voer de afgiftedatum in",
    'qual.err_expiry': "Voer de vervaldatum in of vink «geen vervaldatum» aan",
    'qual.added_toast': "Kwalificatie toegevoegd",
    'qual.err_save': "Kwalificatie kon niet worden opgeslagen — probeer het opnieuw",
    'qual.back_staff_profile': "Medewerkerprofiel",
    'qual.subtitle': "Leg een certificaat, diploma of vergunning van deze bediener vast",
    'qual.type_title': "Kwalificatietype",
    'qual.name_label': "Naam van de kwalificatie",
    'qual.name_placeholder': "bijv. NPTC-bosmaaiercertificaat",
    'qual.cert_details': "Certificaatgegevens",
    'qual.cert_number': "Certificaatnummer",
    'common.optional_suffix': "— optioneel",
    'qual.cert_number_placeholder': "bijv. NPORS-123456",
    'qual.issuing_body': "Uitgevende instantie",
    'qual.issuing_body_placeholder': "bijv. NPORS, LANTRA, CITB",
    'qual.issue_date': "Afgiftedatum",
    'qual.expiry_date': "Vervaldatum",
    'qual.no_expiry_label': "Deze kwalificatie heeft geen vervaldatum",
    'qual.cert_document': "Certificaatdocument",
    'qual.upload_note': "Upload een foto of scan van het certificaat. Dit wordt privé opgeslagen en nooit gedeeld.",
    'common.remove': "Verwijderen",
    'qual.click_upload': "Klik om het certificaat te uploaden",
    'qual.file_types': "JPG, PNG of PDF",
    'common.saving': "Opslaan…",
    'qual.save': "Kwalificatie opslaan",
    'defects.title': "Gebreken",
    'defects.n_open': "open",
    'defects.n_critical': "kritiek",
    'defects.stat_total': "Totaal gebreken",
    'defects.status_open': "Open",
    'defects.status_in_progress': "In behandeling",
    'defects.status_resolved': "Opgelost",
    'defects.all_severities': "Alle ernstniveaus",
    'defects.sev_minor': "Gering",
    'defects.sev_moderate': "Matig",
    'defects.sev_major': "Ernstig",
    'defects.sev_critical': "Kritiek",
    'defects.search': "Gebreken zoeken…",
    'common.clear': "Wissen",
    'defects.col_description': "Omschrijving",
    'defects.reported_by': "Gemeld door",
    'defects.col_severity': "Ernst",
    'defects.no_description': "Geen omschrijving",
    'defects.none_found': "Geen gebreken gevonden",
    'defects.none_reported': "Er zijn geen gebreken gemeld",
    'defects.acknowledged_toast': "Gebrek bevestigd",
    'defects.acknowledge_failed': "Gebrek kon niet worden bevestigd",
    'defects.resolved_released': "Gebrek opgelost — machine vrijgegeven",
    'defects.resolved_toast': "Gebrek opgelost",
    'defects.resolve_failed': "Gebrek kon niet worden opgelost",
    'defects.not_found': "Gebrek niet gevonden",
    'defects.report_title': "Gebrekmelding",
    'defects.acknowledge': "Bevestigen",
    'defects.raise_job': "Werkorder aanmaken",
    'defects.resolve': "Oplossen",
    'defects.blocking_banner': "Machine geblokkeerd — een leidinggevende moet een schriftelijke vrijgave vastleggen voordat de machine weer wordt ingezet",
    'defects.details_title': "Gebrekdetails",
    'defects.no_description_provided': "Geen omschrijving opgegeven",
    'defects.reported_at': "Gemeld op",
    'defects.location': "Locatie",
    'defects.photos': "Foto's",
    'defects.acknowledgement': "Bevestiging",
    'defects.acknowledged_by': "Bevestigd door",
    'defects.resolved_by': "Opgelost door",
    'defects.return_to_service': "Vrijgave",
    'defects.revised': "Herzien",
    'defects.revised_by_suffix': "door {name}",
    'defects.view_machine_profile': "Machineprofiel bekijken",
    'defects.resolve_and_release': "Oplossen en vrijgeven",
    'defects.resolve_defect': "Gebrek oplossen",
    'defects.release_machine': "Machine vrijgeven",
    'defects.mark_resolved': "Markeren als opgelost",
    'defects.release_warning': "Deze machine is geblokkeerd. Je schriftelijke vrijgave wordt vastgelegd met je naam en functie en verschijnt op het machinepaspoort.",
    'defects.resolution_details': "Details van de oplossing",
    'defects.resolution_placeholder': "Beschrijf hoe het gebrek is opgelost…",
    'defects.narrative_placeholder': "Wat is aangetroffen, wat is gedaan en hoe de machine vóór vrijgave is gecontroleerd. Vermeld waar relevant werkordernummers en testgegevens.",
    'defects.chars_needed_one': "teken meer nodig",
    'defects.chars_needed_many': "tekens meer nodig",
    'defects.characters': "tekens",
    'defects.permanent_note': "Dit wordt permanent vastgelegd bij de gebrekmelding.",
    'machines.tab_overview': "Overzicht",
    'machines.tab_history': "Geschiedenis",
    'machines.tab_documents': "Documenten",
    'machines.tab_operators': "Bedieners",
    'machines.tab_sharing': "Delen",
    'machines.tab_incidents': "Incidenten",
    'machines.pdf_only': "Alleen PDF-bestanden worden geaccepteerd.",
    'machines.replace_confirm': "Bestaand document ({name}) vervangen? Het oude bestand wordt verwijderd.",
    'machines.delete_doc_confirm': "Dit document verwijderen? Dit kan niet ongedaan worden gemaakt.",
    'machines.uploaded': "Geüpload",
    'machines.no_file_yet': "Nog geen bestand",
    'machines.uploading': "Uploaden…",
    'machines.view_document': "Document bekijken",
    'common.replace': "Vervangen",
    'common.delete': "Verwijderen",
    'common.upload': "Uploaden",
    'machines.doc_type_manual': "Handleiding",
    'machines.doc_type_private': "Privé",
    'machines.doc_operators_manual': "Bedieningshandleiding",
    'machines.doc_workshop_manual': "Werkplaatshandboek",
    'machines.untitled_document': "Naamloos document",
    'machines.add_document': "Document toevoegen",
    'machines.documents_intro': "De bedieningshandleiding en het werkplaatshandboek hebben vaste plaatsen — zo herkennen wij het juiste document bij het delen met de Agriware-bibliotheek. Andere privédocumenten zijn alleen zichtbaar voor jouw organisatie.",
    'machines.returned_to_service': "Machine weer vrijgegeven",
    'machines.not_blocked': "Deze machine is niet geblokkeerd",
    'machines.resolve_defect_first': "Los het openstaande gebrek op om deze machine weer vrij te geven",
    'machines.return_failed': "Machine kon niet worden vrijgegeven",
    'machines.machine_not_found': "Machine niet gevonden",
    'common.unknown': "Onbekend",
    'machines.unblock': "Vrijgeven",
    'service.add_record': "Onderhoudsregistratie toevoegen",
    'machines.serial_number': "Serienummer",
    'machines.year': "Bouwjaar",
    'machines.blocked_banner': "Machine geblokkeerd — niet gebruiken",
    'machines.current_hours': "Huidige uren",
    'machines.next_service': "Volgend onderhoud",
    'machines.service_records': "Onderhoudsregistraties",
    'machines.service_progress': "Voortgang tot onderhoud",
    'machines.cost_over_time': "Kostenverloop",
    'machines.cost_over_time_sub': "Onderhoud, reparatie en cumulatieve eigendomskosten",
    'machines.cost_empty': "Kostengegevens verschijnen zodra er onderhoudsregistraties worden toegevoegd.",
    'machines.series_service': "Onderhoud",
    'machines.series_repair': "Reparatie",
    'machines.series_cumulative': "Cumulatief",
    'machines.details_title': "Machinegegevens",
    'machines.make': "Merk",
    'machines.model': "Model",
    'machines.category': "Categorie",
    'machines.assigned_to': "Toegewezen aan",
    'machines.pool_machine': "Poolmachine",
    'machines.unassigned': "Niet toegewezen",
    'machines.purchase_value': "Aankoop en waarde",
    'machines.purchase_date': "Aankoopdatum",
    'machines.purchase_price': "Aankoopprijs",
    'machines.depreciation_rate': "Afschrijvingspercentage",
    'machines.per_year': "per jaar",
    'machines.estimated_life': "Geschatte levensduur",
    'common.unit_years': "jaar",
    'machines.cost_tracking': "Kostenregistratie",
    'machines.total_service_cost': "Totale onderhoudskosten",
    'machines.total_repair_cost': "Totale reparatiekosten",
    'machines.total_fuel_cost': "Totale brandstofkosten",
    'machines.total_cost_ownership': "Totale eigendomskosten",
    'machines.service_history': "Onderhouds- en reparatiegeschiedenis",
    'service.add_record_short': "Registratie toevoegen",
    'service.none_yet': "Nog geen onderhoudsregistraties",
    'service.none_yet_msg': "Voeg je eerste onderhouds- of reparatieregistratie toe",
    'service.sealed': "Vergrendeld",
    'service.workshop': "Werkplaats",
    'common.photo_one': "foto",
    'common.photo_many': "foto's",
    'machines.assigned_operators': "Toegewezen bedieners",
    'machines.no_operator': "Geen bediener toegewezen",
    'machines.no_operator_msg': "Aan deze machine is geen bediener toegewezen",
    'machines.pool_machine_msg': "Dit is een poolmachine — beschikbaar voor alle bedieners",
    'machines.ownership_sharing': "Eigendom en delen",
    'machines.share_machine': "Machine delen",
    'machines.current_owner': "Huidige eigenaar",
    'machines.your_organisation': "Jouw organisatie",
    'machines.shared_with': "Gedeeld met",
    'machines.not_shared': "Niet gedeeld met andere organisaties",
    'machines.incident_history': "Incidentgeschiedenis",
    'incidents.none': "Geen incidenten",
    'incidents.none_msg': "Geen incidenten geregistreerd voor deze machine",
    'incidents.impact_detected': "Botsing gedetecteerd",
    'incidents.manual_sos': "Handmatige SOS",
    'incidents.man_down': "Man-down-alarm",
    'machines.unblock_title': "Machine weer vrijgeven",
    'machines.confirm_unblock': "Vrijgave bevestigen",
    'machines.unblock_warning': "Je schriftelijke verklaring wordt vastgelegd bij de controle die deze machine heeft stilgezet en verschijnt op het machinepaspoort. Is de machine geblokkeerd door een openstaand gebrek, los dan eerst het gebrek op.",
    'machines.blocked_reason': "Reden van blokkering",
    'machines.unblock_statement': "Verklaring van vrijgave",
    'machines.unblock_placeholder': "Wat is aangetroffen, wat is gedaan en hoe de machine vóór vrijgave is gecontroleerd.",
    'checks.history_title': "Controlegeschiedenis",
    'checks.stat_total': "Totaal controles",
    'checks.stat_passed': "Geslaagd",
    'checks.stat_failed': "Afgekeurd",
    'checks.n_passed': "geslaagd",
    'checks.n_failed': "afgekeurd",
    'common.clear_filters': "Filters wissen",
    'checks.not_found': "Controle niet gevonden",
    'common.export_pdf': "PDF exporteren",
    'common.pdf_coming_soon': "PDF-export binnenkort beschikbaar",
    'checks.item_failed_one': "item afgekeurd",
    'checks.item_failed_many': "items afgekeurd",
    'checks.auto_blocked': "De machine is bij indienen automatisch geblokkeerd",
    'checks.sealed_record': "Vergrendelde registratie",
    'checks.submitted_by': "Ingediend door",
    'checks.submitted_at': "Ingediend op",
    'checks.hours_at_check': "Uren bij controle",
    'checks.stat_total_items': "Totaal items",
    'checks.stat_mileage': "Kilometerstand",
    'checks.details_title': "Controledetails",
    'checks.failed_items': "Afgekeurde items",
    'checks.no_items_recorded': "Geen controle-items geregistreerd",
    'checks.alt_defect_photo': "Foto van gebrek",
    'checks.alt_check_photo': "Controlefoto",
    'common.unit_hrs': "u",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Sjablonen",
    'checks.tab_history': "Geschiedenis",
    'checks.create_template': "Sjabloon maken",
    'checks.scope_specific': "Specifieke machine",
    'checks.scope_all': "Alle machines",
    'checks.categories': "categorieën",
    'checks.items': "items",
    'checks.title': "Controles",
    'checks.template_one': "sjabloon",
    'checks.template_many': "sjablonen",
    'checks.record_one': "registratie",
    'checks.record_many': "registraties",
    'checks.no_templates': "Nog geen controlesjablonen",
    'checks.no_templates_msg': "Maak sjablonen om te bepalen wat bedieners moeten controleren voor gebruik",
    'checks.search': "Zoek op machine of bediener…",
    'checks.all_results': "Alle resultaten",
    'checks.pass': "Geslaagd",
    'checks.fail': "Afgekeurd",
    'checks.none_found': "Geen controles gevonden",
    'checks.adjust_filters': "Pas je filters aan",
    'checks.none_submitted': "Er zijn nog geen controles ingediend",
    'checks.col_operator': "Bediener",
    'checks.col_datetime': "Datum en tijd",
    'checks.col_result': "Resultaat",
    'machines.add': "Machine toevoegen",
    'machines.col_machine': "Machine",
    'machines.col_serial': "Serienr. / Kenteken",
    'machines.col_site': "Locatie",
    'machines.col_hours': "Uren",
    'machines.col_status': "Status",
    'machines.title': "Machines",
    'machines.count_one': "machine",
    'machines.count_many': "machines",
    'machines.blocked': "geblokkeerd",
    'machines.search': "Zoek op merk, model, serienummer of kenteken…",
    'machines.all_sites': "Alle locaties",
    'machines.all_statuses': "Alle statussen",
    'machines.available': "Beschikbaar",
    'machines.blocked_one': "Geblokkeerd",
    'machines.none_found': "Geen machines gevonden",
    'machines.view': "Bekijken",
    'cat.all': "Alle categorieën",
    'cat.agricultural': "Landbouw",
    'cat.groundcare': "Groenvoorziening",
    'cat.plant': "Materieel",
    'cat.vehicle': "Voertuig",
    'cat.atv': "Quad",
    'nav.dashboard': "Dashboard",
    'nav.staff': "Personeel",
    'nav.checks': "Controles",
    'nav.safety': "Veiligheid",
    'nav.operations': "Activiteiten",
    'nav.settings': "Instellingen",
    'nav.billing': "Facturering",
    'nav.sign_out': "Afmelden",
    'role.admin': "Beheerder",
    'role.manager': "Manager",
    'role.operator': "Bediener",
    'app.name': 'AgriWare Operaties',
    'app.tagline': 'Beheer',
    'nav.home': 'Home',
    'nav.machines': 'Machines',
    'nav.profile': 'Profiel',
    'common.back': 'Terug',
    'common.cancel': 'Annuleren',
    'common.save': 'Opslaan',
    'common.edit': 'Bewerken',
    'common.done': 'Klaar',
    'common.yes': 'Ja',
    'common.no': 'Nee',
    'common.ok': 'OK',
    'common.error': 'Fout',
    'common.loading': 'Laden...',
    'common.retry': 'Opnieuw proberen',
    'common.search': 'Zoeken',
    'common.submit': 'Indienen',
    'common.confirm': 'Bevestigen',
    'common.close': 'Sluiten',
    'common.pass': 'Geslaagd',
    'common.fail': 'Mislukt',
    'common.total': 'totaal',
    'common.today': 'Vandaag',
    'common.yesterday': 'Gisteren',
    'common.online_only': 'Alleen online',
    'common.last_synced': 'Laatste synchronisatie',
    'common.back_to_app': 'Terug naar app',
    'common.gps_shared': 'GPS gedeeld',
    'common.yes_via_saas': 'Ja — via SaaS',
    'common.not_called': 'Niet gebeld',
    'login.sign_in': 'Inloggen',
    'login.email': 'E-mailadres',
    'login.password': 'Wachtwoord',
    'login.forgot_password': 'Wachtwoord vergeten?',
    'login.no_account': 'Geen account?',
    'login.request_access': 'Toegang aanvragen',
    'login.account_created_by_org': 'Uw account is aangemaakt door uw organisatie.',
    'login.email_placeholder': 'u@organisatie.nl',
    'login.password_placeholder': 'Voer uw wachtwoord in',
    'login.error_empty': 'Voer uw e-mail en wachtwoord in.',
    'login.error_invalid': 'Ongeldig e-mail of wachtwoord. Probeer opnieuw.',
    'dashboard.greeting_morning': 'Goedemorgen,',
    'dashboard.greeting_afternoon': 'Goedemiddag,',
    'dashboard.greeting_evening': 'Goedenavond,',
    'dashboard.todays_tasks': 'Taken van vandaag',
    'dashboard.completed': 'Voltooid',
    'dashboard.overdue': 'Achterstallig',
    'dashboard.in_progress': 'Bezig',
    'dashboard.upcoming': 'Aankomend',
    'dashboard.pending': 'In behandeling',
    'machines.search_placeholder': 'Machines zoeken...',
    'machines.favourites': 'Favorieten',
    'machines.all_machines': 'Alle machines',
    'machines.operational': 'Operationeel',
    'machines.needs_attention': 'Aandacht vereist',
    'machines.fault': 'Storing',
    'machines.unsafe_to_operate': 'Niet veilig te bedienen',
    'machines.registration': 'Kenteken',
    'machines.assigned_operator': 'Toegewezen operator',
    'machines.engine_hours': 'Motoruren',
    'machines.documents': 'Documenten',
    'machines.log_fault': 'Storing melden',
    'machines.operator_manual': 'Gebruikershandleiding',
    'machines.service_record': 'Serviceregister',
    'machines.insurance': 'Verzekeringscertificaat',
    'machines.mot': 'APK-certificaat',
    'daily_check.title': 'Dagelijkse controle',
    'daily_check.start': 'Controle starten',
    'daily_check.required': 'Dagelijkse controle vereist',
    'daily_check.required_msg': 'Moet worden voltooid voordat deze machine wordt gebruikt.',
    'daily_check.complete': 'Controle voltooid',
    'daily_check.complete_msg': 'Voltooid door',
    'daily_check.submit': 'Controle indienen',
    'daily_check.items_remaining': 'items resterend',
    'daily_check.reward_title': 'Dankjewel!',
    'daily_check.reward_subtitle': 'Uw dagelijkse controle is geregistreerd.\nEerlijke controles houden iedereen veilig.',
    'daily_check.back_to_machine': 'Terug naar machine',
    'daily_check.day_streak': 'Dagen achtereen',
    'daily_check.completion_rate': 'Voltooiingspercentage',
    'daily_check.cat_lights': 'Verlichting en zicht',
    'daily_check.cat_fluids': 'Vloeistoffen',
    'daily_check.cat_tyres': 'Banden en wielen',
    'daily_check.cat_safety': 'Veiligheid',
    'daily_check.cat_controls': 'Bediening',
    'daily_check.cat_body': 'Carrosserie en toebehoren',
    'daily_check.lights_working': 'Alle lichten werken',
    'daily_check.mirrors': 'Spiegels schoon en ingesteld',
    'daily_check.windscreen': 'Voorruit schoon en onbeschadigd',
    'daily_check.engine_oil': 'Motoroliepeil',
    'daily_check.coolant': 'Koelvloeistofpeil',
    'daily_check.hydraulic': 'Hydraulische vloeistofpeil',
    'daily_check.fuel': 'Brandstofpeil voldoende',
    'daily_check.tyre_pressure': 'Bandenspanning correct',
    'daily_check.tyre_damage': 'Geen zichtbare bandenschade',
    'daily_check.wheel_nuts': 'Wielmoeren vast',
    'daily_check.fire_extinguisher': 'Brandblusser aanwezig',
    'daily_check.first_aid': 'EHBO-kit aanwezig',
    'daily_check.rops': 'ROPS-structuur onbeschadigd',
    'daily_check.seatbelt': 'Veiligheidsgordel werkt',
    'daily_check.brakes': 'Remmen werken',
    'daily_check.steering': 'Stuur reageert',
    'daily_check.horn': 'Claxon werkt',
    'daily_check.body_damage': 'Geen zichtbare carrosserieschade',
    'daily_check.attachments': 'Toebehoren vastgemaakt',
    'daily_check.pto_guard': 'Aftakas-beschermer op zijn plaats',
    'log_fault.title': 'Storing melden',
    'log_fault.description': 'Beschrijving',
    'log_fault.description_placeholder': 'Beschrijf de storing...',
    'log_fault.photos': "Foto's",
    'log_fault.add_photo': "Foto toevoegen",
    'log_fault.submit': 'Storingsrapport indienen',
    'log_fault.success': 'Storing succesvol gemeld',
    'emergency.title': 'Noodgeval',
    'emergency.what_emergency': 'Wat is het noodgeval?',
    'emergency.select_type': 'Selecteer het type noodgeval.\nDe juiste contacten worden onmiddellijk gebeld.',
    'emergency.vibrating': 'Trillen',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Medisch noodgeval',
    'emergency.medical_sub': 'Letsel, ziekte of bewusteloze persoon op locatie',
    'emergency.calls_999': 'Belt direct 112',
    'emergency.electrical': 'Elektrisch noodgeval',
    'emergency.electrical_sub': 'Contact met stroomkabel — blijf in de cabine',
    'emergency.calls_105': 'Belt direct 112',
    'emergency.no_signal': 'Noodnummers opgeslagen op apparaat — beschikbaar zonder signaal',
    'emergency.gps_auto': 'GPS-locatie automatisch gedeeld',
    'emergency.999_called': '112 gebeld',
    'emergency.105_called': 'Noodlijn gebeld',
    'emergency.services_contacted': 'Hulpdiensten zijn gecontacteerd.\nUw supervisor is ook geïnformeerd.',
    'emergency.power_contacted': 'Elektrische noodlijn is gecontacteerd.\nUw supervisor is ook geïnformeerd.',
    'emergency.emergency_type': 'Type noodgeval',
    'emergency.number_called': 'Gebeld nummer',
    'emergency.location': 'Locatie',
    'emergency.admin_notified': 'Admin geïnformeerd',
    'emergency.stay_in_cab': 'Blijf in de cabine',
    'emergency.stay_in_cab_msg': 'Verlaat het voertuig niet. Wacht tot de autoriteit bevestigt dat de lijn veilig is. Houd ramen gesloten.',
    'emergency.medical_type': 'Medisch',
    'emergency.electrical_type': 'Elektrisch',
    'crash.are_you_okay': 'Bent u in orde?',
    'crash.impact_detected': 'Een mogelijke botsing is gedetecteerd.\nReageer alstublieft of er wordt hulp geroepen.',
    'crash.im_okay': 'Ik ben in orde',
    'crash.dismiss_alert': 'Alarm negeren — geen actie',
    'crash.i_need_help': 'Ik heb hulp nodig',
    'crash.notify_supervisor': 'Supervisor informeren met GPS-locatie',
    'crash.call_999': 'Bel 112',
    'crash.call_emergency': 'Bel direct hulpdiensten',
    'crash.glad_okay': 'Blij dat u in orde bent',
    'crash.alert_dismissed': 'Alarm genegeerd. Geen melding verzonden.',
    'crash.help_on_way': 'Hulp is onderweg',
    'crash.supervisor_notified': 'Uw supervisor is geïnformeerd met uw GPS-locatie.',
    'crash.auto_dialled': '112 automatisch gebeld',
    'crash.no_response': 'Geen reactie. Hulpdiensten automatisch gebeld. Spraakbericht wordt uitgezonden.',
    'crash.broadcasting': 'Bericht uitzenden',
    'crash.repeating': 'Elke 15 seconden herhalen',
    'crash.admin_notified': 'Admin geïnformeerd',
    'crash.emergency_services': 'Hulpdiensten',
    'profile.title': 'Profiel',
    'profile.personal_info': 'Persoonlijke gegevens',
    'profile.full_name': 'Volledige naam',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefoon',
    'profile.role': 'Rol',
    'profile.organisation': 'Organisatie',
    'profile.emergency_contact': 'Noodcontact',
    'profile.emergency_contact_note': 'Uw supervisor wordt gecontacteerd in een noodgeval',
    'profile.contact_name': 'Naam contact',
    'profile.contact_phone': 'Telefoon contact',
    'profile.notifications': 'Meldingen',
    'profile.task_reminders': 'Taakherinneringen',
    'profile.overdue_alerts': 'Achterstandswaarschuwingen',
    'profile.crash_detection': 'Botsingsdetectie',
    'profile.account_security': 'Account en beveiliging',
    'profile.change_password': 'Wachtwoord wijzigen',
    'profile.two_factor': 'Tweefactorauthenticatie',
    'profile.login_activity': 'Inlogactiviteit',
    'profile.app_settings': 'App-instellingen',
    'profile.theme': 'Thema',
    'profile.language': 'Taal',
    'profile.sign_out': 'Uitloggen',
    'profile.sign_out_confirm': 'Uitloggen',
    'profile.sign_out_msg': 'Weet u zeker dat u wilt uitloggen?',
    'profile.field_staff': 'Buitendienstmedewerker',
    'theme.light': 'Licht',
    'theme.dark': 'Donker',
    'theme.system': 'Systeemstandaard',
  },

  'pl': {
    'app.name': 'AgriWare Operacje',
    'app.tagline': 'Zarządzanie',
    'nav.home': 'Strona główna',
    'nav.machines': 'Maszyny',
    'nav.profile': 'Profil',
    'common.back': 'Wstecz',
    'common.cancel': 'Anuluj',
    'common.save': 'Zapisz',
    'common.edit': 'Edytuj',
    'common.done': 'Gotowe',
    'common.yes': 'Tak',
    'common.no': 'Nie',
    'common.ok': 'OK',
    'common.error': 'Błąd',
    'common.loading': 'Ładowanie...',
    'common.retry': 'Spróbuj ponownie',
    'common.search': 'Szukaj',
    'common.submit': 'Prześlij',
    'common.confirm': 'Potwierdź',
    'common.close': 'Zamknij',
    'common.pass': 'Zaliczono',
    'common.fail': 'Niezaliczone',
    'common.total': 'łącznie',
    'common.today': 'Dzisiaj',
    'common.yesterday': 'Wczoraj',
    'common.online_only': 'Tylko online',
    'common.last_synced': 'Ostatnia synchronizacja',
    'common.back_to_app': 'Powrót do aplikacji',
    'common.gps_shared': 'GPS udostępniony',
    'common.yes_via_saas': 'Tak — przez SaaS',
    'common.not_called': 'Nie zadzwoniono',
    'login.sign_in': 'Zaloguj się',
    'login.email': 'Adres e-mail',
    'login.password': 'Hasło',
    'login.forgot_password': 'Zapomniałeś hasła?',
    'login.no_account': 'Nie masz konta?',
    'login.request_access': 'Poproś o dostęp',
    'login.account_created_by_org': 'Twoje konto zostało utworzone przez Twoją organizację.',
    'login.email_placeholder': 'ty@organizacja.pl',
    'login.password_placeholder': 'Wprowadź hasło',
    'login.error_empty': 'Proszę wprowadzić e-mail i hasło.',
    'login.error_invalid': 'Nieprawidłowy e-mail lub hasło. Spróbuj ponownie.',
    'dashboard.greeting_morning': 'Dzień dobry,',
    'dashboard.greeting_afternoon': 'Dzień dobry,',
    'dashboard.greeting_evening': 'Dobry wieczór,',
    'dashboard.todays_tasks': 'Zadania na dziś',
    'dashboard.completed': 'Ukończone',
    'dashboard.overdue': 'Zaległe',
    'dashboard.in_progress': 'W toku',
    'dashboard.upcoming': 'Nadchodzące',
    'dashboard.pending': 'Oczekujące',
    'machines.title': 'Maszyny',
    'machines.search_placeholder': 'Szukaj maszyn...',
    'machines.favourites': 'Ulubione',
    'machines.all_machines': 'Wszystkie maszyny',
    'machines.operational': 'Sprawna',
    'machines.needs_attention': 'Wymaga uwagi',
    'machines.fault': 'Usterka',
    'machines.unsafe_to_operate': 'Niebezpieczna w eksploatacji',
    'machines.registration': 'Rejestracja',
    'machines.assigned_operator': 'Przypisany operator',
    'machines.engine_hours': 'Motogodziny',
    'machines.documents': 'Dokumenty',
    'machines.log_fault': 'Zgłoś usterkę',
    'machines.operator_manual': 'Instrukcja obsługi',
    'machines.service_record': 'Książka serwisowa',
    'machines.insurance': 'Polisa ubezpieczeniowa',
    'machines.mot': 'Przegląd techniczny',
    'daily_check.title': 'Codzienna kontrola',
    'daily_check.start': 'Rozpocznij kontrolę',
    'daily_check.required': 'Wymagana codzienna kontrola',
    'daily_check.required_msg': 'Musi być zakończona przed uruchomieniem maszyny.',
    'daily_check.complete': 'Kontrola zakończona',
    'daily_check.complete_msg': 'Zakończona przez',
    'daily_check.submit': 'Prześlij kontrolę',
    'daily_check.items_remaining': 'pozostałych elementów',
    'daily_check.reward_title': 'Dziękujemy!',
    'daily_check.reward_subtitle': 'Twoja codzienna kontrola została zarejestrowana.\nUczciwe kontrole zapewniają bezpieczeństwo wszystkim.',
    'daily_check.back_to_machine': 'Powrót do maszyny',
    'daily_check.day_streak': 'Dni z rzędu',
    'daily_check.completion_rate': 'Wskaźnik ukończenia',
    'daily_check.cat_lights': 'Oświetlenie i widoczność',
    'daily_check.cat_fluids': 'Płyny',
    'daily_check.cat_tyres': 'Opony i koła',
    'daily_check.cat_safety': 'Bezpieczeństwo',
    'daily_check.cat_controls': 'Sterowanie',
    'daily_check.cat_body': 'Nadwozie i osprzęt',
    'daily_check.lights_working': 'Wszystkie światła działają',
    'daily_check.mirrors': 'Lusterka czyste i wyregulowane',
    'daily_check.windscreen': 'Szyba przednia czysta i nienaruszona',
    'daily_check.engine_oil': 'Poziom oleju silnikowego',
    'daily_check.coolant': 'Poziom płynu chłodzącego',
    'daily_check.hydraulic': 'Poziom płynu hydraulicznego',
    'daily_check.fuel': 'Wystarczający poziom paliwa',
    'daily_check.tyre_pressure': 'Ciśnienie w oponach prawidłowe',
    'daily_check.tyre_damage': 'Brak widocznych uszkodzeń opon',
    'daily_check.wheel_nuts': 'Nakrętki kół dokręcone',
    'daily_check.fire_extinguisher': 'Gaśnica obecna',
    'daily_check.first_aid': 'Apteczka pierwszej pomocy obecna',
    'daily_check.rops': 'Konstrukcja ROPS nieuszkodzona',
    'daily_check.seatbelt': 'Pas bezpieczeństwa działa',
    'daily_check.brakes': 'Hamulce działają',
    'daily_check.steering': 'Kierownica reaguje',
    'daily_check.horn': 'Klakson działa',
    'daily_check.body_damage': 'Brak widocznych uszkodzeń nadwozia',
    'daily_check.attachments': 'Osprzęt zamocowany',
    'daily_check.pto_guard': 'Osłona WOM na miejscu',
    'log_fault.title': 'Zgłoś usterkę',
    'log_fault.description': 'Opis',
    'log_fault.description_placeholder': 'Opisz usterkę...',
    'log_fault.photos': 'Zdjęcia',
    'log_fault.add_photo': 'Dodaj zdjęcie',
    'log_fault.submit': 'Prześlij raport',
    'log_fault.success': 'Usterka zgłoszona pomyślnie',
    'emergency.title': 'Nagły wypadek',
    'emergency.what_emergency': 'Co to za nagły wypadek?',
    'emergency.select_type': 'Wybierz rodzaj nagłego wypadku.\nOdpowiednie kontakty zostaną natychmiast powiadomione.',
    'emergency.vibrating': 'Wibracja',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Nagły wypadek medyczny',
    'emergency.medical_sub': 'Uraz, choroba lub nieprzytomna osoba na miejscu',
    'emergency.calls_999': 'Dzwoni natychmiast pod numer 112',
    'emergency.electrical': 'Nagły wypadek elektryczny',
    'emergency.electrical_sub': 'Kontakt z linią elektryczną — pozostań w kabinie',
    'emergency.calls_105': 'Dzwoni natychmiast pod numer 112',
    'emergency.no_signal': 'Numery alarmowe zapisane na urządzeniu — dostępne bez sygnału',
    'emergency.gps_auto': 'Lokalizacja GPS udostępniana automatycznie',
    'emergency.999_called': 'Zadzwoniono pod 112',
    'emergency.105_called': 'Zadzwoniono na linię alarmową',
    'emergency.services_contacted': 'Służby ratunkowe zostały powiadomione.\nTwój przełożony również został poinformowany.',
    'emergency.power_contacted': 'Elektryczna linia alarmowa została powiadomiona.\nTwój przełożony również został poinformowany.',
    'emergency.emergency_type': 'Rodzaj nagłego wypadku',
    'emergency.number_called': 'Wybrany numer',
    'emergency.location': 'Lokalizacja',
    'emergency.admin_notified': 'Admin powiadomiony',
    'emergency.stay_in_cab': 'Pozostań w kabinie',
    'emergency.stay_in_cab_msg': 'Nie wychodź z pojazdu. Poczekaj, aż władze potwierdzą, że linia jest bezpieczna. Trzymaj okna zamknięte.',
    'emergency.medical_type': 'Medyczny',
    'emergency.electrical_type': 'Elektryczny',
    'crash.are_you_okay': 'Czy jesteś bezpieczny?',
    'crash.impact_detected': 'Wykryto możliwe uderzenie.\nProszę odpowiedzieć lub zostanie wezwana pomoc.',
    'crash.im_okay': 'Jestem bezpieczny',
    'crash.dismiss_alert': 'Odrzuć alarm — brak działania',
    'crash.i_need_help': 'Potrzebuję pomocy',
    'crash.notify_supervisor': 'Powiadom przełożonego z lokalizacją GPS',
    'crash.call_999': 'Zadzwoń pod 112',
    'crash.call_emergency': 'Zadzwoń natychmiast do służb ratunkowych',
    'crash.glad_okay': 'Cieszę się, że jesteś bezpieczny',
    'crash.alert_dismissed': 'Alarm odrzucony. Nie wysłano żadnego powiadomienia.',
    'crash.help_on_way': 'Pomoc jest w drodze',
    'crash.supervisor_notified': 'Twój przełożony został powiadomiony z Twoją lokalizacją GPS.',
    'crash.auto_dialled': '112 wybrane automatycznie',
    'crash.no_response': 'Brak odpowiedzi. Służby ratunkowe powiadomione automatycznie. Wiadomość głosowa jest nadawana.',
    'crash.broadcasting': 'Nadawanie wiadomości',
    'crash.repeating': 'Powtarzanie co 15 sekund',
    'crash.admin_notified': 'Admin powiadomiony',
    'crash.emergency_services': 'Służby ratunkowe',
    'profile.title': 'Profil',
    'profile.personal_info': 'Dane osobowe',
    'profile.full_name': 'Pełne imię i nazwisko',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefon',
    'profile.role': 'Rola',
    'profile.organisation': 'Organizacja',
    'profile.emergency_contact': 'Kontakt alarmowy',
    'profile.emergency_contact_note': 'Twój przełożony zostanie skontaktowany w nagłym wypadku',
    'profile.contact_name': 'Nazwa kontaktu',
    'profile.contact_phone': 'Telefon kontaktowy',
    'profile.notifications': 'Powiadomienia',
    'profile.task_reminders': 'Przypomnienia o zadaniach',
    'profile.overdue_alerts': 'Alerty o zaległościach',
    'profile.crash_detection': 'Wykrywanie kolizji',
    'profile.account_security': 'Konto i bezpieczeństwo',
    'profile.change_password': 'Zmień hasło',
    'profile.two_factor': 'Uwierzytelnianie dwuskładnikowe',
    'profile.login_activity': 'Aktywność logowania',
    'profile.app_settings': 'Ustawienia aplikacji',
    'profile.theme': 'Motyw',
    'profile.language': 'Język',
    'profile.sign_out': 'Wyloguj się',
    'profile.sign_out_confirm': 'Wyloguj się',
    'profile.sign_out_msg': 'Czy na pewno chcesz się wylogować?',
    'profile.field_staff': 'Pracownik terenowy',
    'theme.light': 'Jasny',
    'theme.dark': 'Ciemny',
    'theme.system': 'Domyślny systemu',
    'set.emails': "E-maile",
    'set.hold_the_yard': "Cotygodniowy e-mail Hold the Yard",
    'set.hold_the_yard_desc': "W każdy poniedziałek podsumowanie kontroli przed użyciem z poprzedniego tygodnia, wysyłane do administratorów i kierowników organizacji.",
  },

  'sv': {
    'verify.err_reference_required': "En dokumentreferens krävs.",
    'verify.err_rate_limited': "För många försök. Försök igen om en stund.",
    'verify.err_not_found': "Inget maskinpass har utfärdats med den referensen.",
    'verify.err_code_mismatch': "Organisationskoden och referensen stämmer inte överens.",
    'verify.err_unknown_section': "Okänt avsnitt.",
    'verify.err_read_failed': "Posten kunde inte läsas.",
    'verify.intro': "Ange referensen som står på dokumentet för att bekräfta att det utfärdats av Agriware Operations. Lägg till den utfärdande organisationens kod för att se maskinens fullständiga historik — båda står på maskinpasset.",
    'verify.orgcode_optional': "— valfritt, för hela posten",
    'verify.title': "Verifiera ett maskinpass",
    'verify.reference_label': "Dokumentreferens",
    'verify.orgcode_label': "Organisationskod",
    'verify.checking': "Kontrollerar…",
    'verify.submit': "Verifiera",
    'verify.not_verified': "Inte verifierat",
    'verify.withdrawn': "Återkallat",
    'verify.genuine': "Äkta dokument",
    'verify.genuine_superseded': "Äkta, men ersatt",
    'verify.superseded_note': "Ett nyare maskinpass har utfärdats för den här maskinen",
    'verify.fingerprint': "Dokumentets fingeravtryck (SHA-256)",
    'verify.no_result': "Inget resultat.",
    'verify.err_not_verified': "Dokumentet kunde inte verifieras.",
    'verify.err_unreachable': "Verifieringstjänsten kunde inte nås. Försök igen.",
    'verify.row_reference': "Referens",
    'verify.row_issued_by': "Utfärdat av",
    'verify.row_issued_on': "Utfärdat",
    'verify.not_recorded': "Ej registrerat",
    'verify.row_make_model': "Märke och modell",
    'verify.row_status': "Nuvarande status",
    'verify.blocked_from_use': "Spärrad för användning",
    'verify.in_service': "I drift",
    'verify.no_open_defects': "Inga öppna fel registrerade för den här maskinen.",
    'verify.defect_history': "Felhistorik",
    'verify.no_resolved_defects': "Inga åtgärdade fel registrerade för den här maskinen.",
    'verify.inspection_record': "Besiktningsunderlag",
    'verify.check_log': "Kontrollogg",
    'verify.no_checks': "Inga kontroller registrerade för den här maskinen.",
    'verify.service_history': "Servicehistorik",
    'verify.no_services': "Inga serviceposter finns för den här maskinen.",
    'verify.checks_recorded': "Registrerade kontroller",
    'verify.pass_rate': "Godkännandegrad",
    'verify.defects_raised': "Rapporterade fel",
    'verify.most_recent_check': "Senaste kontrollen",
    'verify.show_more': "Visa fler",
    'verify.showing_of': "Visar {shown} av {total}",
    'verify.details': "Detaljer",
    'verify.hide': "Dölj",
    'verify.all_passed': "Alla godkända",
    'verify.n_failed': "{n} underkända",
    'verify.blocked_the_machine': "spärrade maskinen",
    'verify.blocking': "Spärrande",
    'verify.raised': "Rapporterat",
    'verify.resolved': "Åtgärdat",
    'verify.revised_after_issue': "reviderat efter utfärdande",
    'verify.next_service': "Nästa service",
    'verify.parts': "Reservdelar",
    'verify.external': "externt",
    'verify.sealed': "låst",
    'verify.language': "Språk",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Ingen rörelse upptäckt",
    'emergency.triggered_generic': "Nödläge utlöst",
    'emergency.community_badge': "Grannlarm — nödläge i närheten",
    'emergency.panel_responders': "De som svarat",
    'emergency.machine_involved': "Berörd maskin",
    'emergency.impact_label': "Islag",
    'emergency.ago': "sedan",
    'emergency.location_unavailable': "Plats inte tillgänglig",
    'emergency.open_in_maps': "Öppna i Google Maps",
    'emergency.im_responding': "Jag rycker ut",
    'emergency.confirming': "Bekräftar…",
    'emergency.mark_resolved': "Markera som avslutad",
    'emergency.resolving': "Avslutar…",
    'emergency.called_automatically_at': "112 ringdes automatiskt {time}",
    'emergency.state_alert': "NÖDLARM",
    'emergency.state_awaiting': "VÄNTAR PÅ SVAR",
    'emergency.state_needs_help': "OPERATÖREN BEHÖVER HJÄLP",
    'emergency.state_no_response': "INGET SVAR FRÅN OPERATÖREN",
    'emergency.seconds_to_respond': "{n} s för operatören att svara",
    'billing.over_limit_row': "Utöver maskinerna som ingår i din plan",
    'billing.over_limit_full': "Den här maskinen ligger utöver de som ingår i din plan. Lägg till den i din prenumeration för att se dess historik.",
    'nav.reports': "Rapporter",
    'site.not_found': "Anläggningen hittades inte",
    'site.details': "Anläggningsuppgifter",
    'site.edit': "Redigera anläggning",
    'site.updated': "Anläggningen uppdaterad",
    'site.err_update': "Det gick inte att uppdatera anläggningen",
    'site.no_address': "Ingen adress registrerad",
    'site.no_machines': "Inga maskiner på den här anläggningen",
    'site.no_staff': "Ingen är tilldelad den här anläggningen",
    'site.no_defects': "Inga öppna fel på den här anläggningen",
    'checks.new_template': "Ny mall",
    'set.language': "Språk",
    'set.language_hint': "Gäller alla i din organisation",
    'set.your_organisation': "Din organisation",
    'set.group_organisation': "Organisation",
    'set.group_safety': "Säkerhet och efterlevnad",
    'set.group_system': "System",
    'set.reports': "Rapporter",
    'set.org_details': "Organisationsuppgifter",
    'set.org_details_hint': "Namn, adress, organisationsnummer, profil",
    'set.sites_hint': "Gårdar, depåer och var maskinerna står",
    'set.roles': "Roller och behörigheter",
    'set.roles_hint': "Vad varje roll kan se och göra",
    'set.billing_hint': "Abonnemang och betalningsmetod",
    'set.coshh_hint': "Förvarade ämnen och deras bedömningar",
    'set.risk_hint': "Bedömningar och översyner",
    'set.reports_hint': "Maskinparkens status, efterlevnad, koldioxid, kostnader och försäkringsunderlag",
    'set.integrations': "Integrationer",
    'set.integrations_hint': "Telematik, återförsäljarsystem och Almanac",
    'set.notifications_hint': "Vad som skickas och till vem",
    'set.audit_log': "Granskningslogg",
    'set.audit_log_hint': "Vem ändrade vad, och när",
    'set.data': "Data",
    'set.data_hint': "Export och lagring",
    'set.data_retention': "Data och lagring",
    'set.export_title': "Exportera dina data",
    'set.export_desc': "Exportera en fullständig kopia av organisationens data, inklusive maskinuppgifter, servicehistorik, kontroller, personalprofiler och behörigheter.",
    'set.export_coming_soon': "Dataexport kommer snart",
    'set.export_btn': "Exportera alla data",
    'set.retention_title': "Datalagring",
    'set.retention_desc': "Dina data lagras under abonnemangets löptid plus 12 månader efter uppsägning. Serviceposter och låsta arbetsorder lagras tills vidare eftersom de kan krävas av juridiska och försäkringsmässiga skäl.",
    'set.danger_zone': "Riskzon",
    'set.danger_desc': "Om du raderar organisationen tas alla data bort permanent, utom låsta maskinposter som krävs för efterlevnad. Åtgärden kan inte ångras.",
    'set.delete_org': "Radera organisation",
    'set.delete_org_toast': "Kontakta supporten för att radera din organisation",
    'set.audit_log_subtitle': "Fullständig förteckning över alla åtgärder i organisationen",
    'set.audit_search': "Sök i granskningsloggen…",
    'set.col_action': "Åtgärd",
    'set.no_audit': "Inga granskningsposter",
    'set.audit_empty_msg': "Åtgärder visas här efterhand som de sker",
    'set.notif_title': "Aviseringsinställningar",
    'set.notif_desc': "Styr vilka händelser som utlöser push-aviseringar till chefer och administratörer i organisationen.",
    'set.notif_saved': "Aviseringsinställningar sparade",
    'set.save_preferences': "Spara inställningar",
    'set.notif_check_failed': "Kontroll underkänd",
    'set.notif_check_failed_desc': "När en operatör skickar in en underkänd kontroll",
    'set.notif_machine_blocked': "Maskin spärrad",
    'set.notif_machine_blocked_desc': "När en maskin spärras automatiskt efter en underkänd kontroll",
    'set.notif_defect': "Fel rapporterat",
    'set.notif_defect_desc': "När en operatör rapporterar ett fel",
    'set.notif_near_miss': "Tillbud rapporterat",
    'set.notif_near_miss_desc': "När ett tillbud rapporteras in",
    'set.notif_qual_expiring': "Behörighet går ut (30 d)",
    'set.notif_qual_expiring_desc': "När en behörighet går ut inom 30 dagar",
    'set.notif_qual_expired': "Behörighet utgången",
    'set.notif_qual_expired_desc': "När en behörighet har gått ut",
    'set.notif_service_due': "Service förfaller",
    'set.notif_service_due_desc': "När en maskin närmar sig sitt serviceintervall",
    'set.notif_fuel_low': "Låg nivå i bränsletank",
    'set.notif_fuel_low_desc': "När en dieseltank sjunker under gränsvärdet",
    'set.notif_emergency': "Nödlarm",
    'set.notif_emergency_desc': "Alltid på — kan inte stängas av",
    'set.notif_announcement': "Meddelanden",
    'set.notif_announcement_desc': "När ledningen skickar ett meddelande",
    'set.no_sites_msg': "Lägg till din första gård eller anläggning",
    'set.err_site_name': "Anläggningens namn krävs",
    'set.site_added': "Anläggning tillagd",
    'set.err_site_add': "Det gick inte att lägga till anläggningen",
    'set.site_name': "Anläggningens namn",
    'set.site_name_placeholder': "t.ex. Huvudgården",
    'set.address': "Adress",
    'set.address_placeholder': "t.ex. Huvudgården, Gårdsvägen 1, 123 45",
    'set.roles_title': "Roller och behörigheter",
    'set.role_admin_full': "Full åtkomst till alla anläggningar, maskiner, personal, inställningar och fakturering. Kan skicka meddelanden och hantera all data.",
    'set.role_manager_full': "Åtkomst begränsad till anläggningen. Hanterar maskiner och personal på sin anläggning. Ingen åtkomst till fakturering eller organisationsinställningar.",
    'set.role_operator_full': "Endast åtkomst via mobilappen. Utför dagliga kontroller, registrerar tankningar och kan rapportera fel och tillbud.",
    'set.perm_all_machines': "Alla maskiner på alla anläggningar",
    'set.perm_all_staff': "Hantering av all personal",
    'set.perm_all_settings': "Alla inställningar",
    'set.perm_announcements': "Skicka meddelanden",
    'set.perm_emergencies': "Avsluta nödlägen",
    'set.perm_site_machines': "Maskiner på sin anläggning",
    'set.perm_site_staff': "Personal på sin anläggning",
    'set.perm_checks_defects': "Kontroller och fel",
    'set.perm_shifts': "Skifthantering",
    'set.perm_daily_checks_app': "Dagliga kontroller (app)",
    'set.perm_fuel_fills_app': "Tankningar (app)",
    'set.perm_defect_app': "Felrapportering (app)",
    'set.perm_near_miss_app': "Tillbudsrapportering (app)",
    'set.perm_own_quals': "Se sina egna behörigheter",
    'set.perm_sos': "Nöd-SOS",
    'set.org_settings': "Organisationsinställningar",
    'set.identity': "Identitet",
    'set.org_name': "Organisationens namn",
    'set.trading_name': "Firmanamn",
    'set.if_different': "Om annat",
    'set.company_number': "Organisationsnummer",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "Momsregistreringsnummer",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Bransch",
    'set.ind_farm': "Lantbruk",
    'set.ind_estate': "Gods",
    'set.ind_contractor': "Maskinentreprenör",
    'set.ind_dealership': "Återförsäljare",
    'set.ind_other': "Övrigt",
    'set.primary_email': "Primär e-postadress",
    'set.phone_number': "Telefonnummer",
    'set.website': "Webbplats",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Adressrad 1",
    'set.address2': "Adressrad 2",
    'set.town': "Ort",
    'set.county': "Län",
    'set.postcode': "Postnummer",
    'set.branding': "Profil",
    'set.brand_colour': "Profilfärg",
    'set.compliance': "Efterlevnad",
    'set.hse_number': "HSE-registreringsnummer",
    'set.insurance_provider': "Försäkringsbolag",
    'set.policy_number': "Försäkringsnummer",
    'set.insurance_expiry': "Försäkringens slutdatum",
    'set.sharing_transfers': "Delning och överföringar",
    'set.org_code_desc': "Din organisationskod används för att ta emot delade maskiner och överföringar från andra Agriware-kunder. Dela den med den du samäger maskiner med, eller med den som säljer dig en maskin.",
    'set.emails': "E-post",
    'set.hold_the_yard': "Veckovis Hold the Yard-mejl",
    'set.hold_the_yard_desc': "En sammanfattning varje måndag av förra veckans kontroller före användning, skickad till organisationens administratörer och chefer.",
    'set.org_code': "Organisationskod",
    'set.generating': "Genereras…",
    'set.copied': "Kopierat!",
    'set.copy': "Kopiera",
    'set.org_saved': "Organisationsinställningar sparade",
    'set.err_save': "Det gick inte att spara inställningarna",
    'set.save_changes': "Spara ändringar",
    'set.status_trialing': "Provperiod",
    'set.status_past_due': "Förfallen",
    'set.status_cancelled': "Uppsagt",
    'set.status_unpaid': "Obetald",
    'set.status_incomplete': "Ofullständig",
    'set.billing_title': "Fakturering och abonnemang",
    'set.billing_subtitle': "Hantera ditt Agriware Operations-abonnemang.",
    'set.plan_standard': "Standard",
    'set.per_month': "/månad · säg upp när som helst",
    'set.grandfathered': "Den här organisationen har äldre åtkomst. Faktureringsuppgifter saknas eftersom kontot är äldre än Stripe-integrationen.",
    'set.next_billing': "Nästa faktureringsdatum:",
    'set.feat_registry': "Maskinregister och servicehistorik",
    'set.feat_checks': "Dagliga kontroller och besiktningar",
    'set.feat_defects': "Uppföljning av fel och brister",
    'set.feat_staff': "Personalens behörigheter och skift",
    'set.feat_reporting': "Rapportpaket",
    'set.feat_unlimited': "Obegränsat antal anläggningar och operatörer",
    'set.err_no_portal': "Ingen portal-URL returnerades.",
    'set.err_portal': "Det gick inte att öppna faktureringsportalen. Försök igen eller kontakta supporten.",
    'set.opening_portal': "Öppnar faktureringsportalen…",
    'set.manage_billing': "Hantera fakturering",
    'set.admin_only_billing': "Endast organisationsadministratörer kan hantera faktureringen.",
    'set.stripe_note': "Faktureringen hanteras säkert av Stripe. Vi ser aldrig dina kortuppgifter.",
    'int.abax_desc': "Hämta motortimmar, position och nyttjande direkt från ABAX-spårare, så att timmarna kommer in av sig själva i stället för att skrivas in.",
    'int.abax_detail': "Automatiska timmar skulle hålla serviceintervall, koldioxidberäkningar och kontrollefterlevnad korrekta utan att någon matar in ett mätarvärde.",
    'int.dms_desc': "Koppla till din återförsäljares DMS för att skapa jobbförfrågningar, godkänna offerter och få låsta arbetsorder på rätt maskin.",
    'int.dms_detail': "Arbete som din återförsäljare utför hamnar automatiskt på maskinposten och visas på maskinpasset.",
    'int.almanac_desc': "Se hur dina maskiner står sig mot samma modeller i alla Agriware-parker — typiska felkällor, serviceintervall och tillförlitlighet per modell.",
    'int.almanac_detail': "Almanac samlar anonymiserade fel- och servicedata från flera organisationer. Dina data bidrar; i gengäld ser du sammanställningen.",
    'int.consent_shared': "Delas: maskinens märke och modell, feltyper, timmar vid haveri, serviceintervall",
    'int.consent_never': "Delas aldrig: din organisations namn, anläggningar, personal, operatörer, kostnader eller dokument",
    'int.consent_threshold': "Siffror visas endast när det finns tillräckligt många maskiner för att enskilda maskinparker inte ska kunna identifieras",
    'int.consent_withdraw': "Du kan när som helst dra dig ur — bidragna poster tas bort från framtida sammanställningar",
    'int.err_update': "Det gick inte att uppdatera integrationen",
    'int.interest_noted': "Noterat — vi hör av oss när det är klart",
    'int.almanac_enabled': "Almanac aktiverat",
    'int.almanac_disabled': "Almanac inaktiverat",
    'int.subtitle': "Koppla Agriware Operations till de system du redan använder",
    'int.admin_only': "Endast en organisationsadministratör kan ändra integrationer.",
    'int.enabled': "Aktiverad",
    'int.in_development': "Under utveckling",
    'int.withdraw': "Dra dig ur",
    'int.enable_almanac': "Aktivera Almanac",
    'int.interest_registered': "Intresse registrerat",
    'int.register_interest': "Anmäl intresse",
    'int.less': "Mindre",
    'int.what_this_does': "Vad detta gör",
    'int.footer': "Använder du något som inte finns här? Berätta vad du vill koppla — det som efterfrågas avgör vad vi bygger härnäst.",
    'tmpl.scope_all_desc': "Gäller alla maskiner i organisationen",
    'tmpl.scope_category': "Per kategori",
    'tmpl.scope_category_desc': "Gäller valda kategorier",
    'tmpl.scope_specific_desc': "Gäller endast en maskin",
    'tmpl.freq_daily': "Dagligen",
    'tmpl.freq_daily_helper': "Måste vara klar före angiven tid varje dag",
    'tmpl.freq_weekly': "Varje vecka",
    'tmpl.freq_weekly_helper': "Måste utföras en gång per vecka",
    'tmpl.freq_hourly': "Timbaserad",
    'tmpl.freq_hourly_helper': "Utlöses var X:e motortimme",
    'tmpl.freq_monthly': "Varje månad",
    'tmpl.freq_monthly_helper': "Måste utföras en gång per månad",
    'tmpl.item_passfail': "Godkänd / Underkänd",
    'tmpl.item_numeric': "Numeriskt",
    'tmpl.item_text': "Text",
    'tmpl.item_photo': "Foto",
    'tmpl.item_signature': "Signatur",
    'tmpl.fail_none': "Endast logga",
    'tmpl.fail_flag': "Logga och meddela",
    'tmpl.fail_block': "Logga, meddela och spärra",
    'tmpl.section_default': "Avsnitt",
    'tmpl.err_name': "Mallens namn krävs",
    'tmpl.err_category': "Välj minst en kategori",
    'tmpl.err_machine': "Välj en maskin",
    'tmpl.err_items': "Lägg till minst en kontrollpunkt",
    'tmpl.updated': "Mallen uppdaterad",
    'tmpl.created': "Mallen har skapats",
    'tmpl.err_save': "Det gick inte att spara mallen",
    'tmpl.name_placeholder': "Mallens namn",
    'tmpl.save': "Spara mall",
    'tmpl.settings': "Mallinställningar",
    'tmpl.description_placeholder': "Kort beskrivning av när mallen används",
    'tmpl.applies_to': "Gäller",
    'tmpl.select_categories_caps': "VÄLJ KATEGORIER",
    'tmpl.select_machine_caps': "VÄLJ MASKIN",
    'tmpl.choose_machine': "Välj en maskin…",
    'tmpl.frequency': "Kontrollfrekvens",
    'tmpl.estimated_time': "Uppskattad tid (minuter)",
    'tmpl.every_x_hours': "Var X:e motortimme",
    'tmpl.due_by_time': "Klar senast",
    'tmpl.due_by_hint': "— påminnelsen om försening skickas vid denna tid",
    'tmpl.due_by_note': "Push-avisering skickas till operatör och platschef om det inte är klart i tid",
    'tmpl.item_one': "punkt",
    'tmpl.item_many': "punkter",
    'tmpl.new_item': "Ny kontrollpunkt",
    'tmpl.add_item': "Lägg till kontrollpunkt",
    'tmpl.add_section': "Lägg till avsnitt",
    'tmpl.item_panel_title': "Kontrollpunkt",
    'tmpl.select_item_hint': "Välj en kontrollpunkt till vänster för att redigera inställningarna här.",
    'tmpl.label': "Etikett",
    'tmpl.label_placeholder': "t.ex. motoroljenivå",
    'tmpl.if_fails': "Om detta underkänns",
    'tmpl.required': "Obligatorisk",
    'tmpl.required_hint': "Operatören måste fylla i denna punkt",
    'status.active': "Aktiv",
    'status.shared': "Delad",
    'status.transferred': "Överförd",
    'status.archived': "Arkiverad",
    'status.issues': "Anmärkningar",
    'status.emergency': "Nödläge",
    'status.closed': "Stängd",
    'status.due': "Förfaller",
    'status.draft': "Utkast",
    'status.approved': "Godkänd",
    'status.declined': "Avvisad",
    'status.scheduled': "Planerad",
    'photo.title': "Profilbild",
    'photo.upload_title': "Ladda upp ett foto",
    'photo.upload_note': "JPG, PNG eller WebP · max 5 MB · beskärs till en cirkel",
    'photo.choose': "Välj foto",
    'photo.drag_hint': "Dra för att flytta · skrolla eller dra för att zooma",
    'photo.change': "Byt foto",
    'photo.save': "Spara foto",
    'upsell.derv_title': "Bränslehantering",
    'upsell.derv_desc': "Följ tanknivåer, registrera tankningar, hantera leverantörer och bevaka bränsleförbrukningen per maskin på alla anläggningar.",
    'upsell.coshh_title': "Kemikalieregister",
    'upsell.coshh_desc': "För ett digitalt register över farliga ämnen, säkerhetsdatablad och nödvändig skyddsutrustning för personalen.",
    'upsell.risk_title': "Riskbedömningar",
    'upsell.risk_desc': "Skapa, hantera och lås riskbedömningar per maskin eller arbetsmoment. Operatörerna kvitterar innan arbetet startar.",
    'upsell.jobs_title': "DMS-integration",
    'upsell.jobs_desc': "Beställ verkstadsjobb från din återförsäljare, godkänn offerter och få låsta arbetsorder direkt på maskinprofilerna.",
    'upsell.reporting_title': "Rapporter och analys",
    'upsell.reporting_desc': "Rapporter om maskinparkens status, efterlevnad, behörigheter, bränsleförbrukning, koldioxidutsläpp och kostnad per maskin.",
    'upsell.quals_title': "Behörighetsuppföljning",
    'upsell.quals_desc': "Registrera personalens intyg och certifikat med bevakning av utgångsdatum, push-aviseringar och maskinspärr utifrån behörighet.",
    'upsell.sharing_title': "Maskindelning",
    'upsell.sharing_desc': "Dela maskinuppgifter med andra Agriware Ops-organisationer — perfekt för entreprenörer och maskinsamverkan.",
    'upsell.transfers_title': "Maskinöverföringar",
    'upsell.transfers_desc': "Överför maskiner mellan Ops-användare eller DMS-konton med fullständig ägarhistorik och digital loggbok.",
    'upsell.carbon_title': "Koldioxidrapportering",
    'upsell.carbon_desc': "Automatisk beräkning av koldioxidutsläpp utifrån bränsleförbrukning. Rapportering enligt DEFRA-standard för din maskinpark.",
    'upsell.not_included': "Den här funktionen ingår inte i din nuvarande plan.",
    'upsell.upgrade': "Uppgradera din plan",
    'service.record_not_found': "Posten hittades inte",
    'service.record_title_service': "Servicepost",
    'service.record_title_repair': "Reparationspost",
    'service.record_title_inspection': "Besiktningspost",
    'service.record_suffix': "post",
    'service.email_btn': "E-post",
    'service.email_coming_soon': "E-postexport kommer snart",
    'service.sealed_by_workshop': "Låst av {name} och kan inte ändras",
    'service.the_workshop': "verkstaden",
    'service.sealed_permanent': "Den här posten är permanent låst och kan inte ändras",
    'service.sealed_by': "Låst av",
    'service.at_suffix': "på {name}",
    'service.job_ref': "arbetsorder {ref}",
    'service.photos_video': "Foton och video",
    'service.job_photo': "Jobbfoto",
    'service.files_copying': "Vissa filer kopieras fortfarande.",
    'service.date_of_service': "Servicedatum",
    'service.hours_at_service': "Timmar vid service",
    'service.total_cost': "Total kostnad",
    'service.record_details': "Postuppgifter",
    'service.type': "Typ",
    'service.performed_by': "Utförd av",
    'service.performed_by_type': "Typ av utförare",
    'service.next_service_hours': "Timmar till nästa service",
    'service.next_service_date': "Datum för nästa service",
    'service.notes': "Anteckningar",
    'service.parts_used': "Använda reservdelar",
    'service.col_part': "Reservdel",
    'service.col_qty': "Antal",
    'service.col_cost': "Kostnad",
    'service.parts_total': "Totalt reservdelar",
    'service.cost_breakdown': "Kostnadsspecifikation",
    'service.labour_cost': "Arbetskostnad",
    'service.parts_cost': "Reservdelskostnad",
    'service.total': "Totalt",
    'service.audit_trail': "Spårbarhetslogg",
    'service.record_created_by': "Posten skapad av",
    'service.record_sealed_by': "Posten låst av",
    'service.type_service': "Service",
    'service.type_service_desc': "Planerad rutinservice",
    'service.type_repair': "Reparation",
    'service.type_repair_desc': "Oplanerat reparationsarbete",
    'service.type_inspection': "Besiktning",
    'service.type_inspection_desc': "Säkerhets- eller efterlevnadskontroll",
    'service.by_internal': "Internt",
    'service.by_dealer': "Återförsäljare",
    'service.by_external': "Extern entreprenör",
    'service.err_description': "Ange en beskrivning",
    'service.err_date': "Ange servicedatum",
    'service.added_toast': "Servicepost tillagd och låst",
    'service.err_save': "Det gick inte att spara posten — försök igen",
    'service.seal_note': "Posten låses permanent när den sparas",
    'service.record_type': "Typ av post",
    'service.description_placeholder': "Beskriv det utförda arbetet…",
    'service.performed_by_placeholder': "Namn eller företag",
    'service.additional_notes': "Ytterligare anteckningar",
    'service.notes_placeholder': "Eventuella ytterligare anteckningar…",
    'service.add_part': "Lägg till reservdel",
    'service.part_name': "Reservdelens namn",
    'service.cost_placeholder': "Kostnad £",
    'service.cost_next_service': "Kostnad och nästa service",
    'service.labour_cost_field': "Arbetskostnad (£)",
    'service.next_hours_placeholder': "t.ex. 1750",
    'service.seal_warning': "När posten sparats är den permanent låst och kan inte redigeras. Kontrollera att alla uppgifter stämmer innan du sparar.",
    'service.save_seal': "Spara och lås posten",
    'dashboard.there': "där",
    'dashboard.total_machines': "Maskiner totalt",
    'dashboard.blocked_machines': "Spärrade maskiner",
    'dashboard.open_incidents': "Öppna händelser",
    'dashboard.open_defects': "Öppna fel",
    'dashboard.fuel_tanks': "Bränsletankar",
    'common.of': "av",
    'dashboard.fleet': "Maskinpark",
    'common.view_all': "Visa alla",
    'dashboard.no_machines': "Inga maskiner än",
    'dashboard.no_machines_msg': "Lägg till din första maskin för att komma igång",
    'dashboard.recent_incidents': "Senaste händelserna",
    'dashboard.no_incidents_msg': "Inga händelser registrerade",
    'dashboard.recent_defects': "Senaste felen",
    'dashboard.no_defects': "Inga fel",
    'dashboard.no_defects_msg': "Inga fel rapporterade",
    'dashboard.defect_reported': "Fel rapporterat",
    'dashboard.group_overview': "Koncernöversikt",
    'dashboard.send_announcement': "Skicka meddelande",
    'dashboard.sites': "Anläggningar",
    'dashboard.no_sites': "Inga anläggningar än",
    'dashboard.no_sites_msg': "Lägg till din första anläggning i Inställningar för att komma igång",
    'dashboard.add_site': "Lägg till anläggning",
    'dashboard.status_monitor': "Bevaka",
    'dashboard.status_all_good': "Allt bra",
    'dashboard.derv': "Diesel",
    'dashboard.derv_level': "Dieselnivå",
    'qual.short_forklift': "Truck",
    'qual.short_sprayer': "Spruta",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Körkort",
    'qual.short_firstaid': "Första hjälpen",
    'qual.short_chainsaw': "Motorsåg",
    'qual.short_pesticide': "Växtskydd",
    'qual.short_telehandler': "Teleskoplastare",
    'qual.short_atv': "ATV",
    'qual.short_other': "Övrigt",
    'qual.forklift': "Truckkort",
    'qual.sprayer': "PA1/PA6 sprutcertifikat",
    'qual.cscs': "CSCS-kort",
    'qual.driving': "Körkort",
    'qual.firstaid': "Första hjälpen-intyg",
    'qual.chainsaw': "Motorsågskörkort",
    'qual.pesticide': "Behörighet växtskyddsmedel",
    'qual.telehandler': "Teleskoplastarintyg",
    'qual.atv': "ATV-intyg",
    'qual.other': "Annan behörighet",
    'staff.n_expired': "utgångna",
    'staff.n_expiring': "går snart ut",
    'staff.n_valid': "giltiga",
    'common.none': "Inga",
    'staff.tab_members': "Medarbetare",
    'staff.tab_qualifications': "Behörigheter",
    'staff.tab_shifts': "Skift",
    'staff.member_one': "medarbetare",
    'staff.member_many': "medarbetare",
    'staff.alert_one': "behörighetsvarning",
    'staff.alert_many': "behörighetsvarningar",
    'staff.invite': "Bjud in personal",
    'staff.create_shift': "Skapa skift",
    'staff.search': "Sök på namn eller e-post…",
    'staff.none_found': "Ingen personal hittades",
    'staff.adjust_search': "Prova att justera sökningen",
    'staff.invite_first': "Bjud in din första medarbetare",
    'staff.stat_total_quals': "Behörigheter totalt",
    'staff.stat_valid': "Giltiga",
    'staff.stat_expiring_30d': "Går ut (30 d)",
    'staff.stat_expiring': "Går ut",
    'staff.stat_expired': "Utgångna",
    'staff.qual_one': "behörighet",
    'staff.qual_many': "behörigheter",
    'staff.expires': "Går ut",
    'staff.no_quals': "Inga behörigheter registrerade",
    'staff.no_quals_msg': "Lägg till behörigheter från varje medarbetares profil",
    'staff.no_shifts': "Inga skift än",
    'staff.no_shifts_msg': "Skapa ditt första skift för att se vem som arbetar",
    'staff.shift': "Skift",
    'staff.checked_in': "incheckade",
    'staff.not_found': "Medarbetaren hittades inte",
    'staff.add_qualification': "Lägg till behörighet",
    'staff.expired_alert_one': "behörighet har gått ut — den här operatören kan sakna behörighet för vissa maskiner",
    'staff.expired_alert_many': "behörigheter har gått ut — den här operatören kan sakna behörighet för vissa maskiner",
    'staff.expiring_alert_one': "behörighet går ut inom 30 dagar",
    'staff.expiring_alert_many': "behörigheter går ut inom 30 dagar",
    'staff.tab_details': "Uppgifter",
    'staff.contact': "Kontakt",
    'staff.account': "Konto",
    'staff.onboarding': "Introduktion",
    'staff.complete': "Klar",
    'staff.job_title': "Befattning",
    'staff.joined': "Anställd",
    'staff.invited_by': "Inbjuden av",
    'staff.quals_tickets': "Behörigheter och intyg",
    'staff.no_quals_profile_msg': "Lägg till den här operatörens intyg och certifikat",
    'staff.issued': "Utfärdat",
    'staff.no_expiry': "Inget utgångsdatum",
    'staff.expires_today': "Går ut idag",
    'staff.days_remaining_one': "dag kvar",
    'staff.days_remaining_many': "dagar kvar",
    'staff.expired_days_ago_one': "Gick ut för {n} dag sedan",
    'staff.expired_days_ago_many': "Gick ut för {n} dagar sedan",
    'staff.view_certificate': "Visa intyg",
    'staff.assigned_machines': "Tilldelade maskiner",
    'staff.no_machines': "Inga maskiner tilldelade",
    'staff.no_machines_msg': "Den här operatören har inga tilldelade maskiner",
    'staff.err_first_name': "Förnamn krävs",
    'staff.err_last_name': "Efternamn krävs",
    'staff.err_email': "Ange en giltig e-postadress",
    'staff.err_site': "Välj en anläggning",
    'staff.err_create_prefix': "Det gick inte att skapa kontot:",
    'staff.err_timeout': "Tidsgränsen överskreds när kontot skulle skapas. Uppdatera sidan och försök igen.",
    'staff.err_create': "Det gick inte att skapa kontot — försök igen",
    'staff.copy_greeting': "Hej {name},",
    'staff.copy_body': "Ditt konto för Agriware Operations har skapats.",
    'staff.copy_email': "E-post:",
    'staff.copy_temp_password': "Tillfälligt lösenord:",
    'staff.copy_footer': "Du blir ombedd att byta lösenord vid första inloggningen.",
    'staff.copied_toast': "Inloggningsuppgifter kopierade till urklipp",
    'staff.role_admin_desc': "Full åtkomst till alla anläggningar och inställningar",
    'staff.role_manager_desc': "Hanterar en anläggning, personal och maskiner",
    'staff.role_operator_desc': "Utför dagliga kontroller i mobilappen",
    'staff.add_member': "Lägg till medarbetare",
    'staff.add_member_sub': "Kontot skapas direkt. Du får inloggningsuppgifterna att dela.",
    'staff.account_created': "Kontot har skapats",
    'staff.share_details_pre': "Dela dessa inloggningsuppgifter med",
    'staff.share_details_post': "Vid första inloggningen ombeds hen att byta lösenord.",
    'staff.label_email_caps': "E-POST",
    'staff.label_temp_password_caps': "TILLFÄLLIGT LÖSENORD",
    'staff.copy_login_details': "Kopiera inloggningsuppgifter",
    'staff.add_another': "Lägg till en till",
    'staff.back_to_staff': "Tillbaka till personal",
    'staff.personal_details': "Personuppgifter",
    'staff.first_name': "Förnamn",
    'staff.last_name': "Efternamn",
    'staff.work_email': "Arbets-e-post",
    'staff.site_assignment': "Anläggningstilldelning",
    'staff.no_sites': "Inga anläggningar upplagda än — lägg först till en anläggning i Inställningar",
    'staff.creating_account': "Skapar konto…",
    'staff.create_account': "Skapa konto",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Välj en typ av behörighet",
    'qual.err_name': "Ange behörighetens namn",
    'qual.err_issue_date': "Ange utfärdandedatum",
    'qual.err_expiry': "Ange utgångsdatum eller markera ”inget utgångsdatum”",
    'qual.added_toast': "Behörighet tillagd",
    'qual.err_save': "Det gick inte att spara behörigheten — försök igen",
    'qual.back_staff_profile': "Medarbetarprofil",
    'qual.subtitle': "Registrera ett intyg, certifikat eller tillstånd för den här operatören",
    'qual.type_title': "Typ av behörighet",
    'qual.name_label': "Behörighetens namn",
    'qual.name_placeholder': "t.ex. NPTC röjsågsintyg",
    'qual.cert_details': "Intygsuppgifter",
    'qual.cert_number': "Intygsnummer",
    'common.optional_suffix': "— valfritt",
    'qual.cert_number_placeholder': "t.ex. NPORS-123456",
    'qual.issuing_body': "Utfärdande organ",
    'qual.issuing_body_placeholder': "t.ex. NPORS, LANTRA, CITB",
    'qual.issue_date': "Utfärdandedatum",
    'qual.expiry_date': "Utgångsdatum",
    'qual.no_expiry_label': "Den här behörigheten har inget utgångsdatum",
    'qual.cert_document': "Intygsdokument",
    'qual.upload_note': "Ladda upp ett foto eller en skanning av intyget. Det lagras privat och delas aldrig.",
    'common.remove': "Ta bort",
    'qual.click_upload': "Klicka för att ladda upp intyget",
    'qual.file_types': "JPG, PNG eller PDF",
    'common.saving': "Sparar…",
    'qual.save': "Spara behörighet",
    'defects.title': "Fel",
    'defects.n_open': "öppna",
    'defects.n_critical': "kritiska",
    'defects.stat_total': "Fel totalt",
    'defects.status_open': "Öppen",
    'defects.status_in_progress': "Pågår",
    'defects.status_resolved': "Åtgärdad",
    'defects.all_severities': "Alla allvarlighetsgrader",
    'defects.sev_minor': "Mindre",
    'defects.sev_moderate': "Måttlig",
    'defects.sev_major': "Allvarlig",
    'defects.sev_critical': "Kritisk",
    'defects.search': "Sök fel…",
    'common.clear': "Rensa",
    'defects.col_description': "Beskrivning",
    'defects.reported_by': "Rapporterat av",
    'defects.col_severity': "Allvarlighetsgrad",
    'defects.no_description': "Ingen beskrivning",
    'defects.none_found': "Inga fel hittades",
    'defects.none_reported': "Inga fel har rapporterats",
    'defects.acknowledged_toast': "Felet är kvitterat",
    'defects.acknowledge_failed': "Det gick inte att kvittera felet",
    'defects.resolved_released': "Felet åtgärdat — maskinen frisläppt",
    'defects.resolved_toast': "Felet är åtgärdat",
    'defects.resolve_failed': "Det gick inte att åtgärda felet",
    'defects.not_found': "Felet hittades inte",
    'defects.report_title': "Felrapport",
    'defects.acknowledge': "Kvittera",
    'defects.raise_job': "Skapa arbetsorder",
    'defects.resolve': "Åtgärda",
    'defects.blocking_banner': "Maskinen spärrad — en chef måste registrera ett skriftligt frisläppande innan den tas i drift igen",
    'defects.details_title': "Feluppgifter",
    'defects.no_description_provided': "Ingen beskrivning angiven",
    'defects.reported_at': "Rapporterat",
    'defects.location': "Plats",
    'defects.photos': "Foton",
    'defects.acknowledgement': "Kvittering",
    'defects.acknowledged_by': "Kvitterat av",
    'defects.resolved_by': "Åtgärdat av",
    'defects.return_to_service': "Driftsättning",
    'defects.revised': "Reviderad",
    'defects.revised_by_suffix': "av {name}",
    'defects.view_machine_profile': "Visa maskinprofil",
    'defects.resolve_and_release': "Åtgärda och driftsätt",
    'defects.resolve_defect': "Åtgärda felet",
    'defects.release_machine': "Frisläpp maskinen",
    'defects.mark_resolved': "Markera som åtgärdad",
    'defects.release_warning': "Den här maskinen är spärrad. Ditt skriftliga frisläppande registreras med ditt namn och din roll och visas på maskinpasset.",
    'defects.resolution_details': "Uppgifter om åtgärden",
    'defects.resolution_placeholder': "Beskriv hur felet åtgärdades…",
    'defects.narrative_placeholder': "Vad som konstaterades, vad som gjordes och hur maskinen kontrollerades före frisläppande. Ange arbetsordernummer och provningsuppgifter där det är relevant.",
    'defects.chars_needed_one': "tecken till behövs",
    'defects.chars_needed_many': "tecken till behövs",
    'defects.characters': "tecken",
    'defects.permanent_note': "Detta registreras permanent på felrapporten.",
    'machines.tab_overview': "Översikt",
    'machines.tab_history': "Historik",
    'machines.tab_documents': "Dokument",
    'machines.tab_operators': "Operatörer",
    'machines.tab_sharing': "Delning",
    'machines.tab_incidents': "Händelser",
    'machines.pdf_only': "Endast PDF-filer accepteras.",
    'machines.replace_confirm': "Ersätta befintligt dokument ({name})? Den gamla filen tas bort.",
    'machines.delete_doc_confirm': "Radera det här dokumentet? Detta kan inte ångras.",
    'machines.uploaded': "Uppladdad",
    'machines.no_file_yet': "Ingen fil ännu",
    'machines.uploading': "Laddar upp…",
    'machines.view_document': "Visa dokument",
    'common.replace': "Ersätt",
    'common.delete': "Radera",
    'common.upload': "Ladda upp",
    'machines.doc_type_manual': "Manual",
    'machines.doc_type_private': "Privat",
    'machines.doc_operators_manual': "Instruktionsbok",
    'machines.doc_workshop_manual': "Verkstadshandbok",
    'machines.untitled_document': "Namnlöst dokument",
    'machines.add_document': "Lägg till dokument",
    'machines.documents_intro': "Instruktionsbok och verkstadshandbok har egna platser — det hjälper oss att identifiera rätt dokument vid delning med Agriware-biblioteket. Övriga privata dokument syns endast för din organisation.",
    'machines.returned_to_service': "Maskinen är åter i drift",
    'machines.not_blocked': "Den här maskinen är inte spärrad",
    'machines.resolve_defect_first': "Åtgärda det öppna felet för att sätta maskinen i drift igen",
    'machines.return_failed': "Det gick inte att sätta maskinen i drift igen",
    'machines.machine_not_found': "Maskinen hittades inte",
    'common.unknown': "Okänd",
    'machines.unblock': "Häv spärr",
    'service.add_record': "Lägg till servicepost",
    'machines.serial_number': "Serienummer",
    'machines.year': "Årsmodell",
    'machines.blocked_banner': "Maskinen spärrad — får inte användas",
    'machines.current_hours': "Aktuella timmar",
    'machines.next_service': "Nästa service",
    'machines.service_records': "Serviceposter",
    'machines.service_progress': "Serviceintervall",
    'machines.cost_over_time': "Kostnad över tid",
    'machines.cost_over_time_sub': "Service, reparation och ackumulerad ägandekostnad",
    'machines.cost_empty': "Kostnadsdata visas när serviceposter läggs till.",
    'machines.series_service': "Service",
    'machines.series_repair': "Reparation",
    'machines.series_cumulative': "Ackumulerat",
    'machines.details_title': "Maskinuppgifter",
    'machines.make': "Märke",
    'machines.model': "Modell",
    'machines.category': "Kategori",
    'machines.assigned_to': "Tilldelad",
    'machines.pool_machine': "Poolmaskin",
    'machines.unassigned': "Ej tilldelad",
    'machines.purchase_value': "Inköp och värde",
    'machines.purchase_date': "Inköpsdatum",
    'machines.purchase_price': "Inköpspris",
    'machines.depreciation_rate': "Avskrivningstakt",
    'machines.per_year': "per år",
    'machines.estimated_life': "Uppskattad livslängd",
    'common.unit_years': "år",
    'machines.cost_tracking': "Kostnadsuppföljning",
    'machines.total_service_cost': "Total servicekostnad",
    'machines.total_repair_cost': "Total reparationskostnad",
    'machines.total_fuel_cost': "Total bränslekostnad",
    'machines.total_cost_ownership': "Total ägandekostnad",
    'machines.service_history': "Service- och reparationshistorik",
    'service.add_record_short': "Lägg till post",
    'service.none_yet': "Inga serviceposter än",
    'service.none_yet_msg': "Lägg till din första service- eller reparationspost",
    'service.sealed': "Låst",
    'service.workshop': "Verkstad",
    'common.photo_one': "foto",
    'common.photo_many': "foton",
    'machines.assigned_operators': "Tilldelade operatörer",
    'machines.no_operator': "Ingen operatör tilldelad",
    'machines.no_operator_msg': "Den här maskinen har ingen tilldelad operatör",
    'machines.pool_machine_msg': "Detta är en poolmaskin — tillgänglig för alla operatörer",
    'machines.ownership_sharing': "Ägande och delning",
    'machines.share_machine': "Dela maskin",
    'machines.current_owner': "Nuvarande ägare",
    'machines.your_organisation': "Din organisation",
    'machines.shared_with': "Delad med",
    'machines.not_shared': "Inte delad med någon annan organisation",
    'machines.incident_history': "Händelsehistorik",
    'incidents.none': "Inga händelser",
    'incidents.none_msg': "Inga händelser registrerade för den här maskinen",
    'incidents.impact_detected': "Islag upptäckt",
    'incidents.manual_sos': "Manuellt SOS",
    'incidents.man_down': "Mandown-larm",
    'machines.unblock_title': "Sätt maskinen i drift igen",
    'machines.confirm_unblock': "Bekräfta hävning",
    'machines.unblock_warning': "Ditt skriftliga utlåtande registreras på den kontroll som stoppade maskinen och visas på maskinpasset. Om maskinen är spärrad av ett öppet fel ska du åtgärda felet i stället.",
    'machines.blocked_reason': "Orsak till spärr",
    'machines.unblock_statement': "Utlåtande för driftsättning",
    'machines.unblock_placeholder': "Vad som konstaterades, vad som gjordes och hur maskinen kontrollerades före driftsättning.",
    'checks.history_title': "Kontrollhistorik",
    'checks.stat_total': "Kontroller totalt",
    'checks.stat_passed': "Godkända",
    'checks.stat_failed': "Underkända",
    'checks.n_passed': "godkända",
    'checks.n_failed': "underkända",
    'common.clear_filters': "Rensa filter",
    'checks.not_found': "Kontrollen hittades inte",
    'common.export_pdf': "Exportera PDF",
    'common.pdf_coming_soon': "PDF-export kommer snart",
    'checks.item_failed_one': "punkt underkänd",
    'checks.item_failed_many': "punkter underkända",
    'checks.auto_blocked': "Maskinen spärrades automatiskt vid inskickning",
    'checks.sealed_record': "Låst post",
    'checks.submitted_by': "Inskickad av",
    'checks.submitted_at': "Inskickad",
    'checks.hours_at_check': "Timmar vid kontroll",
    'checks.stat_total_items': "Punkter totalt",
    'checks.stat_mileage': "Mätarställning",
    'checks.details_title': "Kontrolluppgifter",
    'checks.failed_items': "Underkända punkter",
    'checks.no_items_recorded': "Inga kontrollpunkter registrerade",
    'checks.alt_defect_photo': "Foto på fel",
    'checks.alt_check_photo': "Kontrollfoto",
    'common.unit_hrs': "tim",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Mallar",
    'checks.tab_history': "Historik",
    'checks.create_template': "Skapa mall",
    'checks.scope_specific': "Specifik maskin",
    'checks.scope_all': "Alla maskiner",
    'checks.categories': "kategorier",
    'checks.items': "punkter",
    'checks.title': "Kontroller",
    'checks.template_one': "mall",
    'checks.template_many': "mallar",
    'checks.record_one': "post",
    'checks.record_many': "poster",
    'checks.no_templates': "Inga kontrollmallar än",
    'checks.no_templates_msg': "Skapa mallar för att ange vad operatörer ska kontrollera innan de använder maskinen",
    'checks.search': "Sök på maskin eller operatör…",
    'checks.all_results': "Alla resultat",
    'checks.pass': "Godkänd",
    'checks.fail': "Underkänd",
    'checks.none_found': "Inga kontroller hittades",
    'checks.adjust_filters': "Prova att justera filtren",
    'checks.none_submitted': "Inga kontroller har skickats in än",
    'checks.col_operator': "Operatör",
    'checks.col_datetime': "Datum och tid",
    'checks.col_result': "Resultat",
    'machines.add': "Lägg till maskin",
    'machines.col_machine': "Maskin",
    'machines.col_serial': "Serienr / Reg.nr",
    'machines.col_site': "Anläggning",
    'machines.col_hours': "Timmar",
    'machines.col_status': "Status",
    'machines.title': "Maskiner",
    'machines.count_one': "maskin",
    'machines.count_many': "maskiner",
    'machines.blocked': "spärrade",
    'machines.search': "Sök på märke, modell, serienummer eller reg.nr…",
    'machines.all_sites': "Alla anläggningar",
    'machines.all_statuses': "Alla statusar",
    'machines.available': "Tillgänglig",
    'machines.blocked_one': "Spärrad",
    'machines.none_found': "Inga maskiner hittades",
    'machines.view': "Visa",
    'cat.all': "Alla kategorier",
    'cat.agricultural': "Lantbruk",
    'cat.groundcare': "Grönyteskötsel",
    'cat.plant': "Entreprenadmaskiner",
    'cat.vehicle': "Fordon",
    'cat.atv': "ATV",
    'nav.dashboard': "Översikt",
    'nav.staff': "Personal",
    'nav.checks': "Kontroller",
    'nav.safety': "Säkerhet",
    'nav.operations': "Verksamhet",
    'nav.settings': "Inställningar",
    'nav.billing': "Fakturering",
    'nav.sign_out': "Logga ut",
    'role.admin': "Administratör",
    'role.manager': "Chef",
    'role.operator': "Operatör",
    'app.name': 'AgriWare Drift',
    'app.tagline': 'Hantering',
    'nav.home': 'Hem',
    'nav.machines': 'Maskiner',
    'nav.profile': 'Profil',
    'common.back': 'Tillbaka',
    'common.cancel': 'Avbryt',
    'common.save': 'Spara',
    'common.edit': 'Redigera',
    'common.done': 'Klar',
    'common.yes': 'Ja',
    'common.no': 'Nej',
    'common.ok': 'OK',
    'common.error': 'Fel',
    'common.loading': 'Laddar...',
    'common.retry': 'Försök igen',
    'common.search': 'Sök',
    'common.submit': 'Skicka',
    'common.confirm': 'Bekräfta',
    'common.close': 'Stäng',
    'common.pass': 'Godkänd',
    'common.fail': 'Underkänd',
    'common.total': 'totalt',
    'common.today': 'Idag',
    'common.yesterday': 'Igår',
    'common.online_only': 'Endast online',
    'common.last_synced': 'Senast synkad',
    'common.back_to_app': 'Tillbaka till appen',
    'common.gps_shared': 'GPS delad',
    'common.yes_via_saas': 'Ja — via SaaS',
    'common.not_called': 'Ej ringt',
    'login.sign_in': 'Logga in',
    'login.email': 'E-postadress',
    'login.password': 'Lösenord',
    'login.forgot_password': 'Glömt lösenordet?',
    'login.no_account': 'Inget konto?',
    'login.request_access': 'Begär åtkomst',
    'login.account_created_by_org': 'Ditt konto har skapats av din organisation.',
    'login.email_placeholder': 'du@organisation.se',
    'login.password_placeholder': 'Ange ditt lösenord',
    'login.error_empty': 'Ange din e-post och ditt lösenord.',
    'login.error_invalid': 'Ogiltig e-post eller lösenord. Försök igen.',
    'dashboard.greeting_morning': 'God morgon,',
    'dashboard.greeting_afternoon': 'God eftermiddag,',
    'dashboard.greeting_evening': 'God kväll,',
    'dashboard.todays_tasks': 'Dagens uppgifter',
    'dashboard.completed': 'Avslutade',
    'dashboard.overdue': 'Försenade',
    'dashboard.in_progress': 'Pågående',
    'dashboard.upcoming': 'Kommande',
    'dashboard.pending': 'Väntande',
    'machines.search_placeholder': 'Sök maskiner...',
    'machines.favourites': 'Favoriter',
    'machines.all_machines': 'Alla maskiner',
    'machines.operational': 'Driftklar',
    'machines.needs_attention': 'Kräver uppmärksamhet',
    'machines.fault': 'Fel',
    'machines.unsafe_to_operate': 'Osäker att använda',
    'machines.registration': 'Registreringsnummer',
    'machines.assigned_operator': 'Tilldelad operatör',
    'machines.engine_hours': 'Motortimmar',
    'machines.documents': 'Dokument',
    'machines.log_fault': 'Rapportera fel',
    'machines.operator_manual': 'Operatörsmanual',
    'machines.service_record': 'Servicebok',
    'machines.insurance': 'Försäkringsintyg',
    'machines.mot': 'Besiktningsintyg',
    'daily_check.title': 'Daglig kontroll',
    'daily_check.start': 'Starta kontroll',
    'daily_check.required': 'Daglig kontroll krävs',
    'daily_check.required_msg': 'Måste slutföras innan denna maskin används.',
    'daily_check.complete': 'Kontroll slutförd',
    'daily_check.complete_msg': 'Slutförd av',
    'daily_check.submit': 'Skicka kontroll',
    'daily_check.items_remaining': 'punkter kvar',
    'daily_check.reward_title': 'Tack!',
    'daily_check.reward_subtitle': 'Din dagliga kontroll har registrerats.\nÄrliga kontroller håller alla säkra.',
    'daily_check.back_to_machine': 'Tillbaka till maskinen',
    'daily_check.day_streak': 'Dagars svit',
    'daily_check.completion_rate': 'Slutförandegrad',
    'daily_check.cat_lights': 'Belysning och sikt',
    'daily_check.cat_fluids': 'Vätskor',
    'daily_check.cat_tyres': 'Däck och hjul',
    'daily_check.cat_safety': 'Säkerhet',
    'daily_check.cat_controls': 'Reglage',
    'daily_check.cat_body': 'Kaross och tillbehör',
    'daily_check.lights_working': 'Alla lampor fungerar',
    'daily_check.mirrors': 'Speglar rena och justerade',
    'daily_check.windscreen': 'Vindruta ren och hel',
    'daily_check.engine_oil': 'Motoroljenivå',
    'daily_check.coolant': 'Kylvätskans nivå',
    'daily_check.hydraulic': 'Hydrauloljenivå',
    'daily_check.fuel': 'Bränslenivå tillräcklig',
    'daily_check.tyre_pressure': 'Däcktrycket korrekt',
    'daily_check.tyre_damage': 'Inga synliga däckskador',
    'daily_check.wheel_nuts': 'Hjulmuttrar åtdragna',
    'daily_check.fire_extinguisher': 'Brandsläckare finns',
    'daily_check.first_aid': 'Första hjälpen-kit finns',
    'daily_check.rops': 'ROPS-struktur oskadad',
    'daily_check.seatbelt': 'Säkerhetsbältet fungerar',
    'daily_check.brakes': 'Bromsarna fungerar',
    'daily_check.steering': 'Styrningen svarar',
    'daily_check.horn': 'Signalhornet fungerar',
    'daily_check.body_damage': 'Inga synliga karosskador',
    'daily_check.attachments': 'Tillbehör säkrade',
    'daily_check.pto_guard': 'PTO-skydd på plats',
    'log_fault.title': 'Rapportera fel',
    'log_fault.description': 'Beskrivning',
    'log_fault.description_placeholder': 'Beskriv felet...',
    'log_fault.photos': 'Foton',
    'log_fault.add_photo': 'Lägg till foto',
    'log_fault.submit': 'Skicka felrapport',
    'log_fault.success': 'Fel rapporterat',
    'emergency.title': 'Nödsituation',
    'emergency.what_emergency': 'Vad är nödsituationen?',
    'emergency.select_type': 'Välj typ av nödsituation.\nLämpliga kontakter rings omedelbart.',
    'emergency.vibrating': 'Vibrerar',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Medicinsk nödsituation',
    'emergency.medical_sub': 'Skada, sjukdom eller medvetslös person på plats',
    'emergency.calls_999': 'Ringer 112 omedelbart',
    'emergency.electrical': 'Elektrisk nödsituation',
    'emergency.electrical_sub': 'Kontakt med kraftledning — stanna i hytten',
    'emergency.calls_105': 'Ringer 112 omedelbart',
    'emergency.no_signal': 'Nödnummer lagrade på enheten — tillgängliga utan signal',
    'emergency.gps_auto': 'GPS-position delas automatiskt',
    'emergency.999_called': '112 ringt',
    'emergency.105_called': 'Nödlinje ringt',
    'emergency.services_contacted': 'Räddningstjänsten har kontaktats.\nDin chef har också meddelats.',
    'emergency.power_contacted': 'Den elektriska nödlinjen har kontaktats.\nDin chef har också meddelats.',
    'emergency.emergency_type': 'Typ av nödsituation',
    'emergency.number_called': 'Ringt nummer',
    'emergency.location': 'Plats',
    'emergency.admin_notified': 'Admin meddelad',
    'emergency.stay_in_cab': 'Stanna i hytten',
    'emergency.stay_in_cab_msg': 'Lämna inte fordonet. Vänta tills myndigheten bekräftar att linjen är säker. Håll fönstren stängda.',
    'emergency.medical_type': 'Medicinsk',
    'emergency.electrical_type': 'Elektrisk',
    'crash.are_you_okay': 'Är du okej?',
    'crash.impact_detected': 'En möjlig kollision har upptäckts.\nVänligen svara eller så kallas hjälp.',
    'crash.im_okay': 'Jag är okej',
    'crash.dismiss_alert': 'Avfärda alarm — ingen åtgärd',
    'crash.i_need_help': 'Jag behöver hjälp',
    'crash.notify_supervisor': 'Meddela chef med GPS-position',
    'crash.call_999': 'Ring 112',
    'crash.call_emergency': 'Ring räddningstjänsten omedelbart',
    'crash.glad_okay': 'Glad att du är okej',
    'crash.alert_dismissed': 'Alarm avfärdat. Inget meddelande skickat.',
    'crash.help_on_way': 'Hjälpen är på väg',
    'crash.supervisor_notified': 'Din chef har meddelats med din GPS-position.',
    'crash.auto_dialled': '112 ringt automatiskt',
    'crash.no_response': 'Inget svar. Räddningstjänsten ringt automatiskt. Röstmeddelande sänds.',
    'crash.broadcasting': 'Sänder meddelande',
    'crash.repeating': 'Upprepar var 15:e sekund',
    'crash.admin_notified': 'Admin meddelad',
    'crash.emergency_services': 'Räddningstjänst',
    'profile.title': 'Profil',
    'profile.personal_info': 'Personuppgifter',
    'profile.full_name': 'Fullständigt namn',
    'profile.email': 'E-post',
    'profile.phone': 'Telefon',
    'profile.role': 'Roll',
    'profile.organisation': 'Organisation',
    'profile.emergency_contact': 'Nödkontakt',
    'profile.emergency_contact_note': 'Din chef kontaktas vid nödsituation',
    'profile.contact_name': 'Kontaktnamn',
    'profile.contact_phone': 'Kontakttelefon',
    'profile.notifications': 'Notiser',
    'profile.task_reminders': 'Uppgiftspåminnelser',
    'profile.overdue_alerts': 'Förseningsvarningar',
    'profile.crash_detection': 'Kollisionsdetektering',
    'profile.account_security': 'Konto och säkerhet',
    'profile.change_password': 'Ändra lösenord',
    'profile.two_factor': 'Tvåfaktorsautentisering',
    'profile.login_activity': 'Inloggningsaktivitet',
    'profile.app_settings': 'Appinställningar',
    'profile.theme': 'Tema',
    'profile.language': 'Språk',
    'profile.sign_out': 'Logga ut',
    'profile.sign_out_confirm': 'Logga ut',
    'profile.sign_out_msg': 'Är du säker på att du vill logga ut?',
    'profile.field_staff': 'Fältpersonal',
    'theme.light': 'Ljust',
    'theme.dark': 'Mörkt',
    'theme.system': 'Systemstandard',
  },

  'da': {
    'verify.err_reference_required': "Der kræves en dokumentreference.",
    'verify.err_rate_limited': "For mange forsøg. Prøv igen om lidt.",
    'verify.err_not_found': "Der er ikke udstedt noget maskinpas med den reference.",
    'verify.err_code_mismatch': "Organisationskoden og referencen stemmer ikke overens.",
    'verify.err_unknown_section': "Ukendt afsnit.",
    'verify.err_read_failed': "Posten kunne ikke læses.",
    'verify.intro': "Indtast referencen, der står på dokumentet, for at bekræfte, at det er udstedt af Agriware Operations. Tilføj den udstedende organisations kode for at se maskinens fulde historik — begge står på maskinpasset.",
    'verify.orgcode_optional': "— valgfrit, for hele posten",
    'verify.title': "Verificér et maskinpas",
    'verify.reference_label': "Dokumentreference",
    'verify.orgcode_label': "Organisationskode",
    'verify.checking': "Kontrollerer…",
    'verify.submit': "Verificér",
    'verify.not_verified': "Ikke verificeret",
    'verify.withdrawn': "Tilbagekaldt",
    'verify.genuine': "Ægte dokument",
    'verify.genuine_superseded': "Ægte, men erstattet",
    'verify.superseded_note': "Der er udstedt et nyere maskinpas for denne maskine",
    'verify.fingerprint': "Dokumentets fingeraftryk (SHA-256)",
    'verify.no_result': "Intet resultat.",
    'verify.err_not_verified': "Dokumentet kunne ikke verificeres.",
    'verify.err_unreachable': "Verifikationstjenesten kunne ikke nås. Prøv igen.",
    'verify.row_reference': "Reference",
    'verify.row_issued_by': "Udstedt af",
    'verify.row_issued_on': "Udstedt",
    'verify.not_recorded': "Ikke registreret",
    'verify.row_make_model': "Mærke og model",
    'verify.row_status': "Nuværende status",
    'verify.blocked_from_use': "Spærret for brug",
    'verify.in_service': "I drift",
    'verify.no_open_defects': "Ingen åbne fejl registreret for denne maskine.",
    'verify.defect_history': "Fejlhistorik",
    'verify.no_resolved_defects': "Ingen udbedrede fejl registreret for denne maskine.",
    'verify.inspection_record': "Inspektionsgrundlag",
    'verify.check_log': "Kontrollog",
    'verify.no_checks': "Ingen kontroller registreret for denne maskine.",
    'verify.service_history': "Servicehistorik",
    'verify.no_services': "Ingen serviceposter for denne maskine.",
    'verify.checks_recorded': "Registrerede kontroller",
    'verify.pass_rate': "Godkendelsesgrad",
    'verify.defects_raised': "Rapporterede fejl",
    'verify.most_recent_check': "Seneste kontrol",
    'verify.show_more': "Vis flere",
    'verify.showing_of': "Viser {shown} af {total}",
    'verify.details': "Detaljer",
    'verify.hide': "Skjul",
    'verify.all_passed': "Alle godkendt",
    'verify.n_failed': "{n} ikke godkendt",
    'verify.blocked_the_machine': "spærrede maskinen",
    'verify.blocking': "Spærrende",
    'verify.raised': "Rapporteret",
    'verify.resolved': "Udbedret",
    'verify.revised_after_issue': "revideret efter udstedelse",
    'verify.next_service': "Næste service",
    'verify.parts': "Reservedele",
    'verify.external': "eksternt",
    'verify.sealed': "låst",
    'verify.language': "Sprog",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Ingen bevægelse registreret",
    'emergency.triggered_generic': "Nødsituation udløst",
    'emergency.community_badge': "Naboalarm — nødsituation i nærheden",
    'emergency.panel_responders': "De der har svaret",
    'emergency.machine_involved': "Berørt maskine",
    'emergency.impact_label': "Sammenstød",
    'emergency.ago': "siden",
    'emergency.location_unavailable': "Position ikke tilgængelig",
    'emergency.open_in_maps': "Åbn i Google Maps",
    'emergency.im_responding': "Jeg rykker ud",
    'emergency.confirming': "Bekræfter…",
    'emergency.mark_resolved': "Markér som afsluttet",
    'emergency.resolving': "Afslutter…",
    'emergency.called_automatically_at': "112 ringet automatisk kl. {time}",
    'emergency.state_alert': "NØDALARM",
    'emergency.state_awaiting': "AFVENTER SVAR",
    'emergency.state_needs_help': "OPERATØREN HAR BRUG FOR HJÆLP",
    'emergency.state_no_response': "INTET SVAR FRA OPERATØREN",
    'emergency.seconds_to_respond': "{n} s for operatøren at svare",
    'billing.over_limit_row': "Ud over maskinerne i din plan",
    'billing.over_limit_full': "Denne maskine ligger ud over dem, der er med i din plan. Tilføj den til dit abonnement for at se dens historik.",
    'nav.reports': "Rapporter",
    'site.not_found': "Lokationen blev ikke fundet",
    'site.details': "Lokationsdetaljer",
    'site.edit': "Rediger lokation",
    'site.updated': "Lokationen er opdateret",
    'site.err_update': "Lokationen kunne ikke opdateres",
    'site.no_address': "Ingen adresse registreret",
    'site.no_machines': "Ingen maskiner på denne lokation",
    'site.no_staff': "Ingen er tildelt denne lokation",
    'site.no_defects': "Ingen åbne fejl på denne lokation",
    'checks.new_template': "Ny skabelon",
    'set.language': "Sprog",
    'set.language_hint': "Gælder alle i din organisation",
    'set.your_organisation': "Din organisation",
    'set.group_organisation': "Organisation",
    'set.group_safety': "Sikkerhed og compliance",
    'set.group_system': "System",
    'set.reports': "Rapporter",
    'set.org_details': "Organisationsoplysninger",
    'set.org_details_hint': "Navn, adresse, CVR-nummer, branding",
    'set.sites_hint': "Gårdspladser, depoter og hvor maskinerne står",
    'set.roles': "Roller og tilladelser",
    'set.roles_hint': "Hvad hver rolle kan se og gøre",
    'set.billing_hint': "Abonnement og betalingsmetode",
    'set.coshh_hint': "Opbevarede stoffer og deres vurderinger",
    'set.risk_hint': "Vurderinger og gennemgange",
    'set.reports_hint': "Maskinparkens tilstand, compliance, CO₂, omkostninger og forsikringspakker",
    'set.integrations': "Integrationer",
    'set.integrations_hint': "Telematik, forhandlersystemer og Almanac",
    'set.notifications_hint': "Hvad der sendes, og til hvem",
    'set.audit_log': "Revisionslog",
    'set.audit_log_hint': "Hvem ændrede hvad, og hvornår",
    'set.data': "Data",
    'set.data_hint': "Eksport og opbevaring",
    'set.data_retention': "Data og opbevaring",
    'set.export_title': "Eksportér dine data",
    'set.export_desc': "Eksportér en komplet kopi af organisationens data, herunder maskindata, servicehistorik, kontroller, medarbejderprofiler og kvalifikationer.",
    'set.export_coming_soon': "Dataeksport kommer snart",
    'set.export_btn': "Eksportér alle data",
    'set.retention_title': "Dataopbevaring",
    'set.retention_desc': "Dine data opbevares i abonnementets levetid plus 12 måneder efter opsigelse. Serviceposter og låste arbejdskort opbevares på ubestemt tid, da de kan være påkrævet af juridiske og forsikringsmæssige årsager.",
    'set.danger_zone': "Farezone",
    'set.danger_desc': "Sletning af din organisation fjerner alle data permanent, undtagen låste maskinposter, der kræves af hensyn til compliance. Handlingen kan ikke fortrydes.",
    'set.delete_org': "Slet organisation",
    'set.delete_org_toast': "Kontakt supporten for at slette din organisation",
    'set.audit_log_subtitle': "Komplet oversigt over alle handlinger i organisationen",
    'set.audit_search': "Søg i revisionsloggen…",
    'set.col_action': "Handling",
    'set.no_audit': "Ingen revisionsposter",
    'set.audit_empty_msg': "Handlinger vises her, efterhånden som de sker",
    'set.notif_title': "Notifikationsindstillinger",
    'set.notif_desc': "Styr hvilke hændelser der udløser push-notifikationer til ledere og administratorer i organisationen.",
    'set.notif_saved': "Notifikationsindstillinger gemt",
    'set.save_preferences': "Gem indstillinger",
    'set.notif_check_failed': "Kontrol ikke godkendt",
    'set.notif_check_failed_desc': "Når en operatør indsender en ikke godkendt kontrol",
    'set.notif_machine_blocked': "Maskine spærret",
    'set.notif_machine_blocked_desc': "Når en maskine spærres automatisk efter en ikke godkendt kontrol",
    'set.notif_defect': "Fejl rapporteret",
    'set.notif_defect_desc': "Når en operatør rapporterer en fejl",
    'set.notif_near_miss': "Nærved-hændelse rapporteret",
    'set.notif_near_miss_desc': "Når en nærved-hændelse indsendes",
    'set.notif_qual_expiring': "Kvalifikation udløber (30 d)",
    'set.notif_qual_expiring_desc': "Når en kvalifikation udløber inden for 30 dage",
    'set.notif_qual_expired': "Kvalifikation udløbet",
    'set.notif_qual_expired_desc': "Når en kvalifikation er udløbet",
    'set.notif_service_due': "Service forfalder",
    'set.notif_service_due_desc': "Når en maskine nærmer sig sit serviceinterval",
    'set.notif_fuel_low': "Lavt niveau i brændstoftank",
    'set.notif_fuel_low_desc': "Når en dieseltank falder under grænseværdien",
    'set.notif_emergency': "Nødalarm",
    'set.notif_emergency_desc': "Altid slået til — kan ikke deaktiveres",
    'set.notif_announcement': "Meddelelser",
    'set.notif_announcement_desc': "Når ledelsen sender en meddelelse",
    'set.no_sites_msg': "Tilføj din første gård eller lokation",
    'set.err_site_name': "Lokationsnavn er påkrævet",
    'set.site_added': "Lokation tilføjet",
    'set.err_site_add': "Lokationen kunne ikke tilføjes",
    'set.site_name': "Lokationsnavn",
    'set.site_name_placeholder': "f.eks. Hovedgården",
    'set.address': "Adresse",
    'set.address_placeholder': "f.eks. Hovedgården, Gårdvej 1, 1234",
    'set.roles_title': "Roller og tilladelser",
    'set.role_admin_full': "Fuld adgang til alle lokationer, maskiner, medarbejdere, indstillinger og fakturering. Kan sende meddelelser og administrere alle data.",
    'set.role_manager_full': "Adgang begrænset til lokationen. Administrerer maskiner og medarbejdere på sin lokation. Ingen adgang til fakturering eller organisationsindstillinger.",
    'set.role_operator_full': "Kun adgang via mobilappen. Udfører daglige kontroller, registrerer påfyldninger og kan rapportere fejl og nærved-hændelser.",
    'set.perm_all_machines': "Alle maskiner på alle lokationer",
    'set.perm_all_staff': "Administration af alle medarbejdere",
    'set.perm_all_settings': "Alle indstillinger",
    'set.perm_announcements': "Sende meddelelser",
    'set.perm_emergencies': "Afslutte nødsituationer",
    'set.perm_site_machines': "Maskiner på deres lokation",
    'set.perm_site_staff': "Medarbejdere på deres lokation",
    'set.perm_checks_defects': "Kontroller og fejl",
    'set.perm_shifts': "Vagtadministration",
    'set.perm_daily_checks_app': "Daglige kontroller (app)",
    'set.perm_fuel_fills_app': "Påfyldninger (app)",
    'set.perm_defect_app': "Fejlrapportering (app)",
    'set.perm_near_miss_app': "Rapportering af nærved-hændelser (app)",
    'set.perm_own_quals': "Se egne kvalifikationer",
    'set.perm_sos': "Nød-SOS",
    'set.org_settings': "Organisationsindstillinger",
    'set.identity': "Identitet",
    'set.org_name': "Organisationens navn",
    'set.trading_name': "Firmanavn",
    'set.if_different': "Hvis anderledes",
    'set.company_number': "CVR-nummer",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "Momsnummer",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Branche",
    'set.ind_farm': "Landbrug",
    'set.ind_estate': "Gods",
    'set.ind_contractor': "Maskinstation",
    'set.ind_dealership': "Forhandler",
    'set.ind_other': "Andet",
    'set.primary_email': "Primær e-mailadresse",
    'set.phone_number': "Telefonnummer",
    'set.website': "Websted",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Adresselinje 1",
    'set.address2': "Adresselinje 2",
    'set.town': "By",
    'set.county': "Region",
    'set.postcode': "Postnummer",
    'set.branding': "Branding",
    'set.brand_colour': "Brandfarve",
    'set.compliance': "Compliance",
    'set.hse_number': "HSE-registreringsnummer",
    'set.insurance_provider': "Forsikringsselskab",
    'set.policy_number': "Policenummer",
    'set.insurance_expiry': "Forsikringens udløb",
    'set.sharing_transfers': "Deling og overdragelser",
    'set.org_code_desc': "Din organisationskode bruges til at modtage delte maskiner og overdragelser fra andre Agriware-kunder. Del den med dem, du ejer maskiner sammen med, eller med den, der sælger dig en maskine.",
    'set.emails': "E-mails",
    'set.hold_the_yard': "Ugentlig Hold the Yard-e-mail",
    'set.hold_the_yard_desc': "Hver mandag et overblik over sidste uges kontroller før brug, sendt til organisationens administratorer og ledere.",
    'set.org_code': "Organisationskode",
    'set.generating': "Genererer…",
    'set.copied': "Kopieret!",
    'set.copy': "Kopiér",
    'set.org_saved': "Organisationsindstillinger gemt",
    'set.err_save': "Indstillingerne kunne ikke gemmes",
    'set.save_changes': "Gem ændringer",
    'set.status_trialing': "Prøveperiode",
    'set.status_past_due': "Forfalden",
    'set.status_cancelled': "Opsagt",
    'set.status_unpaid': "Ubetalt",
    'set.status_incomplete': "Ufuldstændig",
    'set.billing_title': "Fakturering og abonnement",
    'set.billing_subtitle': "Administrér dit Agriware Operations-abonnement.",
    'set.plan_standard': "Standard",
    'set.per_month': "/måned · opsig når som helst",
    'set.grandfathered': "Denne organisation har videreført adgang. Faktureringsoplysninger er ikke tilgængelige, da kontoen er ældre end Stripe-integrationen.",
    'set.next_billing': "Næste faktureringsdato:",
    'set.feat_registry': "Maskinregister og servicehistorik",
    'set.feat_checks': "Daglige kontroller og inspektioner",
    'set.feat_defects': "Opfølgning på fejl og mangler",
    'set.feat_staff': "Medarbejdernes kvalifikationer og vagter",
    'set.feat_reporting': "Rapportpakke",
    'set.feat_unlimited': "Ubegrænset antal lokationer og operatører",
    'set.err_no_portal': "Der blev ikke returneret nogen portal-URL.",
    'set.err_portal': "Faktureringsportalen kunne ikke åbnes. Prøv igen, eller kontakt supporten.",
    'set.opening_portal': "Åbner faktureringsportalen…",
    'set.manage_billing': "Administrér fakturering",
    'set.admin_only_billing': "Kun organisationsadministratorer kan administrere faktureringen.",
    'set.stripe_note': "Faktureringen håndteres sikkert af Stripe. Vi ser aldrig dine kortoplysninger.",
    'int.abax_desc': "Hent motortimer, position og udnyttelse direkte fra ABAX-trackere, så timerne kommer ind af sig selv i stedet for at blive tastet ind.",
    'int.abax_detail': "Automatiske timer ville holde serviceintervaller, CO₂-beregninger og kontrolefterlevelse præcise, uden at nogen indtaster en aflæsning.",
    'int.dms_desc': "Forbind til din forhandlers DMS for at oprette jobanmodninger, godkende tilbud og modtage låste arbejdskort på den rigtige maskine.",
    'int.dms_detail': "Arbejde udført af din forhandler lander automatisk på maskinposten og vises på maskinpasset.",
    'int.almanac_desc': "Se, hvordan dine maskiner klarer sig sammenlignet med samme modeller i alle Agriware-parker — typiske fejlpunkter, serviceintervaller og driftssikkerhed pr. model.",
    'int.almanac_detail': "Almanac samler anonymiserede fejl- og servicedata på tværs af organisationer. Dine data bidrager; til gengæld ser du det samlede billede.",
    'int.consent_shared': "Deles: maskinens mærke og model, fejltyper, timer ved havari, serviceintervaller",
    'int.consent_never': "Deles aldrig: din organisations navn, lokationer, medarbejdere, operatører, omkostninger eller dokumenter",
    'int.consent_threshold': "Tal vises kun, når der er nok maskiner til, at enkelte maskinparker ikke kan identificeres",
    'int.consent_withdraw': "Du kan trække dig når som helst — bidragne poster fjernes fra fremtidige sammenstillinger",
    'int.err_update': "Denne integration kunne ikke opdateres",
    'int.interest_noted': "Noteret — vi kontakter dig, når det er klar",
    'int.almanac_enabled': "Almanac aktiveret",
    'int.almanac_disabled': "Almanac deaktiveret",
    'int.subtitle': "Forbind Agriware Operations med de systemer, du allerede bruger",
    'int.admin_only': "Kun en organisationsadministrator kan ændre integrationer.",
    'int.enabled': "Aktiveret",
    'int.in_development': "Under udvikling",
    'int.withdraw': "Træk dig",
    'int.enable_almanac': "Aktivér Almanac",
    'int.interest_registered': "Interesse registreret",
    'int.register_interest': "Tilkendegiv interesse",
    'int.less': "Mindre",
    'int.what_this_does': "Hvad dette gør",
    'int.footer': "Bruger du noget, der ikke står her? Fortæl os, hvad du gerne vil forbinde — det, folk efterspørger, afgør, hvad vi bygger næste gang.",
    'tmpl.scope_all_desc': "Gælder alle maskiner i organisationen",
    'tmpl.scope_category': "Efter kategori",
    'tmpl.scope_category_desc': "Gælder valgte kategorier",
    'tmpl.scope_specific_desc': "Gælder kun én maskine",
    'tmpl.freq_daily': "Dagligt",
    'tmpl.freq_daily_helper': "Skal være fuldført inden det angivne tidspunkt hver dag",
    'tmpl.freq_weekly': "Ugentligt",
    'tmpl.freq_weekly_helper': "Skal udføres én gang om ugen",
    'tmpl.freq_hourly': "Timebaseret",
    'tmpl.freq_hourly_helper': "Udløses for hver X motortime",
    'tmpl.freq_monthly': "Månedligt",
    'tmpl.freq_monthly_helper': "Skal udføres én gang om måneden",
    'tmpl.item_passfail': "Godkendt / Ikke godkendt",
    'tmpl.item_numeric': "Numerisk",
    'tmpl.item_text': "Tekst",
    'tmpl.item_photo': "Foto",
    'tmpl.item_signature': "Underskrift",
    'tmpl.fail_none': "Kun log",
    'tmpl.fail_flag': "Log og underret",
    'tmpl.fail_block': "Log, underret og spær",
    'tmpl.section_default': "Afsnit",
    'tmpl.err_name': "Skabelonnavn er påkrævet",
    'tmpl.err_category': "Vælg mindst én kategori",
    'tmpl.err_machine': "Vælg en maskine",
    'tmpl.err_items': "Tilføj mindst ét kontrolpunkt",
    'tmpl.updated': "Skabelonen er opdateret",
    'tmpl.created': "Skabelonen er oprettet",
    'tmpl.err_save': "Skabelonen kunne ikke gemmes",
    'tmpl.name_placeholder': "Skabelonnavn",
    'tmpl.save': "Gem skabelon",
    'tmpl.settings': "Skabelonindstillinger",
    'tmpl.description_placeholder': "Kort beskrivelse af, hvornår skabelonen bruges",
    'tmpl.applies_to': "Gælder",
    'tmpl.select_categories_caps': "VÆLG KATEGORIER",
    'tmpl.select_machine_caps': "VÆLG MASKINE",
    'tmpl.choose_machine': "Vælg en maskine…",
    'tmpl.frequency': "Kontrolfrekvens",
    'tmpl.estimated_time': "Estimeret tid (minutter)",
    'tmpl.every_x_hours': "For hver X motortime",
    'tmpl.due_by_time': "Frist klokkeslæt",
    'tmpl.due_by_hint': "— påmindelsen om forsinkelse sendes på dette tidspunkt",
    'tmpl.due_by_note': "Push-notifikation sendes til operatør og lokationsleder, hvis det ikke er fuldført til tiden",
    'tmpl.item_one': "punkt",
    'tmpl.item_many': "punkter",
    'tmpl.new_item': "Nyt kontrolpunkt",
    'tmpl.add_item': "Tilføj kontrolpunkt",
    'tmpl.add_section': "Tilføj afsnit",
    'tmpl.item_panel_title': "Kontrolpunkt",
    'tmpl.select_item_hint': "Vælg et kontrolpunkt til venstre for at redigere indstillingerne her.",
    'tmpl.label': "Etiket",
    'tmpl.label_placeholder': "f.eks. motorolieniveau",
    'tmpl.if_fails': "Hvis dette ikke godkendes",
    'tmpl.required': "Obligatorisk",
    'tmpl.required_hint': "Operatøren skal udfylde dette punkt",
    'status.active': "Aktiv",
    'status.shared': "Delt",
    'status.transferred': "Overført",
    'status.archived': "Arkiveret",
    'status.issues': "Anmærkninger",
    'status.emergency': "Nødsituation",
    'status.closed': "Lukket",
    'status.due': "Forfalder",
    'status.draft': "Kladde",
    'status.approved': "Godkendt",
    'status.declined': "Afvist",
    'status.scheduled': "Planlagt",
    'photo.title': "Profilbillede",
    'photo.upload_title': "Upload et foto",
    'photo.upload_note': "JPG, PNG eller WebP · maks. 5 MB · beskæres til en cirkel",
    'photo.choose': "Vælg foto",
    'photo.drag_hint': "Træk for at flytte · rul eller træk for at zoome",
    'photo.change': "Skift foto",
    'photo.save': "Gem foto",
    'upsell.derv_title': "Brændstofstyring",
    'upsell.derv_desc': "Følg tankniveauer, registrér påfyldninger, administrér leverandører og overvåg brændstofforbruget pr. maskine på alle lokationer.",
    'upsell.coshh_title': "Kemikalieregister",
    'upsell.coshh_desc': "Før et digitalt register over farlige stoffer, sikkerhedsdatablade og nødvendige værnemidler til medarbejderne.",
    'upsell.risk_title': "Risikovurderinger",
    'upsell.risk_desc': "Opret, administrér og lås risikovurderinger pr. maskine eller opgave. Operatørerne kvitterer, før arbejdet starter.",
    'upsell.jobs_title': "DMS-integration",
    'upsell.jobs_desc': "Bestil værkstedsopgaver hos din forhandler, godkend tilbud og modtag låste arbejdskort direkte på maskinprofilerne.",
    'upsell.reporting_title': "Rapporter og analyse",
    'upsell.reporting_desc': "Rapporter om maskinparkens tilstand, compliance, kvalifikationer, brændstofforbrug, CO₂-udledning og omkostning pr. maskine.",
    'upsell.quals_title': "Kvalifikationsopfølgning",
    'upsell.quals_desc': "Registrér medarbejdernes beviser og certifikater med udløbsovervågning, push-notifikationer og maskinspærring efter kvalifikation.",
    'upsell.sharing_title': "Maskindeling",
    'upsell.sharing_desc': "Del maskindata med andre Agriware Ops-organisationer — ideelt for maskinstationer og fælles maskiner.",
    'upsell.transfers_title': "Maskineoverdragelser",
    'upsell.transfers_desc': "Overdrag maskiner mellem Ops-brugere eller DMS-konti med fuld ejerhistorik og digital logbog.",
    'upsell.carbon_title': "CO₂-rapportering",
    'upsell.carbon_desc': "Automatisk beregning af CO₂-udledning ud fra brændstofforbrug. Rapportering efter DEFRA-standarden for din maskinpark.",
    'upsell.not_included': "Denne funktion er ikke inkluderet i din nuværende plan.",
    'upsell.upgrade': "Opgradér din plan",
    'service.record_not_found': "Posten blev ikke fundet",
    'service.record_title_service': "Servicepost",
    'service.record_title_repair': "Reparationspost",
    'service.record_title_inspection': "Inspektionspost",
    'service.record_suffix': "post",
    'service.email_btn': "E-mail",
    'service.email_coming_soon': "E-maileksport kommer snart",
    'service.sealed_by_workshop': "Låst af {name} og kan ikke ændres",
    'service.the_workshop': "værkstedet",
    'service.sealed_permanent': "Denne post er permanent låst og kan ikke ændres",
    'service.sealed_by': "Låst af",
    'service.at_suffix': "hos {name}",
    'service.job_ref': "arbejdsordre {ref}",
    'service.photos_video': "Fotos og video",
    'service.job_photo': "Jobfoto",
    'service.files_copying': "Nogle filer kopieres stadig.",
    'service.date_of_service': "Servicedato",
    'service.hours_at_service': "Timer ved service",
    'service.total_cost': "Samlet omkostning",
    'service.record_details': "Postdetaljer",
    'service.type': "Type",
    'service.performed_by': "Udført af",
    'service.performed_by_type': "Type udfører",
    'service.next_service_hours': "Timer til næste service",
    'service.next_service_date': "Dato for næste service",
    'service.notes': "Noter",
    'service.parts_used': "Anvendte reservedele",
    'service.col_part': "Reservedel",
    'service.col_qty': "Antal",
    'service.col_cost': "Omkostning",
    'service.parts_total': "Reservedele i alt",
    'service.cost_breakdown': "Omkostningsspecifikation",
    'service.labour_cost': "Arbejdsomkostning",
    'service.parts_cost': "Reservedelsomkostning",
    'service.total': "I alt",
    'service.audit_trail': "Sporingslog",
    'service.record_created_by': "Posten oprettet af",
    'service.record_sealed_by': "Posten låst af",
    'service.type_service': "Service",
    'service.type_service_desc': "Planlagt rutineservice",
    'service.type_repair': "Reparation",
    'service.type_repair_desc': "Uplanlagt reparationsarbejde",
    'service.type_inspection': "Inspektion",
    'service.type_inspection_desc': "Sikkerheds- eller compliancekontrol",
    'service.by_internal': "Internt",
    'service.by_dealer': "Forhandler",
    'service.by_external': "Ekstern leverandør",
    'service.err_description': "Angiv en beskrivelse",
    'service.err_date': "Angiv servicedato",
    'service.added_toast': "Servicepost tilføjet og låst",
    'service.err_save': "Posten kunne ikke gemmes — prøv igen",
    'service.seal_note': "Posten låses permanent, når den gemmes",
    'service.record_type': "Posttype",
    'service.description_placeholder': "Beskriv det udførte arbejde…",
    'service.performed_by_placeholder': "Navn eller firma",
    'service.additional_notes': "Yderligere noter",
    'service.notes_placeholder': "Eventuelle yderligere noter…",
    'service.add_part': "Tilføj reservedel",
    'service.part_name': "Reservedelens navn",
    'service.cost_placeholder': "Omkostning £",
    'service.cost_next_service': "Omkostning og næste service",
    'service.labour_cost_field': "Arbejdsomkostning (£)",
    'service.next_hours_placeholder': "f.eks. 1750",
    'service.seal_warning': "Når posten er gemt, er den permanent låst og kan ikke redigeres. Kontrollér, at alle oplysninger er korrekte, før du gemmer.",
    'service.save_seal': "Gem og lås posten",
    'dashboard.there': "der",
    'dashboard.total_machines': "Maskiner i alt",
    'dashboard.blocked_machines': "Spærrede maskiner",
    'dashboard.open_incidents': "Åbne hændelser",
    'dashboard.open_defects': "Åbne fejl",
    'dashboard.fuel_tanks': "Brændstoftanke",
    'common.of': "af",
    'dashboard.fleet': "Maskinpark",
    'common.view_all': "Vis alle",
    'dashboard.no_machines': "Ingen maskiner endnu",
    'dashboard.no_machines_msg': "Tilføj din første maskine for at komme i gang",
    'dashboard.recent_incidents': "Seneste hændelser",
    'dashboard.no_incidents_msg': "Ingen hændelser registreret",
    'dashboard.recent_defects': "Seneste fejl",
    'dashboard.no_defects': "Ingen fejl",
    'dashboard.no_defects_msg': "Ingen fejl rapporteret",
    'dashboard.defect_reported': "Fejl rapporteret",
    'dashboard.group_overview': "Koncernoversigt",
    'dashboard.send_announcement': "Send meddelelse",
    'dashboard.sites': "Lokationer",
    'dashboard.no_sites': "Ingen lokationer endnu",
    'dashboard.no_sites_msg': "Tilføj din første lokation i Indstillinger for at komme i gang",
    'dashboard.add_site': "Tilføj lokation",
    'dashboard.status_monitor': "Overvåg",
    'dashboard.status_all_good': "Alt i orden",
    'dashboard.derv': "Diesel",
    'dashboard.derv_level': "Dieselniveau",
    'qual.short_forklift': "Truck",
    'qual.short_sprayer': "Sprøjte",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Kørekort",
    'qual.short_firstaid': "Førstehjælp",
    'qual.short_chainsaw': "Motorsav",
    'qual.short_pesticide': "Plantebeskyttelse",
    'qual.short_telehandler': "Teleskoplæsser",
    'qual.short_atv': "ATV",
    'qual.short_other': "Andet",
    'qual.forklift': "Truckcertifikat",
    'qual.sprayer': "PA1/PA6 sprøjtecertifikat",
    'qual.cscs': "CSCS-kort",
    'qual.driving': "Kørekort",
    'qual.firstaid': "Førstehjælpsbevis",
    'qual.chainsaw': "Motorsavscertifikat",
    'qual.pesticide': "Sprøjtecertifikat",
    'qual.telehandler': "Teleskoplæssercertifikat",
    'qual.atv': "ATV-certifikat",
    'qual.other': "Anden kvalifikation",
    'staff.n_expired': "udløbet",
    'staff.n_expiring': "udløber snart",
    'staff.n_valid': "gyldige",
    'common.none': "Ingen",
    'staff.tab_members': "Medarbejdere",
    'staff.tab_qualifications': "Kvalifikationer",
    'staff.tab_shifts': "Vagter",
    'staff.member_one': "medarbejder",
    'staff.member_many': "medarbejdere",
    'staff.alert_one': "kvalifikationsadvarsel",
    'staff.alert_many': "kvalifikationsadvarsler",
    'staff.invite': "Inviter medarbejder",
    'staff.create_shift': "Opret vagt",
    'staff.search': "Søg på navn eller e-mail…",
    'staff.none_found': "Ingen medarbejdere fundet",
    'staff.adjust_search': "Prøv at justere søgningen",
    'staff.invite_first': "Inviter din første medarbejder",
    'staff.stat_total_quals': "Kvalifikationer i alt",
    'staff.stat_valid': "Gyldige",
    'staff.stat_expiring_30d': "Udløber (30 d)",
    'staff.stat_expiring': "Udløber",
    'staff.stat_expired': "Udløbet",
    'staff.qual_one': "kvalifikation",
    'staff.qual_many': "kvalifikationer",
    'staff.expires': "Udløber",
    'staff.no_quals': "Ingen kvalifikationer registreret",
    'staff.no_quals_msg': "Tilføj kvalifikationer fra hver medarbejders profil",
    'staff.no_shifts': "Ingen vagter endnu",
    'staff.no_shifts_msg': "Opret din første vagt for at se, hvem der arbejder",
    'staff.shift': "Vagt",
    'staff.checked_in': "tjekket ind",
    'staff.not_found': "Medarbejderen blev ikke fundet",
    'staff.add_qualification': "Tilføj kvalifikation",
    'staff.expired_alert_one': "kvalifikation er udløbet — denne operatør må muligvis ikke bruge visse maskiner",
    'staff.expired_alert_many': "kvalifikationer er udløbet — denne operatør må muligvis ikke bruge visse maskiner",
    'staff.expiring_alert_one': "kvalifikation udløber inden for 30 dage",
    'staff.expiring_alert_many': "kvalifikationer udløber inden for 30 dage",
    'staff.tab_details': "Detaljer",
    'staff.contact': "Kontakt",
    'staff.account': "Konto",
    'staff.onboarding': "Onboarding",
    'staff.complete': "Gennemført",
    'staff.job_title': "Stilling",
    'staff.joined': "Tiltrådt",
    'staff.invited_by': "Inviteret af",
    'staff.quals_tickets': "Kvalifikationer og certifikater",
    'staff.no_quals_profile_msg': "Tilføj denne operatørs beviser og certifikater",
    'staff.issued': "Udstedt",
    'staff.no_expiry': "Ingen udløbsdato",
    'staff.expires_today': "Udløber i dag",
    'staff.days_remaining_one': "dag tilbage",
    'staff.days_remaining_many': "dage tilbage",
    'staff.expired_days_ago_one': "Udløb for {n} dag siden",
    'staff.expired_days_ago_many': "Udløb for {n} dage siden",
    'staff.view_certificate': "Vis certifikat",
    'staff.assigned_machines': "Tildelte maskiner",
    'staff.no_machines': "Ingen maskiner tildelt",
    'staff.no_machines_msg': "Denne operatør har ingen tildelte maskiner",
    'staff.err_first_name': "Fornavn er påkrævet",
    'staff.err_last_name': "Efternavn er påkrævet",
    'staff.err_email': "Angiv en gyldig e-mailadresse",
    'staff.err_site': "Vælg en lokation",
    'staff.err_create_prefix': "Kontoen kunne ikke oprettes:",
    'staff.err_timeout': "Tidsfristen udløb under oprettelse af kontoen. Opdater siden, og prøv igen.",
    'staff.err_create': "Kontoen kunne ikke oprettes — prøv igen",
    'staff.copy_greeting': "Hej {name},",
    'staff.copy_body': "Din konto til Agriware Operations er oprettet.",
    'staff.copy_email': "E-mail:",
    'staff.copy_temp_password': "Midlertidig adgangskode:",
    'staff.copy_footer': "Du bliver bedt om at ændre adgangskoden ved første login.",
    'staff.copied_toast': "Loginoplysninger kopieret til udklipsholder",
    'staff.role_admin_desc': "Fuld adgang til alle lokationer og indstillinger",
    'staff.role_manager_desc': "Administrerer én lokation, medarbejdere og maskiner",
    'staff.role_operator_desc': "Udfører daglige kontroller i mobilappen",
    'staff.add_member': "Tilføj medarbejder",
    'staff.add_member_sub': "Kontoen oprettes med det samme. Du får loginoplysningerne, du skal dele.",
    'staff.account_created': "Kontoen er oprettet",
    'staff.share_details_pre': "Del disse loginoplysninger med",
    'staff.share_details_post': "Ved første login bliver de bedt om at ændre adgangskoden.",
    'staff.label_email_caps': "E-MAIL",
    'staff.label_temp_password_caps': "MIDLERTIDIG ADGANGSKODE",
    'staff.copy_login_details': "Kopiér loginoplysninger",
    'staff.add_another': "Tilføj en mere",
    'staff.back_to_staff': "Tilbage til medarbejdere",
    'staff.personal_details': "Personoplysninger",
    'staff.first_name': "Fornavn",
    'staff.last_name': "Efternavn",
    'staff.work_email': "Arbejds-e-mail",
    'staff.site_assignment': "Lokationstildeling",
    'staff.no_sites': "Ingen lokationer oprettet endnu — tilføj først en lokation i Indstillinger",
    'staff.creating_account': "Opretter konto…",
    'staff.create_account': "Opret konto",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Vælg en kvalifikationstype",
    'qual.err_name': "Angiv kvalifikationens navn",
    'qual.err_issue_date': "Angiv udstedelsesdato",
    'qual.err_expiry': "Angiv udløbsdato, eller markér »ingen udløbsdato«",
    'qual.added_toast': "Kvalifikation tilføjet",
    'qual.err_save': "Kvalifikationen kunne ikke gemmes — prøv igen",
    'qual.back_staff_profile': "Medarbejderprofil",
    'qual.subtitle': "Registrér et bevis, certifikat eller tilladelse for denne operatør",
    'qual.type_title': "Kvalifikationstype",
    'qual.name_label': "Kvalifikationens navn",
    'qual.name_placeholder': "f.eks. NPTC buskrydder-certifikat",
    'qual.cert_details': "Certifikatoplysninger",
    'qual.cert_number': "Certifikatnummer",
    'common.optional_suffix': "— valgfrit",
    'qual.cert_number_placeholder': "f.eks. NPORS-123456",
    'qual.issuing_body': "Udstedende organ",
    'qual.issuing_body_placeholder': "f.eks. NPORS, LANTRA, CITB",
    'qual.issue_date': "Udstedelsesdato",
    'qual.expiry_date': "Udløbsdato",
    'qual.no_expiry_label': "Denne kvalifikation har ingen udløbsdato",
    'qual.cert_document': "Certifikatdokument",
    'qual.upload_note': "Upload et foto eller en scanning af certifikatet. Det gemmes privat og deles aldrig.",
    'common.remove': "Fjern",
    'qual.click_upload': "Klik for at uploade certifikatet",
    'qual.file_types': "JPG, PNG eller PDF",
    'common.saving': "Gemmer…",
    'qual.save': "Gem kvalifikation",
    'defects.title': "Fejl",
    'defects.n_open': "åbne",
    'defects.n_critical': "kritiske",
    'defects.stat_total': "Fejl i alt",
    'defects.status_open': "Åben",
    'defects.status_in_progress': "I gang",
    'defects.status_resolved': "Udbedret",
    'defects.all_severities': "Alle alvorlighedsgrader",
    'defects.sev_minor': "Mindre",
    'defects.sev_moderate': "Moderat",
    'defects.sev_major': "Alvorlig",
    'defects.sev_critical': "Kritisk",
    'defects.search': "Søg efter fejl…",
    'common.clear': "Ryd",
    'defects.col_description': "Beskrivelse",
    'defects.reported_by': "Rapporteret af",
    'defects.col_severity': "Alvorlighedsgrad",
    'defects.no_description': "Ingen beskrivelse",
    'defects.none_found': "Ingen fejl fundet",
    'defects.none_reported': "Der er ikke rapporteret nogen fejl",
    'defects.acknowledged_toast': "Fejlen er kvitteret",
    'defects.acknowledge_failed': "Fejlen kunne ikke kvitteres",
    'defects.resolved_released': "Fejlen udbedret — maskinen frigivet",
    'defects.resolved_toast': "Fejlen er udbedret",
    'defects.resolve_failed': "Fejlen kunne ikke udbedres",
    'defects.not_found': "Fejlen blev ikke fundet",
    'defects.report_title': "Fejlrapport",
    'defects.acknowledge': "Kvittér",
    'defects.raise_job': "Opret arbejdsordre",
    'defects.resolve': "Udbedr",
    'defects.blocking_banner': "Maskinen spærret — en leder skal registrere en skriftlig frigivelse, før den tages i brug igen",
    'defects.details_title': "Fejldetaljer",
    'defects.no_description_provided': "Ingen beskrivelse angivet",
    'defects.reported_at': "Rapporteret",
    'defects.location': "Sted",
    'defects.photos': "Fotos",
    'defects.acknowledgement': "Kvittering",
    'defects.acknowledged_by': "Kvitteret af",
    'defects.resolved_by': "Udbedret af",
    'defects.return_to_service': "Driftsætning",
    'defects.revised': "Revideret",
    'defects.revised_by_suffix': "af {name}",
    'defects.view_machine_profile': "Vis maskinprofil",
    'defects.resolve_and_release': "Udbedr og driftsæt",
    'defects.resolve_defect': "Udbedr fejlen",
    'defects.release_machine': "Frigiv maskinen",
    'defects.mark_resolved': "Markér som udbedret",
    'defects.release_warning': "Denne maskine er spærret. Din skriftlige frigivelse registreres med dit navn og din rolle og vises på maskinpasset.",
    'defects.resolution_details': "Oplysninger om udbedringen",
    'defects.resolution_placeholder': "Beskriv, hvordan fejlen blev udbedret…",
    'defects.narrative_placeholder': "Hvad der blev fundet, hvad der blev gjort, og hvordan maskinen blev kontrolleret før frigivelse. Angiv arbejdsordrenumre og testoplysninger, hvor det er relevant.",
    'defects.chars_needed_one': "tegn mere kræves",
    'defects.chars_needed_many': "tegn mere kræves",
    'defects.characters': "tegn",
    'defects.permanent_note': "Dette registreres permanent på fejlrapporten.",
    'machines.tab_overview': "Oversigt",
    'machines.tab_history': "Historik",
    'machines.tab_documents': "Dokumenter",
    'machines.tab_operators': "Operatører",
    'machines.tab_sharing': "Deling",
    'machines.tab_incidents': "Hændelser",
    'machines.pdf_only': "Kun PDF-filer accepteres.",
    'machines.replace_confirm': "Erstat det eksisterende dokument ({name})? Den gamle fil slettes.",
    'machines.delete_doc_confirm': "Slet dette dokument? Dette kan ikke fortrydes.",
    'machines.uploaded': "Uploadet",
    'machines.no_file_yet': "Ingen fil endnu",
    'machines.uploading': "Uploader…",
    'machines.view_document': "Vis dokument",
    'common.replace': "Erstat",
    'common.delete': "Slet",
    'common.upload': "Upload",
    'machines.doc_type_manual': "Manual",
    'machines.doc_type_private': "Privat",
    'machines.doc_operators_manual': "Instruktionsbog",
    'machines.doc_workshop_manual': "Værkstedshåndbog",
    'machines.untitled_document': "Unavngivet dokument",
    'machines.add_document': "Tilføj dokument",
    'machines.documents_intro': "Instruktionsbog og værkstedshåndbog har faste pladser — det hjælper os med at identificere det rigtige dokument ved deling med Agriware-biblioteket. Øvrige private dokumenter er kun synlige for din organisation.",
    'machines.returned_to_service': "Maskinen er sat i drift igen",
    'machines.not_blocked': "Denne maskine er ikke spærret",
    'machines.resolve_defect_first': "Udbedr den åbne fejl for at sætte maskinen i drift igen",
    'machines.return_failed': "Maskinen kunne ikke sættes i drift igen",
    'machines.machine_not_found': "Maskinen blev ikke fundet",
    'common.unknown': "Ukendt",
    'machines.unblock': "Ophæv spærring",
    'service.add_record': "Tilføj servicepost",
    'machines.serial_number': "Serienummer",
    'machines.year': "Årgang",
    'machines.blocked_banner': "Maskinen spærret — må ikke bruges",
    'machines.current_hours': "Aktuelle timer",
    'machines.next_service': "Næste service",
    'machines.service_records': "Serviceposter",
    'machines.service_progress': "Serviceinterval",
    'machines.cost_over_time': "Omkostning over tid",
    'machines.cost_over_time_sub': "Service, reparation og akkumuleret ejeromkostning",
    'machines.cost_empty': "Omkostningsdata vises, efterhånden som der tilføjes serviceposter.",
    'machines.series_service': "Service",
    'machines.series_repair': "Reparation",
    'machines.series_cumulative': "Akkumuleret",
    'machines.details_title': "Maskindetaljer",
    'machines.make': "Mærke",
    'machines.model': "Model",
    'machines.category': "Kategori",
    'machines.assigned_to': "Tildelt",
    'machines.pool_machine': "Poolmaskine",
    'machines.unassigned': "Ikke tildelt",
    'machines.purchase_value': "Køb og værdi",
    'machines.purchase_date': "Købsdato",
    'machines.purchase_price': "Købspris",
    'machines.depreciation_rate': "Afskrivningssats",
    'machines.per_year': "pr. år",
    'machines.estimated_life': "Estimeret levetid",
    'common.unit_years': "år",
    'machines.cost_tracking': "Omkostningsopfølgning",
    'machines.total_service_cost': "Samlet serviceomkostning",
    'machines.total_repair_cost': "Samlet reparationsomkostning",
    'machines.total_fuel_cost': "Samlet brændstofomkostning",
    'machines.total_cost_ownership': "Samlede ejeromkostninger",
    'machines.service_history': "Service- og reparationshistorik",
    'service.add_record_short': "Tilføj post",
    'service.none_yet': "Ingen serviceposter endnu",
    'service.none_yet_msg': "Tilføj din første service- eller reparationspost",
    'service.sealed': "Låst",
    'service.workshop': "Værksted",
    'common.photo_one': "foto",
    'common.photo_many': "fotos",
    'machines.assigned_operators': "Tildelte operatører",
    'machines.no_operator': "Ingen operatør tildelt",
    'machines.no_operator_msg': "Denne maskine har ingen tildelt operatør",
    'machines.pool_machine_msg': "Dette er en poolmaskine — tilgængelig for alle operatører",
    'machines.ownership_sharing': "Ejerskab og deling",
    'machines.share_machine': "Del maskine",
    'machines.current_owner': "Nuværende ejer",
    'machines.your_organisation': "Din organisation",
    'machines.shared_with': "Delt med",
    'machines.not_shared': "Ikke delt med andre organisationer",
    'machines.incident_history': "Hændelseshistorik",
    'incidents.none': "Ingen hændelser",
    'incidents.none_msg': "Ingen hændelser registreret for denne maskine",
    'incidents.impact_detected': "Sammenstød registreret",
    'incidents.manual_sos': "Manuelt SOS",
    'incidents.man_down': "Mand-nede-alarm",
    'machines.unblock_title': "Sæt maskinen i drift igen",
    'machines.confirm_unblock': "Bekræft ophævelse",
    'machines.unblock_warning': "Din skriftlige erklæring registreres på den kontrol, der stoppede maskinen, og vises på maskinpasset. Er maskinen spærret af en åben fejl, skal du i stedet udbedre fejlen.",
    'machines.blocked_reason': "Årsag til spærring",
    'machines.unblock_statement': "Erklæring om driftsætning",
    'machines.unblock_placeholder': "Hvad der blev fundet, hvad der blev gjort, og hvordan maskinen blev kontrolleret før driftsætning.",
    'checks.history_title': "Kontrolhistorik",
    'checks.stat_total': "Kontroller i alt",
    'checks.stat_passed': "Godkendte",
    'checks.stat_failed': "Ikke godkendte",
    'checks.n_passed': "godkendte",
    'checks.n_failed': "ikke godkendte",
    'common.clear_filters': "Ryd filtre",
    'checks.not_found': "Kontrollen blev ikke fundet",
    'common.export_pdf': "Eksportér PDF",
    'common.pdf_coming_soon': "PDF-eksport kommer snart",
    'checks.item_failed_one': "punkt ikke godkendt",
    'checks.item_failed_many': "punkter ikke godkendt",
    'checks.auto_blocked': "Maskinen blev spærret automatisk ved indsendelse",
    'checks.sealed_record': "Låst post",
    'checks.submitted_by': "Indsendt af",
    'checks.submitted_at': "Indsendt",
    'checks.hours_at_check': "Timer ved kontrol",
    'checks.stat_total_items': "Punkter i alt",
    'checks.stat_mileage': "Kilometerstand",
    'checks.details_title': "Kontroldetaljer",
    'checks.failed_items': "Ikke godkendte punkter",
    'checks.no_items_recorded': "Ingen kontrolpunkter registreret",
    'checks.alt_defect_photo': "Foto af fejl",
    'checks.alt_check_photo': "Kontrolfoto",
    'common.unit_hrs': "timer",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Skabeloner",
    'checks.tab_history': "Historik",
    'checks.create_template': "Opret skabelon",
    'checks.scope_specific': "Bestemt maskine",
    'checks.scope_all': "Alle maskiner",
    'checks.categories': "kategorier",
    'checks.items': "punkter",
    'checks.title': "Kontroller",
    'checks.template_one': "skabelon",
    'checks.template_many': "skabeloner",
    'checks.record_one': "post",
    'checks.record_many': "poster",
    'checks.no_templates': "Ingen kontrolskabeloner endnu",
    'checks.no_templates_msg': "Opret skabeloner for at angive, hvad operatører skal kontrollere før brug",
    'checks.search': "Søg på maskine eller operatør…",
    'checks.all_results': "Alle resultater",
    'checks.pass': "Godkendt",
    'checks.fail': "Ikke godkendt",
    'checks.none_found': "Ingen kontroller fundet",
    'checks.adjust_filters': "Prøv at justere filtrene",
    'checks.none_submitted': "Der er endnu ikke indsendt nogen kontroller",
    'checks.col_operator': "Operatør",
    'checks.col_datetime': "Dato og tid",
    'checks.col_result': "Resultat",
    'machines.add': "Tilføj maskine",
    'machines.col_machine': "Maskine",
    'machines.col_serial': "Serienr / Reg.nr",
    'machines.col_site': "Lokation",
    'machines.col_hours': "Timer",
    'machines.col_status': "Status",
    'machines.title': "Maskiner",
    'machines.count_one': "maskine",
    'machines.count_many': "maskiner",
    'machines.blocked': "spærret",
    'machines.search': "Søg på mærke, model, serienummer eller reg.nr…",
    'machines.all_sites': "Alle lokationer",
    'machines.all_statuses': "Alle statusser",
    'machines.available': "Tilgængelig",
    'machines.blocked_one': "Spærret",
    'machines.none_found': "Ingen maskiner fundet",
    'machines.view': "Vis",
    'cat.all': "Alle kategorier",
    'cat.agricultural': "Landbrug",
    'cat.groundcare': "Grønne områder",
    'cat.plant': "Entreprenørmaskiner",
    'cat.vehicle': "Køretøj",
    'cat.atv': "ATV",
    'nav.dashboard': "Oversigt",
    'nav.staff': "Personale",
    'nav.checks': "Kontroller",
    'nav.safety': "Sikkerhed",
    'nav.operations': "Drift",
    'nav.settings': "Indstillinger",
    'nav.billing': "Fakturering",
    'nav.sign_out': "Log ud",
    'role.admin': "Administrator",
    'role.manager': "Leder",
    'role.operator': "Operatør",
    'app.name': 'AgriWare Drift',
    'app.tagline': 'Administration',
    'nav.home': 'Hjem',
    'nav.machines': 'Maskiner',
    'nav.profile': 'Profil',
    'common.back': 'Tilbage',
    'common.cancel': 'Annuller',
    'common.save': 'Gem',
    'common.edit': 'Rediger',
    'common.done': 'Færdig',
    'common.yes': 'Ja',
    'common.no': 'Nej',
    'common.ok': 'OK',
    'common.error': 'Fejl',
    'common.loading': 'Indlæser...',
    'common.retry': 'Prøv igen',
    'common.search': 'Søg',
    'common.submit': 'Indsend',
    'common.confirm': 'Bekræft',
    'common.close': 'Luk',
    'common.pass': 'Godkendt',
    'common.fail': 'Ikke godkendt',
    'common.total': 'total',
    'common.today': 'I dag',
    'common.yesterday': 'I går',
    'common.online_only': 'Kun online',
    'common.last_synced': 'Sidst synkroniseret',
    'common.back_to_app': 'Tilbage til app',
    'common.gps_shared': 'GPS delt',
    'common.yes_via_saas': 'Ja — via SaaS',
    'common.not_called': 'Ikke ringet',
    'login.sign_in': 'Log ind',
    'login.email': 'E-mailadresse',
    'login.password': 'Adgangskode',
    'login.forgot_password': 'Glemt adgangskode?',
    'login.no_account': 'Ingen konto?',
    'login.request_access': 'Anmod om adgang',
    'login.account_created_by_org': 'Din konto er oprettet af din organisation.',
    'login.email_placeholder': 'dig@organisation.dk',
    'login.password_placeholder': 'Indtast din adgangskode',
    'login.error_empty': 'Indtast venligst din e-mail og adgangskode.',
    'login.error_invalid': 'Ugyldig e-mail eller adgangskode. Prøv igen.',
    'dashboard.greeting_morning': 'God morgen,',
    'dashboard.greeting_afternoon': 'God eftermiddag,',
    'dashboard.greeting_evening': 'God aften,',
    'dashboard.todays_tasks': 'Dagens opgaver',
    'dashboard.completed': 'Afsluttede',
    'dashboard.overdue': 'Forsinkede',
    'dashboard.in_progress': 'I gang',
    'dashboard.upcoming': 'Kommende',
    'dashboard.pending': 'Afventende',
    'machines.search_placeholder': 'Søg maskiner...',
    'machines.favourites': 'Favoritter',
    'machines.all_machines': 'Alle maskiner',
    'machines.operational': 'Driftsklar',
    'machines.needs_attention': 'Kræver opmærksomhed',
    'machines.fault': 'Fejl',
    'machines.unsafe_to_operate': 'Usikker at betjene',
    'machines.registration': 'Registreringsnummer',
    'machines.assigned_operator': 'Tildelt operatør',
    'machines.engine_hours': 'Motortimer',
    'machines.documents': 'Dokumenter',
    'machines.log_fault': 'Rapporter fejl',
    'machines.operator_manual': 'Brugermanual',
    'machines.service_record': 'Servicebog',
    'machines.insurance': 'Forsikringsattest',
    'machines.mot': 'Syn',
    'daily_check.title': 'Dagligt tjek',
    'daily_check.start': 'Start tjek',
    'daily_check.required': 'Dagligt tjek påkrævet',
    'daily_check.required_msg': 'Skal gennemføres før betjening af denne maskine.',
    'daily_check.complete': 'Tjek gennemført',
    'daily_check.complete_msg': 'Gennemført af',
    'daily_check.submit': 'Indsend tjek',
    'daily_check.items_remaining': 'punkter tilbage',
    'daily_check.reward_title': 'Tak!',
    'daily_check.reward_subtitle': 'Dit daglige tjek er registreret.\nÆrlige tjek holder alle sikre.',
    'daily_check.back_to_machine': 'Tilbage til maskine',
    'daily_check.day_streak': 'Dages stribe',
    'daily_check.completion_rate': 'Gennemførelsesrate',
    'daily_check.cat_lights': 'Belysning og udsyn',
    'daily_check.cat_fluids': 'Væsker',
    'daily_check.cat_tyres': 'Dæk og hjul',
    'daily_check.cat_safety': 'Sikkerhed',
    'daily_check.cat_controls': 'Betjening',
    'daily_check.cat_body': 'Karosseri og tilbehør',
    'daily_check.lights_working': 'Alle lygter virker',
    'daily_check.mirrors': 'Spejle rene og justerede',
    'daily_check.windscreen': 'Forrude ren og ubeskadiget',
    'daily_check.engine_oil': 'Motorolieniveau',
    'daily_check.coolant': 'Kølervæskeniveau',
    'daily_check.hydraulic': 'Hydraulikvæskeniveau',
    'daily_check.fuel': 'Brændstofniveau tilstrækkeligt',
    'daily_check.tyre_pressure': 'Dæktryk korrekt',
    'daily_check.tyre_damage': 'Ingen synlige dækskader',
    'daily_check.wheel_nuts': 'Hjulmøtrikker stramme',
    'daily_check.fire_extinguisher': 'Brandslukker til stede',
    'daily_check.first_aid': 'Førstehjælpskasse til stede',
    'daily_check.rops': 'ROPS-struktur ubeskadiget',
    'daily_check.seatbelt': 'Sikkerhedssele virker',
    'daily_check.brakes': 'Bremser virker',
    'daily_check.steering': 'Styring reagerer',
    'daily_check.horn': 'Horn virker',
    'daily_check.body_damage': 'Ingen synlige karosseri skader',
    'daily_check.attachments': 'Tilbehør fastgjort',
    'daily_check.pto_guard': 'PTO-beskytter på plads',
    'log_fault.title': 'Rapporter fejl',
    'log_fault.description': 'Beskrivelse',
    'log_fault.description_placeholder': 'Beskriv fejlen...',
    'log_fault.photos': 'Billeder',
    'log_fault.add_photo': 'Tilføj billede',
    'log_fault.submit': 'Indsend fejlrapport',
    'log_fault.success': 'Fejl rapporteret',
    'emergency.title': 'Nødsituation',
    'emergency.what_emergency': 'Hvad er nødsituationen?',
    'emergency.select_type': 'Vælg type af nødsituation.\nPassende kontakter ringes op straks.',
    'emergency.vibrating': 'Vibrerer',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Medicinsk nødsituation',
    'emergency.medical_sub': 'Skade, sygdom eller bevidstløs person på stedet',
    'emergency.calls_999': 'Ringer 112 straks',
    'emergency.electrical': 'Elektrisk nødsituation',
    'emergency.electrical_sub': 'Kontakt med strømledning — bliv i kabinen',
    'emergency.calls_105': 'Ringer 112 straks',
    'emergency.no_signal': 'Nødnumre gemt på enheden — tilgængelige uden signal',
    'emergency.gps_auto': 'GPS-position deles automatisk',
    'emergency.999_called': '112 ringet',
    'emergency.105_called': 'Nødlinje ringet',
    'emergency.services_contacted': 'Redningstjenester er kontaktet.\nDin leder er også informeret.',
    'emergency.power_contacted': 'Den elektriske nødlinje er kontaktet.\nDin leder er også informeret.',
    'emergency.emergency_type': 'Type nødsituation',
    'emergency.number_called': 'Ringet nummer',
    'emergency.location': 'Placering',
    'emergency.admin_notified': 'Admin informeret',
    'emergency.stay_in_cab': 'Bliv i kabinen',
    'emergency.stay_in_cab_msg': 'Forlad ikke køretøjet. Vent til myndighederne bekræfter, at linjen er sikker. Hold vinduer lukket.',
    'emergency.medical_type': 'Medicinsk',
    'emergency.electrical_type': 'Elektrisk',
    'crash.are_you_okay': 'Er du okay?',
    'crash.impact_detected': 'En mulig kollision er registreret.\nSvar venligst, eller der vil blive ringet efter hjælp.',
    'crash.im_okay': 'Jeg er okay',
    'crash.dismiss_alert': 'Afvis alarm — ingen handling',
    'crash.i_need_help': 'Jeg har brug for hjælp',
    'crash.notify_supervisor': 'Informer leder med GPS-position',
    'crash.call_999': 'Ring 112',
    'crash.call_emergency': 'Ring straks til redningstjenester',
    'crash.glad_okay': 'Glad for at du er okay',
    'crash.alert_dismissed': 'Alarm afvist. Ingen besked sendt.',
    'crash.help_on_way': 'Hjælpen er på vej',
    'crash.supervisor_notified': 'Din leder er informeret med din GPS-position.',
    'crash.auto_dialled': '112 ringet automatisk',
    'crash.no_response': 'Intet svar. Redningstjenester ringet automatisk. Talebesked sendes.',
    'crash.broadcasting': 'Sender besked',
    'crash.repeating': 'Gentager hvert 15. sekund',
    'crash.admin_notified': 'Admin informeret',
    'crash.emergency_services': 'Redningstjenester',
    'profile.title': 'Profil',
    'profile.personal_info': 'Personlige oplysninger',
    'profile.full_name': 'Fulde navn',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefon',
    'profile.role': 'Rolle',
    'profile.organisation': 'Organisation',
    'profile.emergency_contact': 'Nødkontakt',
    'profile.emergency_contact_note': 'Din leder kontaktes i en nødsituation',
    'profile.contact_name': 'Kontaktnavn',
    'profile.contact_phone': 'Kontakttelefon',
    'profile.notifications': 'Notifikationer',
    'profile.task_reminders': 'Opgavepåmindelser',
    'profile.overdue_alerts': 'Forsinkelsesadvarsler',
    'profile.crash_detection': 'Kollisionsregistrering',
    'profile.account_security': 'Konto og sikkerhed',
    'profile.change_password': 'Skift adgangskode',
    'profile.two_factor': 'To-faktor-godkendelse',
    'profile.login_activity': 'Loginaktivitet',
    'profile.app_settings': 'App-indstillinger',
    'profile.theme': 'Tema',
    'profile.language': 'Sprog',
    'profile.sign_out': 'Log ud',
    'profile.sign_out_confirm': 'Log ud',
    'profile.sign_out_msg': 'Er du sikker på, at du vil logge ud?',
    'profile.field_staff': 'Markpersonale',
    'theme.light': 'Lyst',
    'theme.dark': 'Mørkt',
    'theme.system': 'Systemstandard',
  },

  'no': {
    'verify.err_reference_required': "En dokumentreferanse kreves.",
    'verify.err_rate_limited': "For mange forsøk. Prøv igjen om en stund.",
    'verify.err_not_found': "Ingen maskinpass er utstedt med den referansen.",
    'verify.err_code_mismatch': "Organisasjonskoden og referansen stemmer ikke overens.",
    'verify.err_unknown_section': "Ukjent seksjon.",
    'verify.err_read_failed': "Posten kunne ikke leses.",
    'verify.intro': "Skriv inn referansen som står på dokumentet for å bekrefte at det er utstedt av Agriware Operations. Legg til den utstedende organisasjonens kode for å se maskinens fullstendige historikk — begge står på maskinpasset.",
    'verify.orgcode_optional': "— valgfritt, for hele oppføringen",
    'verify.title': "Verifiser et maskinpass",
    'verify.reference_label': "Dokumentreferanse",
    'verify.orgcode_label': "Organisasjonskode",
    'verify.checking': "Kontrollerer…",
    'verify.submit': "Verifiser",
    'verify.not_verified': "Ikke verifisert",
    'verify.withdrawn': "Trukket tilbake",
    'verify.genuine': "Ekte dokument",
    'verify.genuine_superseded': "Ekte, men erstattet",
    'verify.superseded_note': "Det er utstedt et nyere maskinpass for denne maskinen",
    'verify.fingerprint': "Dokumentets fingeravtrykk (SHA-256)",
    'verify.no_result': "Ingen treff.",
    'verify.err_not_verified': "Dokumentet kunne ikke verifiseres.",
    'verify.err_unreachable': "Verifiseringstjenesten kunne ikke nås. Prøv igjen.",
    'verify.row_reference': "Referanse",
    'verify.row_issued_by': "Utstedt av",
    'verify.row_issued_on': "Utstedt",
    'verify.not_recorded': "Ikke registrert",
    'verify.row_make_model': "Merke og modell",
    'verify.row_status': "Nåværende status",
    'verify.blocked_from_use': "Sperret for bruk",
    'verify.in_service': "I drift",
    'verify.no_open_defects': "Ingen åpne feil registrert for denne maskinen.",
    'verify.defect_history': "Feilhistorikk",
    'verify.no_resolved_defects': "Ingen utbedrede feil registrert for denne maskinen.",
    'verify.inspection_record': "Inspeksjonsgrunnlag",
    'verify.check_log': "Kontrollogg",
    'verify.no_checks': "Ingen kontroller registrert for denne maskinen.",
    'verify.service_history': "Servicehistorikk",
    'verify.no_services': "Ingen serviceoppføringer for denne maskinen.",
    'verify.checks_recorded': "Registrerte kontroller",
    'verify.pass_rate': "Godkjenningsgrad",
    'verify.defects_raised': "Rapporterte feil",
    'verify.most_recent_check': "Siste kontroll",
    'verify.show_more': "Vis flere",
    'verify.showing_of': "Viser {shown} av {total}",
    'verify.details': "Detaljer",
    'verify.hide': "Skjul",
    'verify.all_passed': "Alle godkjent",
    'verify.n_failed': "{n} ikke godkjent",
    'verify.blocked_the_machine': "sperret maskinen",
    'verify.blocking': "Sperrende",
    'verify.raised': "Rapportert",
    'verify.resolved': "Utbedret",
    'verify.revised_after_issue': "revidert etter utstedelse",
    'verify.next_service': "Neste service",
    'verify.parts': "Deler",
    'verify.external': "eksternt",
    'verify.sealed': "låst",
    'verify.language': "Språk",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Ingen bevegelse registrert",
    'emergency.triggered_generic': "Nødssituasjon utløst",
    'emergency.community_badge': "Nabovarsel — nødssituasjon i nærheten",
    'emergency.panel_responders': "De som har svart",
    'emergency.machine_involved': "Berørt maskin",
    'emergency.impact_label': "Sammenstøt",
    'emergency.ago': "siden",
    'emergency.location_unavailable': "Posisjon ikke tilgjengelig",
    'emergency.open_in_maps': "Åpne i Google Maps",
    'emergency.im_responding': "Jeg rykker ut",
    'emergency.confirming': "Bekrefter…",
    'emergency.mark_resolved': "Merk som avsluttet",
    'emergency.resolving': "Avslutter…",
    'emergency.called_automatically_at': "112 ble ringt automatisk {time}",
    'emergency.state_alert': "NØDVARSEL",
    'emergency.state_awaiting': "VENTER PÅ SVAR",
    'emergency.state_needs_help': "OPERATØREN TRENGER HJELP",
    'emergency.state_no_response': "INGEN SVAR FRA OPERATØREN",
    'emergency.seconds_to_respond': "{n} s for operatøren å svare",
    'billing.over_limit_row': "Utover maskinene som inngår i planen din",
    'billing.over_limit_full': "Denne maskinen kommer i tillegg til dem som inngår i planen din. Legg den til i abonnementet for å se historikken.",
    'nav.reports': "Rapporter",
    'site.not_found': "Fant ikke anlegget",
    'site.details': "Anleggsdetaljer",
    'site.edit': "Rediger anlegg",
    'site.updated': "Anlegget er oppdatert",
    'site.err_update': "Kunne ikke oppdatere anlegget",
    'site.no_address': "Ingen adresse registrert",
    'site.no_machines': "Ingen maskiner på dette anlegget",
    'site.no_staff': "Ingen er tildelt dette anlegget",
    'site.no_defects': "Ingen åpne feil på dette anlegget",
    'checks.new_template': "Ny mal",
    'set.language': "Språk",
    'set.language_hint': "Gjelder alle i organisasjonen",
    'set.your_organisation': "Din organisasjon",
    'set.group_organisation': "Organisasjon",
    'set.group_safety': "Sikkerhet og samsvar",
    'set.group_system': "System",
    'set.reports': "Rapporter",
    'set.org_details': "Organisasjonsopplysninger",
    'set.org_details_hint': "Navn, adresse, organisasjonsnummer, profil",
    'set.sites_hint': "Gårdsplasser, depoter og hvor maskinene står",
    'set.roles': "Roller og tillatelser",
    'set.roles_hint': "Hva hver rolle kan se og gjøre",
    'set.billing_hint': "Abonnement og betalingsmåte",
    'set.coshh_hint': "Lagrede stoffer og vurderingene av dem",
    'set.risk_hint': "Vurderinger og gjennomganger",
    'set.reports_hint': "Maskinparkens tilstand, samsvar, klimagass, kostnader og forsikringspakker",
    'set.integrations': "Integrasjoner",
    'set.integrations_hint': "Telematikk, forhandlersystemer og Almanac",
    'set.notifications_hint': "Hva som sendes, og til hvem",
    'set.audit_log': "Revisjonslogg",
    'set.audit_log_hint': "Hvem endret hva, og når",
    'set.data': "Data",
    'set.data_hint': "Eksport og oppbevaring",
    'set.data_retention': "Data og oppbevaring",
    'set.export_title': "Eksporter dataene dine",
    'set.export_desc': "Eksporter en fullstendig kopi av organisasjonens data, inkludert maskindata, servicehistorikk, kontroller, medarbeiderprofiler og kompetansebevis.",
    'set.export_coming_soon': "Dataeksport kommer snart",
    'set.export_btn': "Eksporter alle data",
    'set.retention_title': "Dataoppbevaring",
    'set.retention_desc': "Dataene dine oppbevares i abonnementets levetid pluss 12 måneder etter oppsigelse. Serviceoppføringer og låste arbeidsordrer oppbevares på ubestemt tid fordi de kan kreves av juridiske og forsikringsmessige årsaker.",
    'set.danger_zone': "Faresone",
    'set.danger_desc': "Sletting av organisasjonen fjerner alle data permanent, bortsett fra låste maskinoppføringer som kreves for samsvar. Handlingen kan ikke angres.",
    'set.delete_org': "Slett organisasjon",
    'set.delete_org_toast': "Kontakt support for å slette organisasjonen din",
    'set.audit_log_subtitle': "Fullstendig oversikt over alle handlinger i organisasjonen",
    'set.audit_search': "Søk i revisjonsloggen…",
    'set.col_action': "Handling",
    'set.no_audit': "Ingen revisjonsoppføringer",
    'set.audit_empty_msg': "Handlinger vises her etter hvert som de skjer",
    'set.notif_title': "Varslingsinnstillinger",
    'set.notif_desc': "Styr hvilke hendelser som utløser push-varsler til ledere og administratorer i organisasjonen.",
    'set.notif_saved': "Varslingsinnstillinger lagret",
    'set.save_preferences': "Lagre innstillinger",
    'set.notif_check_failed': "Kontroll ikke godkjent",
    'set.notif_check_failed_desc': "Når en operatør sender inn en ikke godkjent kontroll",
    'set.notif_machine_blocked': "Maskin sperret",
    'set.notif_machine_blocked_desc': "Når en maskin sperres automatisk etter en ikke godkjent kontroll",
    'set.notif_defect': "Feil rapportert",
    'set.notif_defect_desc': "Når en operatør rapporterer en feil",
    'set.notif_near_miss': "Nestenulykke rapportert",
    'set.notif_near_miss_desc': "Når en nestenulykke sendes inn",
    'set.notif_qual_expiring': "Kompetansebevis utløper (30 d)",
    'set.notif_qual_expiring_desc': "Når et kompetansebevis utløper innen 30 dager",
    'set.notif_qual_expired': "Kompetansebevis utløpt",
    'set.notif_qual_expired_desc': "Når et kompetansebevis er utløpt",
    'set.notif_service_due': "Service forfaller",
    'set.notif_service_due_desc': "Når en maskin nærmer seg serviceintervallet",
    'set.notif_fuel_low': "Lavt nivå i drivstofftank",
    'set.notif_fuel_low_desc': "Når en dieseltank faller under grenseverdien",
    'set.notif_emergency': "Nødvarsel",
    'set.notif_emergency_desc': "Alltid på — kan ikke slås av",
    'set.notif_announcement': "Meldinger",
    'set.notif_announcement_desc': "Når ledelsen sender en melding",
    'set.no_sites_msg': "Legg til din første gård eller ditt første anlegg",
    'set.err_site_name': "Anleggsnavn er påkrevd",
    'set.site_added': "Anlegg lagt til",
    'set.err_site_add': "Kunne ikke legge til anlegget",
    'set.site_name': "Anleggsnavn",
    'set.site_name_placeholder': "f.eks. Hovedgården",
    'set.address': "Adresse",
    'set.address_placeholder': "f.eks. Hovedgården, Gårdsveien 1, 1234",
    'set.roles_title': "Roller og tillatelser",
    'set.role_admin_full': "Full tilgang til alle anlegg, maskiner, ansatte, innstillinger og fakturering. Kan sende meldinger og administrere alle data.",
    'set.role_manager_full': "Tilgang begrenset til anlegget. Administrerer maskiner og ansatte på sitt anlegg. Ingen tilgang til fakturering eller organisasjonsinnstillinger.",
    'set.role_operator_full': "Kun tilgang via mobilappen. Utfører daglige kontroller, registrerer fyllinger og kan rapportere feil og nestenulykker.",
    'set.perm_all_machines': "Alle maskiner på alle anlegg",
    'set.perm_all_staff': "Administrasjon av alle ansatte",
    'set.perm_all_settings': "Alle innstillinger",
    'set.perm_announcements': "Sende meldinger",
    'set.perm_emergencies': "Avslutte nødssituasjoner",
    'set.perm_site_machines': "Maskiner på sitt anlegg",
    'set.perm_site_staff': "Ansatte på sitt anlegg",
    'set.perm_checks_defects': "Kontroller og feil",
    'set.perm_shifts': "Skiftadministrasjon",
    'set.perm_daily_checks_app': "Daglige kontroller (app)",
    'set.perm_fuel_fills_app': "Fyllinger (app)",
    'set.perm_defect_app': "Feilrapportering (app)",
    'set.perm_near_miss_app': "Rapportering av nestenulykker (app)",
    'set.perm_own_quals': "Se egne kompetansebevis",
    'set.perm_sos': "Nød-SOS",
    'set.org_settings': "Organisasjonsinnstillinger",
    'set.identity': "Identitet",
    'set.org_name': "Organisasjonens navn",
    'set.trading_name': "Foretaksnavn",
    'set.if_different': "Hvis annet",
    'set.company_number': "Organisasjonsnummer",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "MVA-nummer",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Bransje",
    'set.ind_farm': "Gårdsbruk",
    'set.ind_estate': "Gods",
    'set.ind_contractor': "Maskinentreprenør",
    'set.ind_dealership': "Forhandler",
    'set.ind_other': "Annet",
    'set.primary_email': "Primær e-postadresse",
    'set.phone_number': "Telefonnummer",
    'set.website': "Nettsted",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Adresselinje 1",
    'set.address2': "Adresselinje 2",
    'set.town': "Sted",
    'set.county': "Fylke",
    'set.postcode': "Postnummer",
    'set.branding': "Profil",
    'set.brand_colour': "Profilfarge",
    'set.compliance': "Samsvar",
    'set.hse_number': "HSE-registreringsnummer",
    'set.insurance_provider': "Forsikringsselskap",
    'set.policy_number': "Polisenummer",
    'set.insurance_expiry': "Forsikringens utløp",
    'set.sharing_transfers': "Deling og overføringer",
    'set.org_code_desc': "Organisasjonskoden din brukes til å motta delte maskiner og overføringer fra andre Agriware-kunder. Del den med dem du eier maskiner sammen med, eller med den som selger deg en maskin.",
    'set.emails': "E-post",
    'set.hold_the_yard': "Ukentlig Hold the Yard-e-post",
    'set.hold_the_yard_desc': "Hver mandag en oppsummering av forrige ukes kontroller før bruk, sendt til organisasjonens administratorer og ledere.",
    'set.org_code': "Organisasjonskode",
    'set.generating': "Genererer…",
    'set.copied': "Kopiert!",
    'set.copy': "Kopier",
    'set.org_saved': "Organisasjonsinnstillinger lagret",
    'set.err_save': "Kunne ikke lagre innstillingene",
    'set.save_changes': "Lagre endringer",
    'set.status_trialing': "Prøveperiode",
    'set.status_past_due': "Forfalt",
    'set.status_cancelled': "Sagt opp",
    'set.status_unpaid': "Ubetalt",
    'set.status_incomplete': "Ufullstendig",
    'set.billing_title': "Fakturering og abonnement",
    'set.billing_subtitle': "Administrer Agriware Operations-abonnementet ditt.",
    'set.plan_standard': "Standard",
    'set.per_month': "/måned · si opp når som helst",
    'set.grandfathered': "Denne organisasjonen har videreført tilgang. Faktureringsdetaljer er ikke tilgjengelige fordi kontoen er eldre enn Stripe-integrasjonen.",
    'set.next_billing': "Neste faktureringsdato:",
    'set.feat_registry': "Maskinregister og servicehistorikk",
    'set.feat_checks': "Daglige kontroller og inspeksjoner",
    'set.feat_defects': "Oppfølging av feil og mangler",
    'set.feat_staff': "Ansattes kompetansebevis og skift",
    'set.feat_reporting': "Rapportpakke",
    'set.feat_unlimited': "Ubegrenset antall anlegg og operatører",
    'set.err_no_portal': "Ingen portal-URL ble returnert.",
    'set.err_portal': "Kunne ikke åpne faktureringsportalen. Prøv igjen, eller kontakt support.",
    'set.opening_portal': "Åpner faktureringsportalen…",
    'set.manage_billing': "Administrer fakturering",
    'set.admin_only_billing': "Bare organisasjonsadministratorer kan administrere faktureringen.",
    'set.stripe_note': "Faktureringen håndteres sikkert av Stripe. Vi ser aldri kortopplysningene dine.",
    'int.abax_desc': "Hent motortimer, posisjon og utnyttelse rett fra ABAX-sporere, slik at timene kommer inn av seg selv i stedet for å tastes inn.",
    'int.abax_detail': "Automatiske timer ville holde serviceintervaller, klimaberegninger og kontrollsamsvar nøyaktige uten at noen taster inn en avlesning.",
    'int.dms_desc': "Koble til forhandlerens DMS for å opprette jobbforespørsler, godkjenne tilbud og motta låste arbeidsordrer på riktig maskin.",
    'int.dms_detail': "Arbeid utført av forhandleren havner automatisk på maskinoppføringen og vises på maskinpasset.",
    'int.almanac_desc': "Se hvordan maskinene dine sammenlignes med de samme modellene i alle Agriware-parker — typiske feilpunkter, serviceintervaller og pålitelighet per modell.",
    'int.almanac_detail': "Almanac samler anonymiserte feil- og servicedata på tvers av organisasjoner. Dine data bidrar; til gjengjeld ser du det samlede bildet.",
    'int.consent_shared': "Deles: maskinens merke og modell, feiltyper, timer ved havari, serviceintervaller",
    'int.consent_never': "Deles aldri: organisasjonens navn, anlegg, ansatte, operatører, kostnader eller dokumenter",
    'int.consent_threshold': "Tall vises bare når det finnes nok maskiner til at enkeltparker forblir uidentifiserbare",
    'int.consent_withdraw': "Du kan trekke deg når som helst — bidratte oppføringer fjernes fra framtidige sammenstillinger",
    'int.err_update': "Kunne ikke oppdatere denne integrasjonen",
    'int.interest_noted': "Notert — vi tar kontakt når dette er klart",
    'int.almanac_enabled': "Almanac aktivert",
    'int.almanac_disabled': "Almanac deaktivert",
    'int.subtitle': "Koble Agriware Operations til systemene du allerede bruker",
    'int.admin_only': "Bare en organisasjonsadministrator kan endre integrasjoner.",
    'int.enabled': "Aktivert",
    'int.in_development': "Under utvikling",
    'int.withdraw': "Trekk deg",
    'int.enable_almanac': "Aktiver Almanac",
    'int.interest_registered': "Interesse registrert",
    'int.register_interest': "Meld interesse",
    'int.less': "Mindre",
    'int.what_this_does': "Hva dette gjør",
    'int.footer': "Bruker du noe som ikke står her? Fortell oss hva du vil koble til — det folk etterspør avgjør hva vi bygger neste gang.",
    'tmpl.scope_all_desc': "Gjelder alle maskiner i organisasjonen",
    'tmpl.scope_category': "Per kategori",
    'tmpl.scope_category_desc': "Gjelder valgte kategorier",
    'tmpl.scope_specific_desc': "Gjelder bare én maskin",
    'tmpl.freq_daily': "Daglig",
    'tmpl.freq_daily_helper': "Må være fullført innen angitt tidspunkt hver dag",
    'tmpl.freq_weekly': "Ukentlig",
    'tmpl.freq_weekly_helper': "Må utføres én gang per uke",
    'tmpl.freq_hourly': "Timebasert",
    'tmpl.freq_hourly_helper': "Utløses hver X. motortime",
    'tmpl.freq_monthly': "Månedlig",
    'tmpl.freq_monthly_helper': "Må utføres én gang per måned",
    'tmpl.item_passfail': "Godkjent / Ikke godkjent",
    'tmpl.item_numeric': "Numerisk",
    'tmpl.item_text': "Tekst",
    'tmpl.item_photo': "Bilde",
    'tmpl.item_signature': "Signatur",
    'tmpl.fail_none': "Bare logg",
    'tmpl.fail_flag': "Logg og varsle",
    'tmpl.fail_block': "Logg, varsle og sperr",
    'tmpl.section_default': "Seksjon",
    'tmpl.err_name': "Malnavn er påkrevd",
    'tmpl.err_category': "Velg minst én kategori",
    'tmpl.err_machine': "Velg en maskin",
    'tmpl.err_items': "Legg til minst ett kontrollpunkt",
    'tmpl.updated': "Malen er oppdatert",
    'tmpl.created': "Malen er opprettet",
    'tmpl.err_save': "Kunne ikke lagre malen",
    'tmpl.name_placeholder': "Malnavn",
    'tmpl.save': "Lagre mal",
    'tmpl.settings': "Malinnstillinger",
    'tmpl.description_placeholder': "Kort beskrivelse av når malen brukes",
    'tmpl.applies_to': "Gjelder",
    'tmpl.select_categories_caps': "VELG KATEGORIER",
    'tmpl.select_machine_caps': "VELG MASKIN",
    'tmpl.choose_machine': "Velg en maskin…",
    'tmpl.frequency': "Kontrollfrekvens",
    'tmpl.estimated_time': "Estimert tid (minutter)",
    'tmpl.every_x_hours': "Hver X. motortime",
    'tmpl.due_by_time': "Frist klokkeslett",
    'tmpl.due_by_hint': "— påminnelsen om forsinkelse sendes på dette tidspunktet",
    'tmpl.due_by_note': "Push-varsel sendes til operatør og anleggsleder hvis det ikke er fullført i tide",
    'tmpl.item_one': "punkt",
    'tmpl.item_many': "punkter",
    'tmpl.new_item': "Nytt kontrollpunkt",
    'tmpl.add_item': "Legg til kontrollpunkt",
    'tmpl.add_section': "Legg til seksjon",
    'tmpl.item_panel_title': "Kontrollpunkt",
    'tmpl.select_item_hint': "Velg et kontrollpunkt til venstre for å redigere innstillingene her.",
    'tmpl.label': "Etikett",
    'tmpl.label_placeholder': "f.eks. motoroljenivå",
    'tmpl.if_fails': "Hvis dette ikke godkjennes",
    'tmpl.required': "Obligatorisk",
    'tmpl.required_hint': "Operatøren må fylle ut dette punktet",
    'status.active': "Aktiv",
    'status.shared': "Delt",
    'status.transferred': "Overført",
    'status.archived': "Arkivert",
    'status.issues': "Anmerkninger",
    'status.emergency': "Nødssituasjon",
    'status.closed': "Lukket",
    'status.due': "Forfaller",
    'status.draft': "Utkast",
    'status.approved': "Godkjent",
    'status.declined': "Avvist",
    'status.scheduled': "Planlagt",
    'photo.title': "Profilbilde",
    'photo.upload_title': "Last opp et bilde",
    'photo.upload_note': "JPG, PNG eller WebP · maks 5 MB · beskjæres til en sirkel",
    'photo.choose': "Velg bilde",
    'photo.drag_hint': "Dra for å flytte · rull eller dra for å zoome",
    'photo.change': "Endre bilde",
    'photo.save': "Lagre bilde",
    'upsell.derv_title': "Drivstoffstyring",
    'upsell.derv_desc': "Følg tanknivåer, registrer fyllinger, administrer leverandører og overvåk drivstofforbruket per maskin på alle anlegg.",
    'upsell.coshh_title': "Kjemikalieregister",
    'upsell.coshh_desc': "Før et digitalt register over farlige stoffer, sikkerhetsdatablad og nødvendig verneutstyr for de ansatte.",
    'upsell.risk_title': "Risikovurderinger",
    'upsell.risk_desc': "Opprett, administrer og lås risikovurderinger per maskin eller oppgave. Operatørene kvitterer før arbeidet starter.",
    'upsell.jobs_title': "DMS-integrasjon",
    'upsell.jobs_desc': "Bestill verkstedjobber fra forhandleren, godkjenn tilbud og motta låste arbeidsordrer direkte på maskinprofilene.",
    'upsell.reporting_title': "Rapporter og analyse",
    'upsell.reporting_desc': "Rapporter om maskinparkens tilstand, samsvar, kompetanse, drivstofforbruk, CO₂-utslipp og kostnad per maskin.",
    'upsell.quals_title': "Kompetanseoppfølging",
    'upsell.quals_desc': "Registrer ansattes bevis og sertifikater med utløpsovervåking, push-varsler og maskinsperre basert på kompetanse.",
    'upsell.sharing_title': "Maskindeling",
    'upsell.sharing_desc': "Del maskindata med andre Agriware Ops-organisasjoner — ideelt for entreprenører og maskinsamarbeid.",
    'upsell.transfers_title': "Maskinoverføringer",
    'upsell.transfers_desc': "Overfør maskiner mellom Ops-brukere eller DMS-kontoer med full eierhistorikk og digital loggbok.",
    'upsell.carbon_title': "Klimarapportering",
    'upsell.carbon_desc': "Automatisk beregning av CO₂-utslipp basert på drivstofforbruk. Rapportering etter DEFRA-standarden for maskinparken.",
    'upsell.not_included': "Denne funksjonen inngår ikke i din nåværende plan.",
    'upsell.upgrade': "Oppgrader planen",
    'service.record_not_found': "Fant ikke oppføringen",
    'service.record_title_service': "Serviceoppføring",
    'service.record_title_repair': "Reparasjonsoppføring",
    'service.record_title_inspection': "Inspeksjonsoppføring",
    'service.record_suffix': "oppføring",
    'service.email_btn': "E-post",
    'service.email_coming_soon': "E-posteksport kommer snart",
    'service.sealed_by_workshop': "Låst av {name} og kan ikke endres",
    'service.the_workshop': "verkstedet",
    'service.sealed_permanent': "Denne oppføringen er permanent låst og kan ikke endres",
    'service.sealed_by': "Låst av",
    'service.at_suffix': "hos {name}",
    'service.job_ref': "arbeidsordre {ref}",
    'service.photos_video': "Bilder og video",
    'service.job_photo': "Jobbbilde",
    'service.files_copying': "Noen filer kopieres fortsatt.",
    'service.date_of_service': "Servicedato",
    'service.hours_at_service': "Timer ved service",
    'service.total_cost': "Total kostnad",
    'service.record_details': "Oppføringsdetaljer",
    'service.type': "Type",
    'service.performed_by': "Utført av",
    'service.performed_by_type': "Type utfører",
    'service.next_service_hours': "Timer til neste service",
    'service.next_service_date': "Dato for neste service",
    'service.notes': "Notater",
    'service.parts_used': "Brukte deler",
    'service.col_part': "Del",
    'service.col_qty': "Antall",
    'service.col_cost': "Kostnad",
    'service.parts_total': "Totalt deler",
    'service.cost_breakdown': "Kostnadsspesifikasjon",
    'service.labour_cost': "Arbeidskostnad",
    'service.parts_cost': "Delekostnad",
    'service.total': "Totalt",
    'service.audit_trail': "Sporingslogg",
    'service.record_created_by': "Oppføringen opprettet av",
    'service.record_sealed_by': "Oppføringen låst av",
    'service.type_service': "Service",
    'service.type_service_desc': "Planlagt rutineservice",
    'service.type_repair': "Reparasjon",
    'service.type_repair_desc': "Uplanlagt reparasjonsarbeid",
    'service.type_inspection': "Inspeksjon",
    'service.type_inspection_desc': "Sikkerhets- eller samsvarskontroll",
    'service.by_internal': "Internt",
    'service.by_dealer': "Forhandler",
    'service.by_external': "Ekstern leverandør",
    'service.err_description': "Angi en beskrivelse",
    'service.err_date': "Angi servicedato",
    'service.added_toast': "Serviceoppføring lagt til og låst",
    'service.err_save': "Kunne ikke lagre oppføringen — prøv igjen",
    'service.seal_note': "Oppføringen låses permanent når den lagres",
    'service.record_type': "Type oppføring",
    'service.description_placeholder': "Beskriv arbeidet som ble utført…",
    'service.performed_by_placeholder': "Navn eller firma",
    'service.additional_notes': "Tilleggsnotater",
    'service.notes_placeholder': "Eventuelle tilleggsnotater…",
    'service.add_part': "Legg til del",
    'service.part_name': "Navn på del",
    'service.cost_placeholder': "Kostnad £",
    'service.cost_next_service': "Kostnad og neste service",
    'service.labour_cost_field': "Arbeidskostnad (£)",
    'service.next_hours_placeholder': "f.eks. 1750",
    'service.seal_warning': "Når oppføringen er lagret, er den permanent låst og kan ikke redigeres. Kontroller at alle opplysninger er riktige før du lagrer.",
    'service.save_seal': "Lagre og lås oppføringen",
    'dashboard.there': "der",
    'dashboard.total_machines': "Maskiner totalt",
    'dashboard.blocked_machines': "Sperrede maskiner",
    'dashboard.open_incidents': "Åpne hendelser",
    'dashboard.open_defects': "Åpne feil",
    'dashboard.fuel_tanks': "Drivstofftanker",
    'common.of': "av",
    'dashboard.fleet': "Maskinpark",
    'common.view_all': "Vis alle",
    'dashboard.no_machines': "Ingen maskiner ennå",
    'dashboard.no_machines_msg': "Legg til din første maskin for å komme i gang",
    'dashboard.recent_incidents': "Siste hendelser",
    'dashboard.no_incidents_msg': "Ingen hendelser registrert",
    'dashboard.recent_defects': "Siste feil",
    'dashboard.no_defects': "Ingen feil",
    'dashboard.no_defects_msg': "Ingen feil rapportert",
    'dashboard.defect_reported': "Feil rapportert",
    'dashboard.group_overview': "Konsernoversikt",
    'dashboard.send_announcement': "Send melding",
    'dashboard.sites': "Anlegg",
    'dashboard.no_sites': "Ingen anlegg ennå",
    'dashboard.no_sites_msg': "Legg til ditt første anlegg i Innstillinger for å komme i gang",
    'dashboard.add_site': "Legg til anlegg",
    'dashboard.status_monitor': "Overvåk",
    'dashboard.status_all_good': "Alt i orden",
    'dashboard.derv': "Diesel",
    'dashboard.derv_level': "Dieselnivå",
    'qual.short_forklift': "Truck",
    'qual.short_sprayer': "Sprøyte",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Førerkort",
    'qual.short_firstaid': "Førstehjelp",
    'qual.short_chainsaw': "Motorsag",
    'qual.short_pesticide': "Plantevern",
    'qual.short_telehandler': "Teleskoptruck",
    'qual.short_atv': "ATV",
    'qual.short_other': "Annet",
    'qual.forklift': "Truckførerbevis",
    'qual.sprayer': "PA1/PA6 sprøytesertifikat",
    'qual.cscs': "CSCS-kort",
    'qual.driving': "Førerkort",
    'qual.firstaid': "Førstehjelpsbevis",
    'qual.chainsaw': "Motorsagbevis",
    'qual.pesticide': "Autorisasjon plantevernmidler",
    'qual.telehandler': "Teleskoptruckbevis",
    'qual.atv': "ATV-bevis",
    'qual.other': "Annet kompetansebevis",
    'staff.n_expired': "utløpt",
    'staff.n_expiring': "utløper snart",
    'staff.n_valid': "gyldige",
    'common.none': "Ingen",
    'staff.tab_members': "Medarbeidere",
    'staff.tab_qualifications': "Kompetansebevis",
    'staff.tab_shifts': "Skift",
    'staff.member_one': "medarbeider",
    'staff.member_many': "medarbeidere",
    'staff.alert_one': "kompetansevarsel",
    'staff.alert_many': "kompetansevarsler",
    'staff.invite': "Inviter ansatt",
    'staff.create_shift': "Opprett skift",
    'staff.search': "Søk på navn eller e-post…",
    'staff.none_found': "Fant ingen ansatte",
    'staff.adjust_search': "Prøv å justere søket",
    'staff.invite_first': "Inviter din første medarbeider",
    'staff.stat_total_quals': "Kompetansebevis totalt",
    'staff.stat_valid': "Gyldige",
    'staff.stat_expiring_30d': "Utløper (30 d)",
    'staff.stat_expiring': "Utløper",
    'staff.stat_expired': "Utløpt",
    'staff.qual_one': "kompetansebevis",
    'staff.qual_many': "kompetansebevis",
    'staff.expires': "Utløper",
    'staff.no_quals': "Ingen kompetansebevis registrert",
    'staff.no_quals_msg': "Legg til kompetansebevis fra hver medarbeiders profil",
    'staff.no_shifts': "Ingen skift ennå",
    'staff.no_shifts_msg': "Opprett ditt første skift for å se hvem som jobber",
    'staff.shift': "Skift",
    'staff.checked_in': "innsjekket",
    'staff.not_found': "Fant ikke medarbeideren",
    'staff.add_qualification': "Legg til kompetansebevis",
    'staff.expired_alert_one': "kompetansebevis er utløpt — denne operatøren har kanskje ikke lov til å bruke visse maskiner",
    'staff.expired_alert_many': "kompetansebevis er utløpt — denne operatøren har kanskje ikke lov til å bruke visse maskiner",
    'staff.expiring_alert_one': "kompetansebevis utløper innen 30 dager",
    'staff.expiring_alert_many': "kompetansebevis utløper innen 30 dager",
    'staff.tab_details': "Detaljer",
    'staff.contact': "Kontakt",
    'staff.account': "Konto",
    'staff.onboarding': "Onboarding",
    'staff.complete': "Fullført",
    'staff.job_title': "Stilling",
    'staff.joined': "Ansatt",
    'staff.invited_by': "Invitert av",
    'staff.quals_tickets': "Kompetansebevis og sertifikater",
    'staff.no_quals_profile_msg': "Legg til denne operatørens bevis og sertifikater",
    'staff.issued': "Utstedt",
    'staff.no_expiry': "Ingen utløpsdato",
    'staff.expires_today': "Utløper i dag",
    'staff.days_remaining_one': "dag igjen",
    'staff.days_remaining_many': "dager igjen",
    'staff.expired_days_ago_one': "Utløp for {n} dag siden",
    'staff.expired_days_ago_many': "Utløp for {n} dager siden",
    'staff.view_certificate': "Vis sertifikat",
    'staff.assigned_machines': "Tildelte maskiner",
    'staff.no_machines': "Ingen maskiner tildelt",
    'staff.no_machines_msg': "Denne operatøren har ingen tildelte maskiner",
    'staff.err_first_name': "Fornavn er påkrevd",
    'staff.err_last_name': "Etternavn er påkrevd",
    'staff.err_email': "Angi en gyldig e-postadresse",
    'staff.err_site': "Velg et anlegg",
    'staff.err_create_prefix': "Kunne ikke opprette kontoen:",
    'staff.err_timeout': "Tidsavbrudd under oppretting av kontoen. Oppdater siden og prøv igjen.",
    'staff.err_create': "Kunne ikke opprette kontoen — prøv igjen",
    'staff.copy_greeting': "Hei {name},",
    'staff.copy_body': "Kontoen din for Agriware Operations er opprettet.",
    'staff.copy_email': "E-post:",
    'staff.copy_temp_password': "Midlertidig passord:",
    'staff.copy_footer': "Du blir bedt om å endre passordet ved første pålogging.",
    'staff.copied_toast': "Påloggingsdetaljer kopiert til utklippstavlen",
    'staff.role_admin_desc': "Full tilgang til alle anlegg og innstillinger",
    'staff.role_manager_desc': "Administrerer ett anlegg, ansatte og maskiner",
    'staff.role_operator_desc': "Utfører daglige kontroller i mobilappen",
    'staff.add_member': "Legg til medarbeider",
    'staff.add_member_sub': "Kontoen opprettes umiddelbart. Du får påloggingsdetaljene som skal deles.",
    'staff.account_created': "Kontoen er opprettet",
    'staff.share_details_pre': "Del disse påloggingsdetaljene med",
    'staff.share_details_post': "Ved første pålogging blir de bedt om å endre passordet.",
    'staff.label_email_caps': "E-POST",
    'staff.label_temp_password_caps': "MIDLERTIDIG PASSORD",
    'staff.copy_login_details': "Kopier påloggingsdetaljer",
    'staff.add_another': "Legg til en til",
    'staff.back_to_staff': "Tilbake til ansatte",
    'staff.personal_details': "Personopplysninger",
    'staff.first_name': "Fornavn",
    'staff.last_name': "Etternavn",
    'staff.work_email': "Jobb-e-post",
    'staff.site_assignment': "Anleggstildeling",
    'staff.no_sites': "Ingen anlegg opprettet ennå — legg først til et anlegg i Innstillinger",
    'staff.creating_account': "Oppretter konto…",
    'staff.create_account': "Opprett konto",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Velg en type kompetansebevis",
    'qual.err_name': "Angi navnet på kompetansebeviset",
    'qual.err_issue_date': "Angi utstedelsesdato",
    'qual.err_expiry': "Angi utløpsdato eller merk «ingen utløpsdato»",
    'qual.added_toast': "Kompetansebevis lagt til",
    'qual.err_save': "Kunne ikke lagre kompetansebeviset — prøv igjen",
    'qual.back_staff_profile': "Medarbeiderprofil",
    'qual.subtitle': "Registrer et bevis, sertifikat eller tillatelse for denne operatøren",
    'qual.type_title': "Type kompetansebevis",
    'qual.name_label': "Navn på kompetansebevis",
    'qual.name_placeholder': "f.eks. NPTC ryddesagbevis",
    'qual.cert_details': "Sertifikatopplysninger",
    'qual.cert_number': "Sertifikatnummer",
    'common.optional_suffix': "— valgfritt",
    'qual.cert_number_placeholder': "f.eks. NPORS-123456",
    'qual.issuing_body': "Utstedende organ",
    'qual.issuing_body_placeholder': "f.eks. NPORS, LANTRA, CITB",
    'qual.issue_date': "Utstedelsesdato",
    'qual.expiry_date': "Utløpsdato",
    'qual.no_expiry_label': "Dette kompetansebeviset har ingen utløpsdato",
    'qual.cert_document': "Sertifikatdokument",
    'qual.upload_note': "Last opp et bilde eller en skanning av sertifikatet. Det lagres privat og deles aldri.",
    'common.remove': "Fjern",
    'qual.click_upload': "Klikk for å laste opp sertifikatet",
    'qual.file_types': "JPG, PNG eller PDF",
    'common.saving': "Lagrer…",
    'qual.save': "Lagre kompetansebevis",
    'defects.title': "Feil",
    'defects.n_open': "åpne",
    'defects.n_critical': "kritiske",
    'defects.stat_total': "Feil totalt",
    'defects.status_open': "Åpen",
    'defects.status_in_progress': "Pågår",
    'defects.status_resolved': "Utbedret",
    'defects.all_severities': "Alle alvorlighetsgrader",
    'defects.sev_minor': "Mindre",
    'defects.sev_moderate': "Moderat",
    'defects.sev_major': "Alvorlig",
    'defects.sev_critical': "Kritisk",
    'defects.search': "Søk etter feil…",
    'common.clear': "Tøm",
    'defects.col_description': "Beskrivelse",
    'defects.reported_by': "Rapportert av",
    'defects.col_severity': "Alvorlighetsgrad",
    'defects.no_description': "Ingen beskrivelse",
    'defects.none_found': "Fant ingen feil",
    'defects.none_reported': "Ingen feil er rapportert",
    'defects.acknowledged_toast': "Feilen er kvittert",
    'defects.acknowledge_failed': "Kunne ikke kvittere feilen",
    'defects.resolved_released': "Feilen utbedret — maskinen frigitt",
    'defects.resolved_toast': "Feilen er utbedret",
    'defects.resolve_failed': "Kunne ikke utbedre feilen",
    'defects.not_found': "Fant ikke feilen",
    'defects.report_title': "Feilrapport",
    'defects.acknowledge': "Kvitter",
    'defects.raise_job': "Opprett arbeidsordre",
    'defects.resolve': "Utbedre",
    'defects.blocking_banner': "Maskinen sperret — en leder må registrere en skriftlig frigivelse før den tas i bruk igjen",
    'defects.details_title': "Feildetaljer",
    'defects.no_description_provided': "Ingen beskrivelse oppgitt",
    'defects.reported_at': "Rapportert",
    'defects.location': "Sted",
    'defects.photos': "Bilder",
    'defects.acknowledgement': "Kvittering",
    'defects.acknowledged_by': "Kvittert av",
    'defects.resolved_by': "Utbedret av",
    'defects.return_to_service': "Driftsetting",
    'defects.revised': "Revidert",
    'defects.revised_by_suffix': "av {name}",
    'defects.view_machine_profile': "Vis maskinprofil",
    'defects.resolve_and_release': "Utbedre og driftsett",
    'defects.resolve_defect': "Utbedre feilen",
    'defects.release_machine': "Frigi maskinen",
    'defects.mark_resolved': "Merk som utbedret",
    'defects.release_warning': "Denne maskinen er sperret. Din skriftlige frigivelse registreres med navn og rolle, og vises på maskinpasset.",
    'defects.resolution_details': "Opplysninger om utbedringen",
    'defects.resolution_placeholder': "Beskriv hvordan feilen ble utbedret…",
    'defects.narrative_placeholder': "Hva som ble funnet, hva som ble gjort, og hvordan maskinen ble kontrollert før frigivelse. Oppgi arbeidsordrenummer og testdetaljer der det er relevant.",
    'defects.chars_needed_one': "tegn til kreves",
    'defects.chars_needed_many': "tegn til kreves",
    'defects.characters': "tegn",
    'defects.permanent_note': "Dette registreres permanent på feilrapporten.",
    'machines.tab_overview': "Oversikt",
    'machines.tab_history': "Historikk",
    'machines.tab_documents': "Dokumenter",
    'machines.tab_operators': "Operatører",
    'machines.tab_sharing': "Deling",
    'machines.tab_incidents': "Hendelser",
    'machines.pdf_only': "Kun PDF-filer godtas.",
    'machines.replace_confirm': "Erstatte eksisterende dokument ({name})? Den gamle filen slettes.",
    'machines.delete_doc_confirm': "Slette dette dokumentet? Dette kan ikke angres.",
    'machines.uploaded': "Lastet opp",
    'machines.no_file_yet': "Ingen fil ennå",
    'machines.uploading': "Laster opp…",
    'machines.view_document': "Vis dokument",
    'common.replace': "Erstatt",
    'common.delete': "Slett",
    'common.upload': "Last opp",
    'machines.doc_type_manual': "Manual",
    'machines.doc_type_private': "Privat",
    'machines.doc_operators_manual': "Instruksjonsbok",
    'machines.doc_workshop_manual': "Verkstedhåndbok",
    'machines.untitled_document': "Dokument uten navn",
    'machines.add_document': "Legg til dokument",
    'machines.documents_intro': "Instruksjonsbok og verkstedhåndbok har egne plasser — det hjelper oss å identifisere riktig dokument ved deling med Agriware-biblioteket. Andre private dokumenter er kun synlige for din organisasjon.",
    'machines.returned_to_service': "Maskinen er satt i drift igjen",
    'machines.not_blocked': "Denne maskinen er ikke sperret",
    'machines.resolve_defect_first': "Utbedre den åpne feilen for å sette maskinen i drift igjen",
    'machines.return_failed': "Kunne ikke sette maskinen i drift igjen",
    'machines.machine_not_found': "Fant ikke maskinen",
    'common.unknown': "Ukjent",
    'machines.unblock': "Opphev sperre",
    'service.add_record': "Legg til serviceoppføring",
    'machines.serial_number': "Serienummer",
    'machines.year': "Årsmodell",
    'machines.blocked_banner': "Maskinen sperret — skal ikke brukes",
    'machines.current_hours': "Nåværende timer",
    'machines.next_service': "Neste service",
    'machines.service_records': "Serviceoppføringer",
    'machines.service_progress': "Serviceintervall",
    'machines.cost_over_time': "Kostnad over tid",
    'machines.cost_over_time_sub': "Service, reparasjon og akkumulert eierkostnad",
    'machines.cost_empty': "Kostnadsdata vises etter hvert som serviceoppføringer legges til.",
    'machines.series_service': "Service",
    'machines.series_repair': "Reparasjon",
    'machines.series_cumulative': "Akkumulert",
    'machines.details_title': "Maskindetaljer",
    'machines.make': "Merke",
    'machines.model': "Modell",
    'machines.category': "Kategori",
    'machines.assigned_to': "Tildelt",
    'machines.pool_machine': "Poolmaskin",
    'machines.unassigned': "Ikke tildelt",
    'machines.purchase_value': "Kjøp og verdi",
    'machines.purchase_date': "Kjøpsdato",
    'machines.purchase_price': "Kjøpspris",
    'machines.depreciation_rate': "Avskrivningssats",
    'machines.per_year': "per år",
    'machines.estimated_life': "Estimert levetid",
    'common.unit_years': "år",
    'machines.cost_tracking': "Kostnadsoppfølging",
    'machines.total_service_cost': "Total servicekostnad",
    'machines.total_repair_cost': "Total reparasjonskostnad",
    'machines.total_fuel_cost': "Total drivstoffkostnad",
    'machines.total_cost_ownership': "Total eierkostnad",
    'machines.service_history': "Service- og reparasjonshistorikk",
    'service.add_record_short': "Legg til oppføring",
    'service.none_yet': "Ingen serviceoppføringer ennå",
    'service.none_yet_msg': "Legg til din første service- eller reparasjonsoppføring",
    'service.sealed': "Låst",
    'service.workshop': "Verksted",
    'common.photo_one': "bilde",
    'common.photo_many': "bilder",
    'machines.assigned_operators': "Tildelte operatører",
    'machines.no_operator': "Ingen operatør tildelt",
    'machines.no_operator_msg': "Denne maskinen har ingen tildelt operatør",
    'machines.pool_machine_msg': "Dette er en poolmaskin — tilgjengelig for alle operatører",
    'machines.ownership_sharing': "Eierskap og deling",
    'machines.share_machine': "Del maskin",
    'machines.current_owner': "Nåværende eier",
    'machines.your_organisation': "Din organisasjon",
    'machines.shared_with': "Delt med",
    'machines.not_shared': "Ikke delt med andre organisasjoner",
    'machines.incident_history': "Hendelseshistorikk",
    'incidents.none': "Ingen hendelser",
    'incidents.none_msg': "Ingen hendelser registrert for denne maskinen",
    'incidents.impact_detected': "Sammenstøt registrert",
    'incidents.manual_sos': "Manuelt SOS",
    'incidents.man_down': "Mann-nede-alarm",
    'machines.unblock_title': "Sett maskinen i drift igjen",
    'machines.confirm_unblock': "Bekreft oppheving",
    'machines.unblock_warning': "Din skriftlige erklæring registreres på kontrollen som stanset maskinen, og vises på maskinpasset. Er maskinen sperret av en åpen feil, må du utbedre feilen i stedet.",
    'machines.blocked_reason': "Årsak til sperring",
    'machines.unblock_statement': "Erklæring om driftsetting",
    'machines.unblock_placeholder': "Hva som ble funnet, hva som ble gjort, og hvordan maskinen ble kontrollert før driftsetting.",
    'checks.history_title': "Kontrollhistorikk",
    'checks.stat_total': "Kontroller totalt",
    'checks.stat_passed': "Godkjente",
    'checks.stat_failed': "Ikke godkjente",
    'checks.n_passed': "godkjente",
    'checks.n_failed': "ikke godkjente",
    'common.clear_filters': "Tøm filtre",
    'checks.not_found': "Fant ikke kontrollen",
    'common.export_pdf': "Eksporter PDF",
    'common.pdf_coming_soon': "PDF-eksport kommer snart",
    'checks.item_failed_one': "punkt ikke godkjent",
    'checks.item_failed_many': "punkter ikke godkjent",
    'checks.auto_blocked': "Maskinen ble automatisk sperret ved innsending",
    'checks.sealed_record': "Låst oppføring",
    'checks.submitted_by': "Sendt inn av",
    'checks.submitted_at': "Sendt inn",
    'checks.hours_at_check': "Timer ved kontroll",
    'checks.stat_total_items': "Punkter totalt",
    'checks.stat_mileage': "Kilometerstand",
    'checks.details_title': "Kontrolldetaljer",
    'checks.failed_items': "Ikke godkjente punkter",
    'checks.no_items_recorded': "Ingen kontrollpunkter registrert",
    'checks.alt_defect_photo': "Bilde av feil",
    'checks.alt_check_photo': "Kontrollbilde",
    'common.unit_hrs': "timer",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Maler",
    'checks.tab_history': "Historikk",
    'checks.create_template': "Opprett mal",
    'checks.scope_specific': "Bestemt maskin",
    'checks.scope_all': "Alle maskiner",
    'checks.categories': "kategorier",
    'checks.items': "punkter",
    'checks.title': "Kontroller",
    'checks.template_one': "mal",
    'checks.template_many': "maler",
    'checks.record_one': "oppføring",
    'checks.record_many': "oppføringer",
    'checks.no_templates': "Ingen kontrollmaler ennå",
    'checks.no_templates_msg': "Lag maler for å angi hva operatører må kontrollere før bruk",
    'checks.search': "Søk på maskin eller operatør…",
    'checks.all_results': "Alle resultater",
    'checks.pass': "Godkjent",
    'checks.fail': "Ikke godkjent",
    'checks.none_found': "Ingen kontroller funnet",
    'checks.adjust_filters': "Prøv å justere filtrene",
    'checks.none_submitted': "Ingen kontroller er sendt inn ennå",
    'checks.col_operator': "Operatør",
    'checks.col_datetime': "Dato og tid",
    'checks.col_result': "Resultat",
    'machines.add': "Legg til maskin",
    'machines.col_machine': "Maskin",
    'machines.col_serial': "Serienr / Reg.nr",
    'machines.col_site': "Anlegg",
    'machines.col_hours': "Timer",
    'machines.col_status': "Status",
    'machines.title': "Maskiner",
    'machines.count_one': "maskin",
    'machines.count_many': "maskiner",
    'machines.blocked': "sperret",
    'machines.search': "Søk på merke, modell, serienummer eller reg.nr…",
    'machines.all_sites': "Alle anlegg",
    'machines.all_statuses': "Alle statuser",
    'machines.available': "Tilgjengelig",
    'machines.blocked_one': "Sperret",
    'machines.none_found': "Ingen maskiner funnet",
    'machines.view': "Vis",
    'cat.all': "Alle kategorier",
    'cat.agricultural': "Landbruk",
    'cat.groundcare': "Grøntanlegg",
    'cat.plant': "Anleggsmaskiner",
    'cat.vehicle': "Kjøretøy",
    'cat.atv': "ATV",
    'nav.dashboard': "Oversikt",
    'nav.staff': "Ansatte",
    'nav.checks': "Kontroller",
    'nav.safety': "Sikkerhet",
    'nav.operations': "Drift",
    'nav.settings': "Innstillinger",
    'nav.billing': "Fakturering",
    'nav.sign_out': "Logg ut",
    'role.admin': "Administrator",
    'role.manager': "Leder",
    'role.operator': "Operatør",
    'app.name': 'AgriWare Drift',
    'app.tagline': 'Administrasjon',
    'nav.home': 'Hjem',
    'nav.machines': 'Maskiner',
    'nav.profile': 'Profil',
    'common.back': 'Tilbake',
    'common.cancel': 'Avbryt',
    'common.save': 'Lagre',
    'common.edit': 'Rediger',
    'common.done': 'Ferdig',
    'common.yes': 'Ja',
    'common.no': 'Nei',
    'common.ok': 'OK',
    'common.error': 'Feil',
    'common.loading': 'Laster...',
    'common.retry': 'Prøv igjen',
    'common.search': 'Søk',
    'common.submit': 'Send inn',
    'common.confirm': 'Bekreft',
    'common.close': 'Lukk',
    'common.pass': 'Godkjent',
    'common.fail': 'Ikke godkjent',
    'common.total': 'totalt',
    'common.today': 'I dag',
    'common.yesterday': 'I går',
    'common.online_only': 'Kun online',
    'common.last_synced': 'Sist synkronisert',
    'common.back_to_app': 'Tilbake til app',
    'common.gps_shared': 'GPS delt',
    'common.yes_via_saas': 'Ja — via SaaS',
    'common.not_called': 'Ikke ringt',
    'login.sign_in': 'Logg inn',
    'login.email': 'E-postadresse',
    'login.password': 'Passord',
    'login.forgot_password': 'Glemt passord?',
    'login.no_account': 'Ingen konto?',
    'login.request_access': 'Be om tilgang',
    'login.account_created_by_org': 'Kontoen din er opprettet av organisasjonen din.',
    'login.email_placeholder': 'deg@organisasjon.no',
    'login.password_placeholder': 'Skriv inn passordet ditt',
    'login.error_empty': 'Skriv inn e-post og passord.',
    'login.error_invalid': 'Ugyldig e-post eller passord. Prøv igjen.',
    'dashboard.greeting_morning': 'God morgen,',
    'dashboard.greeting_afternoon': 'God ettermiddag,',
    'dashboard.greeting_evening': 'God kveld,',
    'dashboard.todays_tasks': 'Dagens oppgaver',
    'dashboard.completed': 'Fullførte',
    'dashboard.overdue': 'Forsinkede',
    'dashboard.in_progress': 'Pågående',
    'dashboard.upcoming': 'Kommende',
    'dashboard.pending': 'Ventende',
    'machines.search_placeholder': 'Søk maskiner...',
    'machines.favourites': 'Favoritter',
    'machines.all_machines': 'Alle maskiner',
    'machines.operational': 'Driftsklar',
    'machines.needs_attention': 'Krever oppmerksomhet',
    'machines.fault': 'Feil',
    'machines.unsafe_to_operate': 'Usikker å betjene',
    'machines.registration': 'Registreringsnummer',
    'machines.assigned_operator': 'Tildelt operatør',
    'machines.engine_hours': 'Motortimer',
    'machines.documents': 'Dokumenter',
    'machines.log_fault': 'Rapporter feil',
    'machines.operator_manual': 'Brukermanual',
    'machines.service_record': 'Servicebok',
    'machines.insurance': 'Forsikringsbevis',
    'machines.mot': 'EU-kontroll',
    'daily_check.title': 'Daglig sjekk',
    'daily_check.start': 'Start sjekk',
    'daily_check.required': 'Daglig sjekk påkrevd',
    'daily_check.required_msg': 'Må fullføres før bruk av denne maskinen.',
    'daily_check.complete': 'Sjekk fullført',
    'daily_check.complete_msg': 'Fullført av',
    'daily_check.submit': 'Send inn sjekk',
    'daily_check.items_remaining': 'punkter gjenstår',
    'daily_check.reward_title': 'Takk!',
    'daily_check.reward_subtitle': 'Din daglige sjekk er registrert.\nÆrlige sjekker holder alle trygge.',
    'daily_check.back_to_machine': 'Tilbake til maskin',
    'daily_check.day_streak': 'Dagers rekke',
    'daily_check.completion_rate': 'Fullføringsgrad',
    'daily_check.cat_lights': 'Belysning og sikt',
    'daily_check.cat_fluids': 'Væsker',
    'daily_check.cat_tyres': 'Dekk og hjul',
    'daily_check.cat_safety': 'Sikkerhet',
    'daily_check.cat_controls': 'Betjening',
    'daily_check.cat_body': 'Karosseri og tilbehør',
    'daily_check.lights_working': 'Alle lys fungerer',
    'daily_check.mirrors': 'Speil rene og justerte',
    'daily_check.windscreen': 'Frontrute ren og uskadet',
    'daily_check.engine_oil': 'Motoroljenivå',
    'daily_check.coolant': 'Kjølevæskenivå',
    'daily_check.hydraulic': 'Hydraulikkvæskenivå',
    'daily_check.fuel': 'Drivstoffnivå tilstrekkelig',
    'daily_check.tyre_pressure': 'Dekktrykk korrekt',
    'daily_check.tyre_damage': 'Ingen synlige dekkskader',
    'daily_check.wheel_nuts': 'Hjulmuttere stramme',
    'daily_check.fire_extinguisher': 'Brannslukker til stede',
    'daily_check.first_aid': 'Førstehjelpskit til stede',
    'daily_check.rops': 'ROPS-struktur uskadet',
    'daily_check.seatbelt': 'Sikkerhetsbelte fungerer',
    'daily_check.brakes': 'Bremser fungerer',
    'daily_check.steering': 'Styring reagerer',
    'daily_check.horn': 'Horn fungerer',
    'daily_check.body_damage': 'Ingen synlige karosseri skader',
    'daily_check.attachments': 'Tilbehør sikret',
    'daily_check.pto_guard': 'PTO-vern på plass',
    'log_fault.title': 'Rapporter feil',
    'log_fault.description': 'Beskrivelse',
    'log_fault.description_placeholder': 'Beskriv feilen...',
    'log_fault.photos': 'Bilder',
    'log_fault.add_photo': 'Legg til bilde',
    'log_fault.submit': 'Send inn feilrapport',
    'log_fault.success': 'Feil rapportert',
    'emergency.title': 'Nødsituasjon',
    'emergency.what_emergency': 'Hva er nødsituasjonen?',
    'emergency.select_type': 'Velg type nødsituasjon.\nPassende kontakter ringes umiddelbart.',
    'emergency.vibrating': 'Vibrerer',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Medisinsk nødsituasjon',
    'emergency.medical_sub': 'Skade, sykdom eller bevisstløs person på stedet',
    'emergency.calls_999': 'Ringer 112 umiddelbart',
    'emergency.electrical': 'Elektrisk nødsituasjon',
    'emergency.electrical_sub': 'Kontakt med strømledning — bli i kabinen',
    'emergency.calls_105': 'Ringer 110 umiddelbart',
    'emergency.no_signal': 'Nødnumre lagret på enheten — tilgjengelige uten signal',
    'emergency.gps_auto': 'GPS-posisjon deles automatisk',
    'emergency.999_called': '112 ringt',
    'emergency.105_called': 'Nødlinje ringt',
    'emergency.services_contacted': 'Redningstjenester er kontaktet.\nDin leder er også informert.',
    'emergency.power_contacted': 'Den elektriske nødlinjen er kontaktet.\nDin leder er også informert.',
    'emergency.emergency_type': 'Type nødsituasjon',
    'emergency.number_called': 'Ringt nummer',
    'emergency.location': 'Sted',
    'emergency.admin_notified': 'Admin informert',
    'emergency.stay_in_cab': 'Bli i kabinen',
    'emergency.stay_in_cab_msg': 'Forlat ikke kjøretøyet. Vent til myndighetene bekrefter at linjen er trygg. Hold vinduene lukket.',
    'emergency.medical_type': 'Medisinsk',
    'emergency.electrical_type': 'Elektrisk',
    'crash.are_you_okay': 'Er du okay?',
    'crash.impact_detected': 'En mulig kollisjon er oppdaget.\nSvar venligst, eller det vil bli ringt etter hjelp.',
    'crash.im_okay': 'Jeg er okay',
    'crash.dismiss_alert': 'Avvis alarm — ingen handling',
    'crash.i_need_help': 'Jeg trenger hjelp',
    'crash.notify_supervisor': 'Informer leder med GPS-posisjon',
    'crash.call_999': 'Ring 113',
    'crash.call_emergency': 'Ring redningstjenester umiddelbart',
    'crash.glad_okay': 'Glad for at du er okay',
    'crash.alert_dismissed': 'Alarm avvist. Ingen melding sendt.',
    'crash.help_on_way': 'Hjelpen er på vei',
    'crash.supervisor_notified': 'Din leder er informert med din GPS-posisjon.',
    'crash.auto_dialled': '113 ringt automatisk',
    'crash.no_response': 'Ingen svar. Redningstjenester ringt automatisk. Talemelding sendes.',
    'crash.broadcasting': 'Sender melding',
    'crash.repeating': 'Gjentar hvert 15. sekund',
    'crash.admin_notified': 'Admin informert',
    'crash.emergency_services': 'Redningstjenester',
    'profile.title': 'Profil',
    'profile.personal_info': 'Personlig informasjon',
    'profile.full_name': 'Fullt navn',
    'profile.email': 'E-post',
    'profile.phone': 'Telefon',
    'profile.role': 'Rolle',
    'profile.organisation': 'Organisasjon',
    'profile.emergency_contact': 'Nødkontakt',
    'profile.emergency_contact_note': 'Din leder kontaktes i en nødsituasjon',
    'profile.contact_name': 'Kontaktnavn',
    'profile.contact_phone': 'Kontakttelefon',
    'profile.notifications': 'Varsler',
    'profile.task_reminders': 'Oppgavepåminnelser',
    'profile.overdue_alerts': 'Forsinkelsesadvarsler',
    'profile.crash_detection': 'Kollisjonsregistrering',
    'profile.account_security': 'Konto og sikkerhet',
    'profile.change_password': 'Endre passord',
    'profile.two_factor': 'To-faktor-autentisering',
    'profile.login_activity': 'Innloggingsaktivitet',
    'profile.app_settings': 'App-innstillinger',
    'profile.theme': 'Tema',
    'profile.language': 'Språk',
    'profile.sign_out': 'Logg ut',
    'profile.sign_out_confirm': 'Logg ut',
    'profile.sign_out_msg': 'Er du sikker på at du vil logge ut?',
    'profile.field_staff': 'Feltpersonell',
    'theme.light': 'Lyst',
    'theme.dark': 'Mørkt',
    'theme.system': 'Systemstandard',
  },

  'fi': {
    'verify.err_reference_required': "Asiakirjaviite vaaditaan.",
    'verify.err_rate_limited': "Liian monta yritystä. Yritä hetken kuluttua uudelleen.",
    'verify.err_not_found': "Tällä viitteellä ei ole myönnetty passia.",
    'verify.err_code_mismatch': "Organisaatiokoodi ja viite eivät täsmää.",
    'verify.err_unknown_section': "Tuntematon osio.",
    'verify.err_read_failed': "Tietuetta ei voitu lukea.",
    'verify.intro': "Syötä asiakirjaan painettu viite vahvistaaksesi, että sen on myöntänyt Agriware Operations. Nähdäksesi koneen koko tietueen lisää myöntäneen organisaation koodi — molemmat on painettu passiin.",
    'verify.orgcode_optional': "— valinnainen, koko tietueen näkemiseen",
    'verify.title': "Vahvista koneen passi",
    'verify.reference_label': "Asiakirjan viite",
    'verify.orgcode_label': "Organisaation koodi",
    'verify.checking': "Tarkistetaan…",
    'verify.submit': "Vahvista",
    'verify.not_verified': "Ei vahvistettu",
    'verify.withdrawn': "Peruutettu",
    'verify.genuine': "Aito asiakirja",
    'verify.genuine_superseded': "Aito, mutta korvattu",
    'verify.superseded_note': "Tälle koneelle on myönnetty uudempi passi",
    'verify.fingerprint': "Asiakirjan tiiviste (SHA-256)",
    'verify.no_result': "Ei tuloksia.",
    'verify.err_not_verified': "Asiakirjaa ei voitu vahvistaa.",
    'verify.err_unreachable': "Vahvistuspalveluun ei saatu yhteyttä. Yritä uudelleen.",
    'verify.row_reference': "Viite",
    'verify.row_issued_by': "Myöntäjä",
    'verify.row_issued_on': "Myönnetty",
    'verify.not_recorded': "Ei kirjattu",
    'verify.row_make_model': "Merkki ja malli",
    'verify.row_status': "Nykyinen tila",
    'verify.blocked_from_use': "Käyttö estetty",
    'verify.in_service': "Käytössä",
    'verify.no_open_defects': "Tälle koneelle ei ole kirjattu avoimia vikoja.",
    'verify.defect_history': "Vikahistoria",
    'verify.no_resolved_defects': "Tälle koneelle ei ole kirjattu korjattuja vikoja.",
    'verify.inspection_record': "Tarkastustiedot",
    'verify.check_log': "Tarkastusloki",
    'verify.no_checks': "Tälle koneelle ei ole kirjattu tarkastuksia.",
    'verify.service_history': "Huoltohistoria",
    'verify.no_services': "Tälle koneelle ei ole huoltokirjauksia.",
    'verify.checks_recorded': "Kirjatut tarkastukset",
    'verify.pass_rate': "Hyväksymisaste",
    'verify.defects_raised': "Ilmoitetut viat",
    'verify.most_recent_check': "Viimeisin tarkastus",
    'verify.show_more': "Näytä lisää",
    'verify.showing_of': "Näytetään {shown}/{total}",
    'verify.details': "Tiedot",
    'verify.hide': "Piilota",
    'verify.all_passed': "Kaikki hyväksytty",
    'verify.n_failed': "{n} hylättyä",
    'verify.blocked_the_machine': "esti koneen",
    'verify.blocking': "Estävä",
    'verify.raised': "Ilmoitettu",
    'verify.resolved': "Korjattu",
    'verify.revised_after_issue': "muutettu myöntämisen jälkeen",
    'verify.next_service': "Seuraava huolto",
    'verify.parts': "Osat",
    'verify.external': "ulkoinen",
    'verify.sealed': "lukittu",
    'verify.language': "Kieli",
    'emergency.tel_number': "112",
    'emergency.no_movement': "Liikettä ei havaittu",
    'emergency.triggered_generic': "Hätätilanne laukaistu",
    'emergency.community_badge': "Lähialueen hälytys — hätätilanne lähellä",
    'emergency.panel_responders': "Vastanneet",
    'emergency.machine_involved': "Osallinen kone",
    'emergency.impact_label': "Törmäys",
    'emergency.ago': "sitten",
    'emergency.location_unavailable': "Sijainti ei saatavilla",
    'emergency.open_in_maps': "Avaa Google Mapsissa",
    'emergency.im_responding': "Olen matkalla",
    'emergency.confirming': "Vahvistetaan…",
    'emergency.mark_resolved': "Merkitse hoidetuksi",
    'emergency.resolving': "Suljetaan…",
    'emergency.called_automatically_at': "112 soitettu automaattisesti klo {time}",
    'emergency.state_alert': "HÄTÄHÄLYTYS",
    'emergency.state_awaiting': "ODOTETAAN VASTAUSTA",
    'emergency.state_needs_help': "KULJETTAJA TARVITSEE APUA",
    'emergency.state_no_response': "EI VASTAUSTA KULJETTAJALTA",
    'emergency.seconds_to_respond': "{n} s aikaa kuljettajan vastata",
    'billing.over_limit_row': "Tilaukseesi sisältyvien koneiden lisäksi",
    'billing.over_limit_full': "Tämä kone ei sisälly tilaukseesi. Lisää se tilaukseesi nähdäksesi sen tiedot.",
    'nav.reports': "Raportit",
    'site.not_found': "Toimipaikkaa ei löytynyt",
    'site.details': "Toimipaikan tiedot",
    'site.edit': "Muokkaa toimipaikkaa",
    'site.updated': "Toimipaikka päivitetty",
    'site.err_update': "Toimipaikan päivitys epäonnistui",
    'site.no_address': "Osoitetta ei ole kirjattu",
    'site.no_machines': "Tässä toimipaikassa ei ole koneita",
    'site.no_staff': "Tähän toimipaikkaan ei ole osoitettu ketään",
    'site.no_defects': "Tässä toimipaikassa ei ole avoimia vikoja",
    'checks.new_template': "Uusi malli",
    'set.language': "Kieli",
    'set.language_hint': "Koskee kaikkia organisaatiossasi",
    'set.your_organisation': "Organisaatiosi",
    'set.group_organisation': "Organisaatio",
    'set.group_safety': "Turvallisuus ja vaatimustenmukaisuus",
    'set.group_system': "Järjestelmä",
    'set.reports': "Raportit",
    'set.org_details': "Organisaation tiedot",
    'set.org_details_hint': "Nimi, osoite, y-tunnus, ilme",
    'set.sites_hint': "Pihat, varikot ja koneiden sijaintipaikat",
    'set.roles': "Roolit ja oikeudet",
    'set.roles_hint': "Mitä kukin rooli näkee ja voi tehdä",
    'set.billing_hint': "Tilaus ja maksutapa",
    'set.coshh_hint': "Varastoidut aineet ja niiden arvioinnit",
    'set.risk_hint': "Arvioinnit ja katselmukset",
    'set.reports_hint': "Konekannan kunto, vaatimustenmukaisuus, hiilipäästöt, kustannukset ja vakuutusaineistot",
    'set.integrations': "Integraatiot",
    'set.integrations_hint': "Telematiikka, jälleenmyyjäjärjestelmät ja Almanac",
    'set.notifications_hint': "Mitä lähetetään ja kenelle",
    'set.audit_log': "Tarkastusloki",
    'set.audit_log_hint': "Kuka muutti mitä ja milloin",
    'set.data': "Tiedot",
    'set.data_hint': "Vienti ja säilytys",
    'set.data_retention': "Tiedot ja säilytys",
    'set.export_title': "Vie tietosi",
    'set.export_desc': "Vie täydellinen kopio organisaatiosi tiedoista: koneiden tiedot, huoltohistoria, tarkastukset, henkilöstöprofiilit ja pätevyydet.",
    'set.export_coming_soon': "Tietojen vienti tulossa pian",
    'set.export_btn': "Vie kaikki tiedot",
    'set.retention_title': "Tietojen säilytys",
    'set.retention_desc': "Tietojasi säilytetään tilauksen voimassaolon ajan ja 12 kuukautta sen päättymisen jälkeen. Huoltokirjaukset ja lukitut työkortit säilytetään toistaiseksi, koska niitä voidaan tarvita oikeudellisiin ja vakuutustarkoituksiin.",
    'set.danger_zone': "Vaaravyöhyke",
    'set.danger_desc': "Organisaation poistaminen poistaa kaikki tiedot pysyvästi lukuun ottamatta lukittuja konekirjauksia, joita vaatimustenmukaisuus edellyttää. Toimintoa ei voi perua.",
    'set.delete_org': "Poista organisaatio",
    'set.delete_org_toast': "Ota yhteyttä tukeen organisaation poistamiseksi",
    'set.audit_log_subtitle': "Täydellinen kirjaus kaikista organisaatiosi toimista",
    'set.audit_search': "Hae tarkastuslokista…",
    'set.col_action': "Toimi",
    'set.no_audit': "Ei tarkastusmerkintöjä",
    'set.audit_empty_msg': "Toimet näkyvät tässä sitä mukaa kun niitä tapahtuu",
    'set.notif_title': "Ilmoitusasetukset",
    'set.notif_desc': "Määritä, mitkä tapahtumat lähettävät push-ilmoituksia organisaatiosi esihenkilöille ja pääkäyttäjille.",
    'set.notif_saved': "Ilmoitusasetukset tallennettu",
    'set.save_preferences': "Tallenna asetukset",
    'set.notif_check_failed': "Tarkastus hylätty",
    'set.notif_check_failed_desc': "Kun kuljettaja lähettää hylätyn tarkastuksen",
    'set.notif_machine_blocked': "Kone estetty",
    'set.notif_machine_blocked_desc': "Kun kone estetään automaattisesti hylätyn tarkastuksen jälkeen",
    'set.notif_defect': "Vika ilmoitettu",
    'set.notif_defect_desc': "Kun kuljettaja ilmoittaa viasta",
    'set.notif_near_miss': "Läheltä piti -tilanne ilmoitettu",
    'set.notif_near_miss_desc': "Kun läheltä piti -tilanne lähetetään",
    'set.notif_qual_expiring': "Pätevyys vanhenee (30 pv)",
    'set.notif_qual_expiring_desc': "Kun pätevyys vanhenee 30 päivän kuluessa",
    'set.notif_qual_expired': "Pätevyys vanhentunut",
    'set.notif_qual_expired_desc': "Kun pätevyys on vanhentunut",
    'set.notif_service_due': "Huolto erääntyy",
    'set.notif_service_due_desc': "Kun kone lähestyy huoltoväliään",
    'set.notif_fuel_low': "Polttoainesäiliö vähissä",
    'set.notif_fuel_low_desc': "Kun dieselsäiliö laskee raja-arvon alle",
    'set.notif_emergency': "Hätähälytys",
    'set.notif_emergency_desc': "Aina päällä — ei voi poistaa käytöstä",
    'set.notif_announcement': "Tiedotteet",
    'set.notif_announcement_desc': "Kun johto lähettää tiedotteen",
    'set.no_sites_msg': "Lisää ensimmäinen tila tai toimipaikka",
    'set.err_site_name': "Toimipaikan nimi vaaditaan",
    'set.site_added': "Toimipaikka lisätty",
    'set.err_site_add': "Toimipaikan lisääminen epäonnistui",
    'set.site_name': "Toimipaikan nimi",
    'set.site_name_placeholder': "esim. Päätila",
    'set.address': "Osoite",
    'set.address_placeholder': "esim. Päätila, Tilantie 1, 00100",
    'set.roles_title': "Roolit ja oikeudet",
    'set.role_admin_full': "Täysi pääsy kaikkiin toimipaikkoihin, koneisiin, henkilöstöön, asetuksiin ja laskutukseen. Voi lähettää tiedotteita ja hallita kaikkia tietoja.",
    'set.role_manager_full': "Pääsy rajattu toimipaikkaan. Hallinnoi oman toimipaikkansa koneita ja henkilöstöä. Ei pääsyä laskutukseen tai organisaation asetuksiin.",
    'set.role_operator_full': "Pääsy vain mobiilisovelluksella. Tekee päivittäiset tarkastukset, kirjaa tankkaukset ja voi ilmoittaa vioista ja läheltä piti -tilanteista.",
    'set.perm_all_machines': "Kaikki koneet kaikissa toimipaikoissa",
    'set.perm_all_staff': "Koko henkilöstön hallinta",
    'set.perm_all_settings': "Kaikki asetukset",
    'set.perm_announcements': "Tiedotteiden lähetys",
    'set.perm_emergencies': "Hätätilanteiden käsittely",
    'set.perm_site_machines': "Oman toimipaikan koneet",
    'set.perm_site_staff': "Oman toimipaikan henkilöstö",
    'set.perm_checks_defects': "Tarkastukset ja viat",
    'set.perm_shifts': "Vuorojen hallinta",
    'set.perm_daily_checks_app': "Päivittäiset tarkastukset (sovellus)",
    'set.perm_fuel_fills_app': "Tankkaukset (sovellus)",
    'set.perm_defect_app': "Vikailmoitukset (sovellus)",
    'set.perm_near_miss_app': "Läheltä piti -ilmoitukset (sovellus)",
    'set.perm_own_quals': "Omien pätevyyksien katselu",
    'set.perm_sos': "Hätä-SOS",
    'set.org_settings': "Organisaation asetukset",
    'set.identity': "Tunnistetiedot",
    'set.org_name': "Organisaation nimi",
    'set.trading_name': "Toiminimi",
    'set.if_different': "Jos eri",
    'set.company_number': "Y-tunnus",
    'set.company_number_placeholder': "12345678",
    'set.vat_number': "ALV-numero",
    'set.vat_placeholder': "GB123456789",
    'set.industry_type': "Toimiala",
    'set.ind_farm': "Maatila",
    'set.ind_estate': "Kartano",
    'set.ind_contractor': "Koneurakoitsija",
    'set.ind_dealership': "Jälleenmyyjä",
    'set.ind_other': "Muu",
    'set.primary_email': "Ensisijainen sähköposti",
    'set.phone_number': "Puhelinnumero",
    'set.website': "Verkkosivusto",
    'set.website_placeholder': "farm.co.uk",
    'set.address1': "Osoiterivi 1",
    'set.address2': "Osoiterivi 2",
    'set.town': "Paikkakunta",
    'set.county': "Maakunta",
    'set.postcode': "Postinumero",
    'set.branding': "Ilme",
    'set.brand_colour': "Brändiväri",
    'set.compliance': "Vaatimustenmukaisuus",
    'set.hse_number': "HSE-rekisterinumero",
    'set.insurance_provider': "Vakuutusyhtiö",
    'set.policy_number': "Vakuutusnumero",
    'set.insurance_expiry': "Vakuutuksen päättyminen",
    'set.sharing_transfers': "Jakaminen ja siirrot",
    'set.org_code_desc': "Organisaatiokoodillasi vastaanotetaan jaettuja koneita ja siirtoja muilta Agriware-asiakkailta. Jaa se niille, joiden kanssa omistat koneita yhdessä, tai konetta sinulle myyvälle.",
    'set.emails': "Sähköpostit",
    'set.hold_the_yard': "Viikoittainen Hold the Yard -sähköposti",
    'set.hold_the_yard_desc': "Maanantaisin koottu yhteenveto edellisen viikon käyttöä edeltävistä tarkastuksista, lähetetään organisaation ylläpitäjille ja esihenkilöille.",
    'set.org_code': "Organisaatiokoodi",
    'set.generating': "Luodaan…",
    'set.copied': "Kopioitu!",
    'set.copy': "Kopioi",
    'set.org_saved': "Organisaation asetukset tallennettu",
    'set.err_save': "Asetusten tallennus epäonnistui",
    'set.save_changes': "Tallenna muutokset",
    'set.status_trialing': "Kokeilussa",
    'set.status_past_due': "Erääntynyt",
    'set.status_cancelled': "Peruutettu",
    'set.status_unpaid': "Maksamatta",
    'set.status_incomplete': "Keskeneräinen",
    'set.billing_title': "Laskutus ja tilaus",
    'set.billing_subtitle': "Hallitse Agriware Operations -tilaustasi.",
    'set.plan_standard': "Standard",
    'set.per_month': "/kk · peru milloin tahansa",
    'set.grandfathered': "Tällä organisaatiolla on aiemman sopimuksen mukainen käyttöoikeus. Laskutustiedot eivät ole saatavilla, koska tili on Stripe-integraatiota vanhempi.",
    'set.next_billing': "Seuraava laskutuspäivä:",
    'set.feat_registry': "Konerekisteri ja huoltohistoria",
    'set.feat_checks': "Päivittäiset tarkastukset ja katsastukset",
    'set.feat_defects': "Häiriöiden ja vikojen seuranta",
    'set.feat_staff': "Henkilöstön pätevyydet ja vuorot",
    'set.feat_reporting': "Raportointikokonaisuus",
    'set.feat_unlimited': "Rajattomasti toimipaikkoja ja kuljettajia",
    'set.err_no_portal': "Portaalin URL-osoitetta ei palautettu.",
    'set.err_portal': "Laskutusportaalia ei voitu avata. Yritä uudelleen tai ota yhteyttä tukeen.",
    'set.opening_portal': "Avataan laskutusportaalia…",
    'set.manage_billing': "Hallitse laskutusta",
    'set.admin_only_billing': "Vain organisaation pääkäyttäjät voivat hallita laskutusta.",
    'set.stripe_note': "Laskutuksen hoitaa turvallisesti Stripe. Emme näe koskaan korttitietojasi.",
    'int.abax_desc': "Nouda moottorityötunnit, sijainti ja käyttöaste suoraan ABAX-seurantalaitteista, jolloin tunnit tulevat itsestään eikä niitä tarvitse näppäillä.",
    'int.abax_detail': "Automaattiset tunnit pitäisivät huoltovälit, hiiliarviot ja tarkastusten vaatimustenmukaisuuden tarkkoina ilman lukemien syöttämistä.",
    'int.dms_desc': "Yhdistä jälleenmyyjäsi DMS-järjestelmään, jotta voit luoda työpyyntöjä, hyväksyä tarjouksia ja saada lukitut työkortit oikealle koneelle.",
    'int.dms_detail': "Jälleenmyyjän tekemä työ kirjautuu automaattisesti koneen tietoihin ja näkyy sen passissa.",
    'int.almanac_desc': "Näe, miten koneesi vertautuvat samoihin malleihin kaikissa Agriware-konekannoissa — tyypilliset vikakohdat, huoltovälit ja mallikohtainen luotettavuus.",
    'int.almanac_detail': "Almanac yhdistää anonymisoidut vika- ja huoltotiedot eri organisaatioista. Omat tietosi ovat mukana; vastineeksi näet koostetun tuloksen.",
    'int.consent_shared': "Jaetaan: koneen merkki ja malli, vikatyypit, käyttötunnit vikaantuessa, huoltovälit",
    'int.consent_never': "Ei koskaan jaeta: organisaatiosi nimi, toimipaikat, henkilöstö, kuljettajat, kustannukset tai asiakirjat",
    'int.consent_threshold': "Luvut näytetään vain, kun koneita on tarpeeksi, jottei yksittäisiä konekantoja voi tunnistaa",
    'int.consent_withdraw': "Voit perua osallistumisen milloin tahansa — luovutetut tiedot poistetaan tulevista koosteista",
    'int.err_update': "Tämän integraation päivitys epäonnistui",
    'int.interest_noted': "Merkitty — otamme yhteyttä, kun tämä on valmis",
    'int.almanac_enabled': "Almanac käytössä",
    'int.almanac_disabled': "Almanac pois käytöstä",
    'int.subtitle': "Yhdistä Agriware Operations jo käyttämiisi järjestelmiin",
    'int.admin_only': "Vain organisaation pääkäyttäjä voi muuttaa integraatioita.",
    'int.enabled': "Käytössä",
    'int.in_development': "Kehitteillä",
    'int.withdraw': "Peru osallistuminen",
    'int.enable_almanac': "Ota Almanac käyttöön",
    'int.interest_registered': "Kiinnostus kirjattu",
    'int.register_interest': "Ilmoita kiinnostuksesta",
    'int.less': "Vähemmän",
    'int.what_this_does': "Mitä tämä tekee",
    'int.footer': "Käytätkö jotain, jota ei ole tässä? Kerro, mitä haluaisit liitettävän — toiveet ratkaisevat, mitä rakennamme seuraavaksi.",
    'tmpl.scope_all_desc': "Koskee organisaation kaikkia koneita",
    'tmpl.scope_category': "Luokan mukaan",
    'tmpl.scope_category_desc': "Koskee valittuja luokkia",
    'tmpl.scope_specific_desc': "Koskee vain yhtä konetta",
    'tmpl.freq_daily': "Päivittäin",
    'tmpl.freq_daily_helper': "On tehtävä päivittäin määräaikaan mennessä",
    'tmpl.freq_weekly': "Viikoittain",
    'tmpl.freq_weekly_helper': "On tehtävä kerran viikossa",
    'tmpl.freq_hourly': "Käyttötuntien mukaan",
    'tmpl.freq_hourly_helper': "Käynnistyy joka X moottorityötunnin välein",
    'tmpl.freq_monthly': "Kuukausittain",
    'tmpl.freq_monthly_helper': "On tehtävä kerran kuukaudessa",
    'tmpl.item_passfail': "Hyväksytty / Hylätty",
    'tmpl.item_numeric': "Numeerinen",
    'tmpl.item_text': "Teksti",
    'tmpl.item_photo': "Kuva",
    'tmpl.item_signature': "Allekirjoitus",
    'tmpl.fail_none': "Vain kirjaus",
    'tmpl.fail_flag': "Kirjaus ja ilmoitus",
    'tmpl.fail_block': "Kirjaus, ilmoitus ja esto",
    'tmpl.section_default': "Osio",
    'tmpl.err_name': "Mallin nimi vaaditaan",
    'tmpl.err_category': "Valitse vähintään yksi luokka",
    'tmpl.err_machine': "Valitse kone",
    'tmpl.err_items': "Lisää vähintään yksi tarkastuskohta",
    'tmpl.updated': "Malli päivitetty",
    'tmpl.created': "Malli luotu",
    'tmpl.err_save': "Mallin tallennus epäonnistui",
    'tmpl.name_placeholder': "Mallin nimi",
    'tmpl.save': "Tallenna malli",
    'tmpl.settings': "Mallin asetukset",
    'tmpl.description_placeholder': "Lyhyt kuvaus siitä, milloin mallia käytetään",
    'tmpl.applies_to': "Koskee",
    'tmpl.select_categories_caps': "VALITSE LUOKAT",
    'tmpl.select_machine_caps': "VALITSE KONE",
    'tmpl.choose_machine': "Valitse kone…",
    'tmpl.frequency': "Tarkastusväli",
    'tmpl.estimated_time': "Arvioitu aika (minuuttia)",
    'tmpl.every_x_hours': "Joka X moottorityötunnin välein",
    'tmpl.due_by_time': "Määräaika",
    'tmpl.due_by_hint': "— myöhästymismuistutus lähtee tähän aikaan",
    'tmpl.due_by_note': "Push-ilmoitus lähetetään kuljettajalle ja toimipaikan esihenkilölle, jos työtä ei ole tehty ajoissa",
    'tmpl.item_one': "kohta",
    'tmpl.item_many': "kohtaa",
    'tmpl.new_item': "Uusi tarkastuskohta",
    'tmpl.add_item': "Lisää tarkastuskohta",
    'tmpl.add_section': "Lisää osio",
    'tmpl.item_panel_title': "Tarkastuskohta",
    'tmpl.select_item_hint': "Valitse vasemmalta tarkastuskohta, niin voit muokata sen asetuksia tässä.",
    'tmpl.label': "Nimike",
    'tmpl.label_placeholder': "esim. moottoriöljyn taso",
    'tmpl.if_fails': "Jos tämä hylätään",
    'tmpl.required': "Pakollinen",
    'tmpl.required_hint': "Kuljettajan on täytettävä tämä kohta",
    'status.active': "Aktiivinen",
    'status.shared': "Jaettu",
    'status.transferred': "Siirretty",
    'status.archived': "Arkistoitu",
    'status.issues': "Huomautuksia",
    'status.emergency': "Hätätilanne",
    'status.closed': "Suljettu",
    'status.due': "Erääntyy",
    'status.draft': "Luonnos",
    'status.approved': "Hyväksytty",
    'status.declined': "Hylätty",
    'status.scheduled': "Suunniteltu",
    'photo.title': "Profiilikuva",
    'photo.upload_title': "Lataa kuva",
    'photo.upload_note': "JPG, PNG tai WebP · enintään 5 Mt · rajataan ympyräksi",
    'photo.choose': "Valitse kuva",
    'photo.drag_hint': "Siirrä vetämällä · zoomaa vierittämällä tai liukusäätimellä",
    'photo.change': "Vaihda kuva",
    'photo.save': "Tallenna kuva",
    'upsell.derv_title': "Polttoaineen hallinta",
    'upsell.derv_desc': "Seuraa säiliötasoja, kirjaa tankkaukset, hallitse toimittajia ja valvo konekohtaista polttoaineenkulutusta kaikissa toimipaikoissa.",
    'upsell.coshh_title': "Vaarallisten aineiden rekisteri",
    'upsell.coshh_desc': "Ylläpidä digitaalista rekisteriä vaarallisista aineista, käyttöturvallisuustiedotteista ja henkilöstön tarvitsemista suojaimista.",
    'upsell.risk_title': "Riskinarvioinnit",
    'upsell.risk_desc': "Luo, hallitse ja lukitse riskinarvioinnit konetta tai tehtävää kohden. Kuljettajat kuittaavat ne ennen työn aloittamista.",
    'upsell.jobs_title': "DMS-integraatio",
    'upsell.jobs_desc': "Tilaa korjaamotöitä jälleenmyyjältäsi, hyväksy tarjoukset ja saa lukitut työkortit suoraan koneiden profiileihin.",
    'upsell.reporting_title': "Raportit ja analytiikka",
    'upsell.reporting_desc': "Raportit konekannan kunnosta, vaatimustenmukaisuudesta, pätevyyksistä, polttoaineenkulutuksesta, CO₂-päästöistä ja konekohtaisista kustannuksista.",
    'upsell.quals_title': "Pätevyyksien seuranta",
    'upsell.quals_desc': "Kirjaa henkilöstön kortit ja todistukset vanhenemisen seurannalla, push-ilmoituksilla ja pätevyyteen perustuvalla konelukituksella.",
    'upsell.sharing_title': "Koneiden jakaminen",
    'upsell.sharing_desc': "Jaa koneiden tiedot muiden Agriware Ops -organisaatioiden kanssa — sopii urakoitsijoille ja yhteiskoneille.",
    'upsell.transfers_title': "Koneiden siirrot",
    'upsell.transfers_desc': "Siirrä koneita Ops-käyttäjien tai DMS-tilien välillä täydellä omistushistorialla ja digitaalisella ajopäiväkirjalla.",
    'upsell.carbon_title': "Hiiliraportointi",
    'upsell.carbon_desc': "CO₂-päästöjen automaattinen laskenta polttoaineenkulutuksen perusteella. DEFRA-standardin mukainen raportointi konekannallesi.",
    'upsell.not_included': "Tämä ominaisuus ei sisälly nykyiseen tilaukseesi.",
    'upsell.upgrade': "Päivitä tilauksesi",
    'service.record_not_found': "Kirjausta ei löytynyt",
    'service.record_title_service': "Huoltokirjaus",
    'service.record_title_repair': "Korjauskirjaus",
    'service.record_title_inspection': "Tarkastuskirjaus",
    'service.record_suffix': "kirjaus",
    'service.email_btn': "Sähköposti",
    'service.email_coming_soon': "Sähköpostivienti tulossa pian",
    'service.sealed_by_workshop': "{name} lukitsi, eikä sitä voi muuttaa",
    'service.the_workshop': "korjaamo",
    'service.sealed_permanent': "Tämä kirjaus on lukittu pysyvästi eikä sitä voi muuttaa",
    'service.sealed_by': "Lukitsija",
    'service.at_suffix': "({name})",
    'service.job_ref': "työmääräys {ref}",
    'service.photos_video': "Kuvat ja video",
    'service.job_photo': "Työkuva",
    'service.files_copying': "Joitakin tiedostoja kopioidaan yhä.",
    'service.date_of_service': "Huoltopäivä",
    'service.hours_at_service': "Käyttötunnit huollossa",
    'service.total_cost': "Kokonaiskustannus",
    'service.record_details': "Kirjauksen tiedot",
    'service.type': "Tyyppi",
    'service.performed_by': "Suorittaja",
    'service.performed_by_type': "Suorittajan tyyppi",
    'service.next_service_hours': "Tunnit seuraavaan huoltoon",
    'service.next_service_date': "Seuraavan huollon päivä",
    'service.notes': "Muistiinpanot",
    'service.parts_used': "Käytetyt osat",
    'service.col_part': "Osa",
    'service.col_qty': "Määrä",
    'service.col_cost': "Kustannus",
    'service.parts_total': "Osat yhteensä",
    'service.cost_breakdown': "Kustannuserittely",
    'service.labour_cost': "Työkustannus",
    'service.parts_cost': "Osakustannus",
    'service.total': "Yhteensä",
    'service.audit_trail': "Muutosloki",
    'service.record_created_by': "Kirjauksen luoja",
    'service.record_sealed_by': "Kirjauksen lukitsija",
    'service.type_service': "Huolto",
    'service.type_service_desc': "Määräaikaishuolto",
    'service.type_repair': "Korjaus",
    'service.type_repair_desc': "Suunnittelematon korjaustyö",
    'service.type_inspection': "Tarkastus",
    'service.type_inspection_desc': "Turvallisuus- tai vaatimustenmukaisuustarkastus",
    'service.by_internal': "Oma väki",
    'service.by_dealer': "Jälleenmyyjä",
    'service.by_external': "Ulkopuolinen urakoitsija",
    'service.err_description': "Anna kuvaus",
    'service.err_date': "Anna huoltopäivä",
    'service.added_toast': "Huoltokirjaus lisätty ja lukittu",
    'service.err_save': "Kirjauksen tallennus epäonnistui — yritä uudelleen",
    'service.seal_note': "Tämä kirjaus lukitaan pysyvästi tallennuksen jälkeen",
    'service.record_type': "Kirjauksen tyyppi",
    'service.description_placeholder': "Kuvaa tehty työ…",
    'service.performed_by_placeholder': "Nimi tai yritys",
    'service.additional_notes': "Lisämuistiinpanot",
    'service.notes_placeholder': "Mahdolliset lisämuistiinpanot…",
    'service.add_part': "Lisää osa",
    'service.part_name': "Osan nimi",
    'service.cost_placeholder': "Kustannus £",
    'service.cost_next_service': "Kustannus ja seuraava huolto",
    'service.labour_cost_field': "Työkustannus (£)",
    'service.next_hours_placeholder': "esim. 1750",
    'service.seal_warning': "Tallennuksen jälkeen kirjaus on pysyvästi lukittu eikä sitä voi muokata. Varmista, että kaikki tiedot ovat oikein ennen tallennusta.",
    'service.save_seal': "Tallenna ja lukitse kirjaus",
    'dashboard.there': "sinä",
    'dashboard.total_machines': "Koneita yhteensä",
    'dashboard.blocked_machines': "Estetyt koneet",
    'dashboard.open_incidents': "Avoimet tapahtumat",
    'dashboard.open_defects': "Avoimet viat",
    'dashboard.fuel_tanks': "Polttoainesäiliöt",
    'common.of': "/",
    'dashboard.fleet': "Konekanta",
    'common.view_all': "Näytä kaikki",
    'dashboard.no_machines': "Ei vielä koneita",
    'dashboard.no_machines_msg': "Aloita lisäämällä ensimmäinen kone",
    'dashboard.recent_incidents': "Viimeisimmät tapahtumat",
    'dashboard.no_incidents_msg': "Tapahtumia ei ole kirjattu",
    'dashboard.recent_defects': "Viimeisimmät viat",
    'dashboard.no_defects': "Ei vikoja",
    'dashboard.no_defects_msg': "Vikoja ei ole ilmoitettu",
    'dashboard.defect_reported': "Vika ilmoitettu",
    'dashboard.group_overview': "Konsernin yleiskatsaus",
    'dashboard.send_announcement': "Lähetä tiedote",
    'dashboard.sites': "Toimipaikat",
    'dashboard.no_sites': "Ei vielä toimipaikkoja",
    'dashboard.no_sites_msg': "Aloita lisäämällä ensimmäinen toimipaikka Asetuksissa",
    'dashboard.add_site': "Lisää toimipaikka",
    'dashboard.status_monitor': "Seurattava",
    'dashboard.status_all_good': "Kaikki kunnossa",
    'dashboard.derv': "Diesel",
    'dashboard.derv_level': "Dieselin määrä",
    'qual.short_forklift': "Trukki",
    'qual.short_sprayer': "Ruisku",
    'qual.short_cscs': "CSCS",
    'qual.short_driving': "Ajokortti",
    'qual.short_firstaid': "Ensiapu",
    'qual.short_chainsaw': "Moottorisaha",
    'qual.short_pesticide': "Kasvinsuojelu",
    'qual.short_telehandler': "Kurottaja",
    'qual.short_atv': "Mönkijä",
    'qual.short_other': "Muu",
    'qual.forklift': "Trukinkuljettajan kortti",
    'qual.sprayer': "PA1/PA6-ruiskutodistus",
    'qual.cscs': "CSCS-kortti",
    'qual.driving': "Ajokortti",
    'qual.firstaid': "Ensiaputodistus",
    'qual.chainsaw': "Moottorisahakortti",
    'qual.pesticide': "Kasvinsuojeluaineiden käyttö",
    'qual.telehandler': "Kurottajan käyttökortti",
    'qual.atv': "Mönkijäkortti",
    'qual.other': "Muu pätevyys",
    'staff.n_expired': "vanhentunut",
    'staff.n_expiring': "vanhenee pian",
    'staff.n_valid': "voimassa",
    'common.none': "Ei mitään",
    'staff.tab_members': "Jäsenet",
    'staff.tab_qualifications': "Pätevyydet",
    'staff.tab_shifts': "Vuorot",
    'staff.member_one': "jäsen",
    'staff.member_many': "jäsentä",
    'staff.alert_one': "pätevyyshälytys",
    'staff.alert_many': "pätevyyshälytystä",
    'staff.invite': "Kutsu henkilö",
    'staff.create_shift': "Luo vuoro",
    'staff.search': "Hae nimellä tai sähköpostilla…",
    'staff.none_found': "Henkilöstöä ei löytynyt",
    'staff.adjust_search': "Kokeile muuttaa hakua",
    'staff.invite_first': "Kutsu ensimmäinen työntekijä",
    'staff.stat_total_quals': "Pätevyyksiä yhteensä",
    'staff.stat_valid': "Voimassa",
    'staff.stat_expiring_30d': "Vanhenee (30 pv)",
    'staff.stat_expiring': "Vanhenee",
    'staff.stat_expired': "Vanhentuneet",
    'staff.qual_one': "pätevyys",
    'staff.qual_many': "pätevyyttä",
    'staff.expires': "Vanhenee",
    'staff.no_quals': "Pätevyyksiä ei ole kirjattu",
    'staff.no_quals_msg': "Lisää pätevyydet kunkin työntekijän profiilista",
    'staff.no_shifts': "Ei vielä vuoroja",
    'staff.no_shifts_msg': "Luo ensimmäinen vuoro, niin näet kuka on työssä",
    'staff.shift': "Vuoro",
    'staff.checked_in': "kirjautunut sisään",
    'staff.not_found': "Työntekijää ei löytynyt",
    'staff.add_qualification': "Lisää pätevyys",
    'staff.expired_alert_one': "pätevyys on vanhentunut — tällä kuljettajalla ei ehkä ole lupaa käyttää tiettyjä koneita",
    'staff.expired_alert_many': "pätevyyttä on vanhentunut — tällä kuljettajalla ei ehkä ole lupaa käyttää tiettyjä koneita",
    'staff.expiring_alert_one': "pätevyys vanhenee 30 päivän kuluessa",
    'staff.expiring_alert_many': "pätevyyttä vanhenee 30 päivän kuluessa",
    'staff.tab_details': "Tiedot",
    'staff.contact': "Yhteystiedot",
    'staff.account': "Tili",
    'staff.onboarding': "Perehdytys",
    'staff.complete': "Valmis",
    'staff.job_title': "Tehtävänimike",
    'staff.joined': "Liittynyt",
    'staff.invited_by': "Kutsuja",
    'staff.quals_tickets': "Pätevyydet ja kortit",
    'staff.no_quals_profile_msg': "Lisää tämän kuljettajan kortit ja todistukset",
    'staff.issued': "Myönnetty",
    'staff.no_expiry': "Ei vanhenemispäivää",
    'staff.expires_today': "Vanhenee tänään",
    'staff.days_remaining_one': "päivä jäljellä",
    'staff.days_remaining_many': "päivää jäljellä",
    'staff.expired_days_ago_one': "Vanhentui {n} päivä sitten",
    'staff.expired_days_ago_many': "Vanhentui {n} päivää sitten",
    'staff.view_certificate': "Näytä todistus",
    'staff.assigned_machines': "Osoitetut koneet",
    'staff.no_machines': "Koneita ei ole osoitettu",
    'staff.no_machines_msg': "Tälle kuljettajalle ei ole osoitettu koneita",
    'staff.err_first_name': "Etunimi vaaditaan",
    'staff.err_last_name': "Sukunimi vaaditaan",
    'staff.err_email': "Anna kelvollinen sähköpostiosoite",
    'staff.err_site': "Valitse toimipaikka",
    'staff.err_create_prefix': "Tilin luonti epäonnistui:",
    'staff.err_timeout': "Aikakatkaisu tiliä luotaessa. Päivitä sivu ja yritä uudelleen.",
    'staff.err_create': "Tilin luonti epäonnistui — yritä uudelleen",
    'staff.copy_greeting': "Hei {name},",
    'staff.copy_body': "Agriware Operations -tilisi on luotu.",
    'staff.copy_email': "Sähköposti:",
    'staff.copy_temp_password': "Väliaikainen salasana:",
    'staff.copy_footer': "Sinua pyydetään vaihtamaan salasana ensimmäisellä kirjautumisella.",
    'staff.copied_toast': "Kirjautumistiedot kopioitu leikepöydälle",
    'staff.role_admin_desc': "Täysi pääsy kaikkiin toimipaikkoihin ja asetuksiin",
    'staff.role_manager_desc': "Hallinnoi yhtä toimipaikkaa, henkilöstöä ja koneita",
    'staff.role_operator_desc': "Tekee päivittäiset tarkastukset mobiilisovelluksella",
    'staff.add_member': "Lisää työntekijä",
    'staff.add_member_sub': "Tili luodaan heti. Näet kirjautumistiedot jaettavaksi.",
    'staff.account_created': "Tili luotu",
    'staff.share_details_pre': "Jaa nämä kirjautumistiedot henkilölle",
    'staff.share_details_post': "Ensimmäisellä kirjautumisella pyydetään vaihtamaan salasana.",
    'staff.label_email_caps': "SÄHKÖPOSTI",
    'staff.label_temp_password_caps': "VÄLIAIKAINEN SALASANA",
    'staff.copy_login_details': "Kopioi kirjautumistiedot",
    'staff.add_another': "Lisää toinen",
    'staff.back_to_staff': "Takaisin henkilöstöön",
    'staff.personal_details': "Henkilötiedot",
    'staff.first_name': "Etunimi",
    'staff.last_name': "Sukunimi",
    'staff.work_email': "Työsähköposti",
    'staff.site_assignment': "Toimipaikan osoitus",
    'staff.no_sites': "Toimipaikkoja ei ole vielä luotu — lisää ensin toimipaikka Asetuksissa",
    'staff.creating_account': "Luodaan tiliä…",
    'staff.create_account': "Luo tili",
    'staff.first_name_placeholder': "James",
    'staff.last_name_placeholder': "Doyle",
    'staff.work_email_placeholder': "james.doyle@farm.co.uk",
    'qual.err_type': "Valitse pätevyyden tyyppi",
    'qual.err_name': "Anna pätevyyden nimi",
    'qual.err_issue_date': "Anna myöntämispäivä",
    'qual.err_expiry': "Anna vanhenemispäivä tai merkitse ”ei vanhenemispäivää”",
    'qual.added_toast': "Pätevyys lisätty",
    'qual.err_save': "Pätevyyden tallennus epäonnistui — yritä uudelleen",
    'qual.back_staff_profile': "Työntekijän profiili",
    'qual.subtitle': "Kirjaa tämän kuljettajan kortti, todistus tai lupa",
    'qual.type_title': "Pätevyyden tyyppi",
    'qual.name_label': "Pätevyyden nimi",
    'qual.name_placeholder': "esim. NPTC-raivaussahatodistus",
    'qual.cert_details': "Todistuksen tiedot",
    'qual.cert_number': "Todistuksen numero",
    'common.optional_suffix': "— valinnainen",
    'qual.cert_number_placeholder': "esim. NPORS-123456",
    'qual.issuing_body': "Myöntäjä",
    'qual.issuing_body_placeholder': "esim. NPORS, LANTRA, CITB",
    'qual.issue_date': "Myöntämispäivä",
    'qual.expiry_date': "Vanhenemispäivä",
    'qual.no_expiry_label': "Tällä pätevyydellä ei ole vanhenemispäivää",
    'qual.cert_document': "Todistusasiakirja",
    'qual.upload_note': "Lataa todistuksesta valokuva tai skannaus. Se säilytetään yksityisenä eikä sitä jaeta.",
    'common.remove': "Poista",
    'qual.click_upload': "Lataa todistus napsauttamalla",
    'qual.file_types': "JPG, PNG tai PDF",
    'common.saving': "Tallennetaan…",
    'qual.save': "Tallenna pätevyys",
    'defects.title': "Viat",
    'defects.n_open': "avointa",
    'defects.n_critical': "kriittistä",
    'defects.stat_total': "Vikoja yhteensä",
    'defects.status_open': "Avoin",
    'defects.status_in_progress': "Käsittelyssä",
    'defects.status_resolved': "Korjattu",
    'defects.all_severities': "Kaikki vakavuudet",
    'defects.sev_minor': "Vähäinen",
    'defects.sev_moderate': "Kohtalainen",
    'defects.sev_major': "Vakava",
    'defects.sev_critical': "Kriittinen",
    'defects.search': "Hae vikoja…",
    'common.clear': "Tyhjennä",
    'defects.col_description': "Kuvaus",
    'defects.reported_by': "Ilmoittaja",
    'defects.col_severity': "Vakavuus",
    'defects.no_description': "Ei kuvausta",
    'defects.none_found': "Vikoja ei löytynyt",
    'defects.none_reported': "Vikoja ei ole ilmoitettu",
    'defects.acknowledged_toast': "Vika kuitattu",
    'defects.acknowledge_failed': "Vian kuittaaminen epäonnistui",
    'defects.resolved_released': "Vika korjattu — kone vapautettu",
    'defects.resolved_toast': "Vika korjattu",
    'defects.resolve_failed': "Vian korjaaminen epäonnistui",
    'defects.not_found': "Vikaa ei löytynyt",
    'defects.report_title': "Vikailmoitus",
    'defects.acknowledge': "Kuittaa",
    'defects.raise_job': "Luo työmääräys",
    'defects.resolve': "Korjaa",
    'defects.blocking_banner': "Kone estetty — esihenkilön on kirjattava kirjallinen vapautus ennen käyttöönottoa",
    'defects.details_title': "Vian tiedot",
    'defects.no_description_provided': "Kuvausta ei annettu",
    'defects.reported_at': "Ilmoitettu",
    'defects.location': "Sijainti",
    'defects.photos': "Kuvat",
    'defects.acknowledgement': "Kuittaus",
    'defects.acknowledged_by': "Kuittaaja",
    'defects.resolved_by': "Korjaaja",
    'defects.return_to_service': "Käyttöönotto",
    'defects.revised': "Muutettu",
    'defects.revised_by_suffix': "muuttaja {name}",
    'defects.view_machine_profile': "Näytä koneen profiili",
    'defects.resolve_and_release': "Korjaa ja palauta käyttöön",
    'defects.resolve_defect': "Korjaa vika",
    'defects.release_machine': "Vapauta kone",
    'defects.mark_resolved': "Merkitse korjatuksi",
    'defects.release_warning': "Tämä kone on estetty. Kirjallinen vapautuksesi tallennetaan nimelläsi ja roolillasi ja näkyy koneen passissa.",
    'defects.resolution_details': "Korjauksen tiedot",
    'defects.resolution_placeholder': "Kuvaa, miten vika korjattiin…",
    'defects.narrative_placeholder': "Mitä havaittiin, mitä tehtiin ja miten kone tarkastettiin ennen vapauttamista. Mainitse tarvittaessa työmääräysnumerot ja testitiedot.",
    'defects.chars_needed_one': "merkki lisää tarvitaan",
    'defects.chars_needed_many': "merkkiä lisää tarvitaan",
    'defects.characters': "merkkiä",
    'defects.permanent_note': "Tämä tallennetaan pysyvästi vikailmoitukseen.",
    'machines.tab_overview': "Yleiskatsaus",
    'machines.tab_history': "Historia",
    'machines.tab_documents': "Asiakirjat",
    'machines.tab_operators': "Kuljettajat",
    'machines.tab_sharing': "Jakaminen",
    'machines.tab_incidents': "Tapahtumat",
    'machines.pdf_only': "Vain PDF-tiedostot hyväksytään.",
    'machines.replace_confirm': "Korvataanko nykyinen asiakirja ({name})? Vanha tiedosto poistetaan.",
    'machines.delete_doc_confirm': "Poistetaanko tämä asiakirja? Toimintoa ei voi perua.",
    'machines.uploaded': "Ladattu",
    'machines.no_file_yet': "Ei vielä tiedostoa",
    'machines.uploading': "Ladataan…",
    'machines.view_document': "Näytä asiakirja",
    'common.replace': "Korvaa",
    'common.delete': "Poista",
    'common.upload': "Lataa",
    'machines.doc_type_manual': "Käsikirja",
    'machines.doc_type_private': "Yksityinen",
    'machines.doc_operators_manual': "Käyttöohjekirja",
    'machines.doc_workshop_manual': "Korjaamokäsikirja",
    'machines.untitled_document': "Nimetön asiakirja",
    'machines.add_document': "Lisää asiakirja",
    'machines.documents_intro': "Käyttöohjekirjalla ja korjaamokäsikirjalla on omat paikkansa — niiden avulla tunnistamme oikean asiakirjan, kun se jaetaan Agriware-kirjastoon. Muut yksityiset asiakirjat näkyvät vain omalle organisaatiollesi.",
    'machines.returned_to_service': "Kone palautettu käyttöön",
    'machines.not_blocked': "Tätä konetta ei ole estetty",
    'machines.resolve_defect_first': "Korjaa avoin vika, jotta kone voidaan palauttaa käyttöön",
    'machines.return_failed': "Koneen palauttaminen käyttöön epäonnistui",
    'machines.machine_not_found': "Konetta ei löytynyt",
    'common.unknown': "Tuntematon",
    'machines.unblock': "Poista esto",
    'service.add_record': "Lisää huoltokirjaus",
    'machines.serial_number': "Sarjanumero",
    'machines.year': "Vuosimalli",
    'machines.blocked_banner': "Kone estetty — ei saa käyttää",
    'machines.current_hours': "Nykyiset käyttötunnit",
    'machines.next_service': "Seuraava huolto",
    'machines.service_records': "Huoltokirjaukset",
    'machines.service_progress': "Huoltoväli",
    'machines.cost_over_time': "Kustannukset ajan myötä",
    'machines.cost_over_time_sub': "Huolto, korjaus ja kumulatiiviset omistuskustannukset",
    'machines.cost_empty': "Kustannustiedot ilmestyvät, kun huoltokirjauksia lisätään.",
    'machines.series_service': "Huolto",
    'machines.series_repair': "Korjaus",
    'machines.series_cumulative': "Kumulatiivinen",
    'machines.details_title': "Koneen tiedot",
    'machines.make': "Merkki",
    'machines.model': "Malli",
    'machines.category': "Luokka",
    'machines.assigned_to': "Kenelle osoitettu",
    'machines.pool_machine': "Yhteiskäyttökone",
    'machines.unassigned': "Ei osoitettu",
    'machines.purchase_value': "Hankinta ja arvo",
    'machines.purchase_date': "Ostopäivä",
    'machines.purchase_price': "Ostohinta",
    'machines.depreciation_rate': "Poistoprosentti",
    'machines.per_year': "vuodessa",
    'machines.estimated_life': "Arvioitu käyttöikä",
    'common.unit_years': "vuotta",
    'machines.cost_tracking': "Kustannusseuranta",
    'machines.total_service_cost': "Huoltokustannukset yhteensä",
    'machines.total_repair_cost': "Korjauskustannukset yhteensä",
    'machines.total_fuel_cost': "Polttoainekustannukset yhteensä",
    'machines.total_cost_ownership': "Kokonaisomistuskustannus",
    'machines.service_history': "Huolto- ja korjaushistoria",
    'service.add_record_short': "Lisää kirjaus",
    'service.none_yet': "Ei vielä huoltokirjauksia",
    'service.none_yet_msg': "Lisää ensimmäinen huolto- tai korjauskirjaus",
    'service.sealed': "Lukittu",
    'service.workshop': "Korjaamo",
    'common.photo_one': "kuva",
    'common.photo_many': "kuvaa",
    'machines.assigned_operators': "Osoitetut kuljettajat",
    'machines.no_operator': "Kuljettajaa ei ole osoitettu",
    'machines.no_operator_msg': "Tälle koneelle ei ole osoitettu kuljettajaa",
    'machines.pool_machine_msg': "Tämä on yhteiskäyttökone — kaikkien kuljettajien käytettävissä",
    'machines.ownership_sharing': "Omistus ja jakaminen",
    'machines.share_machine': "Jaa kone",
    'machines.current_owner': "Nykyinen omistaja",
    'machines.your_organisation': "Oma organisaatiosi",
    'machines.shared_with': "Jaettu",
    'machines.not_shared': "Ei jaettu muille organisaatioille",
    'machines.incident_history': "Tapahtumahistoria",
    'incidents.none': "Ei tapahtumia",
    'incidents.none_msg': "Tälle koneelle ei ole kirjattu tapahtumia",
    'incidents.impact_detected': "Törmäys havaittu",
    'incidents.manual_sos': "Manuaalinen SOS",
    'incidents.man_down': "Man down -hälytys",
    'machines.unblock_title': "Palauta kone käyttöön",
    'machines.confirm_unblock': "Vahvista eston poisto",
    'machines.unblock_warning': "Kirjallinen selvityksesi tallennetaan koneen pysäyttäneeseen tarkastukseen ja näkyy koneen passissa. Jos konetta estää avoin vika, korjaa sen sijaan vika.",
    'machines.blocked_reason': "Eston syy",
    'machines.unblock_statement': "Käyttöönottoselvitys",
    'machines.unblock_placeholder': "Mitä havaittiin, mitä tehtiin ja miten kone tarkastettiin ennen käyttöönottoa.",
    'checks.history_title': "Tarkastushistoria",
    'checks.stat_total': "Tarkastuksia yhteensä",
    'checks.stat_passed': "Hyväksytyt",
    'checks.stat_failed': "Hylätyt",
    'checks.n_passed': "hyväksyttyä",
    'checks.n_failed': "hylättyä",
    'common.clear_filters': "Tyhjennä suodattimet",
    'checks.not_found': "Tarkastusta ei löytynyt",
    'common.export_pdf': "Vie PDF",
    'common.pdf_coming_soon': "PDF-vienti tulossa pian",
    'checks.item_failed_one': "kohta hylätty",
    'checks.item_failed_many': "kohtaa hylätty",
    'checks.auto_blocked': "Kone estettiin automaattisesti lähetyksen yhteydessä",
    'checks.sealed_record': "Lukittu kirjaus",
    'checks.submitted_by': "Lähettäjä",
    'checks.submitted_at': "Lähetetty",
    'checks.hours_at_check': "Käyttötunnit tarkastuksessa",
    'checks.stat_total_items': "Kohtia yhteensä",
    'checks.stat_mileage': "Mittarilukema",
    'checks.details_title': "Tarkastuksen tiedot",
    'checks.failed_items': "Hylätyt kohdat",
    'checks.no_items_recorded': "Tarkastuskohtia ei kirjattu",
    'checks.alt_defect_photo': "Kuva viasta",
    'checks.alt_check_photo': "Tarkastuskuva",
    'common.unit_hrs': "h",
    'common.unit_mi': "mi",
    'checks.tab_templates': "Mallit",
    'checks.tab_history': "Historia",
    'checks.create_template': "Luo malli",
    'checks.scope_specific': "Tietty kone",
    'checks.scope_all': "Kaikki koneet",
    'checks.categories': "luokkaa",
    'checks.items': "kohtaa",
    'checks.title': "Tarkastukset",
    'checks.template_one': "malli",
    'checks.template_many': "mallia",
    'checks.record_one': "kirjaus",
    'checks.record_many': "kirjausta",
    'checks.no_templates': "Ei vielä tarkastusmalleja",
    'checks.no_templates_msg': "Luo malleja määrittääksesi, mitä kuljettajien on tarkastettava ennen käyttöä",
    'checks.search': "Hae koneen tai kuljettajan mukaan…",
    'checks.all_results': "Kaikki tulokset",
    'checks.pass': "Hyväksytty",
    'checks.fail': "Hylätty",
    'checks.none_found': "Tarkastuksia ei löytynyt",
    'checks.adjust_filters': "Kokeile muuttaa suodattimia",
    'checks.none_submitted': "Tarkastuksia ei ole vielä lähetetty",
    'checks.col_operator': "Kuljettaja",
    'checks.col_datetime': "Päivä ja aika",
    'checks.col_result': "Tulos",
    'machines.add': "Lisää kone",
    'machines.col_machine': "Kone",
    'machines.col_serial': "Sarjanro / Rek.nro",
    'machines.col_site': "Toimipaikka",
    'machines.col_hours': "Tunnit",
    'machines.col_status': "Tila",
    'machines.title': "Koneet",
    'machines.count_one': "kone",
    'machines.count_many': "konetta",
    'machines.blocked': "estetty",
    'machines.search': "Hae merkin, mallin, sarjanumeron tai rekisterin mukaan…",
    'machines.all_sites': "Kaikki toimipaikat",
    'machines.all_statuses': "Kaikki tilat",
    'machines.available': "Käytettävissä",
    'machines.blocked_one': "Estetty",
    'machines.none_found': "Koneita ei löytynyt",
    'machines.view': "Näytä",
    'cat.all': "Kaikki luokat",
    'cat.agricultural': "Maatalous",
    'cat.groundcare': "Viheralueiden hoito",
    'cat.plant': "Työkoneet",
    'cat.vehicle': "Ajoneuvo",
    'cat.atv': "Mönkijä",
    'nav.dashboard': "Kojelauta",
    'nav.staff': "Henkilöstö",
    'nav.checks': "Tarkastukset",
    'nav.safety': "Turvallisuus",
    'nav.operations': "Toiminta",
    'nav.settings': "Asetukset",
    'nav.billing': "Laskutus",
    'nav.sign_out': "Kirjaudu ulos",
    'role.admin': "Ylläpitäjä",
    'role.manager': "Esihenkilö",
    'role.operator': "Kuljettaja",
    'app.name': 'AgriWare Toiminnot',
    'app.tagline': 'Hallinta',
    'nav.home': 'Koti',
    'nav.machines': 'Koneet',
    'nav.profile': 'Profiili',
    'common.back': 'Takaisin',
    'common.cancel': 'Peruuta',
    'common.save': 'Tallenna',
    'common.edit': 'Muokkaa',
    'common.done': 'Valmis',
    'common.yes': 'Kyllä',
    'common.no': 'Ei',
    'common.ok': 'OK',
    'common.error': 'Virhe',
    'common.loading': 'Ladataan...',
    'common.retry': 'Yritä uudelleen',
    'common.search': 'Hae',
    'common.submit': 'Lähetä',
    'common.confirm': 'Vahvista',
    'common.close': 'Sulje',
    'common.pass': 'Hyväksytty',
    'common.fail': 'Hylätty',
    'common.total': 'yhteensä',
    'common.today': 'Tänään',
    'common.yesterday': 'Eilen',
    'common.online_only': 'Vain verkossa',
    'common.last_synced': 'Viimeksi synkronoitu',
    'common.back_to_app': 'Takaisin sovellukseen',
    'common.gps_shared': 'GPS jaettu',
    'common.yes_via_saas': 'Kyllä — SaaS:n kautta',
    'common.not_called': 'Ei soitettu',
    'login.sign_in': 'Kirjaudu sisään',
    'login.email': 'Sähköpostiosoite',
    'login.password': 'Salasana',
    'login.forgot_password': 'Unohditko salasanan?',
    'login.no_account': 'Ei tiliä?',
    'login.request_access': 'Pyydä käyttöoikeutta',
    'login.account_created_by_org': 'Tilisi on luotu organisaatiosi toimesta.',
    'login.email_placeholder': 'sinä@organisaatio.fi',
    'login.password_placeholder': 'Syötä salasanasi',
    'login.error_empty': 'Syötä sähköpostiosoite ja salasana.',
    'login.error_invalid': 'Virheellinen sähköposti tai salasana. Yritä uudelleen.',
    'dashboard.greeting_morning': 'Hyvää huomenta,',
    'dashboard.greeting_afternoon': 'Hyvää iltapäivää,',
    'dashboard.greeting_evening': 'Hyvää iltaa,',
    'dashboard.todays_tasks': 'Tämän päivän tehtävät',
    'dashboard.completed': 'Suoritettu',
    'dashboard.overdue': 'Myöhässä',
    'dashboard.in_progress': 'Kesken',
    'dashboard.upcoming': 'Tulossa',
    'dashboard.pending': 'Odottaa',
    'machines.search_placeholder': 'Hae koneita...',
    'machines.favourites': 'Suosikit',
    'machines.all_machines': 'Kaikki koneet',
    'machines.operational': 'Toimintakykyinen',
    'machines.needs_attention': 'Vaatii huomiota',
    'machines.fault': 'Vika',
    'machines.unsafe_to_operate': 'Vaarallinen käyttää',
    'machines.registration': 'Rekisterinumero',
    'machines.assigned_operator': 'Nimetty käyttäjä',
    'machines.engine_hours': 'Moottoritunnit',
    'machines.documents': 'Asiakirjat',
    'machines.log_fault': 'Ilmoita viasta',
    'machines.operator_manual': 'Käyttöohje',
    'machines.service_record': 'Huoltokirja',
    'machines.insurance': 'Vakuutustodistus',
    'machines.mot': 'Katsastustodistus',
    'daily_check.title': 'Päivittäinen tarkastus',
    'daily_check.start': 'Aloita tarkastus',
    'daily_check.required': 'Päivittäinen tarkastus vaaditaan',
    'daily_check.required_msg': 'On suoritettava ennen tämän koneen käyttöä.',
    'daily_check.complete': 'Tarkastus suoritettu',
    'daily_check.complete_msg': 'Suorittanut',
    'daily_check.submit': 'Lähetä tarkastus',
    'daily_check.items_remaining': 'kohtaa jäljellä',
    'daily_check.reward_title': 'Kiitos!',
    'daily_check.reward_subtitle': 'Päivittäinen tarkastuksesi on rekisteröity.\nRehelliset tarkastukset pitävät kaikki turvassa.',
    'daily_check.back_to_machine': 'Takaisin koneelle',
    'daily_check.day_streak': 'Päivien putki',
    'daily_check.completion_rate': 'Suoritusaste',
    'daily_check.cat_lights': 'Valaistus ja näkyvyys',
    'daily_check.cat_fluids': 'Nesteet',
    'daily_check.cat_tyres': 'Renkaat ja pyörät',
    'daily_check.cat_safety': 'Turvallisuus',
    'daily_check.cat_controls': 'Ohjaimet',
    'daily_check.cat_body': 'Kori ja varusteet',
    'daily_check.lights_working': 'Kaikki valot toimivat',
    'daily_check.mirrors': 'Peilit puhtaat ja säädetyt',
    'daily_check.windscreen': 'Tuulilasi puhdas ja ehjä',
    'daily_check.engine_oil': 'Moottoriöljyn taso',
    'daily_check.coolant': 'Jäähdytysnesteen taso',
    'daily_check.hydraulic': 'Hydrauliöljyn taso',
    'daily_check.fuel': 'Polttoainetaso riittävä',
    'daily_check.tyre_pressure': 'Rengaspaine oikea',
    'daily_check.tyre_damage': 'Ei näkyviä rengasvaurioita',
    'daily_check.wheel_nuts': 'Pyöränpultit kiinni',
    'daily_check.fire_extinguisher': 'Sammutin mukana',
    'daily_check.first_aid': 'Ensiapupakkaus mukana',
    'daily_check.rops': 'ROPS-rakenne ehjä',
    'daily_check.seatbelt': 'Turvavyö toimii',
    'daily_check.brakes': 'Jarrut toimivat',
    'daily_check.steering': 'Ohjaus reagoi',
    'daily_check.horn': 'Äänitorvi toimii',
    'daily_check.body_damage': 'Ei näkyviä korivaurioita',
    'daily_check.attachments': 'Varusteet kiinnitetty',
    'daily_check.pto_guard': 'Ulosottoakselin suoja paikallaan',
    'log_fault.title': 'Ilmoita viasta',
    'log_fault.description': 'Kuvaus',
    'log_fault.description_placeholder': 'Kuvaile vika...',
    'log_fault.photos': 'Valokuvat',
    'log_fault.add_photo': 'Lisää valokuva',
    'log_fault.submit': 'Lähetä vikaraportti',
    'log_fault.success': 'Vika ilmoitettu',
    'emergency.title': 'Hätätilanne',
    'emergency.what_emergency': 'Mikä hätätilanne?',
    'emergency.select_type': 'Valitse hätätilanteen tyyppi.\nAsianmukaisiin yhteystietoihin soitetaan välittömästi.',
    'emergency.vibrating': 'Värisee',
    'emergency.alarm': 'Hälytys',
    'emergency.medical': 'Lääketieteellinen hätätilanne',
    'emergency.medical_sub': 'Vamma, sairaus tai tajuton henkilö paikalla',
    'emergency.calls_999': 'Soittaa 112 välittömästi',
    'emergency.electrical': 'Sähköinen hätätilanne',
    'emergency.electrical_sub': 'Sähkölinjakontakti — pysy ohjaamossa',
    'emergency.calls_105': 'Soittaa 112 välittömästi',
    'emergency.no_signal': 'Hätänumerot tallennettu laitteeseen — käytettävissä ilman signaalia',
    'emergency.gps_auto': 'GPS-sijainti jaetaan automaattisesti',
    'emergency.999_called': '112 soitettu',
    'emergency.105_called': 'Hätälinja soitettu',
    'emergency.services_contacted': 'Hätäpalvelut on otettu yhteyttä.\nEsimiehelläsi on myös ilmoitettu.',
    'emergency.power_contacted': 'Sähköinen hätälinja on otettu yhteyttä.\nEsimiehelläsi on myös ilmoitettu.',
    'emergency.emergency_type': 'Hätätilanteen tyyppi',
    'emergency.number_called': 'Soitettu numero',
    'emergency.location': 'Sijainti',
    'emergency.admin_notified': 'Ylläpitäjä ilmoitettu',
    'emergency.stay_in_cab': 'Pysy ohjaamossa',
    'emergency.stay_in_cab_msg': 'Älä poistu ajoneuvosta. Odota, kunnes viranomaiset vahvistavat linjan olevan turvallinen. Pidä ikkunat suljettuina.',
    'emergency.medical_type': 'Lääketieteellinen',
    'emergency.electrical_type': 'Sähköinen',
    'crash.are_you_okay': 'Oletko kunnossa?',
    'crash.impact_detected': 'Mahdollinen törmäys havaittu.\nVastaa pyydettäessä tai apua kutsutaan.',
    'crash.im_okay': 'Olen kunnossa',
    'crash.dismiss_alert': 'Hylkää hälytys — ei toimenpiteitä',
    'crash.i_need_help': 'Tarvitsen apua',
    'crash.notify_supervisor': 'Ilmoita esimiehelle GPS-sijainnilla',
    'crash.call_999': 'Soita 112',
    'crash.call_emergency': 'Soita hätäpalveluihin välittömästi',
    'crash.glad_okay': 'Hyvä että olet kunnossa',
    'crash.alert_dismissed': 'Hälytys hylätty. Ilmoitusta ei lähetetty.',
    'crash.help_on_way': 'Apu on tulossa',
    'crash.supervisor_notified': 'Esimiehellesi on ilmoitettu GPS-sijaintisi kanssa.',
    'crash.auto_dialled': '112 soitettu automaattisesti',
    'crash.no_response': 'Ei vastausta. Hätäpalvelut soitettu automaattisesti. Ääniviesti lähetetään.',
    'crash.broadcasting': 'Lähetetään viestiä',
    'crash.repeating': 'Toistetaan 15 sekunnin välein',
    'crash.admin_notified': 'Ylläpitäjä ilmoitettu',
    'crash.emergency_services': 'Hätäpalvelut',
    'profile.title': 'Profiili',
    'profile.personal_info': 'Henkilökohtaiset tiedot',
    'profile.full_name': 'Koko nimi',
    'profile.email': 'Sähköposti',
    'profile.phone': 'Puhelin',
    'profile.role': 'Rooli',
    'profile.organisation': 'Organisaatio',
    'profile.emergency_contact': 'Hätäkontakti',
    'profile.emergency_contact_note': 'Esimiehellesi otetaan yhteyttä hätätilanteessa',
    'profile.contact_name': 'Yhteystiedon nimi',
    'profile.contact_phone': 'Yhteystiedon puhelin',
    'profile.notifications': 'Ilmoitukset',
    'profile.task_reminders': 'Tehtävämuistutukset',
    'profile.overdue_alerts': 'Myöhästymishälytykset',
    'profile.crash_detection': 'Törmäystunnistus',
    'profile.account_security': 'Tili ja turvallisuus',
    'profile.change_password': 'Vaihda salasana',
    'profile.two_factor': 'Kaksivaiheinen todentaminen',
    'profile.login_activity': 'Kirjautumistoiminta',
    'profile.app_settings': 'Sovelluksen asetukset',
    'profile.theme': 'Teema',
    'profile.language': 'Kieli',
    'profile.sign_out': 'Kirjaudu ulos',
    'profile.sign_out_confirm': 'Kirjaudu ulos',
    'profile.sign_out_msg': 'Haluatko varmasti kirjautua ulos?',
    'profile.field_staff': 'Kenttähenkilöstö',
    'theme.light': 'Vaalea',
    'theme.dark': 'Tumma',
    'theme.system': 'Järjestelmän oletus',
  },

  'cs': {
    'app.name': 'AgriWare Provoz',
    'app.tagline': 'Správa',
    'nav.home': 'Domů',
    'nav.machines': 'Stroje',
    'nav.profile': 'Profil',
    'common.back': 'Zpět',
    'common.cancel': 'Zrušit',
    'common.save': 'Uložit',
    'common.edit': 'Upravit',
    'common.done': 'Hotovo',
    'common.yes': 'Ano',
    'common.no': 'Ne',
    'common.ok': 'OK',
    'common.error': 'Chyba',
    'common.loading': 'Načítání...',
    'common.retry': 'Zkusit znovu',
    'common.search': 'Hledat',
    'common.submit': 'Odeslat',
    'common.confirm': 'Potvrdit',
    'common.close': 'Zavřít',
    'common.pass': 'Splněno',
    'common.fail': 'Nesplněno',
    'common.total': 'celkem',
    'common.today': 'Dnes',
    'common.yesterday': 'Včera',
    'common.online_only': 'Pouze online',
    'common.last_synced': 'Poslední synchronizace',
    'common.back_to_app': 'Zpět do aplikace',
    'common.gps_shared': 'GPS sdílena',
    'common.yes_via_saas': 'Ano — přes SaaS',
    'common.not_called': 'Nezavoláno',
    'login.sign_in': 'Přihlásit se',
    'login.email': 'E-mailová adresa',
    'login.password': 'Heslo',
    'login.forgot_password': 'Zapomenuté heslo?',
    'login.no_account': 'Nemáte účet?',
    'login.request_access': 'Požádat o přístup',
    'login.account_created_by_org': 'Váš účet byl vytvořen vaší organizací.',
    'login.email_placeholder': 'vy@organizace.cz',
    'login.password_placeholder': 'Zadejte heslo',
    'login.error_empty': 'Zadejte e-mail a heslo.',
    'login.error_invalid': 'Neplatný e-mail nebo heslo. Zkuste to znovu.',
    'dashboard.greeting_morning': 'Dobré ráno,',
    'dashboard.greeting_afternoon': 'Dobré odpoledne,',
    'dashboard.greeting_evening': 'Dobrý večer,',
    'dashboard.todays_tasks': 'Dnešní úkoly',
    'dashboard.completed': 'Dokončené',
    'dashboard.overdue': 'Po termínu',
    'dashboard.in_progress': 'Probíhající',
    'dashboard.upcoming': 'Nadcházející',
    'dashboard.pending': 'Čekající',
    'machines.title': 'Stroje',
    'machines.search_placeholder': 'Hledat stroje...',
    'machines.favourites': 'Oblíbené',
    'machines.all_machines': 'Všechny stroje',
    'machines.operational': 'V provozu',
    'machines.needs_attention': 'Vyžaduje pozornost',
    'machines.fault': 'Porucha',
    'machines.unsafe_to_operate': 'Nebezpečné k obsluze',
    'machines.registration': 'SPZ',
    'machines.assigned_operator': 'Přiřazený operátor',
    'machines.engine_hours': 'Provozní hodiny',
    'machines.documents': 'Dokumenty',
    'machines.log_fault': 'Nahlásit poruchu',
    'machines.operator_manual': 'Návod k obsluze',
    'machines.service_record': 'Servisní kniha',
    'machines.insurance': 'Pojistný certifikát',
    'machines.mot': 'Technická kontrola',
    'daily_check.title': 'Denní kontrola',
    'daily_check.start': 'Spustit kontrolu',
    'daily_check.required': 'Vyžadována denní kontrola',
    'daily_check.required_msg': 'Musí být dokončena před obsluhou tohoto stroje.',
    'daily_check.complete': 'Kontrola dokončena',
    'daily_check.complete_msg': 'Dokončeno uživatelem',
    'daily_check.submit': 'Odeslat kontrolu',
    'daily_check.items_remaining': 'zbývajících položek',
    'daily_check.reward_title': 'Děkujeme!',
    'daily_check.reward_subtitle': 'Vaše denní kontrola byla zaznamenána.\nPoctivé kontroly chrání všechny.',
    'daily_check.back_to_machine': 'Zpět ke stroji',
    'daily_check.day_streak': 'Dní v řadě',
    'daily_check.completion_rate': 'Míra dokončení',
    'daily_check.cat_lights': 'Osvětlení a viditelnost',
    'daily_check.cat_fluids': 'Kapaliny',
    'daily_check.cat_tyres': 'Pneumatiky a kola',
    'daily_check.cat_safety': 'Bezpečnost',
    'daily_check.cat_controls': 'Ovládání',
    'daily_check.cat_body': 'Karoserie a příslušenství',
    'daily_check.lights_working': 'Všechna světla fungují',
    'daily_check.mirrors': 'Zrcátka čistá a seřízená',
    'daily_check.windscreen': 'Čelní sklo čisté a nepoškozené',
    'daily_check.engine_oil': 'Hladina motorového oleje',
    'daily_check.coolant': 'Hladina chladicí kapaliny',
    'daily_check.hydraulic': 'Hladina hydraulické kapaliny',
    'daily_check.fuel': 'Dostatečná hladina paliva',
    'daily_check.tyre_pressure': 'Správný tlak v pneumatikách',
    'daily_check.tyre_damage': 'Žádné viditelné poškození pneumatik',
    'daily_check.wheel_nuts': 'Matice kol utaženy',
    'daily_check.fire_extinguisher': 'Hasicí přístroj přítomen',
    'daily_check.first_aid': 'Lékárnička přítomna',
    'daily_check.rops': 'Konstrukce ROPS nepoškozena',
    'daily_check.seatbelt': 'Bezpečnostní pás funkční',
    'daily_check.brakes': 'Brzdy funkční',
    'daily_check.steering': 'Řízení reaguje',
    'daily_check.horn': 'Klakson funkční',
    'daily_check.body_damage': 'Žádné viditelné poškození karoserie',
    'daily_check.attachments': 'Příslušenství zajištěno',
    'daily_check.pto_guard': 'Kryt vývodového hřídele na místě',
    'log_fault.title': 'Nahlásit poruchu',
    'log_fault.description': 'Popis',
    'log_fault.description_placeholder': 'Popište poruchu...',
    'log_fault.photos': 'Fotografie',
    'log_fault.add_photo': 'Přidat fotografii',
    'log_fault.submit': 'Odeslat zprávu o poruše',
    'log_fault.success': 'Porucha nahlášena',
    'emergency.title': 'Nouzová situace',
    'emergency.what_emergency': 'O jakou nouzovou situaci jde?',
    'emergency.select_type': 'Vyberte typ nouzové situace.\nPříslušné kontakty budou okamžitě kontaktovány.',
    'emergency.vibrating': 'Vibruje',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Lékařská nouzová situace',
    'emergency.medical_sub': 'Zranění, nemoc nebo bezvědomá osoba na místě',
    'emergency.calls_999': 'Volá 112 okamžitě',
    'emergency.electrical': 'Elektrická nouzová situace',
    'emergency.electrical_sub': 'Kontakt s elektrickým vedením — zůstaňte v kabině',
    'emergency.calls_105': 'Volá 112 okamžitě',
    'emergency.no_signal': 'Čísla tísňového volání uložena v zařízení — dostupná bez signálu',
    'emergency.gps_auto': 'Poloha GPS sdílena automaticky',
    'emergency.999_called': '112 voláno',
    'emergency.105_called': 'Tísňová linka volána',
    'emergency.services_contacted': 'Záchranné služby byly kontaktovány.\nVáš nadřízený byl také informován.',
    'emergency.power_contacted': 'Elektrická tísňová linka byla kontaktována.\nVáš nadřízený byl také informován.',
    'emergency.emergency_type': 'Typ nouzové situace',
    'emergency.number_called': 'Volaná čísla',
    'emergency.location': 'Poloha',
    'emergency.admin_notified': 'Admin informován',
    'emergency.stay_in_cab': 'Zůstaňte v kabině',
    'emergency.stay_in_cab_msg': 'Nevycházejte z vozidla. Počkejte, dokud orgány nepotvrdí, že vedení je bezpečné. Nechte okna zavřená.',
    'emergency.medical_type': 'Lékařská',
    'emergency.electrical_type': 'Elektrická',
    'crash.are_you_okay': 'Jste v pořádku?',
    'crash.impact_detected': 'Byl detekován možný náraz.\nOdpovězte prosím, nebo bude přivolána pomoc.',
    'crash.im_okay': 'Jsem v pořádku',
    'crash.dismiss_alert': 'Odmítnout alarm — žádná akce',
    'crash.i_need_help': 'Potřebuji pomoc',
    'crash.notify_supervisor': 'Informovat nadřízeného s GPS polohou',
    'crash.call_999': 'Volat 112',
    'crash.call_emergency': 'Volat záchrannou službu okamžitě',
    'crash.glad_okay': 'Rádi, že jste v pořádku',
    'crash.alert_dismissed': 'Alarm odmítnut. Žádné oznámení nebylo odesláno.',
    'crash.help_on_way': 'Pomoc je na cestě',
    'crash.supervisor_notified': 'Váš nadřízený byl informován s vaší GPS polohou.',
    'crash.auto_dialled': '112 vytočeno automaticky',
    'crash.no_response': 'Žádná odpověď. Záchranné služby volány automaticky. Hlasová zpráva je vysílána.',
    'crash.broadcasting': 'Vysílání zprávy',
    'crash.repeating': 'Opakování každých 15 sekund',
    'crash.admin_notified': 'Admin informován',
    'crash.emergency_services': 'Záchranné služby',
    'profile.title': 'Profil',
    'profile.personal_info': 'Osobní informace',
    'profile.full_name': 'Celé jméno',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefon',
    'profile.role': 'Role',
    'profile.organisation': 'Organizace',
    'profile.emergency_contact': 'Nouzový kontakt',
    'profile.emergency_contact_note': 'Váš nadřízený bude kontaktován v nouzové situaci',
    'profile.contact_name': 'Jméno kontaktu',
    'profile.contact_phone': 'Telefon kontaktu',
    'profile.notifications': 'Oznámení',
    'profile.task_reminders': 'Připomínky úkolů',
    'profile.overdue_alerts': 'Upozornění na zpoždění',
    'profile.crash_detection': 'Detekce nárazu',
    'profile.account_security': 'Účet a bezpečnost',
    'profile.change_password': 'Změnit heslo',
    'profile.two_factor': 'Dvoufaktorové ověřování',
    'profile.login_activity': 'Aktivita přihlášení',
    'profile.app_settings': 'Nastavení aplikace',
    'profile.theme': 'Motiv',
    'profile.language': 'Jazyk',
    'profile.sign_out': 'Odhlásit se',
    'profile.sign_out_confirm': 'Odhlásit se',
    'profile.sign_out_msg': 'Opravdu se chcete odhlásit?',
    'profile.field_staff': 'Terénní pracovník',
    'theme.light': 'Světlý',
    'theme.dark': 'Tmavý',
    'theme.system': 'Výchozí systém',
    'set.emails': "E-maily",
    'set.hold_the_yard': "Týdenní e-mail Hold the Yard",
    'set.hold_the_yard_desc': "Každé pondělí souhrn kontrol před použitím za uplynulý týden, zasílaný správcům a vedoucím organizace.",
  },

  'sk': {
    'app.name': 'AgriWare Prevádzka',
    'app.tagline': 'Správa',
    'nav.home': 'Domov',
    'nav.machines': 'Stroje',
    'nav.profile': 'Profil',
    'common.back': 'Späť',
    'common.cancel': 'Zrušiť',
    'common.save': 'Uložiť',
    'common.edit': 'Upraviť',
    'common.done': 'Hotovo',
    'common.yes': 'Áno',
    'common.no': 'Nie',
    'common.ok': 'OK',
    'common.error': 'Chyba',
    'common.loading': 'Načítavanie...',
    'common.retry': 'Skúsiť znova',
    'common.search': 'Hľadať',
    'common.submit': 'Odoslať',
    'common.confirm': 'Potvrdiť',
    'common.close': 'Zavrieť',
    'common.pass': 'Splnené',
    'common.fail': 'Nesplnené',
    'common.total': 'celkom',
    'common.today': 'Dnes',
    'common.yesterday': 'Včera',
    'common.online_only': 'Iba online',
    'common.last_synced': 'Posledná synchronizácia',
    'common.back_to_app': 'Späť do aplikácie',
    'common.gps_shared': 'GPS zdieľaná',
    'common.yes_via_saas': 'Áno — cez SaaS',
    'common.not_called': 'Nezavolané',
    'login.sign_in': 'Prihlásiť sa',
    'login.email': 'E-mailová adresa',
    'login.password': 'Heslo',
    'login.forgot_password': 'Zabudnuté heslo?',
    'login.no_account': 'Nemáte účet?',
    'login.request_access': 'Požiadať o prístup',
    'login.account_created_by_org': 'Váš účet bol vytvorený vašou organizáciou.',
    'login.email_placeholder': 'vy@organizacia.sk',
    'login.password_placeholder': 'Zadajte heslo',
    'login.error_empty': 'Zadajte e-mail a heslo.',
    'login.error_invalid': 'Neplatný e-mail alebo heslo. Skúste znova.',
    'dashboard.greeting_morning': 'Dobré ráno,',
    'dashboard.greeting_afternoon': 'Dobré popoludnie,',
    'dashboard.greeting_evening': 'Dobrý večer,',
    'dashboard.todays_tasks': 'Dnešné úlohy',
    'dashboard.completed': 'Dokončené',
    'dashboard.overdue': 'Po termíne',
    'dashboard.in_progress': 'Prebieha',
    'dashboard.upcoming': 'Nadchádzajúce',
    'dashboard.pending': 'Čakajúce',
    'machines.title': 'Stroje',
    'machines.search_placeholder': 'Hľadať stroje...',
    'machines.favourites': 'Obľúbené',
    'machines.all_machines': 'Všetky stroje',
    'machines.operational': 'V prevádzke',
    'machines.needs_attention': 'Vyžaduje pozornosť',
    'machines.fault': 'Porucha',
    'machines.unsafe_to_operate': 'Nebezpečné na prevádzku',
    'machines.registration': 'ŠPZ',
    'machines.assigned_operator': 'Priradený operátor',
    'machines.engine_hours': 'Prevádzkové hodiny',
    'machines.documents': 'Dokumenty',
    'machines.log_fault': 'Nahlásiť poruchu',
    'machines.operator_manual': 'Návod na obsluhu',
    'machines.service_record': 'Servisná kniha',
    'machines.insurance': 'Poistný certifikát',
    'machines.mot': 'Technická kontrola',
    'daily_check.title': 'Denná kontrola',
    'daily_check.start': 'Spustiť kontrolu',
    'daily_check.required': 'Vyžaduje sa denná kontrola',
    'daily_check.required_msg': 'Musí byť dokončená pred obsluhou tohto stroja.',
    'daily_check.complete': 'Kontrola dokončená',
    'daily_check.complete_msg': 'Dokončené používateľom',
    'daily_check.submit': 'Odoslať kontrolu',
    'daily_check.items_remaining': 'zostávajúcich položiek',
    'daily_check.reward_title': 'Ďakujeme!',
    'daily_check.reward_subtitle': 'Vaša denná kontrola bola zaznamenaná.\nPoctivé kontroly chránia všetkých.',
    'daily_check.back_to_machine': 'Späť k stroju',
    'daily_check.day_streak': 'Dní za sebou',
    'daily_check.completion_rate': 'Miera dokončenia',
    'daily_check.cat_lights': 'Osvetlenie a viditeľnosť',
    'daily_check.cat_fluids': 'Kvapaliny',
    'daily_check.cat_tyres': 'Pneumatiky a kolesá',
    'daily_check.cat_safety': 'Bezpečnosť',
    'daily_check.cat_controls': 'Ovládanie',
    'daily_check.cat_body': 'Karoséria a príslušenstvo',
    'daily_check.lights_working': 'Všetky svetlá fungujú',
    'daily_check.mirrors': 'Zrkadlá čisté a nastavené',
    'daily_check.windscreen': 'Čelné sklo čisté a nepoškodené',
    'daily_check.engine_oil': 'Hladina motorového oleja',
    'daily_check.coolant': 'Hladina chladiacej kvapaliny',
    'daily_check.hydraulic': 'Hladina hydraulickej kvapaliny',
    'daily_check.fuel': 'Dostatočná hladina paliva',
    'daily_check.tyre_pressure': 'Správny tlak v pneumatikách',
    'daily_check.tyre_damage': 'Žiadne viditeľné poškodenie pneumatík',
    'daily_check.wheel_nuts': 'Matice kolies utiahnuté',
    'daily_check.fire_extinguisher': 'Hasiaci prístroj prítomný',
    'daily_check.first_aid': 'Lekárnička prítomná',
    'daily_check.rops': 'Konštrukcia ROPS nepoškodená',
    'daily_check.seatbelt': 'Bezpečnostný pás funkčný',
    'daily_check.brakes': 'Brzdy funkčné',
    'daily_check.steering': 'Riadenie reaguje',
    'daily_check.horn': 'Klaksón funkčný',
    'daily_check.body_damage': 'Žiadne viditeľné poškodenie karosérie',
    'daily_check.attachments': 'Príslušenstvo zaistené',
    'daily_check.pto_guard': 'Kryt vývodového hriadeľa na mieste',
    'log_fault.title': 'Nahlásiť poruchu',
    'log_fault.description': 'Popis',
    'log_fault.description_placeholder': 'Opíšte poruchu...',
    'log_fault.photos': 'Fotografie',
    'log_fault.add_photo': 'Pridať fotografiu',
    'log_fault.submit': 'Odoslať správu o poruche',
    'log_fault.success': 'Porucha nahlásená',
    'emergency.title': 'Núdzová situácia',
    'emergency.what_emergency': 'O akú núdzovú situáciu ide?',
    'emergency.select_type': 'Vyberte typ núdzovej situácie.\nPríslušné kontakty budú okamžite kontaktované.',
    'emergency.vibrating': 'Vibruje',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Lekárska núdzová situácia',
    'emergency.medical_sub': 'Zranenie, choroba alebo bezvedomá osoba na mieste',
    'emergency.calls_999': 'Volá 112 okamžite',
    'emergency.electrical': 'Elektrická núdzová situácia',
    'emergency.electrical_sub': 'Kontakt s elektrickým vedením — zostaňte v kabíne',
    'emergency.calls_105': 'Volá 112 okamžite',
    'emergency.no_signal': 'Čísla tiesňového volania uložené v zariadení — dostupné bez signálu',
    'emergency.gps_auto': 'Poloha GPS zdieľaná automaticky',
    'emergency.999_called': '112 volané',
    'emergency.105_called': 'Tiesňová linka volaná',
    'emergency.services_contacted': 'Záchranné služby boli kontaktované.\nVáš nadriadený bol tiež informovaný.',
    'emergency.power_contacted': 'Elektrická tiesňová linka bola kontaktovaná.\nVáš nadriadený bol tiež informovaný.',
    'emergency.emergency_type': 'Typ núdzovej situácie',
    'emergency.number_called': 'Volané číslo',
    'emergency.location': 'Poloha',
    'emergency.admin_notified': 'Admin informovaný',
    'emergency.stay_in_cab': 'Zostaňte v kabíne',
    'emergency.stay_in_cab_msg': 'Nevychádzajte z vozidla. Počkajte, kým orgány nepotvrdí, že vedenie je bezpečné. Nechajte okná zatvorené.',
    'emergency.medical_type': 'Lekárska',
    'emergency.electrical_type': 'Elektrická',
    'crash.are_you_okay': 'Ste v poriadku?',
    'crash.impact_detected': 'Bol detegovaný možný náraz.\nOdpoveďte prosím, alebo bude privolaná pomoc.',
    'crash.im_okay': 'Som v poriadku',
    'crash.dismiss_alert': 'Zamietnuť alarm — žiadna akcia',
    'crash.i_need_help': 'Potrebujem pomoc',
    'crash.notify_supervisor': 'Informovať nadriadeného s GPS polohou',
    'crash.call_999': 'Volať 112',
    'crash.call_emergency': 'Volať záchranné služby okamžite',
    'crash.glad_okay': 'Radi, že ste v poriadku',
    'crash.alert_dismissed': 'Alarm zamietnutý. Žiadne oznámenie nebolo odoslané.',
    'crash.help_on_way': 'Pomoc je na ceste',
    'crash.supervisor_notified': 'Váš nadriadený bol informovaný s vašou GPS polohou.',
    'crash.auto_dialled': '112 vytočené automaticky',
    'crash.no_response': 'Žiadna odpoveď. Záchranné služby volané automaticky. Hlasová správa je vysielaná.',
    'crash.broadcasting': 'Vysielanie správy',
    'crash.repeating': 'Opakovanie každých 15 sekúnd',
    'crash.admin_notified': 'Admin informovaný',
    'crash.emergency_services': 'Záchranné služby',
    'profile.title': 'Profil',
    'profile.personal_info': 'Osobné informácie',
    'profile.full_name': 'Celé meno',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefón',
    'profile.role': 'Rola',
    'profile.organisation': 'Organizácia',
    'profile.emergency_contact': 'Núdzový kontakt',
    'profile.emergency_contact_note': 'Váš nadriadený bude kontaktovaný v núdzovej situácii',
    'profile.contact_name': 'Meno kontaktu',
    'profile.contact_phone': 'Telefón kontaktu',
    'profile.notifications': 'Oznámenia',
    'profile.task_reminders': 'Pripomienky úloh',
    'profile.overdue_alerts': 'Upozornenia na omeškanie',
    'profile.crash_detection': 'Detekcia nárazu',
    'profile.account_security': 'Účet a bezpečnosť',
    'profile.change_password': 'Zmeniť heslo',
    'profile.two_factor': 'Dvojfaktorové overenie',
    'profile.login_activity': 'Aktivita prihlásenia',
    'profile.app_settings': 'Nastavenia aplikácie',
    'profile.theme': 'Téma',
    'profile.language': 'Jazyk',
    'profile.sign_out': 'Odhlásiť sa',
    'profile.sign_out_confirm': 'Odhlásiť sa',
    'profile.sign_out_msg': 'Naozaj sa chcete odhlásiť?',
    'profile.field_staff': 'Terénny pracovník',
    'theme.light': 'Svetlá',
    'theme.dark': 'Tmavá',
    'theme.system': 'Predvolená systému',
    'set.emails': "E-maily",
    'set.hold_the_yard': "Týždenný e-mail Hold the Yard",
    'set.hold_the_yard_desc': "Každý pondelok súhrn kontrol pred použitím za uplynulý týždeň, zasielaný správcom a vedúcim organizácie.",
  },

  'hu': {
    'app.name': 'AgriWare Műveletek',
    'app.tagline': 'Kezelés',
    'nav.home': 'Főoldal',
    'nav.machines': 'Gépek',
    'nav.profile': 'Profil',
    'common.back': 'Vissza',
    'common.cancel': 'Mégse',
    'common.save': 'Mentés',
    'common.edit': 'Szerkesztés',
    'common.done': 'Kész',
    'common.yes': 'Igen',
    'common.no': 'Nem',
    'common.ok': 'OK',
    'common.error': 'Hiba',
    'common.loading': 'Betöltés...',
    'common.retry': 'Újra',
    'common.search': 'Keresés',
    'common.submit': 'Küldés',
    'common.confirm': 'Megerősítés',
    'common.close': 'Bezárás',
    'common.pass': 'Megfelelt',
    'common.fail': 'Nem felelt meg',
    'common.total': 'összesen',
    'common.today': 'Ma',
    'common.yesterday': 'Tegnap',
    'common.online_only': 'Csak online',
    'common.last_synced': 'Utolsó szinkronizálás',
    'common.back_to_app': 'Vissza az alkalmazásba',
    'common.gps_shared': 'GPS megosztva',
    'common.yes_via_saas': 'Igen — SaaS-on keresztül',
    'common.not_called': 'Nem hívták',
    'login.sign_in': 'Bejelentkezés',
    'login.email': 'E-mail cím',
    'login.password': 'Jelszó',
    'login.forgot_password': 'Elfelejtette jelszavát?',
    'login.no_account': 'Nincs fiókja?',
    'login.request_access': 'Hozzáférés kérése',
    'login.account_created_by_org': 'Fiókját a szervezete hozta létre.',
    'login.email_placeholder': 'on@szervezet.hu',
    'login.password_placeholder': 'Adja meg jelszavát',
    'login.error_empty': 'Adja meg e-mail címét és jelszavát.',
    'login.error_invalid': 'Érvénytelen e-mail vagy jelszó. Kérjük, próbálja újra.',
    'dashboard.greeting_morning': 'Jó reggelt,',
    'dashboard.greeting_afternoon': 'Jó napot,',
    'dashboard.greeting_evening': 'Jó estét,',
    'dashboard.todays_tasks': 'Mai feladatok',
    'dashboard.completed': 'Befejezett',
    'dashboard.overdue': 'Késedelmes',
    'dashboard.in_progress': 'Folyamatban',
    'dashboard.upcoming': 'Közelgő',
    'dashboard.pending': 'Függőben',
    'machines.title': 'Gépek',
    'machines.search_placeholder': 'Gépek keresése...',
    'machines.favourites': 'Kedvencek',
    'machines.all_machines': 'Összes gép',
    'machines.operational': 'Üzemkész',
    'machines.needs_attention': 'Figyelmet igényel',
    'machines.fault': 'Hiba',
    'machines.unsafe_to_operate': 'Nem biztonságos üzemeltetni',
    'machines.registration': 'Rendszám',
    'machines.assigned_operator': 'Kijelölt kezelő',
    'machines.engine_hours': 'Üzemórák',
    'machines.documents': 'Dokumentumok',
    'machines.log_fault': 'Hiba bejelentése',
    'machines.operator_manual': 'Kezelési útmutató',
    'machines.service_record': 'Szervizkönyv',
    'machines.insurance': 'Biztosítási igazolás',
    'machines.mot': 'Műszaki vizsga',
    'daily_check.title': 'Napi ellenőrzés',
    'daily_check.start': 'Ellenőrzés indítása',
    'daily_check.required': 'Napi ellenőrzés szükséges',
    'daily_check.required_msg': 'A gép üzemeltetése előtt el kell végezni.',
    'daily_check.complete': 'Ellenőrzés befejezve',
    'daily_check.complete_msg': 'Elvégezte',
    'daily_check.submit': 'Ellenőrzés beküldése',
    'daily_check.items_remaining': 'elem hátralévő',
    'daily_check.reward_title': 'Köszönjük!',
    'daily_check.reward_subtitle': 'Napi ellenőrzése rögzítve.\nAz őszinte ellenőrzések mindenkit biztonságban tartanak.',
    'daily_check.back_to_machine': 'Vissza a géphez',
    'daily_check.day_streak': 'Napos sorozat',
    'daily_check.completion_rate': 'Teljesítési arány',
    'daily_check.cat_lights': 'Világítás és láthatóság',
    'daily_check.cat_fluids': 'Folyadékok',
    'daily_check.cat_tyres': 'Gumiabroncsok és kerekek',
    'daily_check.cat_safety': 'Biztonság',
    'daily_check.cat_controls': 'Vezérlés',
    'daily_check.cat_body': 'Karosszéria és tartozékok',
    'daily_check.lights_working': 'Minden lámpa működik',
    'daily_check.mirrors': 'Tükrök tiszták és beállítottak',
    'daily_check.windscreen': 'Szélvédő tiszta és sértetlen',
    'daily_check.engine_oil': 'Motorolaj szint',
    'daily_check.coolant': 'Hűtőfolyadék szint',
    'daily_check.hydraulic': 'Hidraulikaolaj szint',
    'daily_check.fuel': 'Megfelelő üzemanyagszint',
    'daily_check.tyre_pressure': 'Helyes gumiabroncsnyomás',
    'daily_check.tyre_damage': 'Nincs látható gumiabroncs-sérülés',
    'daily_check.wheel_nuts': 'Kerékanyák meghúzva',
    'daily_check.fire_extinguisher': 'Tűzoltó készülék megvan',
    'daily_check.first_aid': 'Elsősegély-csomag megvan',
    'daily_check.rops': 'ROPS szerkezet sértetlen',
    'daily_check.seatbelt': 'Biztonsági öv működik',
    'daily_check.brakes': 'Fékek működnek',
    'daily_check.steering': 'Kormányzás reagál',
    'daily_check.horn': 'Kürt működik',
    'daily_check.body_damage': 'Nincs látható karosszéria-sérülés',
    'daily_check.attachments': 'Tartozékok rögzítve',
    'daily_check.pto_guard': 'Kardántengelyvédő a helyén',
    'log_fault.title': 'Hiba bejelentése',
    'log_fault.description': 'Leírás',
    'log_fault.description_placeholder': 'Írja le a hibát...',
    'log_fault.photos': 'Fényképek',
    'log_fault.add_photo': 'Fénykép hozzáadása',
    'log_fault.submit': 'Hibajelentés beküldése',
    'log_fault.success': 'Hiba sikeresen bejelentve',
    'emergency.title': 'Vészhelyzet',
    'emergency.what_emergency': 'Mi a vészhelyzet?',
    'emergency.select_type': 'Válassza ki a vészhelyzet típusát.\nA megfelelő kapcsolattartókat azonnal értesítik.',
    'emergency.vibrating': 'Vibrál',
    'emergency.alarm': 'Riasztó',
    'emergency.medical': 'Orvosi vészhelyzet',
    'emergency.medical_sub': 'Sérülés, betegség vagy eszméletlen személy a helyszínen',
    'emergency.calls_999': 'Azonnal hívja a 112-t',
    'emergency.electrical': 'Elektromos vészhelyzet',
    'emergency.electrical_sub': 'Villanyvezeték-érintkezés — maradjon a fülkében',
    'emergency.calls_105': 'Azonnal hívja a 112-t',
    'emergency.no_signal': 'Vészhelyzeti számok tárolva az eszközön — jel nélkül is elérhetők',
    'emergency.gps_auto': 'GPS-pozíció automatikusan megosztva',
    'emergency.999_called': '112 hívva',
    'emergency.105_called': 'Vészhelyzeti vonal hívva',
    'emergency.services_contacted': 'A mentőszolgálatot értesítettük.\nA felettesét is értesítettük.',
    'emergency.power_contacted': 'Az elektromos vészhelyzeti vonalat értesítettük.\nA felettesét is értesítettük.',
    'emergency.emergency_type': 'Vészhelyzet típusa',
    'emergency.number_called': 'Hívott szám',
    'emergency.location': 'Helyszín',
    'emergency.admin_notified': 'Admin értesítve',
    'emergency.stay_in_cab': 'Maradjon a fülkében',
    'emergency.stay_in_cab_msg': 'Ne szálljon ki a járműből. Várja meg, amíg a hatóság megerősíti, hogy a vonal biztonságos. Tartsa zárva az ablakokat.',
    'emergency.medical_type': 'Orvosi',
    'emergency.electrical_type': 'Elektromos',
    'crash.are_you_okay': 'Jól van?',
    'crash.impact_detected': 'Lehetséges ütközést észleltek.\nKérjük, válaszoljon, különben segítséget hívnak.',
    'crash.im_okay': 'Jól vagyok',
    'crash.dismiss_alert': 'Riasztás elutasítása — nincs intézkedés',
    'crash.i_need_help': 'Segítségre van szükségem',
    'crash.notify_supervisor': 'Felettes értesítése GPS-pozícióval',
    'crash.call_999': 'Hívja a 112-t',
    'crash.call_emergency': 'Azonnal hívja a mentőszolgálatot',
    'crash.glad_okay': 'Örülünk, hogy jól van',
    'crash.alert_dismissed': 'Riasztás elutasítva. Nem küldtek értesítést.',
    'crash.help_on_way': 'Segítség úton van',
    'crash.supervisor_notified': 'Felettesét értesítettük GPS-pozíciójával.',
    'crash.auto_dialled': '112 automatikusan tárcsázva',
    'crash.no_response': 'Nincs válasz. A mentőszolgálatot automatikusan értesítettük. Hangüzenet közvetítése folyamatban.',
    'crash.broadcasting': 'Üzenet közvetítése',
    'crash.repeating': '15 másodpercenként ismétlés',
    'crash.admin_notified': 'Admin értesítve',
    'crash.emergency_services': 'Mentőszolgálat',
    'profile.title': 'Profil',
    'profile.personal_info': 'Személyes adatok',
    'profile.full_name': 'Teljes név',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefon',
    'profile.role': 'Szerepkör',
    'profile.organisation': 'Szervezet',
    'profile.emergency_contact': 'Vészhelyzeti kapcsolat',
    'profile.emergency_contact_note': 'Vészhelyzetben felettesét értesítik',
    'profile.contact_name': 'Kapcsolattartó neve',
    'profile.contact_phone': 'Kapcsolattartó telefonszáma',
    'profile.notifications': 'Értesítések',
    'profile.task_reminders': 'Feladatemlékeztetők',
    'profile.overdue_alerts': 'Késedelmi riasztások',
    'profile.crash_detection': 'Ütközésérzékelés',
    'profile.account_security': 'Fiók és biztonság',
    'profile.change_password': 'Jelszó módosítása',
    'profile.two_factor': 'Kétfaktoros hitelesítés',
    'profile.login_activity': 'Bejelentkezési tevékenység',
    'profile.app_settings': 'Alkalmazás beállításai',
    'profile.theme': 'Téma',
    'profile.language': 'Nyelv',
    'profile.sign_out': 'Kijelentkezés',
    'profile.sign_out_confirm': 'Kijelentkezés',
    'profile.sign_out_msg': 'Biztosan ki szeretne jelentkezni?',
    'profile.field_staff': 'Terepi munkatárs',
    'theme.light': 'Világos',
    'theme.dark': 'Sötét',
    'theme.system': 'Rendszer alapértelmezett',
    'set.emails': "E-mailek",
    'set.hold_the_yard': "Heti Hold the Yard e-mail",
    'set.hold_the_yard_desc': "Minden hétfőn összefoglaló az előző heti használat előtti ellenőrzésekről, a szervezet adminisztrátorainak és vezetőinek.",
  },

  'ro': {
    'app.name': 'AgriWare Operațiuni',
    'app.tagline': 'Management',
    'nav.home': 'Acasă',
    'nav.machines': 'Mașini',
    'nav.profile': 'Profil',
    'common.back': 'Înapoi',
    'common.cancel': 'Anulare',
    'common.save': 'Salvare',
    'common.edit': 'Editare',
    'common.done': 'Gata',
    'common.yes': 'Da',
    'common.no': 'Nu',
    'common.ok': 'OK',
    'common.error': 'Eroare',
    'common.loading': 'Se încarcă...',
    'common.retry': 'Reîncercați',
    'common.search': 'Căutare',
    'common.submit': 'Trimite',
    'common.confirm': 'Confirmare',
    'common.close': 'Închide',
    'common.pass': 'Trecut',
    'common.fail': 'Eșuat',
    'common.total': 'total',
    'common.today': 'Azi',
    'common.yesterday': 'Ieri',
    'common.online_only': 'Doar online',
    'common.last_synced': 'Ultima sincronizare',
    'common.back_to_app': 'Înapoi la aplicație',
    'common.gps_shared': 'GPS partajat',
    'common.yes_via_saas': 'Da — prin SaaS',
    'common.not_called': 'Neapelat',
    'login.sign_in': 'Conectare',
    'login.email': 'Adresă de e-mail',
    'login.password': 'Parolă',
    'login.forgot_password': 'Ați uitat parola?',
    'login.no_account': 'Nu aveți cont?',
    'login.request_access': 'Solicitați acces',
    'login.account_created_by_org': 'Contul dvs. a fost creat de organizația dvs.',
    'login.email_placeholder': 'dvs@organizatie.ro',
    'login.password_placeholder': 'Introduceți parola',
    'login.error_empty': 'Introduceți e-mailul și parola.',
    'login.error_invalid': 'E-mail sau parolă invalidă. Încercați din nou.',
    'dashboard.greeting_morning': 'Bună dimineața,',
    'dashboard.greeting_afternoon': 'Bună ziua,',
    'dashboard.greeting_evening': 'Bună seara,',
    'dashboard.todays_tasks': 'Sarcinile de astăzi',
    'dashboard.completed': 'Finalizate',
    'dashboard.overdue': 'Întârziate',
    'dashboard.in_progress': 'În curs',
    'dashboard.upcoming': 'Viitoare',
    'dashboard.pending': 'În așteptare',
    'machines.title': 'Mașini',
    'machines.search_placeholder': 'Căutați mașini...',
    'machines.favourites': 'Favorite',
    'machines.all_machines': 'Toate mașinile',
    'machines.operational': 'Operațional',
    'machines.needs_attention': 'Necesită atenție',
    'machines.fault': 'Defecțiune',
    'machines.unsafe_to_operate': 'Nesigur de operat',
    'machines.registration': 'Înmatriculare',
    'machines.assigned_operator': 'Operator atribuit',
    'machines.engine_hours': 'Ore motor',
    'machines.documents': 'Documente',
    'machines.log_fault': 'Înregistrați defecțiunea',
    'machines.operator_manual': 'Manual operator',
    'machines.service_record': 'Carte service',
    'machines.insurance': 'Certificat de asigurare',
    'machines.mot': 'ITP',
    'daily_check.title': 'Verificare zilnică',
    'daily_check.start': 'Începeți verificarea',
    'daily_check.required': 'Verificare zilnică necesară',
    'daily_check.required_msg': 'Trebuie finalizată înainte de operarea acestei mașini.',
    'daily_check.complete': 'Verificare finalizată',
    'daily_check.complete_msg': 'Finalizat de',
    'daily_check.submit': 'Trimiteți verificarea',
    'daily_check.items_remaining': 'elemente rămase',
    'daily_check.reward_title': 'Mulțumim!',
    'daily_check.reward_subtitle': 'Verificarea zilnică a fost înregistrată.\nVerificările oneste îi țin pe toți în siguranță.',
    'daily_check.back_to_machine': 'Înapoi la mașină',
    'daily_check.day_streak': 'Zile consecutive',
    'daily_check.completion_rate': 'Rata de finalizare',
    'daily_check.cat_lights': 'Lumini și vizibilitate',
    'daily_check.cat_fluids': 'Fluide',
    'daily_check.cat_tyres': 'Anvelope și roți',
    'daily_check.cat_safety': 'Siguranță',
    'daily_check.cat_controls': 'Comenzi',
    'daily_check.cat_body': 'Caroserie și accesorii',
    'daily_check.lights_working': 'Toate luminile funcționează',
    'daily_check.mirrors': 'Oglinzi curate și reglate',
    'daily_check.windscreen': 'Parbriz curat și intact',
    'daily_check.engine_oil': 'Nivel ulei motor',
    'daily_check.coolant': 'Nivel lichid de răcire',
    'daily_check.hydraulic': 'Nivel lichid hidraulic',
    'daily_check.fuel': 'Nivel combustibil adecvat',
    'daily_check.tyre_pressure': 'Presiune anvelope corectă',
    'daily_check.tyre_damage': 'Fără deteriorări vizibile ale anvelopelor',
    'daily_check.wheel_nuts': 'Piulițe roți strânse',
    'daily_check.fire_extinguisher': 'Stingător prezent',
    'daily_check.first_aid': 'Trusă prim ajutor prezentă',
    'daily_check.rops': 'Structură ROPS intactă',
    'daily_check.seatbelt': 'Centură de siguranță funcționează',
    'daily_check.brakes': 'Frânele funcționează',
    'daily_check.steering': 'Direcția răspunde',
    'daily_check.horn': 'Claxonul funcționează',
    'daily_check.body_damage': 'Fără deteriorări vizibile ale caroseriei',
    'daily_check.attachments': 'Accesorii fixate',
    'daily_check.pto_guard': 'Apărătoare priză de putere la loc',
    'log_fault.title': 'Înregistrați defecțiunea',
    'log_fault.description': 'Descriere',
    'log_fault.description_placeholder': 'Descrieți defecțiunea...',
    'log_fault.photos': 'Fotografii',
    'log_fault.add_photo': 'Adăugați fotografie',
    'log_fault.submit': 'Trimiteți raportul',
    'log_fault.success': 'Defecțiune înregistrată cu succes',
    'emergency.title': 'Urgență',
    'emergency.what_emergency': 'Care este urgența?',
    'emergency.select_type': 'Selectați tipul de urgență.\nContactele corespunzătoare vor fi apelate imediat.',
    'emergency.vibrating': 'Vibrează',
    'emergency.alarm': 'Alarmă',
    'emergency.medical': 'Urgență medicală',
    'emergency.medical_sub': 'Rănire, boală sau persoană inconștientă la fața locului',
    'emergency.calls_999': 'Apelează 112 imediat',
    'emergency.electrical': 'Urgență electrică',
    'emergency.electrical_sub': 'Contact cu linie electrică — rămâneți în cabină',
    'emergency.calls_105': 'Apelează 112 imediat',
    'emergency.no_signal': 'Numerele de urgență stocate pe dispozitiv — disponibile fără semnal',
    'emergency.gps_auto': 'Poziție GPS partajată automat',
    'emergency.999_called': '112 apelat',
    'emergency.105_called': 'Linie urgență apelată',
    'emergency.services_contacted': 'Serviciile de urgență au fost contactate.\nSupervizorii dvs. au fost de asemenea notificați.',
    'emergency.power_contacted': 'Linia de urgență electrică a fost contactată.\nSupervizorii dvs. au fost de asemenea notificați.',
    'emergency.emergency_type': 'Tipul urgenței',
    'emergency.number_called': 'Număr apelat',
    'emergency.location': 'Locație',
    'emergency.admin_notified': 'Admin notificat',
    'emergency.stay_in_cab': 'Rămâneți în cabină',
    'emergency.stay_in_cab_msg': 'Nu ieșiți din vehicul. Așteptați până când autoritatea confirmă că linia este sigură. Țineți geamurile închise.',
    'emergency.medical_type': 'Medicală',
    'emergency.electrical_type': 'Electrică',
    'crash.are_you_okay': 'Sunteți bine?',
    'crash.impact_detected': 'A fost detectat un posibil impact.\nVă rugăm să răspundeți sau va fi chemată ajutor.',
    'crash.im_okay': 'Sunt bine',
    'crash.dismiss_alert': 'Respingeți alerta — fără acțiune',
    'crash.i_need_help': 'Am nevoie de ajutor',
    'crash.notify_supervisor': 'Notificați supervizorul cu poziția GPS',
    'crash.call_999': 'Apelați 112',
    'crash.call_emergency': 'Apelați serviciile de urgență imediat',
    'crash.glad_okay': 'Ne bucurăm că sunteți bine',
    'crash.alert_dismissed': 'Alertă respinsă. Nu a fost trimisă nicio notificare.',
    'crash.help_on_way': 'Ajutorul este pe drum',
    'crash.supervisor_notified': 'Supervizorul dvs. a fost notificat cu poziția dvs. GPS.',
    'crash.auto_dialled': '112 format automat',
    'crash.no_response': 'Niciun răspuns. Serviciile de urgență apelate automat. Mesaj vocal în transmisie.',
    'crash.broadcasting': 'Transmitere mesaj',
    'crash.repeating': 'Repetare la fiecare 15 secunde',
    'crash.admin_notified': 'Admin notificat',
    'crash.emergency_services': 'Servicii de urgență',
    'profile.title': 'Profil',
    'profile.personal_info': 'Informații personale',
    'profile.full_name': 'Nume complet',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefon',
    'profile.role': 'Rol',
    'profile.organisation': 'Organizație',
    'profile.emergency_contact': 'Contact de urgență',
    'profile.emergency_contact_note': 'Supervizorul dvs. va fi contactat în caz de urgență',
    'profile.contact_name': 'Numele contactului',
    'profile.contact_phone': 'Telefonul contactului',
    'profile.notifications': 'Notificări',
    'profile.task_reminders': 'Memento-uri sarcini',
    'profile.overdue_alerts': 'Alerte întârziere',
    'profile.crash_detection': 'Detectare impact',
    'profile.account_security': 'Cont și securitate',
    'profile.change_password': 'Schimbați parola',
    'profile.two_factor': 'Autentificare cu doi factori',
    'profile.login_activity': 'Activitate de conectare',
    'profile.app_settings': 'Setări aplicație',
    'profile.theme': 'Temă',
    'profile.language': 'Limbă',
    'profile.sign_out': 'Deconectare',
    'profile.sign_out_confirm': 'Deconectare',
    'profile.sign_out_msg': 'Sigur doriți să vă deconectați?',
    'profile.field_staff': 'Personal de teren',
    'theme.light': 'Deschis',
    'theme.dark': 'Întunecat',
    'theme.system': 'Implicit sistem',
    'set.emails': "E-mailuri",
    'set.hold_the_yard': "E-mail săptămânal Hold the Yard",
    'set.hold_the_yard_desc': "În fiecare luni, un rezumat al verificărilor dinaintea utilizării din săptămâna precedentă, trimis administratorilor și managerilor organizației.",
  },

  'bg': {
    'app.name': 'AgriWare Операции',
    'app.tagline': 'Управление',
    'nav.home': 'Начало',
    'nav.machines': 'Машини',
    'nav.profile': 'Профил',
    'common.back': 'Назад',
    'common.cancel': 'Отказ',
    'common.save': 'Запазване',
    'common.edit': 'Редактиране',
    'common.done': 'Готово',
    'common.yes': 'Да',
    'common.no': 'Не',
    'common.ok': 'OK',
    'common.error': 'Грешка',
    'common.loading': 'Зареждане...',
    'common.retry': 'Опитайте отново',
    'common.search': 'Търсене',
    'common.submit': 'Изпращане',
    'common.confirm': 'Потвърждение',
    'common.close': 'Затваряне',
    'common.pass': 'Преминато',
    'common.fail': 'Неуспешно',
    'common.total': 'общо',
    'common.today': 'Днес',
    'common.yesterday': 'Вчера',
    'common.online_only': 'Само онлайн',
    'common.last_synced': 'Последна синхронизация',
    'common.back_to_app': 'Обратно към приложението',
    'common.gps_shared': 'GPS споделен',
    'common.yes_via_saas': 'Да — чрез SaaS',
    'common.not_called': 'Не е повикан',
    'login.sign_in': 'Влизане',
    'login.email': 'Имейл адрес',
    'login.password': 'Парола',
    'login.forgot_password': 'Забравена парола?',
    'login.no_account': 'Нямате акаунт?',
    'login.request_access': 'Заявете достъп',
    'login.account_created_by_org': 'Акаунтът ви е създаден от вашата организация.',
    'login.email_placeholder': 'вие@организация.bg',
    'login.password_placeholder': 'Въведете паролата си',
    'login.error_empty': 'Моля, въведете имейл и парола.',
    'login.error_invalid': 'Невалиден имейл или парола. Опитайте отново.',
    'dashboard.greeting_morning': 'Добро утро,',
    'dashboard.greeting_afternoon': 'Добър ден,',
    'dashboard.greeting_evening': 'Добър вечер,',
    'dashboard.todays_tasks': 'Задачи за днес',
    'dashboard.completed': 'Завършени',
    'dashboard.overdue': 'Закъснели',
    'dashboard.in_progress': 'В процес',
    'dashboard.upcoming': 'Предстоящи',
    'dashboard.pending': 'Чакащи',
    'machines.title': 'Машини',
    'machines.search_placeholder': 'Търсене на машини...',
    'machines.favourites': 'Любими',
    'machines.all_machines': 'Всички машини',
    'machines.operational': 'Работоспособна',
    'machines.needs_attention': 'Изисква внимание',
    'machines.fault': 'Неизправност',
    'machines.unsafe_to_operate': 'Небезопасна за работа',
    'machines.registration': 'Регистрация',
    'machines.assigned_operator': 'Назначен оператор',
    'machines.engine_hours': 'Работни часове',
    'machines.documents': 'Документи',
    'machines.log_fault': 'Докладване на неизправност',
    'machines.operator_manual': 'Ръководство за оператора',
    'machines.service_record': 'Сервизна книжка',
    'machines.insurance': 'Застрахователен сертификат',
    'machines.mot': 'Технически преглед',
    'daily_check.title': 'Ежедневна проверка',
    'daily_check.start': 'Стартиране на проверката',
    'daily_check.required': 'Необходима ежедневна проверка',
    'daily_check.required_msg': 'Трябва да бъде завършена преди работа с тази машина.',
    'daily_check.complete': 'Проверката е завършена',
    'daily_check.complete_msg': 'Завършена от',
    'daily_check.submit': 'Изпращане на проверката',
    'daily_check.items_remaining': 'оставащи елементи',
    'daily_check.reward_title': 'Благодарим!',
    'daily_check.reward_subtitle': 'Вашата ежедневна проверка е записана.\nЧестните проверки пазят всички в безопасност.',
    'daily_check.back_to_machine': 'Обратно към машината',
    'daily_check.day_streak': 'Поредни дни',
    'daily_check.completion_rate': 'Степен на завършване',
    'daily_check.cat_lights': 'Осветление и видимост',
    'daily_check.cat_fluids': 'Течности',
    'daily_check.cat_tyres': 'Гуми и колела',
    'daily_check.cat_safety': 'Безопасност',
    'daily_check.cat_controls': 'Управление',
    'daily_check.cat_body': 'Каросерия и приставки',
    'daily_check.lights_working': 'Всички светлини работят',
    'daily_check.mirrors': 'Огледалата чисти и настроени',
    'daily_check.windscreen': 'Предното стъкло чисто и непокътнато',
    'daily_check.engine_oil': 'Ниво на моторното масло',
    'daily_check.coolant': 'Ниво на охладителната течност',
    'daily_check.hydraulic': 'Ниво на хидравличната течност',
    'daily_check.fuel': 'Достатъчно ниво на горивото',
    'daily_check.tyre_pressure': 'Правилно налягане в гумите',
    'daily_check.tyre_damage': 'Без видими повреди по гумите',
    'daily_check.wheel_nuts': 'Гайките на колелата затегнати',
    'daily_check.fire_extinguisher': 'Пожарогасителят е наличен',
    'daily_check.first_aid': 'Аптечката е налична',
    'daily_check.rops': 'Конструкцията ROPS е непокътната',
    'daily_check.seatbelt': 'Предпазният колан работи',
    'daily_check.brakes': 'Спирачките работят',
    'daily_check.steering': 'Кормилото реагира',
    'daily_check.horn': 'Клаксонът работи',
    'daily_check.body_damage': 'Без видими повреди по каросерията',
    'daily_check.attachments': 'Приставките закрепени',
    'daily_check.pto_guard': 'Предпазителят на ВОМ на място',
    'log_fault.title': 'Докладване на неизправност',
    'log_fault.description': 'Описание',
    'log_fault.description_placeholder': 'Опишете неизправността...',
    'log_fault.photos': 'Снимки',
    'log_fault.add_photo': 'Добавяне на снимка',
    'log_fault.submit': 'Изпращане на доклада',
    'log_fault.success': 'Неизправността е докладвана успешно',
    'emergency.title': 'Спешен случай',
    'emergency.what_emergency': 'Какъв е спешният случай?',
    'emergency.select_type': 'Изберете вида на спешния случай.\nСъответните контакти ще бъдат уведомени незабавно.',
    'emergency.vibrating': 'Вибрира',
    'emergency.alarm': 'Аларма',
    'emergency.medical': 'Медицински спешен случай',
    'emergency.medical_sub': 'Нараняване, заболяване или безсъзнателно лице на място',
    'emergency.calls_999': 'Обажда се на 112 незабавно',
    'emergency.electrical': 'Електрически спешен случай',
    'emergency.electrical_sub': 'Контакт с електропровод — останете в кабината',
    'emergency.calls_105': 'Обажда се на 112 незабавно',
    'emergency.no_signal': 'Спешните номера са записани на устройството — достъпни без сигнал',
    'emergency.gps_auto': 'GPS позицията се споделя автоматично',
    'emergency.999_called': '112 повикан',
    'emergency.105_called': 'Спешна линия повикана',
    'emergency.services_contacted': 'Службите за спешна помощ са уведомени.\nВашият ръководител също е уведомен.',
    'emergency.power_contacted': 'Електрическата спешна линия е уведомена.\nВашият ръководител също е уведомен.',
    'emergency.emergency_type': 'Вид на спешния случай',
    'emergency.number_called': 'Повикан номер',
    'emergency.location': 'Местоположение',
    'emergency.admin_notified': 'Администраторът е уведомен',
    'emergency.stay_in_cab': 'Останете в кабината',
    'emergency.stay_in_cab_msg': 'Не излизайте от превозното средство. Изчакайте, докато властите потвърдят, че линията е безопасна. Дръжте прозорците затворени.',
    'emergency.medical_type': 'Медицински',
    'emergency.electrical_type': 'Електрически',
    'crash.are_you_okay': 'Добре ли сте?',
    'crash.impact_detected': 'Открит е възможен удар.\nМоля, отговорете или ще бъде повикана помощ.',
    'crash.im_okay': 'Добре съм',
    'crash.dismiss_alert': 'Отхвърляне на сигнала — без действие',
    'crash.i_need_help': 'Нуждая се от помощ',
    'crash.notify_supervisor': 'Уведомяване на ръководителя с GPS позиция',
    'crash.call_999': 'Обадете се на 112',
    'crash.call_emergency': 'Незабавно повикайте спешните служби',
    'crash.glad_okay': 'Радваме се, че сте добре',
    'crash.alert_dismissed': 'Сигналът е отхвърлен. Не е изпратено уведомление.',
    'crash.help_on_way': 'Помощта е на път',
    'crash.supervisor_notified': 'Вашият ръководител е уведомен с вашата GPS позиция.',
    'crash.auto_dialled': '112 набран автоматично',
    'crash.no_response': 'Няма отговор. Спешните служби са повикани автоматично. Гласово съобщение се излъчва.',
    'crash.broadcasting': 'Излъчване на съобщение',
    'crash.repeating': 'Повтаряне на всеки 15 секунди',
    'crash.admin_notified': 'Администраторът е уведомен',
    'crash.emergency_services': 'Спешни служби',
    'profile.title': 'Профил',
    'profile.personal_info': 'Лична информация',
    'profile.full_name': 'Пълно име',
    'profile.email': 'Имейл',
    'profile.phone': 'Телефон',
    'profile.role': 'Роля',
    'profile.organisation': 'Организация',
    'profile.emergency_contact': 'Спешен контакт',
    'profile.emergency_contact_note': 'Вашият ръководител ще бъде уведомен при спешен случай',
    'profile.contact_name': 'Име на контакта',
    'profile.contact_phone': 'Телефон на контакта',
    'profile.notifications': 'Известия',
    'profile.task_reminders': 'Напомняния за задачи',
    'profile.overdue_alerts': 'Сигнали за закъснение',
    'profile.crash_detection': 'Откриване на удар',
    'profile.account_security': 'Акаунт и сигурност',
    'profile.change_password': 'Промяна на паролата',
    'profile.two_factor': 'Двуфакторно удостоверяване',
    'profile.login_activity': 'Активност при влизане',
    'profile.app_settings': 'Настройки на приложението',
    'profile.theme': 'Тема',
    'profile.language': 'Език',
    'profile.sign_out': 'Изход',
    'profile.sign_out_confirm': 'Изход',
    'profile.sign_out_msg': 'Сигурни ли сте, че искате да излезете?',
    'profile.field_staff': 'Полеви персонал',
    'theme.light': 'Светла',
    'theme.dark': 'Тъмна',
    'theme.system': 'Системна по подразбиране',
    'set.emails': "Имейли",
    'set.hold_the_yard': "Седмичен имейл Hold the Yard",
    'set.hold_the_yard_desc': "Всеки понеделник обобщение на проверките преди употреба от предходната седмица, изпращано до администраторите и мениджърите на организацията.",
  },

  'hr': {
    'app.name': 'AgriWare Operacije',
    'app.tagline': 'Upravljanje',
    'nav.home': 'Početna',
    'nav.machines': 'Strojevi',
    'nav.profile': 'Profil',
    'common.back': 'Natrag',
    'common.cancel': 'Odustani',
    'common.save': 'Spremi',
    'common.edit': 'Uredi',
    'common.done': 'Gotovo',
    'common.yes': 'Da',
    'common.no': 'Ne',
    'common.ok': 'OK',
    'common.error': 'Pogreška',
    'common.loading': 'Učitavanje...',
    'common.retry': 'Pokušaj ponovo',
    'common.search': 'Pretraži',
    'common.submit': 'Pošalji',
    'common.confirm': 'Potvrdi',
    'common.close': 'Zatvori',
    'common.pass': 'Prošlo',
    'common.fail': 'Nije prošlo',
    'common.total': 'ukupno',
    'common.today': 'Danas',
    'common.yesterday': 'Jučer',
    'common.online_only': 'Samo online',
    'common.last_synced': 'Zadnja sinkronizacija',
    'common.back_to_app': 'Natrag na aplikaciju',
    'common.gps_shared': 'GPS podijeljen',
    'common.yes_via_saas': 'Da — putem SaaS-a',
    'common.not_called': 'Nije pozvano',
    'login.sign_in': 'Prijava',
    'login.email': 'E-mail adresa',
    'login.password': 'Lozinka',
    'login.forgot_password': 'Zaboravili ste lozinku?',
    'login.no_account': 'Nemate račun?',
    'login.request_access': 'Zatražite pristup',
    'login.account_created_by_org': 'Vaš račun je stvoren od strane vaše organizacije.',
    'login.email_placeholder': 'vi@organizacija.hr',
    'login.password_placeholder': 'Unesite lozinku',
    'login.error_empty': 'Unesite e-mail i lozinku.',
    'login.error_invalid': 'Nevažeći e-mail ili lozinka. Pokušajte ponovo.',
    'dashboard.greeting_morning': 'Dobro jutro,',
    'dashboard.greeting_afternoon': 'Dobar dan,',
    'dashboard.greeting_evening': 'Dobra večer,',
    'dashboard.todays_tasks': 'Današnji zadaci',
    'dashboard.completed': 'Dovršeni',
    'dashboard.overdue': 'Zakašnjeli',
    'dashboard.in_progress': 'U tijeku',
    'dashboard.upcoming': 'Nadolazeći',
    'dashboard.pending': 'Na čekanju',
    'machines.title': 'Strojevi',
    'machines.search_placeholder': 'Pretraži strojeve...',
    'machines.favourites': 'Favoriti',
    'machines.all_machines': 'Svi strojevi',
    'machines.operational': 'Operativan',
    'machines.needs_attention': 'Zahtijeva pažnju',
    'machines.fault': 'Kvar',
    'machines.unsafe_to_operate': 'Nije sigurno za upravljanje',
    'machines.registration': 'Registracija',
    'machines.assigned_operator': 'Dodijeljeni operater',
    'machines.engine_hours': 'Radni sati motora',
    'machines.documents': 'Dokumenti',
    'machines.log_fault': 'Prijavi kvar',
    'machines.operator_manual': 'Upute za upravljanje',
    'machines.service_record': 'Servisna knjiga',
    'machines.insurance': 'Potvrda o osiguranju',
    'machines.mot': 'Tehnički pregled',
    'daily_check.title': 'Dnevna provjera',
    'daily_check.start': 'Pokrenite provjeru',
    'daily_check.required': 'Dnevna provjera obavezna',
    'daily_check.required_msg': 'Mora se dovršiti prije upravljanja ovim strojem.',
    'daily_check.complete': 'Provjera dovršena',
    'daily_check.complete_msg': 'Dovršio/la',
    'daily_check.submit': 'Pošalji provjeru',
    'daily_check.items_remaining': 'preostalih stavki',
    'daily_check.reward_title': 'Hvala!',
    'daily_check.reward_subtitle': 'Vaša dnevna provjera je zabilježena.\nPoštene provjere čuvaju sve na sigurnom.',
    'daily_check.back_to_machine': 'Natrag na stroj',
    'daily_check.day_streak': 'Uzastopni dani',
    'daily_check.completion_rate': 'Stopa dovršenosti',
    'daily_check.cat_lights': 'Osvjetljenje i vidljivost',
    'daily_check.cat_fluids': 'Tekućine',
    'daily_check.cat_tyres': 'Gume i kotači',
    'daily_check.cat_safety': 'Sigurnost',
    'daily_check.cat_controls': 'Upravljanje',
    'daily_check.cat_body': 'Karoserija i pribor',
    'daily_check.lights_working': 'Sva svjetla rade',
    'daily_check.mirrors': 'Retrovizori čisti i namješteni',
    'daily_check.windscreen': 'Vjetrobransko staklo čisto i neoštećeno',
    'daily_check.engine_oil': 'Razina motornog ulja',
    'daily_check.coolant': 'Razina rashladne tekućine',
    'daily_check.hydraulic': 'Razina hidrauličke tekućine',
    'daily_check.fuel': 'Dovoljna razina goriva',
    'daily_check.tyre_pressure': 'Ispravan tlak guma',
    'daily_check.tyre_damage': 'Nema vidljivih oštećenja guma',
    'daily_check.wheel_nuts': 'Matice kotača zategnute',
    'daily_check.fire_extinguisher': 'Vatrogasni aparat prisutan',
    'daily_check.first_aid': 'Komplet prve pomoći prisutan',
    'daily_check.rops': 'ROPS konstrukcija neoštećena',
    'daily_check.seatbelt': 'Sigurnosni pojas radi',
    'daily_check.brakes': 'Kočnice rade',
    'daily_check.steering': 'Upravljač reagira',
    'daily_check.horn': 'Zvučni signal radi',
    'daily_check.body_damage': 'Nema vidljivih oštećenja karoserije',
    'daily_check.attachments': 'Pribor pričvršćen',
    'daily_check.pto_guard': 'Zaštita priključnog vratila na mjestu',
    'log_fault.title': 'Prijavi kvar',
    'log_fault.description': 'Opis',
    'log_fault.description_placeholder': 'Opišite kvar...',
    'log_fault.photos': 'Fotografije',
    'log_fault.add_photo': 'Dodaj fotografiju',
    'log_fault.submit': 'Pošalji izvješće o kvaru',
    'log_fault.success': 'Kvar uspješno prijavljen',
    'emergency.title': 'Hitna situacija',
    'emergency.what_emergency': 'Što je hitna situacija?',
    'emergency.select_type': 'Odaberite vrstu hitne situacije.\nOdgovarajući kontakti bit će odmah obaviješteni.',
    'emergency.vibrating': 'Vibrira',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Medicinska hitna situacija',
    'emergency.medical_sub': 'Ozljeda, bolest ili osoba bez svijesti na licu mjesta',
    'emergency.calls_999': 'Zove 112 odmah',
    'emergency.electrical': 'Električna hitna situacija',
    'emergency.electrical_sub': 'Kontakt s elektrovodom — ostanite u kabini',
    'emergency.calls_105': 'Zove 112 odmah',
    'emergency.no_signal': 'Hitni brojevi pohranjeni na uređaju — dostupni bez signala',
    'emergency.gps_auto': 'GPS položaj automatski podijeljen',
    'emergency.999_called': '112 pozvan',
    'emergency.105_called': 'Hitna linija pozvana',
    'emergency.services_contacted': 'Hitne službe su obaviještene.\nVaš nadređeni je također obaviješten.',
    'emergency.power_contacted': 'Električna hitna linija je obaviještena.\nVaš nadređeni je također obaviješten.',
    'emergency.emergency_type': 'Vrsta hitne situacije',
    'emergency.number_called': 'Pozvani broj',
    'emergency.location': 'Lokacija',
    'emergency.admin_notified': 'Administrator obaviješten',
    'emergency.stay_in_cab': 'Ostanite u kabini',
    'emergency.stay_in_cab_msg': 'Ne izlazite iz vozila. Pričekajte dok vlasti ne potvrde da je vod siguran. Držite prozore zatvorenima.',
    'emergency.medical_type': 'Medicinska',
    'emergency.electrical_type': 'Električna',
    'crash.are_you_okay': 'Jeste li dobro?',
    'crash.impact_detected': 'Otkriven je mogući udar.\nMolimo odgovorite ili će biti pozvana pomoć.',
    'crash.im_okay': 'Dobro sam',
    'crash.dismiss_alert': 'Odbaci alarm — bez radnje',
    'crash.i_need_help': 'Trebam pomoć',
    'crash.notify_supervisor': 'Obavijesti nadređenog s GPS položajem',
    'crash.call_999': 'Pozovi 112',
    'crash.call_emergency': 'Odmah pozovi hitne službe',
    'crash.glad_okay': 'Drago nam je da ste dobro',
    'crash.alert_dismissed': 'Alarm odbačen. Nije poslana obavijest.',
    'crash.help_on_way': 'Pomoć je na putu',
    'crash.supervisor_notified': 'Vaš nadređeni je obaviješten s vašim GPS položajem.',
    'crash.auto_dialled': '112 automatski pozvan',
    'crash.no_response': 'Nema odgovora. Hitne službe automatski pozvane. Glasovna poruka se emitira.',
    'crash.broadcasting': 'Emitiranje poruke',
    'crash.repeating': 'Ponavljanje svakih 15 sekundi',
    'crash.admin_notified': 'Administrator obaviješten',
    'crash.emergency_services': 'Hitne službe',
    'profile.title': 'Profil',
    'profile.personal_info': 'Osobni podaci',
    'profile.full_name': 'Puno ime',
    'profile.email': 'E-mail',
    'profile.phone': 'Telefon',
    'profile.role': 'Uloga',
    'profile.organisation': 'Organizacija',
    'profile.emergency_contact': 'Hitni kontakt',
    'profile.emergency_contact_note': 'Vaš nadređeni bit će kontaktiran u hitnoj situaciji',
    'profile.contact_name': 'Ime kontakta',
    'profile.contact_phone': 'Telefon kontakta',
    'profile.notifications': 'Obavijesti',
    'profile.task_reminders': 'Podsjetnici zadataka',
    'profile.overdue_alerts': 'Upozorenja o kašnjenju',
    'profile.crash_detection': 'Detekcija udara',
    'profile.account_security': 'Račun i sigurnost',
    'profile.change_password': 'Promjena lozinke',
    'profile.two_factor': 'Dvofaktorska autentifikacija',
    'profile.login_activity': 'Aktivnost prijave',
    'profile.app_settings': 'Postavke aplikacije',
    'profile.theme': 'Tema',
    'profile.language': 'Jezik',
    'profile.sign_out': 'Odjava',
    'profile.sign_out_confirm': 'Odjava',
    'profile.sign_out_msg': 'Jeste li sigurni da se želite odjaviti?',
    'profile.field_staff': 'Terensko osoblje',
    'theme.light': 'Svjetla',
    'theme.dark': 'Tamna',
    'theme.system': 'Zadana sustava',
    'set.emails': "E-pošta",
    'set.hold_the_yard': "Tjedni e-mail Hold the Yard",
    'set.hold_the_yard_desc': "Svakog ponedjeljka sažetak provjera prije uporabe iz prethodnog tjedna, šalje se administratorima i voditeljima organizacije.",
  },

  'el': {
    'app.name': 'AgriWare Λειτουργίες',
    'app.tagline': 'Διαχείριση',
    'nav.home': 'Αρχική',
    'nav.machines': 'Μηχανήματα',
    'nav.profile': 'Προφίλ',
    'common.back': 'Πίσω',
    'common.cancel': 'Ακύρωση',
    'common.save': 'Αποθήκευση',
    'common.edit': 'Επεξεργασία',
    'common.done': 'Τέλος',
    'common.yes': 'Ναι',
    'common.no': 'Όχι',
    'common.ok': 'OK',
    'common.error': 'Σφάλμα',
    'common.loading': 'Φόρτωση...',
    'common.retry': 'Δοκιμάστε ξανά',
    'common.search': 'Αναζήτηση',
    'common.submit': 'Υποβολή',
    'common.confirm': 'Επιβεβαίωση',
    'common.close': 'Κλείσιμο',
    'common.pass': 'Πέρασε',
    'common.fail': 'Απέτυχε',
    'common.total': 'σύνολο',
    'common.today': 'Σήμερα',
    'common.yesterday': 'Χθες',
    'common.online_only': 'Μόνο online',
    'common.last_synced': 'Τελευταίος συγχρονισμός',
    'common.back_to_app': 'Πίσω στην εφαρμογή',
    'common.gps_shared': 'GPS κοινοποιήθηκε',
    'common.yes_via_saas': 'Ναι — μέσω SaaS',
    'common.not_called': 'Δεν κλήθηκε',
    'login.sign_in': 'Σύνδεση',
    'login.email': 'Διεύθυνση email',
    'login.password': 'Κωδικός',
    'login.forgot_password': 'Ξεχάσατε τον κωδικό;',
    'login.no_account': 'Δεν έχετε λογαριασμό;',
    'login.request_access': 'Αίτηση πρόσβασης',
    'login.account_created_by_org': 'Ο λογαριασμός σας δημιουργήθηκε από τον οργανισμό σας.',
    'login.email_placeholder': 'εσεις@οργανισμος.gr',
    'login.password_placeholder': 'Εισάγετε τον κωδικό σας',
    'login.error_empty': 'Εισάγετε email και κωδικό.',
    'login.error_invalid': 'Μη έγκυρο email ή κωδικός. Δοκιμάστε ξανά.',
    'dashboard.greeting_morning': 'Καλημέρα,',
    'dashboard.greeting_afternoon': 'Καλό απόγευμα,',
    'dashboard.greeting_evening': 'Καλησπέρα,',
    'dashboard.todays_tasks': 'Σημερινές εργασίες',
    'dashboard.completed': 'Ολοκληρωμένες',
    'dashboard.overdue': 'Εκπρόθεσμες',
    'dashboard.in_progress': 'Σε εξέλιξη',
    'dashboard.upcoming': 'Επερχόμενες',
    'dashboard.pending': 'Εκκρεμείς',
    'machines.title': 'Μηχανήματα',
    'machines.search_placeholder': 'Αναζήτηση μηχανημάτων...',
    'machines.favourites': 'Αγαπημένα',
    'machines.all_machines': 'Όλα τα μηχανήματα',
    'machines.operational': 'Λειτουργικό',
    'machines.needs_attention': 'Χρειάζεται προσοχή',
    'machines.fault': 'Βλάβη',
    'machines.unsafe_to_operate': 'Μη ασφαλές για χρήση',
    'machines.registration': 'Αριθμός κυκλοφορίας',
    'machines.assigned_operator': 'Αναθεμένος χειριστής',
    'machines.engine_hours': 'Ώρες κινητήρα',
    'machines.documents': 'Έγγραφα',
    'machines.log_fault': 'Καταγραφή βλάβης',
    'machines.operator_manual': 'Εγχειρίδιο χειριστή',
    'machines.service_record': 'Βιβλίο σέρβις',
    'machines.insurance': 'Πιστοποιητικό ασφάλισης',
    'machines.mot': 'ΚΤΕΟ',
    'daily_check.title': 'Ημερήσιος έλεγχος',
    'daily_check.start': 'Έναρξη ελέγχου',
    'daily_check.required': 'Απαιτείται ημερήσιος έλεγχος',
    'daily_check.required_msg': 'Πρέπει να ολοκληρωθεί πριν τη χρήση του μηχανήματος.',
    'daily_check.complete': 'Έλεγχος ολοκληρώθηκε',
    'daily_check.complete_msg': 'Ολοκληρώθηκε από',
    'daily_check.submit': 'Υποβολή ελέγχου',
    'daily_check.items_remaining': 'στοιχεία απομένουν',
    'daily_check.reward_title': 'Ευχαριστούμε!',
    'daily_check.reward_subtitle': 'Ο ημερήσιος έλεγχός σας καταγράφηκε.\nΟι ειλικρινείς έλεγχοι κρατούν όλους ασφαλείς.',
    'daily_check.back_to_machine': 'Πίσω στο μηχάνημα',
    'daily_check.day_streak': 'Ημέρες σερί',
    'daily_check.completion_rate': 'Ποσοστό ολοκλήρωσης',
    'daily_check.cat_lights': 'Φωτισμός και ορατότητα',
    'daily_check.cat_fluids': 'Υγρά',
    'daily_check.cat_tyres': 'Ελαστικά και τροχοί',
    'daily_check.cat_safety': 'Ασφάλεια',
    'daily_check.cat_controls': 'Χειριστήρια',
    'daily_check.cat_body': 'Αμάξωμα και εξαρτήματα',
    'daily_check.lights_working': 'Όλα τα φώτα λειτουργούν',
    'daily_check.mirrors': 'Καθρέπτες καθαροί και ρυθμισμένοι',
    'daily_check.windscreen': 'Παρμπρίζ καθαρό και άθικτο',
    'daily_check.engine_oil': 'Στάθμη λαδιού κινητήρα',
    'daily_check.coolant': 'Στάθμη ψυκτικού υγρού',
    'daily_check.hydraulic': 'Στάθμη υδραυλικού υγρού',
    'daily_check.fuel': 'Επαρκής στάθμη καυσίμου',
    'daily_check.tyre_pressure': 'Σωστή πίεση ελαστικών',
    'daily_check.tyre_damage': 'Χωρίς ορατές ζημιές ελαστικών',
    'daily_check.wheel_nuts': 'Παξιμάδια τροχών σφιγμένα',
    'daily_check.fire_extinguisher': 'Πυροσβεστήρας παρών',
    'daily_check.first_aid': 'Κουτί πρώτων βοηθειών παρόν',
    'daily_check.rops': 'Κατασκευή ROPS άθικτη',
    'daily_check.seatbelt': 'Ζώνη ασφαλείας λειτουργεί',
    'daily_check.brakes': 'Φρένα λειτουργούν',
    'daily_check.steering': 'Τιμόνι ανταποκρίνεται',
    'daily_check.horn': 'Κόρνα λειτουργεί',
    'daily_check.body_damage': 'Χωρίς ορατές ζημιές αμαξώματος',
    'daily_check.attachments': 'Εξαρτήματα ασφαλισμένα',
    'daily_check.pto_guard': 'Προφυλακτήρας PTO στη θέση του',
    'log_fault.title': 'Καταγραφή βλάβης',
    'log_fault.description': 'Περιγραφή',
    'log_fault.description_placeholder': 'Περιγράψτε τη βλάβη...',
    'log_fault.photos': 'Φωτογραφίες',
    'log_fault.add_photo': 'Προσθήκη φωτογραφίας',
    'log_fault.submit': 'Υποβολή αναφοράς',
    'log_fault.success': 'Η βλάβη καταγράφηκε επιτυχώς',
    'emergency.title': 'Έκτακτη ανάγκη',
    'emergency.what_emergency': 'Ποια είναι η έκτακτη ανάγκη;',
    'emergency.select_type': 'Επιλέξτε τον τύπο έκτακτης ανάγκης.\nΟι κατάλληλες επαφές θα ειδοποιηθούν αμέσως.',
    'emergency.vibrating': 'Δονείται',
    'emergency.alarm': 'Συναγερμός',
    'emergency.medical': 'Ιατρική έκτακτη ανάγκη',
    'emergency.medical_sub': 'Τραυματισμός, ασθένεια ή αναίσθητο άτομο στον χώρο',
    'emergency.calls_999': 'Καλεί αμέσως το 112',
    'emergency.electrical': 'Ηλεκτρική έκτακτη ανάγκη',
    'emergency.electrical_sub': 'Επαφή με ηλεκτροφόρο καλώδιο — μείνετε στην καμπίνα',
    'emergency.calls_105': 'Καλεί αμέσως το 112',
    'emergency.no_signal': 'Αριθμοί έκτακτης ανάγκης αποθηκευμένοι στη συσκευή — διαθέσιμοι χωρίς σήμα',
    'emergency.gps_auto': 'Θέση GPS κοινοποιείται αυτόματα',
    'emergency.999_called': '112 κλήθηκε',
    'emergency.105_called': 'Γραμμή έκτακτης ανάγκης κλήθηκε',
    'emergency.services_contacted': 'Οι υπηρεσίες έκτακτης ανάγκης ειδοποιήθηκαν.\nΟ προϊστάμενός σας επίσης ειδοποιήθηκε.',
    'emergency.power_contacted': 'Η ηλεκτρική γραμμή έκτακτης ανάγκης ειδοποιήθηκε.\nΟ προϊστάμενός σας επίσης ειδοποιήθηκε.',
    'emergency.emergency_type': 'Τύπος έκτακτης ανάγκης',
    'emergency.number_called': 'Αριθμός που κλήθηκε',
    'emergency.location': 'Τοποθεσία',
    'emergency.admin_notified': 'Διαχειριστής ειδοποιήθηκε',
    'emergency.stay_in_cab': 'Μείνετε στην καμπίνα',
    'emergency.stay_in_cab_msg': 'Μην εξέλθετε από το όχημα. Περιμένετε μέχρι οι αρχές να επιβεβαιώσουν ότι η γραμμή είναι ασφαλής. Κρατήστε τα παράθυρα κλειστά.',
    'emergency.medical_type': 'Ιατρική',
    'emergency.electrical_type': 'Ηλεκτρική',
    'crash.are_you_okay': 'Είστε καλά;',
    'crash.impact_detected': 'Εντοπίστηκε πιθανή σύγκρουση.\nΑπαντήστε παρακαλώ ή θα κληθεί βοήθεια.',
    'crash.im_okay': 'Είμαι καλά',
    'crash.dismiss_alert': 'Απόρριψη συναγερμού — καμία ενέργεια',
    'crash.i_need_help': 'Χρειάζομαι βοήθεια',
    'crash.notify_supervisor': 'Ειδοποίηση προϊσταμένου με θέση GPS',
    'crash.call_999': 'Καλέστε 112',
    'crash.call_emergency': 'Καλέστε άμεσα τις υπηρεσίες έκτακτης ανάγκης',
    'crash.glad_okay': 'Χαιρόμαστε που είστε καλά',
    'crash.alert_dismissed': 'Συναγερμός απορρίφθηκε. Δεν εστάλη ειδοποίηση.',
    'crash.help_on_way': 'Βοήθεια έρχεται',
    'crash.supervisor_notified': 'Ο προϊστάμενός σας ειδοποιήθηκε με τη θέση GPS σας.',
    'crash.auto_dialled': '112 κλήθηκε αυτόματα',
    'crash.no_response': 'Καμία απάντηση. Οι υπηρεσίες έκτακτης ανάγκης κλήθηκαν αυτόματα. Ηχητικό μήνυμα μεταδίδεται.',
    'crash.broadcasting': 'Μετάδοση μηνύματος',
    'crash.repeating': 'Επανάληψη κάθε 15 δευτερόλεπτα',
    'crash.admin_notified': 'Διαχειριστής ειδοποιήθηκε',
    'crash.emergency_services': 'Υπηρεσίες έκτακτης ανάγκης',
    'profile.title': 'Προφίλ',
    'profile.personal_info': 'Προσωπικά στοιχεία',
    'profile.full_name': 'Πλήρες όνομα',
    'profile.email': 'Email',
    'profile.phone': 'Τηλέφωνο',
    'profile.role': 'Ρόλος',
    'profile.organisation': 'Οργανισμός',
    'profile.emergency_contact': 'Επαφή έκτακτης ανάγκης',
    'profile.emergency_contact_note': 'Ο προϊστάμενός σας θα επικοινωνήσει σε περίπτωση έκτακτης ανάγκης',
    'profile.contact_name': 'Όνομα επαφής',
    'profile.contact_phone': 'Τηλέφωνο επαφής',
    'profile.notifications': 'Ειδοποιήσεις',
    'profile.task_reminders': 'Υπενθυμίσεις εργασιών',
    'profile.overdue_alerts': 'Ειδοποιήσεις καθυστέρησης',
    'profile.crash_detection': 'Ανίχνευση σύγκρουσης',
    'profile.account_security': 'Λογαριασμός και ασφάλεια',
    'profile.change_password': 'Αλλαγή κωδικού',
    'profile.two_factor': 'Έλεγχος ταυτότητας δύο παραγόντων',
    'profile.login_activity': 'Δραστηριότητα σύνδεσης',
    'profile.app_settings': 'Ρυθμίσεις εφαρμογής',
    'profile.theme': 'Θέμα',
    'profile.language': 'Γλώσσα',
    'profile.sign_out': 'Αποσύνδεση',
    'profile.sign_out_confirm': 'Αποσύνδεση',
    'profile.sign_out_msg': 'Είστε σίγουροι ότι θέλετε να αποσυνδεθείτε;',
    'profile.field_staff': 'Προσωπικό πεδίου',
    'theme.light': 'Ανοιχτό',
    'theme.dark': 'Σκοτεινό',
    'theme.system': 'Προεπιλογή συστήματος',
    'set.emails': "Email",
    'set.hold_the_yard': "Εβδομαδιαίο email Hold the Yard",
    'set.hold_the_yard_desc': "Κάθε Δευτέρα μια σύνοψη των ελέγχων πριν από τη χρήση της προηγούμενης εβδομάδας, που αποστέλλεται στους διαχειριστές και τους υπευθύνους του οργανισμού.",
  },

  'uk': {
    'app.name': 'AgriWare Операції',
    'app.tagline': 'Управління',
    'nav.home': 'Головна',
    'nav.machines': 'Машини',
    'nav.profile': 'Профіль',
    'common.back': 'Назад',
    'common.cancel': 'Скасувати',
    'common.save': 'Зберегти',
    'common.edit': 'Редагувати',
    'common.done': 'Готово',
    'common.yes': 'Так',
    'common.no': 'Ні',
    'common.ok': 'OK',
    'common.error': 'Помилка',
    'common.loading': 'Завантаження...',
    'common.retry': 'Спробувати знову',
    'common.search': 'Пошук',
    'common.submit': 'Надіслати',
    'common.confirm': 'Підтвердити',
    'common.close': 'Закрити',
    'common.pass': 'Пройдено',
    'common.fail': 'Не пройдено',
    'common.total': 'всього',
    'common.today': 'Сьогодні',
    'common.yesterday': 'Вчора',
    'common.online_only': 'Тільки онлайн',
    'common.last_synced': 'Остання синхронізація',
    'common.back_to_app': 'Назад до додатку',
    'common.gps_shared': 'GPS поділено',
    'common.yes_via_saas': 'Так — через SaaS',
    'common.not_called': 'Не викликано',
    'login.sign_in': 'Увійти',
    'login.email': 'Адреса електронної пошти',
    'login.password': 'Пароль',
    'login.forgot_password': 'Забули пароль?',
    'login.no_account': 'Немає облікового запису?',
    'login.request_access': 'Запросити доступ',
    'login.account_created_by_org': 'Ваш обліковий запис створено вашою організацією.',
    'login.email_placeholder': 'ви@організація.ua',
    'login.password_placeholder': 'Введіть пароль',
    'login.error_empty': 'Введіть електронну пошту та пароль.',
    'login.error_invalid': 'Невірна електронна пошта або пароль. Спробуйте ще раз.',
    'dashboard.greeting_morning': 'Доброго ранку,',
    'dashboard.greeting_afternoon': 'Доброго дня,',
    'dashboard.greeting_evening': 'Доброго вечора,',
    'dashboard.todays_tasks': 'Сьогоднішні завдання',
    'dashboard.completed': 'Виконані',
    'dashboard.overdue': 'Прострочені',
    'dashboard.in_progress': 'В процесі',
    'dashboard.upcoming': 'Майбутні',
    'dashboard.pending': 'Очікують',
    'machines.title': 'Машини',
    'machines.search_placeholder': 'Пошук машин...',
    'machines.favourites': 'Вибрані',
    'machines.all_machines': 'Всі машини',
    'machines.operational': 'Справна',
    'machines.needs_attention': 'Потребує уваги',
    'machines.fault': 'Несправність',
    'machines.unsafe_to_operate': 'Небезпечно для роботи',
    'machines.registration': 'Реєстрація',
    'machines.assigned_operator': 'Призначений оператор',
    'machines.engine_hours': 'Мотогодини',
    'machines.documents': 'Документи',
    'machines.log_fault': 'Повідомити про несправність',
    'machines.operator_manual': 'Інструкція оператора',
    'machines.service_record': 'Сервісна книга',
    'machines.insurance': 'Страховий сертифікат',
    'machines.mot': 'Технічний огляд',
    'daily_check.title': 'Щоденна перевірка',
    'daily_check.start': 'Розпочати перевірку',
    'daily_check.required': 'Необхідна щоденна перевірка',
    'daily_check.required_msg': 'Повинна бути завершена перед використанням цієї машини.',
    'daily_check.complete': 'Перевірка завершена',
    'daily_check.complete_msg': 'Виконано',
    'daily_check.submit': 'Надіслати перевірку',
    'daily_check.items_remaining': 'пунктів залишилось',
    'daily_check.reward_title': 'Дякуємо!',
    'daily_check.reward_subtitle': 'Вашу щоденну перевірку записано.\nЧесні перевірки захищають усіх.',
    'daily_check.back_to_machine': 'Назад до машини',
    'daily_check.day_streak': 'Днів поспіль',
    'daily_check.completion_rate': 'Рівень виконання',
    'daily_check.cat_lights': 'Освітлення та видимість',
    'daily_check.cat_fluids': 'Рідини',
    'daily_check.cat_tyres': 'Шини та колеса',
    'daily_check.cat_safety': 'Безпека',
    'daily_check.cat_controls': 'Управління',
    'daily_check.cat_body': 'Кузов та насадки',
    'daily_check.lights_working': 'Всі світла працюють',
    'daily_check.mirrors': 'Дзеркала чисті та відрегульовані',
    'daily_check.windscreen': 'Лобове скло чисте та непошкоджене',
    'daily_check.engine_oil': 'Рівень моторного масла',
    'daily_check.coolant': 'Рівень охолоджуючої рідини',
    'daily_check.hydraulic': 'Рівень гідравлічної рідини',
    'daily_check.fuel': 'Достатній рівень палива',
    'daily_check.tyre_pressure': 'Правильний тиск у шинах',
    'daily_check.tyre_damage': 'Немає видимих пошкоджень шин',
    'daily_check.wheel_nuts': 'Гайки коліс затягнуті',
    'daily_check.fire_extinguisher': 'Вогнегасник наявний',
    'daily_check.first_aid': 'Аптечка першої допомоги наявна',
    'daily_check.rops': 'Конструкція ROPS непошкоджена',
    'daily_check.seatbelt': 'Ремінь безпеки працює',
    'daily_check.brakes': 'Гальма працюють',
    'daily_check.steering': 'Керування реагує',
    'daily_check.horn': 'Гудок працює',
    'daily_check.body_damage': 'Немає видимих пошкоджень кузова',
    'daily_check.attachments': 'Насадки закріплені',
    'daily_check.pto_guard': 'Захист ВВП на місці',
    'log_fault.title': 'Повідомити про несправність',
    'log_fault.description': 'Опис',
    'log_fault.description_placeholder': 'Опишіть несправність...',
    'log_fault.photos': 'Фотографії',
    'log_fault.add_photo': 'Додати фотографію',
    'log_fault.submit': 'Надіслати звіт',
    'log_fault.success': 'Несправність успішно повідомлена',
    'emergency.title': 'Надзвичайна ситуація',
    'emergency.what_emergency': 'Яка надзвичайна ситуація?',
    'emergency.select_type': 'Виберіть тип надзвичайної ситуації.\nВідповідні контакти будуть негайно повідомлені.',
    'emergency.vibrating': 'Вібрує',
    'emergency.alarm': 'Сигнал тривоги',
    'emergency.medical': 'Медична надзвичайна ситуація',
    'emergency.medical_sub': 'Травма, хвороба або непритомна людина на місці',
    'emergency.calls_999': 'Дзвонить 112 негайно',
    'emergency.electrical': 'Електрична надзвичайна ситуація',
    'emergency.electrical_sub': 'Контакт з електропроводом — залишайтесь у кабіні',
    'emergency.calls_105': 'Дзвонить 112 негайно',
    'emergency.no_signal': 'Номери екстреної допомоги збережені на пристрої — доступні без сигналу',
    'emergency.gps_auto': 'GPS-позиція ділиться автоматично',
    'emergency.999_called': '112 викликано',
    'emergency.105_called': 'Екстрена лінія викликана',
    'emergency.services_contacted': 'Служби екстреної допомоги повідомлені.\nВашого керівника також повідомлено.',
    'emergency.power_contacted': 'Електрична екстрена лінія повідомлена.\nВашого керівника також повідомлено.',
    'emergency.emergency_type': 'Тип надзвичайної ситуації',
    'emergency.number_called': 'Викликаний номер',
    'emergency.location': 'Місцезнаходження',
    'emergency.admin_notified': 'Адміна повідомлено',
    'emergency.stay_in_cab': 'Залишайтесь у кабіні',
    'emergency.stay_in_cab_msg': 'Не виходьте з транспортного засобу. Зачекайте, поки влада підтвердить, що лінія безпечна. Тримайте вікна закритими.',
    'emergency.medical_type': 'Медична',
    'emergency.electrical_type': 'Електрична',
    'crash.are_you_okay': 'Ви в порядку?',
    'crash.impact_detected': 'Виявлено можливий удар.\nБудь ласка, відповідайте, або буде викликана допомога.',
    'crash.im_okay': 'Я в порядку',
    'crash.dismiss_alert': 'Відхилити сигнал — без дії',
    'crash.i_need_help': 'Мені потрібна допомога',
    'crash.notify_supervisor': 'Повідомити керівника з GPS-позицією',
    'crash.call_999': 'Зателефонувати 112',
    'crash.call_emergency': 'Негайно викликати служби екстреної допомоги',
    'crash.glad_okay': 'Раді, що ви в порядку',
    'crash.alert_dismissed': 'Сигнал відхилено. Повідомлення не надіслано.',
    'crash.help_on_way': 'Допомога вже в дорозі',
    'crash.supervisor_notified': 'Вашого керівника повідомлено з вашою GPS-позицією.',
    'crash.auto_dialled': '112 набрано автоматично',
    'crash.no_response': 'Немає відповіді. Служби екстреної допомоги викликані автоматично. Голосове повідомлення транслюється.',
    'crash.broadcasting': 'Трансляція повідомлення',
    'crash.repeating': 'Повторення кожні 15 секунд',
    'crash.admin_notified': 'Адміна повідомлено',
    'crash.emergency_services': 'Служби екстреної допомоги',
    'profile.title': 'Профіль',
    'profile.personal_info': 'Особиста інформація',
    'profile.full_name': 'Повне ім\'я',
    'profile.email': 'Електронна пошта',
    'profile.phone': 'Телефон',
    'profile.role': 'Роль',
    'profile.organisation': 'Організація',
    'profile.emergency_contact': 'Екстрений контакт',
    'profile.emergency_contact_note': 'Ваш керівник буде повідомлений у надзвичайній ситуації',
    'profile.contact_name': 'Ім\'я контакту',
    'profile.contact_phone': 'Телефон контакту',
    'profile.notifications': 'Сповіщення',
    'profile.task_reminders': 'Нагадування про завдання',
    'profile.overdue_alerts': 'Попередження про прострочення',
    'profile.crash_detection': 'Виявлення зіткнення',
    'profile.account_security': 'Обліковий запис і безпека',
    'profile.change_password': 'Змінити пароль',
    'profile.two_factor': 'Двофакторна автентифікація',
    'profile.login_activity': 'Активність входу',
    'profile.app_settings': 'Налаштування додатку',
    'profile.theme': 'Тема',
    'profile.language': 'Мова',
    'profile.sign_out': 'Вийти',
    'profile.sign_out_confirm': 'Вийти',
    'profile.sign_out_msg': 'Ви впевнені, що хочете вийти?',
    'profile.field_staff': 'Польовий персонал',
    'theme.light': 'Світла',
    'theme.dark': 'Темна',
    'theme.system': 'Системна за замовчуванням',
    'set.emails': "Електронні листи",
    'set.hold_the_yard': "Щотижневий лист Hold the Yard",
    'set.hold_the_yard_desc': "Щопонеділка підсумок перевірок перед використанням за минулий тиждень, який надсилається адміністраторам і керівникам організації.",
  },

  'ru': {
    'app.name': 'AgriWare Операции',
    'app.tagline': 'Управление',
    'nav.home': 'Главная',
    'nav.machines': 'Машины',
    'nav.profile': 'Профиль',
    'common.back': 'Назад',
    'common.cancel': 'Отмена',
    'common.save': 'Сохранить',
    'common.edit': 'Редактировать',
    'common.done': 'Готово',
    'common.yes': 'Да',
    'common.no': 'Нет',
    'common.ok': 'OK',
    'common.error': 'Ошибка',
    'common.loading': 'Загрузка...',
    'common.retry': 'Повторить',
    'common.search': 'Поиск',
    'common.submit': 'Отправить',
    'common.confirm': 'Подтвердить',
    'common.close': 'Закрыть',
    'common.pass': 'Пройдено',
    'common.fail': 'Не пройдено',
    'common.total': 'всего',
    'common.today': 'Сегодня',
    'common.yesterday': 'Вчера',
    'common.online_only': 'Только онлайн',
    'common.last_synced': 'Последняя синхронизация',
    'common.back_to_app': 'Назад в приложение',
    'common.gps_shared': 'GPS передано',
    'common.yes_via_saas': 'Да — через SaaS',
    'common.not_called': 'Не вызвано',
    'login.sign_in': 'Войти',
    'login.email': 'Адрес электронной почты',
    'login.password': 'Пароль',
    'login.forgot_password': 'Забыли пароль?',
    'login.no_account': 'Нет аккаунта?',
    'login.request_access': 'Запросить доступ',
    'login.account_created_by_org': 'Ваш аккаунт создан вашей организацией.',
    'login.email_placeholder': 'вы@организация.ru',
    'login.password_placeholder': 'Введите пароль',
    'login.error_empty': 'Введите электронную почту и пароль.',
    'login.error_invalid': 'Неверная почта или пароль. Попробуйте снова.',
    'dashboard.greeting_morning': 'Доброе утро,',
    'dashboard.greeting_afternoon': 'Добрый день,',
    'dashboard.greeting_evening': 'Добрый вечер,',
    'dashboard.todays_tasks': 'Задачи на сегодня',
    'dashboard.completed': 'Выполненные',
    'dashboard.overdue': 'Просроченные',
    'dashboard.in_progress': 'В процессе',
    'dashboard.upcoming': 'Предстоящие',
    'dashboard.pending': 'Ожидающие',
    'machines.title': 'Машины',
    'machines.search_placeholder': 'Поиск машин...',
    'machines.favourites': 'Избранное',
    'machines.all_machines': 'Все машины',
    'machines.operational': 'Исправна',
    'machines.needs_attention': 'Требует внимания',
    'machines.fault': 'Неисправность',
    'machines.unsafe_to_operate': 'Небезопасна для работы',
    'machines.registration': 'Регистрация',
    'machines.assigned_operator': 'Назначенный оператор',
    'machines.engine_hours': 'Моточасы',
    'machines.documents': 'Документы',
    'machines.log_fault': 'Сообщить о неисправности',
    'machines.operator_manual': 'Руководство оператора',
    'machines.service_record': 'Сервисная книга',
    'machines.insurance': 'Страховой сертификат',
    'machines.mot': 'Технический осмотр',
    'daily_check.title': 'Ежедневная проверка',
    'daily_check.start': 'Начать проверку',
    'daily_check.required': 'Необходима ежедневная проверка',
    'daily_check.required_msg': 'Должна быть завершена до использования этой машины.',
    'daily_check.complete': 'Проверка завершена',
    'daily_check.complete_msg': 'Выполнено',
    'daily_check.submit': 'Отправить проверку',
    'daily_check.items_remaining': 'пунктов осталось',
    'daily_check.reward_title': 'Спасибо!',
    'daily_check.reward_subtitle': 'Ваша ежедневная проверка записана.\nЧестные проверки обеспечивают безопасность всех.',
    'daily_check.back_to_machine': 'Назад к машине',
    'daily_check.day_streak': 'Дней подряд',
    'daily_check.completion_rate': 'Уровень выполнения',
    'daily_check.cat_lights': 'Освещение и видимость',
    'daily_check.cat_fluids': 'Жидкости',
    'daily_check.cat_tyres': 'Шины и колёса',
    'daily_check.cat_safety': 'Безопасность',
    'daily_check.cat_controls': 'Управление',
    'daily_check.cat_body': 'Кузов и навесное оборудование',
    'daily_check.lights_working': 'Все огни работают',
    'daily_check.mirrors': 'Зеркала чистые и отрегулированные',
    'daily_check.windscreen': 'Лобовое стекло чистое и неповреждённое',
    'daily_check.engine_oil': 'Уровень моторного масла',
    'daily_check.coolant': 'Уровень охлаждающей жидкости',
    'daily_check.hydraulic': 'Уровень гидравлической жидкости',
    'daily_check.fuel': 'Достаточный уровень топлива',
    'daily_check.tyre_pressure': 'Правильное давление в шинах',
    'daily_check.tyre_damage': 'Нет видимых повреждений шин',
    'daily_check.wheel_nuts': 'Гайки колёс затянуты',
    'daily_check.fire_extinguisher': 'Огнетушитель имеется',
    'daily_check.first_aid': 'Аптечка первой помощи имеется',
    'daily_check.rops': 'Конструкция ROPS неповреждена',
    'daily_check.seatbelt': 'Ремень безопасности работает',
    'daily_check.brakes': 'Тормоза работают',
    'daily_check.steering': 'Рулевое управление реагирует',
    'daily_check.horn': 'Звуковой сигнал работает',
    'daily_check.body_damage': 'Нет видимых повреждений кузова',
    'daily_check.attachments': 'Навесное оборудование закреплено',
    'daily_check.pto_guard': 'Защита ВОМ на месте',
    'log_fault.title': 'Сообщить о неисправности',
    'log_fault.description': 'Описание',
    'log_fault.description_placeholder': 'Опишите неисправность...',
    'log_fault.photos': 'Фотографии',
    'log_fault.add_photo': 'Добавить фото',
    'log_fault.submit': 'Отправить отчёт',
    'log_fault.success': 'Неисправность успешно сообщена',
    'emergency.title': 'Чрезвычайная ситуация',
    'emergency.what_emergency': 'Какая чрезвычайная ситуация?',
    'emergency.select_type': 'Выберите тип чрезвычайной ситуации.\nСоответствующие контакты будут немедленно уведомлены.',
    'emergency.vibrating': 'Вибрирует',
    'emergency.alarm': 'Сигнал тревоги',
    'emergency.medical': 'Медицинская чрезвычайная ситуация',
    'emergency.medical_sub': 'Травма, болезнь или без сознания на месте',
    'emergency.calls_999': 'Звонит 112 немедленно',
    'emergency.electrical': 'Электрическая чрезвычайная ситуация',
    'emergency.electrical_sub': 'Контакт с электропроводом — оставайтесь в кабине',
    'emergency.calls_105': 'Звонит 112 немедленно',
    'emergency.no_signal': 'Номера экстренной помощи сохранены на устройстве — доступны без сигнала',
    'emergency.gps_auto': 'GPS-позиция передаётся автоматически',
    'emergency.999_called': '112 вызвано',
    'emergency.105_called': 'Экстренная линия вызвана',
    'emergency.services_contacted': 'Службы экстренной помощи уведомлены.\nВаш руководитель также уведомлен.',
    'emergency.power_contacted': 'Электрическая экстренная линия уведомлена.\nВаш руководитель также уведомлен.',
    'emergency.emergency_type': 'Тип чрезвычайной ситуации',
    'emergency.number_called': 'Вызванный номер',
    'emergency.location': 'Местоположение',
    'emergency.admin_notified': 'Администратор уведомлён',
    'emergency.stay_in_cab': 'Оставайтесь в кабине',
    'emergency.stay_in_cab_msg': 'Не выходите из транспортного средства. Дождитесь подтверждения властей, что линия безопасна. Держите окна закрытыми.',
    'emergency.medical_type': 'Медицинская',
    'emergency.electrical_type': 'Электрическая',
    'crash.are_you_okay': 'Вы в порядке?',
    'crash.impact_detected': 'Обнаружен возможный удар.\nПожалуйста, ответьте, иначе будет вызвана помощь.',
    'crash.im_okay': 'Я в порядке',
    'crash.dismiss_alert': 'Отклонить сигнал — без действий',
    'crash.i_need_help': 'Мне нужна помощь',
    'crash.notify_supervisor': 'Уведомить руководителя с GPS-позицией',
    'crash.call_999': 'Позвонить 112',
    'crash.call_emergency': 'Немедленно вызвать службы экстренной помощи',
    'crash.glad_okay': 'Рады, что вы в порядке',
    'crash.alert_dismissed': 'Сигнал отклонён. Уведомление не отправлено.',
    'crash.help_on_way': 'Помощь уже в пути',
    'crash.supervisor_notified': 'Ваш руководитель уведомлён с вашей GPS-позицией.',
    'crash.auto_dialled': '112 набрано автоматически',
    'crash.no_response': 'Нет ответа. Службы экстренной помощи вызваны автоматически. Голосовое сообщение транслируется.',
    'crash.broadcasting': 'Трансляция сообщения',
    'crash.repeating': 'Повторение каждые 15 секунд',
    'crash.admin_notified': 'Администратор уведомлён',
    'crash.emergency_services': 'Службы экстренной помощи',
    'profile.title': 'Профиль',
    'profile.personal_info': 'Личная информация',
    'profile.full_name': 'Полное имя',
    'profile.email': 'Электронная почта',
    'profile.phone': 'Телефон',
    'profile.role': 'Роль',
    'profile.organisation': 'Организация',
    'profile.emergency_contact': 'Экстренный контакт',
    'profile.emergency_contact_note': 'Ваш руководитель будет уведомлён в чрезвычайной ситуации',
    'profile.contact_name': 'Имя контакта',
    'profile.contact_phone': 'Телефон контакта',
    'profile.notifications': 'Уведомления',
    'profile.task_reminders': 'Напоминания о задачах',
    'profile.overdue_alerts': 'Предупреждения о просрочке',
    'profile.crash_detection': 'Обнаружение столкновения',
    'profile.account_security': 'Аккаунт и безопасность',
    'profile.change_password': 'Изменить пароль',
    'profile.two_factor': 'Двухфакторная аутентификация',
    'profile.login_activity': 'Активность входа',
    'profile.app_settings': 'Настройки приложения',
    'profile.theme': 'Тема',
    'profile.language': 'Язык',
    'profile.sign_out': 'Выйти',
    'profile.sign_out_confirm': 'Выйти',
    'profile.sign_out_msg': 'Вы уверены, что хотите выйти?',
    'profile.field_staff': 'Полевой персонал',
    'theme.light': 'Светлая',
    'theme.dark': 'Тёмная',
    'theme.system': 'По умолчанию системы',
    'set.emails': "Электронные письма",
    'set.hold_the_yard': "Еженедельное письмо Hold the Yard",
    'set.hold_the_yard_desc': "Каждый понедельник сводка проверок перед использованием за прошлую неделю, отправляется администраторам и руководителям организации.",
  },

  'lt': {
    'app.name': 'AgriWare Operacijos',
    'app.tagline': 'Valdymas',
    'nav.home': 'Pradžia',
    'nav.machines': 'Mašinos',
    'nav.profile': 'Profilis',
    'common.back': 'Atgal',
    'common.cancel': 'Atšaukti',
    'common.save': 'Išsaugoti',
    'common.edit': 'Redaguoti',
    'common.done': 'Atlikta',
    'common.yes': 'Taip',
    'common.no': 'Ne',
    'common.ok': 'OK',
    'common.error': 'Klaida',
    'common.loading': 'Kraunama...',
    'common.retry': 'Bandyti dar kartą',
    'common.search': 'Ieškoti',
    'common.submit': 'Pateikti',
    'common.confirm': 'Patvirtinti',
    'common.close': 'Uždaryti',
    'common.pass': 'Išlaikyta',
    'common.fail': 'Neišlaikyta',
    'common.total': 'iš viso',
    'common.today': 'Šiandien',
    'common.yesterday': 'Vakar',
    'common.online_only': 'Tik internete',
    'common.last_synced': 'Paskutinė sinchronizacija',
    'common.back_to_app': 'Grįžti į programą',
    'common.gps_shared': 'GPS bendrinama',
    'common.yes_via_saas': 'Taip — per SaaS',
    'common.not_called': 'Neskambinta',
    'login.sign_in': 'Prisijungti',
    'login.email': 'El. pašto adresas',
    'login.password': 'Slaptažodis',
    'login.forgot_password': 'Pamiršote slaptažodį?',
    'login.no_account': 'Neturite paskyros?',
    'login.request_access': 'Prašyti prieigos',
    'login.account_created_by_org': 'Jūsų paskyra sukurta jūsų organizacijos.',
    'login.email_placeholder': 'jus@organizacija.lt',
    'login.password_placeholder': 'Įveskite slaptažodį',
    'login.error_empty': 'Įveskite el. paštą ir slaptažodį.',
    'login.error_invalid': 'Neteisingas el. paštas arba slaptažodis. Bandykite dar kartą.',
    'dashboard.greeting_morning': 'Labas rytas,',
    'dashboard.greeting_afternoon': 'Laba diena,',
    'dashboard.greeting_evening': 'Labas vakaras,',
    'dashboard.todays_tasks': 'Šiandienos užduotys',
    'dashboard.completed': 'Atliktos',
    'dashboard.overdue': 'Vėluojančios',
    'dashboard.in_progress': 'Vykdomos',
    'dashboard.upcoming': 'Artėjančios',
    'dashboard.pending': 'Laukiančios',
    'machines.title': 'Mašinos',
    'machines.search_placeholder': 'Ieškoti mašinų...',
    'machines.favourites': 'Mėgstamiausios',
    'machines.all_machines': 'Visos mašinos',
    'machines.operational': 'Veikianti',
    'machines.needs_attention': 'Reikia dėmesio',
    'machines.fault': 'Gedimas',
    'machines.unsafe_to_operate': 'Nesaugu naudoti',
    'machines.registration': 'Registracija',
    'machines.assigned_operator': 'Priskirtas operatorius',
    'machines.engine_hours': 'Variklio valandos',
    'machines.documents': 'Dokumentai',
    'machines.log_fault': 'Pranešti apie gedimą',
    'machines.operator_manual': 'Operatoriaus vadovas',
    'machines.service_record': 'Techninės priežiūros knyga',
    'machines.insurance': 'Draudimo pažymėjimas',
    'machines.mot': 'Techninė apžiūra',
    'daily_check.title': 'Kasdienė patikra',
    'daily_check.start': 'Pradėti patikrą',
    'daily_check.required': 'Reikalinga kasdienė patikra',
    'daily_check.required_msg': 'Turi būti atlikta prieš naudojant šią mašiną.',
    'daily_check.complete': 'Patikra atlikta',
    'daily_check.complete_msg': 'Atliko',
    'daily_check.submit': 'Pateikti patikrą',
    'daily_check.items_remaining': 'punktų liko',
    'daily_check.reward_title': 'Ačiū!',
    'daily_check.reward_subtitle': 'Jūsų kasdienė patikra užregistruota.\nSąžiningos patikros saugo visus.',
    'daily_check.back_to_machine': 'Grįžti prie mašinos',
    'daily_check.day_streak': 'Dienų iš eilės',
    'daily_check.completion_rate': 'Užbaigimo rodiklis',
    'daily_check.cat_lights': 'Apšvietimas ir matomumas',
    'daily_check.cat_fluids': 'Skysčiai',
    'daily_check.cat_tyres': 'Padangos ir ratai',
    'daily_check.cat_safety': 'Sauga',
    'daily_check.cat_controls': 'Valdymas',
    'daily_check.cat_body': 'Kėbulas ir priedai',
    'daily_check.lights_working': 'Visos lemputės veikia',
    'daily_check.mirrors': 'Veidrodžiai švarūs ir sureguliuoti',
    'daily_check.windscreen': 'Priekinis stiklas švarus ir nesugadintas',
    'daily_check.engine_oil': 'Variklio alyvos lygis',
    'daily_check.coolant': 'Aušinimo skysčio lygis',
    'daily_check.hydraulic': 'Hidraulinio skysčio lygis',
    'daily_check.fuel': 'Pakankamas kuro lygis',
    'daily_check.tyre_pressure': 'Teisingas padangų slėgis',
    'daily_check.tyre_damage': 'Nėra matomų padangų pažeidimų',
    'daily_check.wheel_nuts': 'Ratų veržlės priveržtos',
    'daily_check.fire_extinguisher': 'Gesintuvus yra',
    'daily_check.first_aid': 'Pirmosios pagalbos rinkinys yra',
    'daily_check.rops': 'ROPS konstrukcija nesugadinta',
    'daily_check.seatbelt': 'Saugos diržas veikia',
    'daily_check.brakes': 'Stabdžiai veikia',
    'daily_check.steering': 'Vairas reaguoja',
    'daily_check.horn': 'Signalas veikia',
    'daily_check.body_damage': 'Nėra matomų kėbulo pažeidimų',
    'daily_check.attachments': 'Priedai pritvirtinti',
    'daily_check.pto_guard': 'Kardano apsauga vietoje',
    'log_fault.title': 'Pranešti apie gedimą',
    'log_fault.description': 'Aprašymas',
    'log_fault.description_placeholder': 'Aprašykite gedimą...',
    'log_fault.photos': 'Nuotraukos',
    'log_fault.add_photo': 'Pridėti nuotrauką',
    'log_fault.submit': 'Pateikti gedimo ataskaitą',
    'log_fault.success': 'Gedimas sėkmingai praneštas',
    'emergency.title': 'Ekstremali situacija',
    'emergency.what_emergency': 'Kokia ekstremali situacija?',
    'emergency.select_type': 'Pasirinkite ekstremalios situacijos tipą.\nAtitinkami kontaktai bus nedelsiant informuoti.',
    'emergency.vibrating': 'Vibruoja',
    'emergency.alarm': 'Signalas',
    'emergency.medical': 'Medicininė ekstremali situacija',
    'emergency.medical_sub': 'Sužeidimas, liga ar be sąmonės asmuo vietoje',
    'emergency.calls_999': 'Nedelsiant skambina 112',
    'emergency.electrical': 'Elektrinė ekstremali situacija',
    'emergency.electrical_sub': 'Kontaktas su elektros linija — likite kabinoje',
    'emergency.calls_105': 'Nedelsiant skambina 112',
    'emergency.no_signal': 'Pagalbos numeriai išsaugoti įrenginyje — prieinami be signalo',
    'emergency.gps_auto': 'GPS pozicija bendrinama automatiškai',
    'emergency.999_called': '112 paskambinta',
    'emergency.105_called': 'Pagalbos linija paskambinta',
    'emergency.services_contacted': 'Pagalbos tarnybos informuotos.\nJūsų vadovas taip pat informuotas.',
    'emergency.power_contacted': 'Elektros pagalbos linija informuota.\nJūsų vadovas taip pat informuotas.',
    'emergency.emergency_type': 'Ekstremalios situacijos tipas',
    'emergency.number_called': 'Paskambintas numeris',
    'emergency.location': 'Vieta',
    'emergency.admin_notified': 'Administratorius informuotas',
    'emergency.stay_in_cab': 'Likite kabinoje',
    'emergency.stay_in_cab_msg': 'Neišlipkite iš transporto priemonės. Palaukite, kol valdžia patvirtins, kad linija saugi. Laikykite langus uždarytus.',
    'emergency.medical_type': 'Medicininė',
    'emergency.electrical_type': 'Elektrinė',
    'crash.are_you_okay': 'Ar jums viskas gerai?',
    'crash.impact_detected': 'Aptiktas galimas smūgis.\nPrašome atsakyti arba bus iškviesta pagalba.',
    'crash.im_okay': 'Man viskas gerai',
    'crash.dismiss_alert': 'Atmesti signalą — jokių veiksmų',
    'crash.i_need_help': 'Man reikia pagalbos',
    'crash.notify_supervisor': 'Informuoti vadovą su GPS pozicija',
    'crash.call_999': 'Skambinti 112',
    'crash.call_emergency': 'Nedelsiant iškviesti pagalbos tarnybas',
    'crash.glad_okay': 'Džiaugiamės, kad jums viskas gerai',
    'crash.alert_dismissed': 'Signalas atmestas. Pranešimas neišsiųstas.',
    'crash.help_on_way': 'Pagalba jau kelyje',
    'crash.supervisor_notified': 'Jūsų vadovas informuotas su jūsų GPS pozicija.',
    'crash.auto_dialled': '112 surinkta automatiškai',
    'crash.no_response': 'Nėra atsakymo. Pagalbos tarnybos iškviestos automatiškai. Balso pranešimas transliuojamas.',
    'crash.broadcasting': 'Pranešimo transliacija',
    'crash.repeating': 'Kartojama kas 15 sekundžių',
    'crash.admin_notified': 'Administratorius informuotas',
    'crash.emergency_services': 'Pagalbos tarnybos',
    'profile.title': 'Profilis',
    'profile.personal_info': 'Asmeninė informacija',
    'profile.full_name': 'Pilnas vardas',
    'profile.email': 'El. paštas',
    'profile.phone': 'Telefonas',
    'profile.role': 'Vaidmuo',
    'profile.organisation': 'Organizacija',
    'profile.emergency_contact': 'Pagalbos kontaktas',
    'profile.emergency_contact_note': 'Ekstremalios situacijos atveju bus susisiekta su jūsų vadovu',
    'profile.contact_name': 'Kontakto vardas',
    'profile.contact_phone': 'Kontakto telefonas',
    'profile.notifications': 'Pranešimai',
    'profile.task_reminders': 'Užduočių priminimai',
    'profile.overdue_alerts': 'Vėlavimo įspėjimai',
    'profile.crash_detection': 'Smūgio aptikimas',
    'profile.account_security': 'Paskyra ir saugumas',
    'profile.change_password': 'Keisti slaptažodį',
    'profile.two_factor': 'Dviejų veiksnių autentifikacija',
    'profile.login_activity': 'Prisijungimo veikla',
    'profile.app_settings': 'Programos nustatymai',
    'profile.theme': 'Tema',
    'profile.language': 'Kalba',
    'profile.sign_out': 'Atsijungti',
    'profile.sign_out_confirm': 'Atsijungti',
    'profile.sign_out_msg': 'Ar tikrai norite atsijungti?',
    'profile.field_staff': 'Lauko darbuotojas',
    'theme.light': 'Šviesi',
    'theme.dark': 'Tamsi',
    'theme.system': 'Sistemos numatytoji',
    'set.emails': "El. laiškai",
    'set.hold_the_yard': "Savaitinis „Hold the Yard“ el. laiškas",
    'set.hold_the_yard_desc': "Kiekvieną pirmadienį praėjusios savaitės patikrų prieš naudojimą suvestinė, siunčiama organizacijos administratoriams ir vadovams.",
  },

  'lv': {
    'app.name': 'AgriWare Operācijas',
    'app.tagline': 'Pārvaldība',
    'nav.home': 'Sākums',
    'nav.machines': 'Mašīnas',
    'nav.profile': 'Profils',
    'common.back': 'Atpakaļ',
    'common.cancel': 'Atcelt',
    'common.save': 'Saglabāt',
    'common.edit': 'Rediģēt',
    'common.done': 'Gatavs',
    'common.yes': 'Jā',
    'common.no': 'Nē',
    'common.ok': 'OK',
    'common.error': 'Kļūda',
    'common.loading': 'Ielādē...',
    'common.retry': 'Mēģināt vēlreiz',
    'common.search': 'Meklēt',
    'common.submit': 'Iesniegt',
    'common.confirm': 'Apstiprināt',
    'common.close': 'Aizvērt',
    'common.pass': 'Izturēts',
    'common.fail': 'Neizturēts',
    'common.total': 'kopā',
    'common.today': 'Šodien',
    'common.yesterday': 'Vakar',
    'common.online_only': 'Tikai tiešsaistē',
    'common.last_synced': 'Pēdējā sinhronizācija',
    'common.back_to_app': 'Atpakaļ uz lietotni',
    'common.gps_shared': 'GPS koplietots',
    'common.yes_via_saas': 'Jā — caur SaaS',
    'common.not_called': 'Nav zvanīts',
    'login.sign_in': 'Pieteikties',
    'login.email': 'E-pasta adrese',
    'login.password': 'Parole',
    'login.forgot_password': 'Aizmirsāt paroli?',
    'login.no_account': 'Nav konta?',
    'login.request_access': 'Pieprasīt piekļuvi',
    'login.account_created_by_org': 'Jūsu konts ir izveidots jūsu organizācijas.',
    'login.email_placeholder': 'jus@organizacija.lv',
    'login.password_placeholder': 'Ievadiet paroli',
    'login.error_empty': 'Ievadiet e-pastu un paroli.',
    'login.error_invalid': 'Nepareizs e-pasts vai parole. Mēģiniet vēlreiz.',
    'dashboard.greeting_morning': 'Labrīt,',
    'dashboard.greeting_afternoon': 'Labdien,',
    'dashboard.greeting_evening': 'Labvakar,',
    'dashboard.todays_tasks': 'Šodienas uzdevumi',
    'dashboard.completed': 'Pabeigti',
    'dashboard.overdue': 'Nokavēti',
    'dashboard.in_progress': 'Procesā',
    'dashboard.upcoming': 'Gaidāmie',
    'dashboard.pending': 'Gaidīšanā',
    'machines.title': 'Mašīnas',
    'machines.search_placeholder': 'Meklēt mašīnas...',
    'machines.favourites': 'Izlase',
    'machines.all_machines': 'Visas mašīnas',
    'machines.operational': 'Darbojas',
    'machines.needs_attention': 'Nepieciešama uzmanība',
    'machines.fault': 'Bojājums',
    'machines.unsafe_to_operate': 'Nedrošs lietošanai',
    'machines.registration': 'Reģistrācija',
    'machines.assigned_operator': 'Piešķirtais operators',
    'machines.engine_hours': 'Motora stundas',
    'machines.documents': 'Dokumenti',
    'machines.log_fault': 'Ziņot par bojājumu',
    'machines.operator_manual': 'Operatora rokasgrāmata',
    'machines.service_record': 'Servisa grāmata',
    'machines.insurance': 'Apdrošināšanas sertifikāts',
    'machines.mot': 'Tehniskā apskate',
    'daily_check.title': 'Ikdienas pārbaude',
    'daily_check.start': 'Sākt pārbaudi',
    'daily_check.required': 'Nepieciešama ikdienas pārbaude',
    'daily_check.required_msg': 'Jāpabeidz pirms šīs mašīnas lietošanas.',
    'daily_check.complete': 'Pārbaude pabeigta',
    'daily_check.complete_msg': 'Pabeidza',
    'daily_check.submit': 'Iesniegt pārbaudi',
    'daily_check.items_remaining': 'punkti atlikuši',
    'daily_check.reward_title': 'Paldies!',
    'daily_check.reward_subtitle': 'Jūsu ikdienas pārbaude ir reģistrēta.\nGodīgas pārbaudes saglabā visus drošībā.',
    'daily_check.back_to_machine': 'Atpakaļ pie mašīnas',
    'daily_check.day_streak': 'Dienas pēc kārtas',
    'daily_check.completion_rate': 'Izpildes rādītājs',
    'daily_check.cat_lights': 'Apgaismojums un redzamība',
    'daily_check.cat_fluids': 'Šķidrumi',
    'daily_check.cat_tyres': 'Riepas un riteņi',
    'daily_check.cat_safety': 'Drošība',
    'daily_check.cat_controls': 'Vadība',
    'daily_check.cat_body': 'Virsbūve un piederumi',
    'daily_check.lights_working': 'Visi lukturi darbojas',
    'daily_check.mirrors': 'Spoguļi tīri un noregulēti',
    'daily_check.windscreen': 'Vējstikls tīrs un nesabojāts',
    'daily_check.engine_oil': 'Motoreļļas līmenis',
    'daily_check.coolant': 'Dzesēšanas šķidruma līmenis',
    'daily_check.hydraulic': 'Hidrauliskā šķidruma līmenis',
    'daily_check.fuel': 'Pietiekams degvielas līmenis',
    'daily_check.tyre_pressure': 'Pareizs riepu spiediens',
    'daily_check.tyre_damage': 'Nav redzamu riepu bojājumu',
    'daily_check.wheel_nuts': 'Riteņu uzgriežņi pievelkti',
    'daily_check.fire_extinguisher': 'Ugunsdzēšamais aparāts klāt',
    'daily_check.first_aid': 'Pirmās palīdzības komplekts klāt',
    'daily_check.rops': 'ROPS konstrukcija nesabojāta',
    'daily_check.seatbelt': 'Drošības josta darbojas',
    'daily_check.brakes': 'Bremzes darbojas',
    'daily_check.steering': 'Stūre reaģē',
    'daily_check.horn': 'Signāltaure darbojas',
    'daily_check.body_damage': 'Nav redzamu virsbūves bojājumu',
    'daily_check.attachments': 'Piederumi nostiprināti',
    'daily_check.pto_guard': 'KVA aizsargs savā vietā',
    'log_fault.title': 'Ziņot par bojājumu',
    'log_fault.description': 'Apraksts',
    'log_fault.description_placeholder': 'Aprakstiet bojājumu...',
    'log_fault.photos': 'Fotogrāfijas',
    'log_fault.add_photo': 'Pievienot fotogrāfiju',
    'log_fault.submit': 'Iesniegt bojājuma ziņojumu',
    'log_fault.success': 'Bojājums veiksmīgi ziņots',
    'emergency.title': 'Ārkārtas situācija',
    'emergency.what_emergency': 'Kāda ir ārkārtas situācija?',
    'emergency.select_type': 'Izvēlieties ārkārtas situācijas veidu.\nAtbilstošie kontakti tiks nekavējoties informēti.',
    'emergency.vibrating': 'Vibrē',
    'emergency.alarm': 'Trauksme',
    'emergency.medical': 'Medicīniska ārkārtas situācija',
    'emergency.medical_sub': 'Trauma, slimība vai bezsamaņā esošs cilvēks uz vietas',
    'emergency.calls_999': 'Nekavējoties zvana 112',
    'emergency.electrical': 'Elektriska ārkārtas situācija',
    'emergency.electrical_sub': 'Kontakts ar elektrolīniju — palieciet kabīnē',
    'emergency.calls_105': 'Nekavējoties zvana 112',
    'emergency.no_signal': 'Ārkārtas numuri saglabāti ierīcē — pieejami bez signāla',
    'emergency.gps_auto': 'GPS pozīcija tiek koplietota automātiski',
    'emergency.999_called': '112 izsaukts',
    'emergency.105_called': 'Ārkārtas līnija izsaukta',
    'emergency.services_contacted': 'Ārkārtas dienesti informēti.\nJūsu vadītājs arī informēts.',
    'emergency.power_contacted': 'Elektriskā ārkārtas līnija informēta.\nJūsu vadītājs arī informēts.',
    'emergency.emergency_type': 'Ārkārtas situācijas veids',
    'emergency.number_called': 'Izsauktais numurs',
    'emergency.location': 'Atrašanās vieta',
    'emergency.admin_notified': 'Administrators informēts',
    'emergency.stay_in_cab': 'Palieciet kabīnē',
    'emergency.stay_in_cab_msg': 'Neizejiet no transportlīdzekļa. Pagaidiet, kamēr iestādes apstiprina, ka līnija ir droša. Turiet logus aizvērtus.',
    'emergency.medical_type': 'Medicīniska',
    'emergency.electrical_type': 'Elektriska',
    'crash.are_you_okay': 'Vai esat labi?',
    'crash.impact_detected': 'Konstatēts iespējams trieciens.\nLūdzu atbildiet, pretējā gadījumā tiks izsaukta palīdzība.',
    'crash.im_okay': 'Esmu labi',
    'crash.dismiss_alert': 'Noraidīt trauksmi — bez darbības',
    'crash.i_need_help': 'Man vajag palīdzību',
    'crash.notify_supervisor': 'Informēt vadītāju ar GPS pozīciju',
    'crash.call_999': 'Zvanīt 112',
    'crash.call_emergency': 'Nekavējoties izsaukt ārkārtas dienestus',
    'crash.glad_okay': 'Priecājamies, ka esat labi',
    'crash.alert_dismissed': 'Trauksme noraidīta. Paziņojums nav nosūtīts.',
    'crash.help_on_way': 'Palīdzība jau ceļā',
    'crash.supervisor_notified': 'Jūsu vadītājs informēts ar jūsu GPS pozīciju.',
    'crash.auto_dialled': '112 automātiski izsaukts',
    'crash.no_response': 'Nav atbildes. Ārkārtas dienesti izsaukti automātiski. Balss ziņojums tiek translēts.',
    'crash.broadcasting': 'Ziņojuma translācija',
    'crash.repeating': 'Atkārtošana ik 15 sekundes',
    'crash.admin_notified': 'Administrators informēts',
    'crash.emergency_services': 'Ārkārtas dienesti',
    'profile.title': 'Profils',
    'profile.personal_info': 'Personiskā informācija',
    'profile.full_name': 'Pilns vārds',
    'profile.email': 'E-pasts',
    'profile.phone': 'Tālrunis',
    'profile.role': 'Loma',
    'profile.organisation': 'Organizācija',
    'profile.emergency_contact': 'Ārkārtas kontakts',
    'profile.emergency_contact_note': 'Ārkārtas situācijā tiks sazināts ar jūsu vadītāju',
    'profile.contact_name': 'Kontakta vārds',
    'profile.contact_phone': 'Kontakta tālrunis',
    'profile.notifications': 'Paziņojumi',
    'profile.task_reminders': 'Uzdevumu atgādinājumi',
    'profile.overdue_alerts': 'Kavēšanās brīdinājumi',
    'profile.crash_detection': 'Trieciena noteikšana',
    'profile.account_security': 'Konts un drošība',
    'profile.change_password': 'Mainīt paroli',
    'profile.two_factor': 'Divfaktoru autentifikācija',
    'profile.login_activity': 'Pieteikšanās darbība',
    'profile.app_settings': 'Lietotnes iestatījumi',
    'profile.theme': 'Motīvs',
    'profile.language': 'Valoda',
    'profile.sign_out': 'Izrakstīties',
    'profile.sign_out_confirm': 'Izrakstīties',
    'profile.sign_out_msg': 'Vai tiešām vēlaties izrakstīties?',
    'profile.field_staff': 'Lauka personāls',
    'theme.light': 'Gaišs',
    'theme.dark': 'Tumšs',
    'theme.system': 'Sistēmas noklusējums',
    'set.emails': "E-pasti",
    'set.hold_the_yard': "Iknedēļas Hold the Yard e-pasts",
    'set.hold_the_yard_desc': "Katru pirmdienu iepriekšējās nedēļas pārbaužu pirms lietošanas kopsavilkums, ko nosūta organizācijas administratoriem un vadītājiem.",
  },

  'et': {
    'app.name': 'AgriWare Toimingud',
    'app.tagline': 'Haldus',
    'nav.home': 'Kodu',
    'nav.machines': 'Masinad',
    'nav.profile': 'Profiil',
    'common.back': 'Tagasi',
    'common.cancel': 'Tühista',
    'common.save': 'Salvesta',
    'common.edit': 'Muuda',
    'common.done': 'Valmis',
    'common.yes': 'Jah',
    'common.no': 'Ei',
    'common.ok': 'OK',
    'common.error': 'Viga',
    'common.loading': 'Laadimine...',
    'common.retry': 'Proovi uuesti',
    'common.search': 'Otsi',
    'common.submit': 'Esita',
    'common.confirm': 'Kinnita',
    'common.close': 'Sulge',
    'common.pass': 'Läbitud',
    'common.fail': 'Läbimata',
    'common.total': 'kokku',
    'common.today': 'Täna',
    'common.yesterday': 'Eile',
    'common.online_only': 'Ainult võrgus',
    'common.last_synced': 'Viimane sünkroonimine',
    'common.back_to_app': 'Tagasi rakendusse',
    'common.gps_shared': 'GPS jagatud',
    'common.yes_via_saas': 'Jah — SaaS kaudu',
    'common.not_called': 'Ei helistatud',
    'login.sign_in': 'Logi sisse',
    'login.email': 'E-posti aadress',
    'login.password': 'Parool',
    'login.forgot_password': 'Unustasid parooli?',
    'login.no_account': 'Pole kontot?',
    'login.request_access': 'Taotle juurdepääsu',
    'login.account_created_by_org': 'Teie konto on loodud teie organisatsiooni poolt.',
    'login.email_placeholder': 'teie@organisatsioon.ee',
    'login.password_placeholder': 'Sisesta parool',
    'login.error_empty': 'Sisesta e-post ja parool.',
    'login.error_invalid': 'Vale e-post või parool. Proovi uuesti.',
    'dashboard.greeting_morning': 'Tere hommikust,',
    'dashboard.greeting_afternoon': 'Tere päevast,',
    'dashboard.greeting_evening': 'Tere õhtust,',
    'dashboard.todays_tasks': 'Tänased ülesanded',
    'dashboard.completed': 'Lõpetatud',
    'dashboard.overdue': 'Hilinenud',
    'dashboard.in_progress': 'Käimas',
    'dashboard.upcoming': 'Eelseisvad',
    'dashboard.pending': 'Ootel',
    'machines.title': 'Masinad',
    'machines.search_placeholder': 'Otsi masinaid...',
    'machines.favourites': 'Lemmikud',
    'machines.all_machines': 'Kõik masinad',
    'machines.operational': 'Töökorras',
    'machines.needs_attention': 'Vajab tähelepanu',
    'machines.fault': 'Rike',
    'machines.unsafe_to_operate': 'Ohtlik kasutada',
    'machines.registration': 'Registreerimine',
    'machines.assigned_operator': 'Määratud operaator',
    'machines.engine_hours': 'Mootoritunnid',
    'machines.documents': 'Dokumendid',
    'machines.log_fault': 'Teata riketest',
    'machines.operator_manual': 'Operaatori juhend',
    'machines.service_record': 'Teenindusdokument',
    'machines.insurance': 'Kindlustussertifikaat',
    'machines.mot': 'Tehnoülevaatus',
    'daily_check.title': 'Igapäevane kontroll',
    'daily_check.start': 'Alusta kontrolli',
    'daily_check.required': 'Igapäevane kontroll nõutav',
    'daily_check.required_msg': 'Peab olema lõpetatud enne selle masina kasutamist.',
    'daily_check.complete': 'Kontroll lõpetatud',
    'daily_check.complete_msg': 'Lõpetas',
    'daily_check.submit': 'Esita kontroll',
    'daily_check.items_remaining': 'üksust jäänud',
    'daily_check.reward_title': 'Aitäh!',
    'daily_check.reward_subtitle': 'Teie igapäevane kontroll on registreeritud.\nAusad kontrollid hoiavad kõik turvaliselt.',
    'daily_check.back_to_machine': 'Tagasi masina juurde',
    'daily_check.day_streak': 'Päevade järjest',
    'daily_check.completion_rate': 'Lõpetamise määr',
    'daily_check.cat_lights': 'Valgustus ja nähtavus',
    'daily_check.cat_fluids': 'Vedelikud',
    'daily_check.cat_tyres': 'Rehvid ja rattad',
    'daily_check.cat_safety': 'Ohutus',
    'daily_check.cat_controls': 'Juhtimine',
    'daily_check.cat_body': 'Kere ja lisaseadmed',
    'daily_check.lights_working': 'Kõik tuled töötavad',
    'daily_check.mirrors': 'Peeglid puhtad ja reguleeritud',
    'daily_check.windscreen': 'Esiklaas puhas ja terve',
    'daily_check.engine_oil': 'Mootoriõli tase',
    'daily_check.coolant': 'Jahutusvedeliku tase',
    'daily_check.hydraulic': 'Hüdraulikavedeliku tase',
    'daily_check.fuel': 'Piisav kütusetase',
    'daily_check.tyre_pressure': 'Õige rehvirõhk',
    'daily_check.tyre_damage': 'Nähtavaid rehvikahjustusi pole',
    'daily_check.wheel_nuts': 'Rattapoldid kinni',
    'daily_check.fire_extinguisher': 'Tulekustuti olemas',
    'daily_check.first_aid': 'Esmaabikomplekt olemas',
    'daily_check.rops': 'ROPS konstruktsioon terve',
    'daily_check.seatbelt': 'Turvavöö töötab',
    'daily_check.brakes': 'Pidurid töötavad',
    'daily_check.steering': 'Rool reageerib',
    'daily_check.horn': 'Signaalsarv töötab',
    'daily_check.body_damage': 'Nähtavaid kerekahjustusi pole',
    'daily_check.attachments': 'Lisaseadmed kinnitatud',
    'daily_check.pto_guard': 'Jõuvõtuvõlli kaitse paigas',
    'log_fault.title': 'Teata riketest',
    'log_fault.description': 'Kirjeldus',
    'log_fault.description_placeholder': 'Kirjelda riket...',
    'log_fault.photos': 'Fotod',
    'log_fault.add_photo': 'Lisa foto',
    'log_fault.submit': 'Esita rikeraport',
    'log_fault.success': 'Rike edukalt teatatud',
    'emergency.title': 'Hädaolukord',
    'emergency.what_emergency': 'Mis on hädaolukord?',
    'emergency.select_type': 'Valige hädaolukorra tüüp.\nVastavad kontaktid teavitatakse kohe.',
    'emergency.vibrating': 'Vibreerib',
    'emergency.alarm': 'Alarm',
    'emergency.medical': 'Meditsiiniline hädaolukord',
    'emergency.medical_sub': 'Vigastus, haigus või teadvuseta isik kohal',
    'emergency.calls_999': 'Helistab kohe 112',
    'emergency.electrical': 'Elektriline hädaolukord',
    'emergency.electrical_sub': 'Kontakt elektrijuhtmega — jääge kabiin',
    'emergency.calls_105': 'Helistab kohe 112',
    'emergency.no_signal': 'Hädaabinumbrid salvestatud seadmesse — saadaval ilma signaalita',
    'emergency.gps_auto': 'GPS-asukoht jagatakse automaatselt',
    'emergency.999_called': '112 helistatud',
    'emergency.105_called': 'Hädaabiliin helistatud',
    'emergency.services_contacted': 'Hädaabiteenistused on teavitatud.\nTeie juhataja on samuti teavitatud.',
    'emergency.power_contacted': 'Elektriline hädaabiliin on teavitatud.\nTeie juhataja on samuti teavitatud.',
    'emergency.emergency_type': 'Hädaolukorra tüüp',
    'emergency.number_called': 'Helistatud number',
    'emergency.location': 'Asukoht',
    'emergency.admin_notified': 'Admin teavitatud',
    'emergency.stay_in_cab': 'Jääge kabiini',
    'emergency.stay_in_cab_msg': 'Ärge lahkuge sõidukist. Oodake, kuni ametivõimud kinnitavad, et liin on ohutu. Hoidke aknad suletuna.',
    'emergency.medical_type': 'Meditsiiniline',
    'emergency.electrical_type': 'Elektriline',
    'crash.are_you_okay': 'Kas te olete korras?',
    'crash.impact_detected': 'Tuvastati võimalik löök.\nPalun vastake või kutsutakse abi.',
    'crash.im_okay': 'Olen korras',
    'crash.dismiss_alert': 'Lükka alarm tagasi — mingit tegevust',
    'crash.i_need_help': 'Vajan abi',
    'crash.notify_supervisor': 'Teavita juhatatajat GPS-asukohaga',
    'crash.call_999': 'Helista 112',
    'crash.call_emergency': 'Helista kohe hädaabiteenistustele',
    'crash.glad_okay': 'Hea meel, et olete korras',
    'crash.alert_dismissed': 'Alarm tagasi lükatud. Teadet ei saadetud.',
    'crash.help_on_way': 'Abi on teel',
    'crash.supervisor_notified': 'Teie juhataja on teavitatud teie GPS-asukohaga.',
    'crash.auto_dialled': '112 valitud automaatselt',
    'crash.no_response': 'Vastust pole. Hädaabiteenistused kutsuti automaatselt. Häälsõnum edastatakse.',
    'crash.broadcasting': 'Sõnumi edastamine',
    'crash.repeating': 'Kordamine iga 15 sekundi järel',
    'crash.admin_notified': 'Admin teavitatud',
    'crash.emergency_services': 'Hädaabiteenistused',
    'profile.title': 'Profiil',
    'profile.personal_info': 'Isiklik teave',
    'profile.full_name': 'Täisnimi',
    'profile.email': 'E-post',
    'profile.phone': 'Telefon',
    'profile.role': 'Roll',
    'profile.organisation': 'Organisatsioon',
    'profile.emergency_contact': 'Hädaabi kontakt',
    'profile.emergency_contact_note': 'Hädaolukorras võetakse ühendust teie juhatatajaga',
    'profile.contact_name': 'Kontakti nimi',
    'profile.contact_phone': 'Kontakti telefon',
    'profile.notifications': 'Teavitused',
    'profile.task_reminders': 'Ülesannete meeldetuletused',
    'profile.overdue_alerts': 'Hilinemise hoiatused',
    'profile.crash_detection': 'Löögi tuvastamine',
    'profile.account_security': 'Konto ja turvalisus',
    'profile.change_password': 'Muuda parooli',
    'profile.two_factor': 'Kahefaktoriline autentimine',
    'profile.login_activity': 'Sisselogimise tegevus',
    'profile.app_settings': 'Rakenduse seaded',
    'profile.theme': 'Teema',
    'profile.language': 'Keel',
    'profile.sign_out': 'Logi välja',
    'profile.sign_out_confirm': 'Logi välja',
    'profile.sign_out_msg': 'Kas soovite kindlasti välja logida?',
    'profile.field_staff': 'Väljatöötaja',
    'theme.light': 'Hele',
    'theme.dark': 'Tume',
    'theme.system': 'Süsteemi vaikimisi',
    'set.emails': "E-kirjad",
    'set.hold_the_yard': "Iganädalane Hold the Yardi e-kiri",
    'set.hold_the_yard_desc': "Igal esmaspäeval eelmise nädala kasutuseelsete kontrollide kokkuvõte, mis saadetakse organisatsiooni administraatoritele ja juhtidele.",
  },
};

export default translations;